// @ts-nocheck
/* eslint-disable */
// prettier-ignore
import { RelationshipType } from '../shared-types';
import { RelationshipType as InvestorRelationshipType } from '../shared-types';
import { RolodexRecordStatus } from '../shared-types';
import { RolodexRecordStatus as InvestorRelationshipRecordStatus } from '../shared-types';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `Any` scalar type represents any valid GraphQL value. */
  Any: { input: any; output: any };
  /** A 9-digit string representing Cmg entity key identifier. For example: 000000123 */
  CmgEntityKey: { input: any; output: any };
  /** The `Date` scalar type represents a date in UTC. */
  Date: { input: string; output: string };
  /** The `DateTime` scalar type represents a date and time with time zone offset information. */
  DateTime: { input: string; output: string };
  DateTimeZone: { input: string; output: string };
  /** The `Decimal` scalar type represents a decimal floating-point number with high precision. */
  Decimal: { input: number; output: number };
  Instant: { input: string; output: string };
  /** The `LocalDate` scalar type represents a date without time or time zone information. */
  LocalDate: { input: string; output: string };
  /** The `LocalTime` scalar type represents a time of day without date or time zone information. */
  LocalTime: { input: string; output: string };
  /** The `Long` scalar type represents a signed 64-bit integer. */
  Long: { input: number; output: number };
  /** The `UUID` scalar type represents a Universally Unique Identifier (UUID) as defined by RFC 9562. */
  UUID: { input: string; output: string };
};

export type AccountTrait = {
  readonly __typename?: 'AccountTrait';
  readonly accountCount: Scalars['Int']['output'];
  readonly accountType: Scalars['String']['output'];
  readonly code: Scalars['String']['output'];
  readonly description: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly permissions: ReadonlyArray<Scalars['String']['output']>;
};

export type Accounting = {
  readonly __typename?: 'Accounting';
  readonly averagePriceOfBuybackShares?: Maybe<Scalars['Decimal']['output']>;
  readonly baseDealShares: Scalars['Long']['output'];
  readonly baseGrossSpreadPercent?: Maybe<Scalars['Decimal']['output']>;
  readonly baseGrossSpreadValue?: Maybe<Scalars['Decimal']['output']>;
  readonly baseManagementFee?: Maybe<Scalars['Decimal']['output']>;
  readonly baseSellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly baseUnderwritingFee?: Maybe<Scalars['Decimal']['output']>;
  readonly dealRelatedExpenses?: Maybe<Scalars['Decimal']['output']>;
  readonly excludedShares: Scalars['Long']['output'];
  readonly id: Scalars['ID']['output'];
  readonly incentiveFeePercent?: Maybe<Scalars['Decimal']['output']>;
  readonly incentiveFeeValue?: Maybe<Scalars['Decimal']['output']>;
  readonly incentiveManagementFee?: Maybe<Scalars['Decimal']['output']>;
  readonly incentiveSellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly incentiveUnderwritingFee?: Maybe<Scalars['Decimal']['output']>;
  readonly managerExpenseReimbursement?: Maybe<Scalars['Decimal']['output']>;
  readonly managers: ReadonlyArray<AccountingManager>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly offeringPrice: Scalars['Decimal']['output'];
  readonly overallotmentExercised?: Maybe<Scalars['Long']['output']>;
  readonly potAllocated: Scalars['Long']['output'];
  readonly retailRetention?: Maybe<Scalars['Long']['output']>;
  readonly stabilizationGainLoss?: Maybe<Scalars['Decimal']['output']>;
  readonly totalSharesRefreshed?: Maybe<Scalars['Long']['output']>;
  readonly totalSharesRepurchased?: Maybe<Scalars['Long']['output']>;
};

export type AccountingManager = {
  readonly __typename?: 'AccountingManager';
  readonly baseUnderwritingPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly baseUnderwritingShares?: Maybe<Scalars['Long']['output']>;
  readonly dealExpenses?: Maybe<Scalars['Decimal']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly designatedShares?: Maybe<Scalars['Long']['output']>;
  readonly designationFees?: Maybe<Scalars['Decimal']['output']>;
  readonly finalSettlement?: Maybe<Scalars['Decimal']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly incentiveFeePercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly managementFees?: Maybe<Scalars['Decimal']['output']>;
  readonly managementFeesPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly managerCmgEntityKey: Scalars['String']['output'];
  readonly managerExpenseReimbursement?: Maybe<Scalars['Decimal']['output']>;
  readonly managerFirmName: Scalars['String']['output'];
  readonly managerRole: ExpensesManagerRole;
  /** Display name for ManagerRole */
  readonly managerRoleDisplayName?: Maybe<Scalars['String']['output']>;
  readonly manualAdjustment?: Maybe<Scalars['Decimal']['output']>;
  readonly netDealFees?: Maybe<Scalars['Decimal']['output']>;
  readonly overallotmentUnderwritingShares?: Maybe<Scalars['Long']['output']>;
  readonly potEconomics?: Maybe<Scalars['Decimal']['output']>;
  readonly potEconomicsWithOverwrites?: Maybe<Scalars['Decimal']['output']>;
  readonly retailRetention?: Maybe<Scalars['Decimal']['output']>;
  readonly retailRetentionFees?: Maybe<Scalars['Decimal']['output']>;
  readonly stabilizationGainLoss?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFees?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingShares?: Maybe<Scalars['Long']['output']>;
};

export type AccountingNotes = {
  readonly __typename?: 'AccountingNotes';
  readonly notes: Scalars['String']['output'];
};

/**
 * Actions are performed against Resources.
 * Warning: If breaking changes are made to this enum, then we will need to write a custom migration to update all entitlements stored in the db.
 */
export enum Action {
  Acknowledge = 'ACKNOWLEDGE',
  Create = 'CREATE',
  Delete = 'DELETE',
  LimitedRead = 'LIMITED_READ',
  Manage = 'MANAGE',
  Read = 'READ',
  Receive = 'RECEIVE',
  Release = 'RELEASE',
  Update = 'UPDATE',
}

/**
 * Configures an Action in the context of a Resource.
 * Includes the ability to ensure that an action may only be configured for a manager if the manager has the proper role and/or responsibility.
 */
export type ActionConfiguration = {
  readonly __typename?: 'ActionConfiguration';
  readonly action: Action;
  readonly description: Scalars['String']['output'];
  readonly managerResponsibilityRestriction?: Maybe<ManagerResponsibility>;
  readonly managerRoleRestriction?: Maybe<ManagerRole>;
};

export enum ActivityType {
  Iopb = 'IOPB',
  Sb = 'SB',
  Sct = 'SCT',
}

export type AddCurrencyToTrancheInput = {
  readonly currencyCode: Scalars['String']['input'];
  readonly offeringId: Scalars['UUID']['input'];
  readonly trancheId: Scalars['UUID']['input'];
};

export type AddCurrencyToTranchePayload = {
  readonly __typename?: 'AddCurrencyToTranchePayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type AddInstrumentToTrancheInput = {
  readonly instrumentId: Scalars['UUID']['input'];
  readonly offeringId: Scalars['UUID']['input'];
  readonly trancheId: Scalars['UUID']['input'];
};

export type AddInstrumentToTranchePayload = {
  readonly __typename?: 'AddInstrumentToTranchePayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type AddViewSettingInput = {
  readonly name: Scalars['String']['input'];
  readonly viewData: Scalars['String']['input'];
  readonly viewName: Scalars['String']['input'];
};

export type AddViewSettingPayload = {
  readonly __typename?: 'AddViewSettingPayload';
  readonly viewSetting?: Maybe<ViewSetting>;
};

export type AddWallCrossInvestorCommunicationLogInput = {
  readonly data: WallCrossInvestorCommunicationLogDataInput;
  readonly investorId: Scalars['ID']['input'];
  readonly offeringId: Scalars['ID']['input'];
};

export type AddWallCrossInvestorCommunicationLogPayload = {
  readonly __typename?: 'AddWallCrossInvestorCommunicationLogPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

export type AddWallCrossInvestorInput = {
  readonly data: WallCrossInvestorDataInput;
  readonly investor: InvestorInformationInput;
  readonly offeringId: Scalars['ID']['input'];
};

export type AddWallCrossInvestorPayload = {
  readonly __typename?: 'AddWallCrossInvestorPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

export type AddWallCrossOwnerInput = {
  readonly data: WallCrossOwnerDataInput;
  readonly investorId: Scalars['ID']['input'];
  readonly offeringId: Scalars['ID']['input'];
};

export type AddWallCrossOwnerPayload = {
  readonly __typename?: 'AddWallCrossOwnerPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

export type AdminCreateInvestorFirmEmployeeInput = {
  readonly firmKeyOrId: Scalars['ID']['input'];
  readonly input: InvestorEmployeeCreateDtoInput;
  readonly tenantId: Scalars['UUID']['input'];
};

export type AdminCreateInvestorFirmEmployeePayload = {
  readonly __typename?: 'AdminCreateInvestorFirmEmployeePayload';
  readonly investorFirmContact?: Maybe<InvestorFirmContact>;
};

export type AdminCreateInvestorFirmInput = {
  readonly input: InvestorFirmCreateDtoInput;
  readonly tenantId: Scalars['UUID']['input'];
};

export type AdminCreateInvestorFirmPayload = {
  readonly __typename?: 'AdminCreateInvestorFirmPayload';
  readonly investorFirmsGrid?: Maybe<InvestorFirmsGrid>;
};

export type AdminCreateInvestorRelationshipsInput = {
  readonly input: ReadonlyArray<InvestorFirmRelationshipCreateInput>;
  readonly tenantId: Scalars['UUID']['input'];
};

export type AdminCreateInvestorRelationshipsPayload = {
  readonly __typename?: 'AdminCreateInvestorRelationshipsPayload';
  readonly investorFirmRelationship?: Maybe<ReadonlyArray<InvestorFirmRelationship>>;
};

export type AdminCreateUnderwriterEmployeeInput = {
  readonly input: UnderwriterEmployeeCreateInput;
  readonly tenantId: Scalars['UUID']['input'];
};

export type AdminCreateUnderwriterEmployeePayload = {
  readonly __typename?: 'AdminCreateUnderwriterEmployeePayload';
  readonly underwriterEmployee?: Maybe<UnderwriterEmployee>;
};

export type AdminFirmEmployeeInput = {
  readonly email: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly recordStatus: RolodexRecordStatus;
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminFirmMatch = {
  readonly __typename?: 'AdminFirmMatch';
  readonly addresses?: Maybe<ReadonlyArray<Maybe<AdminFirmMatchAddress>>>;
  readonly entityType?: Maybe<FirmLegalEntityType>;
  readonly firmSource: FirmSource;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly identifiers?: Maybe<AdminFirmMatchIdentifiers>;
  readonly industryType?: Maybe<FirmIndustryType>;
  readonly isConnected: Scalars['Boolean']['output'];
  readonly isOnPlatform: Scalars['Boolean']['output'];
  readonly linkFrequencyData?: Maybe<LinkFrequency>;
  readonly names?: Maybe<ReadonlyArray<Maybe<AdminFirmMatchName>>>;
  readonly parentId?: Maybe<Scalars['String']['output']>;
  readonly parentName?: Maybe<Scalars['String']['output']>;
  readonly roles?: Maybe<ReadonlyArray<FirmRoleType>>;
  readonly rolodexKey?: Maybe<Scalars['String']['output']>;
  readonly score: Scalars['Int']['output'];
  readonly sectors?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly status: FirmStatus;
  readonly ultimateParentId?: Maybe<Scalars['String']['output']>;
  readonly ultimateParentName?: Maybe<Scalars['String']['output']>;
  readonly webDomains?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
};

export type AdminFirmMatchAddress = {
  readonly __typename?: 'AdminFirmMatchAddress';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly type: FirmAddressType;
};

export type AdminFirmMatchIdentifiers = {
  readonly __typename?: 'AdminFirmMatchIdentifiers';
  readonly cik?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly crd?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly cusip?: Maybe<Scalars['String']['output']>;
  readonly factSet?: Maybe<Scalars['String']['output']>;
  readonly isin?: Maybe<Scalars['String']['output']>;
  readonly lei?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly morningStar?: Maybe<Scalars['String']['output']>;
  readonly mpid?: Maybe<Scalars['String']['output']>;
  readonly ticker?: Maybe<Scalars['String']['output']>;
};

export type AdminFirmMatchName = {
  readonly __typename?: 'AdminFirmMatchName';
  readonly isDisplayName: Scalars['Boolean']['output'];
  readonly recordStatus: RolodexRecordStatus;
  readonly type: FirmNameType;
  readonly value?: Maybe<Scalars['String']['output']>;
};

/** A segment of a collection. */
export type AdminInvestorFirmsGridCollectionSegment = {
  readonly __typename?: 'AdminInvestorFirmsGridCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<InvestorFirmsGrid>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type AdminUnderwriterEmployeesCollectionSegment = {
  readonly __typename?: 'AdminUnderwriterEmployeesCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<UnderwriterEmployee>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type AdminUpdateInvestorFirmEmployeeInput = {
  readonly employeeKeyOrId: Scalars['ID']['input'];
  readonly firmKeyOrId: Scalars['ID']['input'];
  readonly input: UpdateInvestorFirmEmployeeInput;
  readonly tenantId: Scalars['UUID']['input'];
};

export type AdminUpdateInvestorFirmEmployeePayload = {
  readonly __typename?: 'AdminUpdateInvestorFirmEmployeePayload';
  readonly investorFirmContact?: Maybe<InvestorFirmContact>;
};

export type AdminUpdateInvestorFirmInput = {
  readonly firmKeyOrId: Scalars['ID']['input'];
  readonly input: UpdateInvestorFirmInput;
  readonly tenantId: Scalars['UUID']['input'];
};

export type AdminUpdateInvestorFirmPayload = {
  readonly __typename?: 'AdminUpdateInvestorFirmPayload';
  readonly investorFirmsGrid?: Maybe<InvestorFirmsGrid>;
};

export type AdminUpdateInvestorRelationshipInput = {
  readonly firmId: Scalars['UUID']['input'];
  readonly input: InvestorRelationshipUpdateDtoInput;
  readonly tenantId: Scalars['UUID']['input'];
  readonly underwriterEmployeeId: Scalars['UUID']['input'];
};

export type AdminUpdateInvestorRelationshipPayload = {
  readonly __typename?: 'AdminUpdateInvestorRelationshipPayload';
  readonly investorFirmRelationship?: Maybe<InvestorFirmRelationship>;
};

export type AdminUpdateUnderwriterEmployeeInput = {
  readonly employeeKeyOrId: Scalars['ID']['input'];
  readonly input: UnderwriterEmployeeUpdateInput;
  readonly tenantId: Scalars['UUID']['input'];
};

export type AdminUpdateUnderwriterEmployeePayload = {
  readonly __typename?: 'AdminUpdateUnderwriterEmployeePayload';
  readonly underwriterEmployee?: Maybe<UnderwriterEmployee>;
};

export type Advisor = {
  readonly __typename?: 'Advisor';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly recordStatus: RecordStatus;
  readonly role: AdvisorRole;
};

export enum AdvisorRole {
  IssuerAuditor = 'ISSUER_AUDITOR',
  IssuerCounsel = 'ISSUER_COUNSEL',
  Trustee = 'TRUSTEE',
  UnderwriterCounsel = 'UNDERWRITER_COUNSEL',
}

export type Affiliate = {
  readonly __typename?: 'Affiliate';
  readonly crdNumber?: Maybe<Scalars['Long']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly mpid?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
};

export enum AlertSeverity {
  Error = 'ERROR',
  None = 'NONE',
  Warning = 'WARNING',
}

export type AlertSeverityOperationFilterInput = {
  readonly eq?: InputMaybe<AlertSeverity>;
  readonly in?: InputMaybe<ReadonlyArray<AlertSeverity>>;
  readonly neq?: InputMaybe<AlertSeverity>;
  readonly nin?: InputMaybe<ReadonlyArray<AlertSeverity>>;
};

export type Allocation = {
  readonly __typename?: 'Allocation';
  readonly allocationNotional?: Maybe<Scalars['Decimal']['output']>;
  readonly allocationSetId: Scalars['UUID']['output'];
  readonly shares?: Maybe<Scalars['Long']['output']>;
};

export enum AllocationAcknowledgement {
  Acknowledged = 'ACKNOWLEDGED',
  Rejected = 'REJECTED',
  Unacknowledged = 'UNACKNOWLEDGED',
}

export enum AllocationAcknowledgementNewStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Rejected = 'REJECTED',
}

export type AllocationAcknowledgementOperationFilterInput = {
  readonly eq?: InputMaybe<AllocationAcknowledgement>;
  readonly in?: InputMaybe<ReadonlyArray<AllocationAcknowledgement>>;
  readonly neq?: InputMaybe<AllocationAcknowledgement>;
  readonly nin?: InputMaybe<ReadonlyArray<AllocationAcknowledgement>>;
};

export type AllocationChangeDetail = {
  readonly __typename?: 'AllocationChangeDetail';
  readonly investorFirmDisplayName?: Maybe<Scalars['String']['output']>;
  readonly new: AllocationRevisionDetail;
  readonly old?: Maybe<AllocationRevisionDetail>;
};

export type AllocationDtoFilterInput = {
  readonly allocationNotional?: InputMaybe<DecimalOperationFilterInput>;
  readonly allocationSetId?: InputMaybe<UuidOperationFilterInput>;
  readonly and?: InputMaybe<ReadonlyArray<AllocationDtoFilterInput>>;
  readonly or?: InputMaybe<ReadonlyArray<AllocationDtoFilterInput>>;
  readonly shares?: InputMaybe<LongOperationFilterInput>;
};

export type AllocationDtoSortInput = {
  readonly allocationNotional?: InputMaybe<SortEnumType>;
  readonly allocationSetId: Scalars['UUID']['input'];
  readonly shares?: InputMaybe<SortEnumType>;
};

export type AllocationInvestorReplyDiff = IndicationScopedDiffEntry &
  OrderBookDiffEntry & {
    readonly __typename?: 'AllocationInvestorReplyDiff';
    readonly allocationVersion: Scalars['String']['output'];
    readonly authorCmgEntityKey?: Maybe<Scalars['String']['output']>;
    readonly indicationId: Scalars['UUID']['output'];
    readonly investorCmgEntityKey?: Maybe<Scalars['String']['output']>;
    readonly missingFrom: ReadonlyArray<OrderBookNode>;
    readonly presentAt: ReadonlyArray<OrderBookNode>;
    readonly version: Scalars['String']['output'];
  };

export type AllocationRevisionDetail = {
  readonly __typename?: 'AllocationRevisionDetail';
  readonly allocationVersion: Scalars['Long']['output'];
  readonly indicationId: Scalars['UUID']['output'];
  readonly shares?: Maybe<Scalars['Long']['output']>;
};

export type AllocationSet = {
  readonly __typename?: 'AllocationSet';
  readonly auditInfo: AuditInformation;
  readonly author: FirmInfo;
  readonly dealLayout: OfferingDealLayout;
  readonly edition: RevisionEdition;
  readonly id: Scalars['ID']['output'];
  readonly isDefault: Scalars['Boolean']['output'];
  readonly isFinal: Scalars['Boolean']['output'];
  readonly isReleased: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly releaseTimestamp?: Maybe<Scalars['Instant']['output']>;
  readonly shareTimestamp?: Maybe<Scalars['Instant']['output']>;
  readonly sharedWithManagerCmgEntityKeys?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly sharedWithManagers?: Maybe<ReadonlyArray<Maybe<AllocationSetShareInfo>>>;
  readonly status: AllocationStatus;
};

export type AllocationSetDetail = {
  readonly __typename?: 'AllocationSetDetail';
  readonly id: Scalars['UUID']['output'];
  readonly institutionalTarget?: Maybe<Scalars['Long']['output']>;
  readonly isDraft: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly offeringSize?: Maybe<Scalars['Long']['output']>;
  readonly version: Scalars['Long']['output'];
};

export type AllocationSetDtoFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<AllocationSetDtoFilterInput>>;
  readonly auditInfo?: InputMaybe<AuditInformationFilterInput>;
  readonly author?: InputMaybe<FirmInfoFilterInput>;
  readonly dealLayout?: InputMaybe<DealLayoutReadDtoFilterInput>;
  readonly edition?: InputMaybe<RevisionEditionFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly isDefault?: InputMaybe<BooleanOperationFilterInput>;
  readonly isFinal?: InputMaybe<BooleanOperationFilterInput>;
  readonly isReleased?: InputMaybe<BooleanOperationFilterInput>;
  readonly name?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<AllocationSetDtoFilterInput>>;
  readonly releaseTimestamp?: InputMaybe<InstantOperationFilterInput>;
  readonly shareTimestamp?: InputMaybe<InstantOperationFilterInput>;
  readonly sharedWithManagerCmgEntityKeys?: InputMaybe<ListStringOperationFilterInput>;
  readonly status?: InputMaybe<AllocationStatusOperationFilterInput>;
};

export type AllocationSetDtoSortInput = {
  readonly auditInfo?: InputMaybe<AuditInformationSortInput>;
  readonly author?: InputMaybe<FirmInfoSortInput>;
  readonly dealLayout?: InputMaybe<DealLayoutReadDtoSortInput>;
  readonly edition?: InputMaybe<RevisionEditionSortInput>;
  readonly id?: InputMaybe<SortEnumType>;
  readonly isDefault?: InputMaybe<SortEnumType>;
  readonly isFinal?: InputMaybe<SortEnumType>;
  readonly isReleased?: InputMaybe<SortEnumType>;
  readonly name?: InputMaybe<SortEnumType>;
  readonly releaseTimestamp?: InputMaybe<SortEnumType>;
  readonly shareTimestamp?: InputMaybe<SortEnumType>;
  readonly status?: InputMaybe<SortEnumType>;
};

export type AllocationSetShareInfo = {
  readonly __typename?: 'AllocationSetShareInfo';
  readonly isActive: Scalars['Boolean']['output'];
  readonly manager: FirmInfo;
  readonly sharedAt: Scalars['Instant']['output'];
};

export enum AllocationStatus {
  NeverReleased = 'NEVER_RELEASED',
  Released = 'RELEASED',
  Unreleased = 'UNRELEASED',
}

export type AllocationStatusOperationFilterInput = {
  readonly eq?: InputMaybe<AllocationStatus>;
  readonly in?: InputMaybe<ReadonlyArray<AllocationStatus>>;
  readonly neq?: InputMaybe<AllocationStatus>;
  readonly nin?: InputMaybe<ReadonlyArray<AllocationStatus>>;
};

export type AllocationTotalRow = {
  readonly __typename?: 'AllocationTotalRow';
  readonly allocationSetId: Scalars['UUID']['output'];
  readonly notional?: Maybe<Scalars['Decimal']['output']>;
  readonly shares: Scalars['Long']['output'];
  readonly unAllocatedShares?: Maybe<Scalars['Long']['output']>;
};

export type AllocationUpdateInput = {
  /** The number of shares being allocated. */
  readonly shareQuantity?: InputMaybe<Scalars['Long']['input']>;
};

export type AllocationsInput = {
  readonly allocation: CreateAllocationInput;
  readonly indicationId: Scalars['UUID']['input'];
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION',
}

export type AssignContactInput = {
  readonly email: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
};

export type AssignDealLayoutInput = {
  readonly institutionalTarget?: InputMaybe<Scalars['Long']['input']>;
  readonly offeringSize?: InputMaybe<Scalars['Long']['input']>;
};

export type AssignInvestorInstitutionalIndicationInput = {
  readonly currencyCode?: InputMaybe<Scalars['String']['input']>;
  readonly instrumentId?: InputMaybe<Scalars['UUID']['input']>;
  /** The demand expression of the indication. Empty for Interested (PP-only). */
  readonly interestLevels: ReadonlyArray<InterestLevelInput>;
  readonly trancheId: Scalars['UUID']['input'];
};

export type AssignNoteInput = {
  readonly text?: InputMaybe<Scalars['String']['input']>;
  readonly type: IndicationNoteType;
};

export type AssignRetailDemandInput = {
  readonly instrumentId: Scalars['UUID']['input'];
  readonly notionalQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  readonly roundLots?: InputMaybe<Scalars['Int']['input']>;
  readonly shareQuantity?: InputMaybe<Scalars['Long']['input']>;
  readonly trancheId: Scalars['UUID']['input'];
};

export type AssignRetailRetentionInput = {
  readonly shareQuantity: Scalars['Long']['input'];
};

export type AssignRoadshowMeetingTypeEngagementInput = {
  readonly indicationId: Scalars['UUID']['input'];
  readonly value?: InputMaybe<RoadshowMeetingType>;
};

export type AssignTestingTheWatersEngagementInput = {
  readonly indicationId: Scalars['UUID']['input'];
  readonly value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignWallCrossEngagementInput = {
  readonly indicationId: Scalars['UUID']['input'];
  readonly value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Attestation = {
  readonly __typename?: 'Attestation';
  readonly attestationForm?: Maybe<AttestationForm>;
  readonly certificateType: CertificateType;
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly formStatus: AttestationFormStatus;
};

export type AttestationForm = {
  readonly __typename?: 'AttestationForm';
  readonly addressLine1: Scalars['String']['output'];
  readonly bankRequesterCmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly certificateType: CertificateType;
  readonly cityStateZip?: Maybe<Scalars['String']['output']>;
  readonly effectiveDate: Scalars['LocalDate']['output'];
  readonly envelopeId?: Maybe<Scalars['UUID']['output']>;
  readonly expirationDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly firmIdentifier?: Maybe<Scalars['String']['output']>;
  readonly firmName: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isBlanketForm: Scalars['Boolean']['output'];
  readonly primaryFirmCmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly signatoryDate: Scalars['LocalDate']['output'];
  readonly signers: ReadonlyArray<Signer>;
};

export enum AttestationFormStatus {
  Blanket = 'BLANKET',
  Expired = 'EXPIRED',
  NotOnFile = 'NOT_ON_FILE',
  Partial = 'PARTIAL',
}

export type AttestationStatus = {
  readonly __typename?: 'AttestationStatus';
  readonly certificateType: CertificateType;
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly status: AttestationFormStatus;
};

/**
 * Audit information tracked by the CMG platform. This data structure will contain a combination of system level
 * and user level information, where available.
 */
export type AuditInfo = {
  readonly __typename?: 'AuditInfo';
  readonly createdAt: Scalars['Instant']['output'];
  readonly createdByFirmKey?: Maybe<Scalars['String']['output']>;
  readonly createdByFirmName?: Maybe<Scalars['String']['output']>;
  readonly createdByUserEmail?: Maybe<Scalars['String']['output']>;
  readonly firmKeys: Scalars['String']['output'];
  readonly modifiedAt: Scalars['Instant']['output'];
  readonly modifiedByFirmKey?: Maybe<Scalars['String']['output']>;
  readonly modifiedByFirmName?: Maybe<Scalars['String']['output']>;
  readonly modifiedByUserEmail?: Maybe<Scalars['String']['output']>;
};

/**
 * Audit information tracked by the CMG platform. This data structure will contain a combination of system level
 * and user level information, where available.
 */
export type AuditInfoSortInput = {
  readonly createdAt?: InputMaybe<SortEnumType>;
  readonly createdByFirmKey?: InputMaybe<SortEnumType>;
  readonly createdByUserEmail?: InputMaybe<SortEnumType>;
  readonly modifiedAt?: InputMaybe<SortEnumType>;
  readonly modifiedByFirmKey?: InputMaybe<SortEnumType>;
  readonly modifiedByUserEmail?: InputMaybe<SortEnumType>;
};

export type AuditInformation = {
  readonly __typename?: 'AuditInformation';
  readonly createdAt: Scalars['Instant']['output'];
  readonly createdBy?: Maybe<FirmInfo>;
  readonly modifiedAt: Scalars['Instant']['output'];
  readonly modifiedBy?: Maybe<FirmInfo>;
};

export type AuditInformationFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<AuditInformationFilterInput>>;
  readonly createdAt?: InputMaybe<InstantOperationFilterInput>;
  readonly createdBy?: InputMaybe<FirmInfoFilterInput>;
  readonly modifiedAt?: InputMaybe<InstantOperationFilterInput>;
  readonly modifiedBy?: InputMaybe<FirmInfoFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<AuditInformationFilterInput>>;
};

export type AuditInformationSortInput = {
  readonly createdAt?: InputMaybe<SortEnumType>;
  readonly createdBy?: InputMaybe<FirmInfoSortInput>;
  readonly modifiedAt?: InputMaybe<SortEnumType>;
  readonly modifiedBy?: InputMaybe<FirmInfoSortInput>;
};

export type BackfillViewSettingInput = {
  readonly isFavorite: Scalars['Boolean']['input'];
  readonly name: Scalars['String']['input'];
  readonly viewData: Scalars['String']['input'];
  readonly viewName: Scalars['String']['input'];
};

export type BackfillViewSettingsInput = {
  readonly viewSettings: ReadonlyArray<BackfillViewSettingInput>;
};

export type BackfillViewSettingsPayload = {
  readonly __typename?: 'BackfillViewSettingsPayload';
  readonly viewSettings?: Maybe<ReadonlyArray<ViewSetting>>;
};

export type BankRelationship = {
  readonly __typename?: 'BankRelationship';
  readonly bankCmgEntityKey: Scalars['String']['output'];
  readonly bankId: Scalars['UUID']['output'];
  readonly bankName: Scalars['String']['output'];
  readonly linkedInvestorFirms: ReadonlyArray<InvestorFirmsGrid>;
};

export type BaseRegulatoryFiling = {
  readonly __typename?: 'BaseRegulatoryFiling';
  readonly id: Scalars['ID']['output'];
  readonly status: FilingStatus;
  readonly submittedDateTime: Scalars['Instant']['output'];
};

export type BasicPublishedOfferingProfile = {
  readonly __typename?: 'BasicPublishedOfferingProfile';
  readonly bookCloseDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly bookCloseTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly bookOpenDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly bookOpenTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly disclaimers: DisclaimersProfile;
  readonly firstTradeDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly hasForwardAgreement?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['ID']['output'];
  /** Returns an Investor Relationship on an On-Platform Offering */
  readonly investorRelationship: OfferingInvestorRelationship;
  readonly issuerBusinessDescription?: Maybe<Scalars['String']['output']>;
  readonly issuerName: Scalars['String']['output'];
  readonly issuerSector?: Maybe<Sector>;
  /** Display name for IssuerSector */
  readonly issuerSectorDisplayName?: Maybe<Scalars['String']['output']>;
  readonly marketing: Marketing;
  readonly myInstitutionalIndication?: Maybe<MyInstitutionalIndication>;
  readonly offerPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly orderBook: OrderBook;
  readonly orderEntryProfile?: Maybe<OfferingOrderEntryProfile>;
  readonly pricingCurrencyCode: Scalars['String']['output'];
  readonly pricingDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly prospectusDocuments: ReadonlyArray<ProspectusDocumentProfile>;
  readonly publicOrderBook: PublicOrderBook;
  readonly roadshowSchedules: ReadonlyArray<RoadshowScheduleProfile>;
  readonly securityType: SecurityType;
  /** Display name for SecurityType */
  readonly securityTypeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly settlementDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly stage: OfferingStage;
  readonly status: OfferingStatus;
  readonly syndicate: SyndicateProfile;
  readonly syndicateEntitlements: Entitlements;
  readonly terminatedDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly terms: TermsProfile;
  readonly timeZone?: Maybe<Scalars['DateTimeZone']['output']>;
  readonly type: OfferingType;
  /** Display name for Type */
  readonly typeDisplayName?: Maybe<Scalars['String']['output']>;
};

export type BasicPublishedOfferingProfileSyndicateEntitlementsArgs = {
  filters?: InputMaybe<RecordStatusFilterInput>;
};

export type BatchAssignRoadshowMeetingTypeEngagementInput = {
  readonly input: ReadonlyArray<AssignRoadshowMeetingTypeEngagementInput>;
  readonly offeringId: Scalars['UUID']['input'];
};

export type BatchAssignRoadshowMeetingTypeEngagementPayload = {
  readonly __typename?: 'BatchAssignRoadshowMeetingTypeEngagementPayload';
  readonly investorEngagement?: Maybe<ReadonlyArray<InvestorEngagement>>;
};

export type BatchAssignTestingTheWatersEngagementInput = {
  readonly input: ReadonlyArray<AssignTestingTheWatersEngagementInput>;
  readonly offeringId: Scalars['UUID']['input'];
};

export type BatchAssignTestingTheWatersEngagementPayload = {
  readonly __typename?: 'BatchAssignTestingTheWatersEngagementPayload';
  readonly investorEngagement?: Maybe<ReadonlyArray<InvestorEngagement>>;
};

export type BatchAssignWallCrossEngagementInput = {
  readonly input: ReadonlyArray<AssignWallCrossEngagementInput>;
  readonly offeringId: Scalars['UUID']['input'];
};

export type BatchAssignWallCrossEngagementPayload = {
  readonly __typename?: 'BatchAssignWallCrossEngagementPayload';
  readonly investorEngagement?: Maybe<ReadonlyArray<InvestorEngagement>>;
};

export type BillingAndDeliveryAgent = {
  readonly __typename?: 'BillingAndDeliveryAgent';
  readonly auditInfo: AuditInfo;
  readonly indicationId: Scalars['UUID']['output'];
  readonly managerCmgEntityKey: Scalars['String']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly version: Scalars['String']['output'];
};

export type BillingAndDeliveryAgentBatchUpdateInput = {
  readonly billingAndDeliveryAgentKey?: InputMaybe<Scalars['String']['input']>;
  readonly indicationIds: ReadonlyArray<Scalars['UUID']['input']>;
};

export type BillingAndDeliveryAgentDiff = IndicationScopedDiffEntry &
  OrderBookDiffEntry & {
    readonly __typename?: 'BillingAndDeliveryAgentDiff';
    readonly authorCmgEntityKey?: Maybe<Scalars['String']['output']>;
    readonly fromIndicationVersion: Scalars['String']['output'];
    readonly indicationId: Scalars['UUID']['output'];
    readonly investorCmgEntityKey?: Maybe<Scalars['String']['output']>;
    readonly missingFrom: ReadonlyArray<OrderBookNode>;
    readonly presentAt: ReadonlyArray<OrderBookNode>;
    readonly version: Scalars['String']['output'];
  };

export type BillingAndDeliveryAgentUpdateInput = {
  readonly managerCmgEntityKey: Scalars['String']['input'];
};

export type BillingAndDeliveryPayment = {
  readonly __typename?: 'BillingAndDeliveryPayment';
  readonly billAndDeliveryShares: Scalars['Long']['output'];
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly payment: Scalars['Decimal']['output'];
};

export type BndAgentBatchUpdateInput = {
  readonly bndAgentKey?: InputMaybe<Scalars['CmgEntityKey']['input']>;
  readonly indicationId: Scalars['UUID']['input'];
};

export type BndAgentUpdateInput = {
  readonly bndAgentKey?: InputMaybe<Scalars['CmgEntityKey']['input']>;
};

export type BooleanOperationFilterInput = {
  readonly eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly neq?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Used to group entitlements and explicitly define the owner of each Resource */
export enum BoundedContext {
  FinalSettlement = 'FINAL_SETTLEMENT',
  OfferingSetup = 'OFFERING_SETUP',
  OrderBook = 'ORDER_BOOK',
  Roadshows = 'ROADSHOWS',
  SyndicateWires = 'SYNDICATE_WIRES',
}

export type BrokerDealerMyRetailFees = {
  readonly __typename?: 'BrokerDealerMyRetailFees';
  readonly brokerCmgEntityKey: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly payment?: Maybe<Scalars['Decimal']['output']>;
};

export type BulkAssignBndAgentPayload = {
  readonly __typename?: 'BulkAssignBndAgentPayload';
  readonly updatedIndicationIds: ReadonlyArray<Scalars['UUID']['output']>;
};

export enum BuySellType {
  Buy = 'BUY',
  Sell = 'SELL',
}

/** Supply distributions to be used in calculation versus the stored distributions on the offering. */
export type CalculateFeesDistributionsDataInput = {
  /** Specify an override value for the incentive fee percentage distribution. */
  readonly incentiveFeePercentagesOverride?: InputMaybe<
    ReadonlyArray<PercentagePerCmgEntityDataInput>
  >;
  /** Specify an override value for the underwriting fee percentage distribution. */
  readonly underwritingFeePercentagesOverride?: InputMaybe<
    ReadonlyArray<PercentagePerCmgEntityDataInput>
  >;
};

export type CalculateFeesDistributionsInput = {
  readonly data?: InputMaybe<CalculateFeesDistributionsDataInput>;
  readonly offeringId: Scalars['UUID']['input'];
};

export type CalculateFeesDistributionsPayload = {
  readonly __typename?: 'CalculateFeesDistributionsPayload';
  readonly calculatedPercentageDistributions?: Maybe<CalculatedPercentageDistributions>;
};

export type CalculateShareDistributions = {
  readonly __typename?: 'CalculateShareDistributions';
  readonly overallotmentExercisedShareDistribution: ReadonlyArray<SharesPerCmgEntity>;
  readonly underwritingBaseShareDistribution: ReadonlyArray<SharesPerCmgEntity>;
  readonly underwritingTotalSharesDistribution: ReadonlyArray<SharesPerCmgEntity>;
};

export type CalculateSharesDistributionsDataInput = {
  /** Specify an override value for the underwriting fee total. */
  readonly underwritingFeeTotalDistributionOverride?: InputMaybe<
    ReadonlyArray<PercentagePerCmgEntityDataInput>
  >;
};

export type CalculateSharesDistributionsInput = {
  readonly data?: InputMaybe<CalculateSharesDistributionsDataInput>;
  readonly offeringId: Scalars['UUID']['input'];
};

export type CalculateSharesDistributionsPayload = {
  readonly __typename?: 'CalculateSharesDistributionsPayload';
  readonly calculateShareDistributions?: Maybe<CalculateShareDistributions>;
};

export type CalculatedPercentageDistributions = {
  readonly __typename?: 'CalculatedPercentageDistributions';
  readonly managementFeeDistribution: ReadonlyArray<PercentagePerCmgEntity>;
  readonly sellingConcessionDistribution: ReadonlyArray<PercentagePerCmgEntity>;
  readonly underwritingFeeTotalDistribution: ReadonlyArray<PercentagePerCmgEntity>;
};

export type Certificate = {
  readonly __typename?: 'Certificate';
  readonly certificateId: Scalars['UUID']['output'];
  readonly certificateStatus: AttestationFormStatus;
  readonly certificateType: CertificateType;
  readonly expirationDate?: Maybe<Scalars['Date']['output']>;
  readonly lastUpdated?: Maybe<Scalars['Instant']['output']>;
  readonly signatoryDate: Scalars['Date']['output'];
};

export type CertificateFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<CertificateFilterInput>>;
  readonly certificateId?: InputMaybe<UuidOperationFilterInput>;
  readonly certificateStatus?: InputMaybe<CertificateStatusOperationFilterInput>;
  readonly certificateType?: InputMaybe<CertificateTypeOperationFilterInput>;
  readonly expirationDate?: InputMaybe<DateOperationFilterInput>;
  readonly lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<CertificateFilterInput>>;
  readonly signatoryDate?: InputMaybe<DateOperationFilterInput>;
};

export type CertificateSort51305131Input = {
  readonly certificateId?: InputMaybe<SortEnumType>;
  readonly certificateStatus?: InputMaybe<SortEnumType>;
  readonly certificateType?: InputMaybe<SortEnumType>;
  readonly expirationDate?: InputMaybe<SortEnumType>;
  readonly lastUpdated?: InputMaybe<SortEnumType>;
  readonly signatoryDate?: InputMaybe<SortEnumType>;
};

export type CertificateSortQibInput = {
  readonly certificateId?: InputMaybe<SortEnumType>;
  readonly certificateStatus?: InputMaybe<SortEnumType>;
  readonly certificateType?: InputMaybe<SortEnumType>;
  readonly expirationDate?: InputMaybe<SortEnumType>;
  readonly lastUpdated?: InputMaybe<SortEnumType>;
  readonly signatoryDate?: InputMaybe<SortEnumType>;
};

export type CertificateSortRegSInput = {
  readonly certificateId?: InputMaybe<SortEnumType>;
  readonly certificateStatus?: InputMaybe<SortEnumType>;
  readonly certificateType?: InputMaybe<SortEnumType>;
  readonly expirationDate?: InputMaybe<SortEnumType>;
  readonly lastUpdated?: InputMaybe<SortEnumType>;
  readonly signatoryDate?: InputMaybe<SortEnumType>;
};

export type CertificateStatusOperationFilterInput = {
  readonly eq?: InputMaybe<AttestationFormStatus>;
  readonly in?: InputMaybe<ReadonlyArray<AttestationFormStatus>>;
  readonly neq?: InputMaybe<AttestationFormStatus>;
  readonly nin?: InputMaybe<ReadonlyArray<AttestationFormStatus>>;
};

export enum CertificateType {
  Form51305131 = 'FORM51305131',
  Qib = 'QIB',
  RegS = 'REG_S',
}

export type CertificateTypeOperationFilterInput = {
  readonly eq?: InputMaybe<CertificateType>;
  readonly in?: InputMaybe<ReadonlyArray<CertificateType>>;
  readonly neq?: InputMaybe<CertificateType>;
  readonly nin?: InputMaybe<ReadonlyArray<CertificateType>>;
};

export type CmgEntityKeyFilterInput = {
  readonly eq?: InputMaybe<Scalars['String']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<CmgEntityKeyFilterInput>>;
};

export enum CmgService {
  OfferingSetup = 'OFFERING_SETUP',
  OrderBooks = 'ORDER_BOOKS',
  Settlement = 'SETTLEMENT',
}

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  readonly __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** Indicates the start of the requested page. This is either the request 'skip' argument or a server configured default if no argument is provided. */
  readonly offset: Scalars['Int']['output'];
  /** Indicates the size of the requested page. This is either the request 'take' argument or a server configured default if no argument is provided. */
  readonly pageSize: Scalars['Int']['output'];
};

export type Contact = {
  readonly __typename?: 'Contact';
  readonly email: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly source: ContactSource;
};

export type ContactCollection = {
  readonly __typename?: 'ContactCollection';
  readonly contacts: ReadonlyArray<Contact>;
  readonly id: Scalars['ID']['output'];
  readonly indicationId: Scalars['UUID']['output'];
  readonly version: Scalars['String']['output'];
};

export type ContactFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<ContactFilterInput>>;
  readonly email?: InputMaybe<StringOperationFilterInput>;
  readonly name?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<ContactFilterInput>>;
  readonly source?: InputMaybe<ContactSourceOperationFilterInput>;
};

export type ContactListFilterInput = {
  readonly all?: InputMaybe<ContactFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<ContactFilterInput>;
  readonly some?: InputMaybe<ContactFilterInput>;
};

/** The source of a contact, if it is submitted by sell-side or came directly from the buy-side's XC account. */
export enum ContactSource {
  BuySide = 'BUY_SIDE',
  SellSide = 'SELL_SIDE',
}

export type ContactSourceOperationFilterInput = {
  readonly eq?: InputMaybe<ContactSource>;
  readonly in?: InputMaybe<ReadonlyArray<ContactSource>>;
  readonly neq?: InputMaybe<ContactSource>;
  readonly nin?: InputMaybe<ReadonlyArray<ContactSource>>;
};

export type ConvertibleDemandCollectionInput = {
  readonly items?: InputMaybe<ReadonlyArray<ConvertibleDemandInput>>;
  readonly referenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConvertibleDemandInput = {
  readonly coupon: Scalars['Decimal']['input'];
  readonly id: Scalars['Int']['input'];
  readonly premium: Scalars['Decimal']['input'];
  readonly priceAsOfPar?: InputMaybe<Scalars['Decimal']['input']>;
};

export type ConvertibleDemandLevel = {
  readonly __typename?: 'ConvertibleDemandLevel';
  readonly bonds: Scalars['Long']['output'];
  readonly coupon?: Maybe<Scalars['Decimal']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly notional: Scalars['Decimal']['output'];
  readonly premium?: Maybe<Scalars['Decimal']['output']>;
  readonly priceAsOfPar?: Maybe<Scalars['Decimal']['output']>;
};

export type ConvertibleDemandLevelFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<ConvertibleDemandLevelFilterInput>>;
  readonly bonds?: InputMaybe<LongOperationFilterInput>;
  readonly coupon?: InputMaybe<DecimalOperationFilterInput>;
  readonly id?: InputMaybe<IntOperationFilterInput>;
  readonly notional?: InputMaybe<DecimalOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<ConvertibleDemandLevelFilterInput>>;
  readonly premium?: InputMaybe<DecimalOperationFilterInput>;
  readonly priceAsOfPar?: InputMaybe<DecimalOperationFilterInput>;
};

export type ConvertibleDemandLevelSortInput = {
  readonly bonds?: InputMaybe<SortEnumType>;
  readonly coupon?: InputMaybe<SortEnumType>;
  readonly id: Scalars['Int']['input'];
  readonly notional?: InputMaybe<SortEnumType>;
  readonly premium?: InputMaybe<SortEnumType>;
  readonly priceAsOfPar?: InputMaybe<SortEnumType>;
};

export type ConvertibleDemandLevelTotalRow = {
  readonly __typename?: 'ConvertibleDemandLevelTotalRow';
  readonly bonds: Scalars['Long']['output'];
  readonly id: Scalars['Int']['output'];
  readonly notional: Scalars['Decimal']['output'];
};

export type CopyViewSettingInput = {
  readonly id: Scalars['UUID']['input'];
  readonly recipientUserIds: ReadonlyArray<Scalars['UUID']['input']>;
};

export type CopyViewSettingPayload = {
  readonly __typename?: 'CopyViewSettingPayload';
  readonly viewSettings?: Maybe<ReadonlyArray<ViewSetting>>;
};

/** A segment of a collection. */
export type CountriesCollectionSegment = {
  readonly __typename?: 'CountriesCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<EnumLabelOfCountry>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export enum Country {
  Ae = 'AE',
  Am = 'AM',
  Ao = 'AO',
  Ar = 'AR',
  At = 'AT',
  Au = 'AU',
  Az = 'AZ',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bg = 'BG',
  Bh = 'BH',
  Bm = 'BM',
  Bo = 'BO',
  Br = 'BR',
  Bs = 'BS',
  Bw = 'BW',
  Ca = 'CA',
  Ch = 'CH',
  Ci = 'CI',
  Cl = 'CL',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dk = 'DK',
  Dz = 'DZ',
  Ee = 'EE',
  Eg = 'EG',
  Es = 'ES',
  Fi = 'FI',
  Fj = 'FJ',
  Fr = 'FR',
  Gb = 'GB',
  Ge = 'GE',
  Gh = 'GH',
  Gr = 'GR',
  Hk = 'HK',
  Hr = 'HR',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  In = 'IN',
  Iq = 'IQ',
  Is = 'IS',
  It = 'IT',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kh = 'KH',
  Kr = 'KR',
  Kw = 'KW',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lk = 'LK',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ma = 'MA',
  Me = 'ME',
  Mk = 'MK',
  Mn = 'MN',
  Mt = 'MT',
  Mu = 'MU',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Ng = 'NG',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Ps = 'PS',
  Pt = 'PT',
  Py = 'PY',
  Qa = 'QA',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Se = 'SE',
  Sg = 'SG',
  Si = 'SI',
  Sk = 'SK',
  Sy = 'SY',
  Th = 'TH',
  Tn = 'TN',
  Tr = 'TR',
  Tt = 'TT',
  Tw = 'TW',
  Tz = 'TZ',
  Ug = 'UG',
  Us = 'US',
  Uz = 'UZ',
  Ve = 'VE',
  Vn = 'VN',
  Za = 'ZA',
  Zm = 'ZM',
}

export type CountryFilterInput = {
  readonly eq?: InputMaybe<Country>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Country>>>;
  readonly neq?: InputMaybe<Country>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Country>>>;
};

export type CountrySortInput = {
  readonly displayName?: InputMaybe<SortEnumType>;
  readonly name?: InputMaybe<SortEnumType>;
  readonly value?: InputMaybe<SortEnumType>;
};

export type CoveredIndicationChangeSet = {
  readonly __typename?: 'CoveredIndicationChangeSet';
  readonly added: ReadonlyArray<CoveredInstitutionalIndicationWithAttestation>;
  readonly fullRefreshOfferingIds: ReadonlyArray<Scalars['UUID']['output']>;
  readonly removedIds: ReadonlyArray<Scalars['UUID']['output']>;
  readonly updated: ReadonlyArray<CoveredInstitutionalIndicationWithAttestation>;
};

export type CoveredIndicationChanged = {
  readonly __typename?: 'CoveredIndicationChanged';
  readonly eventSource?: Maybe<Scalars['String']['output']>;
  readonly indicationId?: Maybe<Scalars['UUID']['output']>;
  readonly investorKey?: Maybe<Scalars['String']['output']>;
  readonly offeringId?: Maybe<Scalars['UUID']['output']>;
  readonly source: OrdersGridChangeSource;
};

export type CoveredInstitutionalIndication = {
  readonly __typename?: 'CoveredInstitutionalIndication';
  readonly acknowledgementStatus?: Maybe<AllocationAcknowledgement>;
  readonly allocationCurrency?: Maybe<Scalars['Decimal']['output']>;
  readonly allocationPercentOfOffering?: Maybe<Scalars['Decimal']['output']>;
  readonly allocationShares?: Maybe<Scalars['Long']['output']>;
  readonly allocationVersion?: Maybe<Scalars['String']['output']>;
  readonly auditInfo: AuditInfo;
  readonly billingAndDeliveryAgentCmgEntityKey?: Maybe<Scalars['String']['output']>;
  /** The list of CMG Entity Keys for Managers that cover the Investor. */
  readonly coveringManagerCmgEntityKeys: ReadonlyArray<Scalars['String']['output']>;
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  readonly demandMax?: Maybe<Scalars['Long']['output']>;
  readonly demandMaxNotional?: Maybe<Scalars['Decimal']['output']>;
  /** For a surviving indication, this property contains the IDs of its duplicate indications */
  readonly duplicateIndicationIds: ReadonlyArray<Scalars['UUID']['output']>;
  /** For a duplicate indication, this property contains the indicationId of the surviving order */
  readonly duplicateOfIndicationId?: Maybe<Scalars['UUID']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly indicationPercentFill?: Maybe<Scalars['Decimal']['output']>;
  readonly institutionalIndicationAcknowledgements: ReadonlyArray<InstitutionalIndicationAcknowledgement>;
  /** An Instrument ID will not be present for Investors who have Passed on the offering. */
  readonly instrumentId?: Maybe<Scalars['UUID']['output']>;
  /** The demand expression of the indication. */
  readonly interestLevels: ReadonlyArray<InterestLevel>;
  /** Investor information fields capture buy-side information. */
  readonly investorInformation: InvestorInformation;
  readonly investorReplyStatus?: Maybe<AllocationAcknowledgement>;
  /**
   * Describe if this Indication has been marked as a duplicate of another Indication.
   * Use `Status` instead.
   * @deprecated Deprecated. Use `status` instead.
   */
  readonly isMarkedAsDuplicate: Scalars['Boolean']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly prospectusStatus?: Maybe<InvestorDeliveryStatus>;
  readonly status: IndicationStatus;
  /** The CMG entity key for the specific manager submitting this indication. */
  readonly submittedByCmgEntityKey: Scalars['String']['output'];
  /** A Tranche ID will not be present for Investors who have Passed on the offering. */
  readonly trancheId?: Maybe<Scalars['UUID']['output']>;
  readonly type: InstitutionalIndicationOrderType;
  readonly version: Scalars['String']['output'];
};

export type CoveredInstitutionalIndicationVersion = {
  readonly __typename?: 'CoveredInstitutionalIndicationVersion';
  readonly acknowledgementStatus?: Maybe<AllocationAcknowledgement>;
  readonly allocationCurrency?: Maybe<Scalars['Decimal']['output']>;
  readonly allocationPercentOfOffering?: Maybe<Scalars['Decimal']['output']>;
  readonly allocationShares?: Maybe<Scalars['Long']['output']>;
  readonly allocationVersion?: Maybe<Scalars['String']['output']>;
  readonly auditInfo: AuditInfo;
  /** The list of CMG Entity Keys for Managers that cover the Investor. */
  readonly coveringManagerCmgEntityKeys: ReadonlyArray<Scalars['String']['output']>;
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  readonly demandMax?: Maybe<Scalars['Long']['output']>;
  readonly demandMaxNotional?: Maybe<Scalars['Decimal']['output']>;
  /** For a surviving indication, this property contains the IDs of its duplicate indications */
  readonly duplicateIndicationIds: ReadonlyArray<Scalars['UUID']['output']>;
  /** For a duplicate indication, this property contains the indicationId of the surviving order */
  readonly duplicateOfIndicationId?: Maybe<Scalars['UUID']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly indicationId: Scalars['UUID']['output'];
  readonly indicationPercentFill?: Maybe<Scalars['Decimal']['output']>;
  /** An Instrument ID will not be present for Investors who have Passed on the offering. */
  readonly instrumentId?: Maybe<Scalars['UUID']['output']>;
  /** The demand expression of the indication. */
  readonly interestLevels: ReadonlyArray<InterestLevel>;
  /** Investor information fields capture buy-side information. */
  readonly investorInformation: InvestorInformation;
  readonly investorReplyStatus?: Maybe<AllocationAcknowledgement>;
  readonly isBuySideRevision: Scalars['Boolean']['output'];
  /**
   * Describe if this Indication has been marked as a duplicate of another Indication.
   * Use `Status` instead.
   * @deprecated Deprecated. Use `status` instead.
   */
  readonly isMarkedAsDuplicate: Scalars['Boolean']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly recordStatus: OrderBookRecordStatus;
  readonly status: IndicationStatus;
  /** The CMG entity key for the specific manager submitting this indication. */
  readonly submittedByCmgEntityKey: Scalars['String']['output'];
  readonly tranche?: Maybe<TranchePrivileged>;
  /** A Tranche ID will not be present for Investors who have Passed on the offering. */
  readonly trancheId?: Maybe<Scalars['UUID']['output']>;
  readonly type: InstitutionalIndicationOrderType;
  readonly version: Scalars['String']['output'];
};

export type CoveredInstitutionalIndicationWithAttestation = {
  readonly __typename?: 'CoveredInstitutionalIndicationWithAttestation';
  readonly acknowledgedBy?: Maybe<UserInfo>;
  readonly acknowledgements: ReadonlyArray<IndicationAcknowledgement>;
  readonly allocationAcknowledgedBy?: Maybe<UserInfo>;
  readonly allocationCurrency?: Maybe<Scalars['Decimal']['output']>;
  readonly allocationPercentOfOffering?: Maybe<Scalars['Decimal']['output']>;
  readonly allocationShares?: Maybe<Scalars['Long']['output']>;
  readonly allocationVersion?: Maybe<Scalars['String']['output']>;
  readonly auditInfo: AuditInfo;
  readonly billingAndDeliveryAgentCmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly coveringManagerCmgEntityKeys: ReadonlyArray<Scalars['String']['output']>;
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  readonly demandMax?: Maybe<Scalars['Long']['output']>;
  readonly demandMaxNotional?: Maybe<Scalars['Decimal']['output']>;
  /** For a surviving indication, this property contains the IDs of its duplicate indications. */
  readonly duplicateIndicationIds: ReadonlyArray<Scalars['UUID']['output']>;
  /** For a duplicate indication, this property contains the indicationId of the surviving order. */
  readonly duplicateOfIndicationId?: Maybe<Scalars['UUID']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly indicationPercentFill?: Maybe<Scalars['Decimal']['output']>;
  /** An Instrument ID will not be present for Investors who have Passed on the offering. */
  readonly instrumentId?: Maybe<Scalars['UUID']['output']>;
  readonly interestLevels: ReadonlyArray<InterestLevel>;
  readonly investorAttestationStatus: AttestationFormStatus;
  /** Investor information fields capture buy-side information. */
  readonly investorInformation: InvestorInformation;
  readonly investorQibStatus: AttestationFormStatus;
  readonly investorReplyStatus?: Maybe<AllocationAcknowledgement>;
  readonly offeringId: Scalars['UUID']['output'];
  readonly prospectusDeliverySummary: ProspectusDeliverySummary;
  readonly status: IndicationStatus;
  /** The CMG entity key for the specific manager submitting this indication. */
  readonly submittedByCmgEntityKey: Scalars['String']['output'];
  /** A Tranche ID will not be present for Investors who have Passed on the offering. */
  readonly trancheId?: Maybe<Scalars['UUID']['output']>;
  readonly type: InstitutionalIndicationOrderType;
  readonly version: Scalars['String']['output'];
};

/** A segment of a collection. */
export type CoveredInvestorFirmsGridCollectionSegment = {
  readonly __typename?: 'CoveredInvestorFirmsGridCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<InvestorFirmsGrid>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type CreateAllocationInput = {
  /** The number of shares being allocated. */
  readonly shareQuantity: Scalars['Long']['input'];
};

export type CreateDsFilingInput = {
  readonly filingFormData: DsFilingFormDataInput;
  readonly recipients: ReadonlyArray<Scalars['String']['input']>;
  readonly shouldAddSenderToBcc: Scalars['Boolean']['input'];
  readonly submissionTimeZone: Scalars['DateTimeZone']['input'];
};

export type CreateDealRelatedExpenseInput = {
  readonly category: ExpenseCategory;
  readonly description: Scalars['String']['input'];
  readonly value: Scalars['Decimal']['input'];
};

export type CreateDeliveryInstrumentDataInput = {
  readonly countryCode?: InputMaybe<Scalars['String']['input']>;
  readonly currencyCode: Scalars['String']['input'];
  readonly cusip?: InputMaybe<Scalars['String']['input']>;
  readonly depositaryReceiptConversionRatioDenominator?: InputMaybe<Scalars['Int']['input']>;
  readonly depositaryReceiptConversionRatioNumerator?: InputMaybe<Scalars['Int']['input']>;
  readonly exchangeMic?: InputMaybe<ExchangeMic>;
  readonly figi?: InputMaybe<Scalars['String']['input']>;
  readonly isDepositaryReceipt: Scalars['Boolean']['input'];
  readonly isin?: InputMaybe<Scalars['String']['input']>;
  readonly lastTradeBeforeFiling?: InputMaybe<Scalars['Decimal']['input']>;
  readonly lastTradeBeforeLaunch?: InputMaybe<Scalars['Decimal']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly rank?: InputMaybe<Rank>;
  readonly referencePrice?: InputMaybe<Scalars['Decimal']['input']>;
  readonly sellingRestrictions?: InputMaybe<SellingRestrictions>;
  readonly stockSymbol?: InputMaybe<Scalars['String']['input']>;
  readonly trancheId?: InputMaybe<Scalars['UUID']['input']>;
  readonly underlyingCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  readonly underlyingExchangeMic?: InputMaybe<ExchangeMic>;
  readonly underlyingStockSymbol?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDeliveryInstrumentInput = {
  readonly data: CreateDeliveryInstrumentDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type CreateDeliveryInstrumentPayload = {
  readonly __typename?: 'CreateDeliveryInstrumentPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type CreateDemandCurrencyInput = {
  readonly data: DemandCurrencyDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type CreateDemandCurrencyPayload = {
  readonly __typename?: 'CreateDemandCurrencyPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type CreateDraftAllocationInput = {
  readonly dealLayout?: InputMaybe<AssignDealLayoutInput>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExpensesRevisionInput = {
  readonly dealRelatedExpenses: ReadonlyArray<CreateDealRelatedExpenseInput>;
  readonly managerExpenses: ReadonlyArray<CreateManagerExpensesInput>;
  readonly notes: Scalars['String']['input'];
};

export type CreateFilingDataInput = {
  readonly conversionPrice?: InputMaybe<Scalars['Decimal']['input']>;
  readonly coupon?: InputMaybe<Scalars['Decimal']['input']>;
  readonly couponTalkHigh?: InputMaybe<Scalars['Decimal']['input']>;
  readonly couponTalkLow?: InputMaybe<Scalars['Decimal']['input']>;
  readonly effectiveConversionPremium?: InputMaybe<Scalars['Decimal']['input']>;
  readonly effectiveConversionPrice?: InputMaybe<Scalars['Decimal']['input']>;
  readonly filingType: FilingType;
  readonly initialConversionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  readonly initialRegistrationValue?: InputMaybe<Scalars['Decimal']['input']>;
  readonly ipoRangeHigh?: InputMaybe<Scalars['Decimal']['input']>;
  readonly ipoRangeLow?: InputMaybe<Scalars['Decimal']['input']>;
  /**
   * This field is deprecated. Please use the LockUpPeriod field in Terms instead.
   * @deprecated Use the LockUpPeriod field in Terms instead
   */
  readonly lockUpPeriod?: InputMaybe<Scalars['Int']['input']>;
  readonly notionalOverAllotmentAuthorized?: InputMaybe<Scalars['Decimal']['input']>;
  /**
   * This field is deprecated. Please use the NotionalOverAllotmentExercised field in Terms instead.
   * @deprecated Use the NotionalOverAllotmentExercised field in Terms instead
   */
  readonly notionalOverAllotmentExercised?: InputMaybe<Scalars['Decimal']['input']>;
  readonly numberOfBondsBaseOffering?: InputMaybe<Scalars['Long']['input']>;
  readonly numberOfBondsOverAllotmentAuthorized?: InputMaybe<Scalars['Long']['input']>;
  readonly offerPrice?: InputMaybe<Scalars['Decimal']['input']>;
  readonly parValue?: InputMaybe<Scalars['Decimal']['input']>;
  readonly postOfferingShares?: InputMaybe<Scalars['Long']['input']>;
  readonly premium?: InputMaybe<Scalars['Decimal']['input']>;
  readonly premiumTalkHigh?: InputMaybe<Scalars['Decimal']['input']>;
  readonly premiumTalkLow?: InputMaybe<Scalars['Decimal']['input']>;
  readonly priceAsOfPar?: InputMaybe<Scalars['Decimal']['input']>;
  readonly primarySharesBaseOffering?: InputMaybe<Scalars['Long']['input']>;
  readonly primarySharesOverAllotmentAuthorized?: InputMaybe<Scalars['Long']['input']>;
  /**
   * This field is deprecated. Please use the PrimarySharesOverAllotmentExercised field in Terms instead.
   * @deprecated Use the PrimarySharesOverAllotmentExercised field in Terms instead
   */
  readonly primarySharesOverAllotmentExercised?: InputMaybe<Scalars['Long']['input']>;
  readonly secondarySharesBaseOffering?: InputMaybe<Scalars['Long']['input']>;
  readonly secondarySharesOverAllotmentAuthorized?: InputMaybe<Scalars['Long']['input']>;
  /**
   * This field is deprecated. Please use the SecondarySharesOverAllotmentExercised field in Terms instead.
   * @deprecated Use the SecondarySharesOverAllotmentExercised field in Terms instead
   */
  readonly secondarySharesOverAllotmentExercised?: InputMaybe<Scalars['Long']['input']>;
  /**
   * This field is deprecated. Please use the UseOfProceeds field in Terms instead.
   * @deprecated Use the UseOfProceeds field in Terms instead
   */
  readonly useOfProceeds?: InputMaybe<ReadonlyArray<UseOfProceeds>>;
};

export type CreateFilingInput = {
  readonly data: CreateFilingDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type CreateFilingPayload = {
  readonly __typename?: 'CreateFilingPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type CreateFirmEmployeeInput = {
  readonly data: AdminFirmEmployeeInput;
  readonly firmId: Scalars['UUID']['input'];
};

export type CreateFirmEmployeePayload = {
  readonly __typename?: 'CreateFirmEmployeePayload';
  readonly firmEmployee?: Maybe<FirmEmployeeFull>;
};

export type CreateFreeFormWireInput = {
  readonly body: Scalars['String']['input'];
  readonly header: Scalars['String']['input'];
};

export type CreateInvestorFirmBasicInput = {
  readonly address1?: InputMaybe<Scalars['String']['input']>;
  readonly address2?: InputMaybe<Scalars['String']['input']>;
  readonly cik1?: InputMaybe<Scalars['String']['input']>;
  readonly cik2?: InputMaybe<Scalars['String']['input']>;
  readonly crd?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly email1?: InputMaybe<Scalars['String']['input']>;
  readonly email2?: InputMaybe<Scalars['String']['input']>;
  readonly factSet?: InputMaybe<Scalars['String']['input']>;
  readonly faxNumber1?: InputMaybe<Scalars['String']['input']>;
  readonly faxNumber2?: InputMaybe<Scalars['String']['input']>;
  readonly firmKey?: InputMaybe<Scalars['String']['input']>;
  readonly investorSubType?: InputMaybe<Scalars['String']['input']>;
  readonly investorType?: InputMaybe<Scalars['String']['input']>;
  readonly lei?: InputMaybe<Scalars['String']['input']>;
  readonly mpid?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly phoneNumber1?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  readonly status: RolodexRecordStatus;
  readonly website1?: InputMaybe<Scalars['String']['input']>;
  readonly website2?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvestorFirmEmployeeInput = {
  readonly firmKeyOrId: Scalars['ID']['input'];
  readonly input: InvestorEmployeeCreateDtoInput;
};

export type CreateInvestorFirmEmployeePayload = {
  readonly __typename?: 'CreateInvestorFirmEmployeePayload';
  readonly investorFirmContact?: Maybe<InvestorFirmContact>;
};

export type CreateInvestorFirmInput = {
  readonly input: InvestorFirmCreateDtoInput;
};

export type CreateInvestorFirmPayload = {
  readonly __typename?: 'CreateInvestorFirmPayload';
  readonly investorFirmsGrid?: Maybe<InvestorFirmsGrid>;
};

export type CreateInvestorRelationshipsInput = {
  readonly input: ReadonlyArray<InvestorFirmRelationshipCreateInput>;
};

export type CreateInvestorRelationshipsPayload = {
  readonly __typename?: 'CreateInvestorRelationshipsPayload';
  readonly investorFirmRelationship?: Maybe<ReadonlyArray<InvestorFirmRelationship>>;
};

export type CreateIssuerInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly businessDescription?: InputMaybe<Scalars['String']['input']>;
  readonly lei?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly sector?: InputMaybe<Sector>;
  readonly subSector?: InputMaybe<Scalars['String']['input']>;
  readonly website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManagerDataInput = {
  readonly cmgEntityKey: Scalars['String']['input'];
  /**
   * Deprecated; Use `Underwriting Base Share Distribution` in Manager Economics instead
   * @deprecated Use Underwriting Base Share Distribution under Manager Economics.
   */
  readonly economics?: InputMaybe<Scalars['Long']['input']>;
  readonly isJuniorRole: Scalars['Boolean']['input'];
  readonly isParticipating: Scalars['Boolean']['input'];
  readonly role: ManagerRole;
};

export type CreateManagerExpensesInput = {
  readonly cmgEntityKey: Scalars['String']['input'];
  readonly miscellaneous?: InputMaybe<Scalars['Decimal']['input']>;
  readonly reimbursement?: InputMaybe<Scalars['Decimal']['input']>;
  readonly technologyAndData?: InputMaybe<Scalars['Decimal']['input']>;
  readonly travelAndMeals?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateManagerInput = {
  readonly data: CreateManagerDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type CreateManagerPayload = {
  readonly __typename?: 'CreateManagerPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type CreateMdlOfferingNoteInput = {
  readonly note: Scalars['String']['input'];
  readonly subject: OfferingNoteSubject;
};

export type CreateMyRetailBrokerInput = {
  readonly demand: MyRetailBrokerDemandInput;
  readonly firmCmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  readonly firmName?: InputMaybe<Scalars['String']['input']>;
  readonly retention: MyRetailRetentionInput;
  readonly sellingConcessionPercentage?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateNoiFilingInput = {
  readonly filingFormData: NoiFilingFormDataInput;
  readonly recipients: ReadonlyArray<Scalars['String']['input']>;
  readonly shouldAddSenderToBcc: Scalars['Boolean']['input'];
  readonly submissionTimeZone: Scalars['DateTimeZone']['input'];
};

export type CreateNonSyndicateFreeFormWireInput = {
  readonly body: Scalars['String']['input'];
  readonly header: Scalars['String']['input'];
};

export type CreateNonSyndicateSellingGroupInvitationWireInput = {
  readonly userDataForRecipients: ReadonlyArray<NonSyndicateSellingGroupInvitationDataForRecipient>;
};

export type CreateNonSyndicateSellingGroupTermsRetentionWireInput = {
  readonly userDataForRecipients: ReadonlyArray<CreateNonSyndicateSellingGroupTermsRetentionWireInputData>;
};

export type CreateNonSyndicateSellingGroupTermsRetentionWireInputData = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly recipient: Scalars['String']['input'];
  readonly sellingConcession: Scalars['Decimal']['input'];
};

export type CreateNonSyndicateTerminationWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly terminationDate: Scalars['Instant']['input'];
  readonly terminationTimeZone: Scalars['DateTimeZone']['input'];
};

export type CreateOfferingDraftInput = {
  readonly countryCode?: InputMaybe<Scalars['String']['input']>;
  readonly isInternal?: Scalars['Boolean']['input'];
  readonly isWallCrossEnabled?: Scalars['Boolean']['input'];
  readonly issuer: CreateIssuerInput;
  readonly pricingCurrencyCode: Scalars['String']['input'];
  readonly security: CreateSecurityInput;
  readonly type: OfferingType;
};

export type CreateOfferingDraftPayload = {
  readonly __typename?: 'CreateOfferingDraftPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type CreateOrUpdateDemandCurrenciesInput = {
  readonly data: ReadonlyArray<DemandCurrencyDataInput>;
  readonly offeringId: Scalars['UUID']['input'];
};

export type CreateOrUpdateDemandCurrenciesPayload = {
  readonly __typename?: 'CreateOrUpdateDemandCurrenciesPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type CreateOrUpdateStabilizationInput = {
  readonly notes: Scalars['String']['input'];
  readonly trades: ReadonlyArray<CreateOrUpdateStabilizationTradeInput>;
};

export type CreateOrUpdateStabilizationTradeInput = {
  readonly activityType?: InputMaybe<TradeActivityType>;
  readonly averagePrice: Scalars['Decimal']['input'];
  readonly date: Scalars['LocalDate']['input'];
  readonly shares: Scalars['Long']['input'];
  readonly type: TradeType;
};

export type CreatePotAccountWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly headerNote?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePotAllocationWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly headerNote?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePricingTermsRetentionWireInput = {
  readonly userDataForRecipients: ReadonlyArray<PricingTermsRetentionUserDataForRecipientInputData>;
};

export type CreatePricingTermsWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRpnFilingInput = {
  readonly filingFormData: RpnFilingFormDataInput;
  readonly recipients: ReadonlyArray<Scalars['String']['input']>;
  readonly shouldAddSenderToBcc: Scalars['Boolean']['input'];
  readonly submissionTimeZone: Scalars['DateTimeZone']['input'];
};

export type CreateRegMWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly notificationPeriod: RegulationMNotificationPeriod;
};

export type CreateResearchRestrictionWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly masterAauDate: Scalars['LocalDate']['input'];
  readonly underwriterInvitationSentDate: Scalars['LocalDate']['input'];
};

export type CreateRoadshowScheduleInput = {
  readonly data: RoadshowScheduleDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type CreateRoadshowSchedulePayload = {
  readonly __typename?: 'CreateRoadshowSchedulePayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type CreateSecurityInput = {
  /**
   * Deprecated, use IsDepositaryReceipt field on Instrument.
   * @deprecated Deprecated. This will be removed in future versions.
   */
  readonly isDepositaryReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  readonly securityDescription?: InputMaybe<Scalars['String']['input']>;
  readonly shareClass?: InputMaybe<SecurityShareClass>;
  readonly type: SecurityType;
};

export type CreateSellingGroupInvitationWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly masterSdaDate: Scalars['LocalDate']['input'];
};

export type CreateSellingGroupTermsWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTnFilingInput = {
  readonly filingFormData: TnFilingFormDataInput;
  readonly recipients: ReadonlyArray<Scalars['String']['input']>;
  readonly shouldAddSenderToBcc: Scalars['Boolean']['input'];
  readonly submissionTimeZone: Scalars['DateTimeZone']['input'];
};

export type CreateTerminationWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly terminationDate: Scalars['Instant']['input'];
  readonly terminationTimeZone: Scalars['DateTimeZone']['input'];
};

export type CreateUsdtnFilingInput = {
  readonly filingFormData: UsdtnFilingFormDataInput;
  readonly recipients: ReadonlyArray<Scalars['String']['input']>;
  readonly shouldAddSenderToBcc: Scalars['Boolean']['input'];
  readonly submissionTimeZone: Scalars['DateTimeZone']['input'];
};

export type CreateUnderwriterEmployeeInput = {
  readonly input: UnderwriterEmployeeCreateInput;
};

export type CreateUnderwriterEmployeePayload = {
  readonly __typename?: 'CreateUnderwriterEmployeePayload';
  readonly underwriterEmployee?: Maybe<UnderwriterEmployee>;
};

export type CreateUnderwriterInvitationWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly masterAauDate: Scalars['LocalDate']['input'];
};

/** A segment of a collection. */
export type CurrenciesCollectionSegment = {
  readonly __typename?: 'CurrenciesCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<EnumLabelOfCurrency>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export enum Currency {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Bov = 'BOV',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Cou = 'COU',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Mxv = 'MXV',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sle = 'SLE',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Stn = 'STN',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Usn = 'USN',
  Uyi = 'UYI',
  Uyu = 'UYU',
  Uyw = 'UYW',
  Uzs = 'UZS',
  Ved = 'VED',
  Ves = 'VES',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xdr = 'XDR',
  Xof = 'XOF',
  Xpf = 'XPF',
  Xsu = 'XSU',
  Xua = 'XUA',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwl = 'ZWL',
}

export type CurrencyExchangeRate = {
  readonly __typename?: 'CurrencyExchangeRate';
  readonly currencyCode: Scalars['String']['output'];
  readonly exchangeRate: Scalars['Decimal']['output'];
};

export type CurrencyFilterInput = {
  readonly eq?: InputMaybe<Currency>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Currency>>>;
  readonly neq?: InputMaybe<Currency>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Currency>>>;
};

export type CurrencySortInput = {
  readonly displayName?: InputMaybe<SortEnumType>;
  readonly name?: InputMaybe<SortEnumType>;
  readonly value?: InputMaybe<SortEnumType>;
};

export type CustomVariable = {
  readonly __typename?: 'CustomVariable';
  readonly displayName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly value?: Maybe<Scalars['String']['output']>;
};

export type CustomVariableGroup = {
  readonly __typename?: 'CustomVariableGroup';
  readonly displayName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly variables: ReadonlyArray<CustomVariable>;
};

export type DsFiling = {
  readonly __typename?: 'DSFiling';
  readonly contactName: Scalars['String']['output'];
  readonly contactTitle: Scalars['String']['output'];
  readonly dealStatus: DealStatus;
  /** Display name for DealStatus */
  readonly dealStatusDisplayName?: Maybe<Scalars['String']['output']>;
  readonly emailAddress: Scalars['String']['output'];
  readonly filingCreatorEmail?: Maybe<Scalars['String']['output']>;
  readonly finraErrorMessages: ReadonlyArray<Scalars['String']['output']>;
  readonly firmCrdNumber: Scalars['String']['output'];
  readonly firmDealId: Scalars['String']['output'];
  readonly firmMpid: Scalars['String']['output'];
  readonly firmName: Scalars['String']['output'];
  readonly formUniqueId: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly issuerName: Scalars['String']['output'];
  readonly issuerSymbol: Scalars['String']['output'];
  readonly status: FilingStatus;
  readonly submittedDateTime: Scalars['Instant']['output'];
  readonly telephoneNumber: Scalars['String']['output'];
};

export type DsFilingFormDataInput = {
  readonly contactName: Scalars['String']['input'];
  readonly contactTitle: Scalars['String']['input'];
  readonly dealStatus: DealStatus;
  readonly emailAddress: Scalars['String']['input'];
  readonly firmCrdNumber: Scalars['String']['input'];
  readonly firmMpid: Scalars['String']['input'];
  readonly firmName: Scalars['String']['input'];
  readonly issuerSymbol: Scalars['String']['input'];
  readonly telephoneNumber: Scalars['String']['input'];
};

export type DataLabFull = {
  readonly __typename?: 'DataLabFull';
  readonly fundIois?: Maybe<FundIois>;
  readonly funds?: Maybe<ReadonlyArray<Fund>>;
  readonly linkedOfferingId?: Maybe<Scalars['UUID']['output']>;
  readonly mdlAllocation?: Maybe<MdlAllocationResponse>;
  readonly mdlIndications?: Maybe<MdlIndications>;
};

export type DataSyncFault = {
  readonly __typename?: 'DataSyncFault';
  readonly exceptions: ReadonlyArray<ExceptionInfoDocument>;
};

export type DataSyncSaga = {
  readonly __typename?: 'DataSyncSaga';
  readonly completedDestinations: ReadonlyArray<DestinationInfo>;
  readonly correlationId: Scalars['UUID']['output'];
  readonly currentState: Scalars['String']['output'];
  readonly faultDetails?: Maybe<DataSyncFault>;
  readonly faultedDestinations: ReadonlyArray<FaultedDestination>;
  readonly lastUpdated: Scalars['DateTime']['output'];
  readonly originTenantId: TenantDetails;
  readonly pendingDestinations: ReadonlyArray<DestinationInfo>;
  readonly requestClrType: Scalars['String']['output'];
  readonly requestData: Scalars['String']['output'];
  readonly sourceService?: Maybe<CmgService>;
};

export type DateOperationFilterInput = {
  readonly eq?: InputMaybe<Scalars['Date']['input']>;
  readonly gt?: InputMaybe<Scalars['Date']['input']>;
  readonly gte?: InputMaybe<Scalars['Date']['input']>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Date']['input']>>>;
  readonly lt?: InputMaybe<Scalars['Date']['input']>;
  readonly lte?: InputMaybe<Scalars['Date']['input']>;
  readonly neq?: InputMaybe<Scalars['Date']['input']>;
  readonly ngt?: InputMaybe<Scalars['Date']['input']>;
  readonly ngte?: InputMaybe<Scalars['Date']['input']>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Date']['input']>>>;
  readonly nlt?: InputMaybe<Scalars['Date']['input']>;
  readonly nlte?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeOperationFilterInput = {
  readonly eq?: InputMaybe<Scalars['DateTime']['input']>;
  readonly gt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly gte?: InputMaybe<Scalars['DateTime']['input']>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['DateTime']['input']>>>;
  readonly lt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly lte?: InputMaybe<Scalars['DateTime']['input']>;
  readonly neq?: InputMaybe<Scalars['DateTime']['input']>;
  readonly ngt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly ngte?: InputMaybe<Scalars['DateTime']['input']>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['DateTime']['input']>>>;
  readonly nlt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeZoneOperationFilterInput = {
  readonly eq?: InputMaybe<Scalars['DateTimeZone']['input']>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['DateTimeZone']['input']>>>;
  readonly neq?: InputMaybe<Scalars['DateTimeZone']['input']>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['DateTimeZone']['input']>>>;
};

export type DealLayout = {
  readonly __typename?: 'DealLayout';
  readonly id: Scalars['ID']['output'];
  readonly institutionalTarget?: Maybe<Scalars['Long']['output']>;
  readonly offeringSize?: Maybe<Scalars['Long']['output']>;
};

export type DealLayoutReadDtoFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<DealLayoutReadDtoFilterInput>>;
  readonly institutionalTarget?: InputMaybe<LongOperationFilterInput>;
  readonly offeringSize?: InputMaybe<LongOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<DealLayoutReadDtoFilterInput>>;
};

export type DealLayoutReadDtoSortInput = {
  readonly institutionalTarget?: InputMaybe<SortEnumType>;
  readonly offeringSize?: InputMaybe<SortEnumType>;
};

export type DealRelatedExpense = {
  readonly __typename?: 'DealRelatedExpense';
  readonly category: ExpenseCategory;
  /** Display name for Category */
  readonly categoryDisplayName?: Maybe<Scalars['String']['output']>;
  readonly description: Scalars['String']['output'];
  readonly value: Scalars['Decimal']['output'];
};

export enum DealStatus {
  Cmplt = 'CMPLT',
  Cncld = 'CNCLD',
  Pspnd = 'PSPND',
}

export type DecimalExtendedData = {
  readonly __typename?: 'DecimalExtendedData';
  readonly key: Scalars['ID']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly value: Scalars['Decimal']['output'];
};

export type DecimalOperationFilterInput = {
  readonly eq?: InputMaybe<Scalars['Decimal']['input']>;
  readonly gt?: InputMaybe<Scalars['Decimal']['input']>;
  readonly gte?: InputMaybe<Scalars['Decimal']['input']>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Decimal']['input']>>>;
  readonly lt?: InputMaybe<Scalars['Decimal']['input']>;
  readonly lte?: InputMaybe<Scalars['Decimal']['input']>;
  readonly neq?: InputMaybe<Scalars['Decimal']['input']>;
  readonly ngt?: InputMaybe<Scalars['Decimal']['input']>;
  readonly ngte?: InputMaybe<Scalars['Decimal']['input']>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Decimal']['input']>>>;
  readonly nlt?: InputMaybe<Scalars['Decimal']['input']>;
  readonly nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DeleteBillingAndDeliveryAgentResult = {
  readonly __typename?: 'DeleteBillingAndDeliveryAgentResult';
  readonly indicationId: Scalars['UUID']['output'];
};

export type DeleteCurrencyFromTrancheInput = {
  readonly currencyCode: Scalars['String']['input'];
  readonly offeringId: Scalars['UUID']['input'];
  readonly trancheId: Scalars['UUID']['input'];
};

export type DeleteCurrencyFromTranchePayload = {
  readonly __typename?: 'DeleteCurrencyFromTranchePayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type DeleteDeliveryInstrumentInput = {
  readonly instrumentId: Scalars['UUID']['input'];
  readonly offeringId: Scalars['UUID']['input'];
};

export type DeleteDeliveryInstrumentPayload = {
  readonly __typename?: 'DeleteDeliveryInstrumentPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type DeleteDemandCurrencyInput = {
  readonly currencyCode: Scalars['String']['input'];
  readonly offeringId: Scalars['UUID']['input'];
};

export type DeleteDemandCurrencyPayload = {
  readonly __typename?: 'DeleteDemandCurrencyPayload';
  readonly offering?: Maybe<OfferingFull>;
};

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteDesignationWireResponseUnion = DeleteWire | ServiceError;

export type DeleteFilingInput = {
  readonly filingId: Scalars['UUID']['input'];
  readonly offeringId: Scalars['UUID']['input'];
};

export type DeleteFilingPayload = {
  readonly __typename?: 'DeleteFilingPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type DeleteFirmEmployeeInput = {
  readonly employeeId: Scalars['UUID']['input'];
  readonly firmId: Scalars['UUID']['input'];
};

export type DeleteFirmEmployeePayload = {
  readonly __typename?: 'DeleteFirmEmployeePayload';
  readonly firmEmployee?: Maybe<FirmEmployeeFull>;
};

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteFreeFormWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteGreenShoeWireResponseUnion = DeleteWire | ServiceError;

export type DeleteIndicationInput = {
  readonly indicationId: Scalars['UUID']['input'];
  readonly offeringId: Scalars['UUID']['input'];
};

export type DeleteIndicationPayload = {
  readonly __typename?: 'DeleteIndicationPayload';
  readonly indicationId: Scalars['UUID']['output'];
};

export type DeleteInstrumentFromTrancheInput = {
  readonly instrumentId: Scalars['UUID']['input'];
  readonly offeringId: Scalars['UUID']['input'];
  readonly trancheId: Scalars['UUID']['input'];
};

export type DeleteInstrumentFromTranchePayload = {
  readonly __typename?: 'DeleteInstrumentFromTranchePayload';
  readonly offering?: Maybe<OfferingFull>;
};

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteIssuerAllocationWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteIssuerIndicationWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteManagerBdWireResponseUnion = DeleteWire | ServiceError;

export type DeleteManagerInput = {
  readonly cmgEntityKey: Scalars['String']['input'];
  readonly offeringId: Scalars['UUID']['input'];
};

export type DeleteManagerPayload = {
  readonly __typename?: 'DeleteManagerPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type DeleteMdlOfferingNoteInput = {
  readonly id: Scalars['ID']['input'];
};

export type DeleteMyRetailDemandBroker = {
  readonly __typename?: 'DeleteMyRetailDemandBroker';
  readonly id: Scalars['ID']['output'];
};

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteNonSyndicateFreeFormWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteNonSyndicatePaymentWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteNonSyndicateSellingGroupInvitationWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteNonSyndicateSellingGroupTermsRetentionWireResponseUnion =
  | DeleteWire
  | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteNonSyndicateTerminationWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeletePaymentWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeletePotAccountWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeletePotAllocationWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeletePricingTermsRetentionWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeletePricingTermsWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteRegMWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteResearchRestrictionWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteRetentionWireResponseUnion = DeleteWire | ServiceError;

export type DeleteRoadshowScheduleInput = {
  readonly offeringId: Scalars['UUID']['input'];
  readonly roadshowScheduleId: Scalars['UUID']['input'];
};

export type DeleteRoadshowSchedulePayload = {
  readonly __typename?: 'DeleteRoadshowSchedulePayload';
  readonly offering?: Maybe<OfferingFull>;
};

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteSellingGroupInvitationWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteSellingGroupTermsWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteTerminationWireResponseUnion = DeleteWire | ServiceError;

/** Union of DeleteWireResponse and ServiceError, either a DeleteWireResponse or ServiceError is returned */
export type DeleteUnderwriterInvitationWireResponseUnion = DeleteWire | ServiceError;

export type DeleteViewSettingInput = {
  readonly id: Scalars['UUID']['input'];
};

export type DeleteViewSettingPayload = {
  readonly __typename?: 'DeleteViewSettingPayload';
  readonly deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteWallCrossIndicationInput = {
  readonly indicationId: Scalars['ID']['input'];
  readonly offeringId: Scalars['ID']['input'];
};

export type DeleteWallCrossIndicationPayload = {
  readonly __typename?: 'DeleteWallCrossIndicationPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

export type DeleteWallCrossInvestorCommunicationLogInput = {
  readonly communicationLogId: Scalars['ID']['input'];
  readonly offeringId: Scalars['ID']['input'];
};

export type DeleteWallCrossInvestorCommunicationLogPayload = {
  readonly __typename?: 'DeleteWallCrossInvestorCommunicationLogPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

export type DeleteWallCrossInvestorInput = {
  readonly investorId: Scalars['ID']['input'];
  readonly offeringId: Scalars['ID']['input'];
};

export type DeleteWallCrossInvestorPayload = {
  readonly __typename?: 'DeleteWallCrossInvestorPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

export type DeleteWallCrossOwnerInput = {
  readonly investorId: Scalars['ID']['input'];
  readonly offeringId: Scalars['ID']['input'];
};

export type DeleteWallCrossOwnerPayload = {
  readonly __typename?: 'DeleteWallCrossOwnerPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

/** Response for delete wire mutation */
export type DeleteWire = {
  readonly __typename?: 'DeleteWire';
  readonly id: Scalars['ID']['output'];
};

export type DeliveryInstrument = {
  readonly __typename?: 'DeliveryInstrument';
  readonly countryCode: Scalars['String']['output'];
  readonly currencyCode: Scalars['String']['output'];
  readonly cusip?: Maybe<Scalars['String']['output']>;
  readonly depositaryReceiptConversionRatio?: Maybe<DepositaryReceiptConversionRatio>;
  readonly exchangeMic?: Maybe<ExchangeMic>;
  /** Display name for ExchangeMic */
  readonly exchangeMicDisplayName?: Maybe<Scalars['String']['output']>;
  readonly figi?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isDepositaryReceipt: Scalars['Boolean']['output'];
  readonly isin?: Maybe<Scalars['String']['output']>;
  readonly lastTradeBeforeFiling?: Maybe<Scalars['Decimal']['output']>;
  readonly lastTradeBeforeLaunch?: Maybe<Scalars['Decimal']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly rank?: Maybe<Rank>;
  readonly recordStatus: RecordStatus;
  readonly referencePrice?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingRestrictions?: Maybe<SellingRestrictions>;
  /** Display name for SellingRestrictions */
  readonly sellingRestrictionsDisplayName?: Maybe<Scalars['String']['output']>;
  readonly stockSymbol?: Maybe<Scalars['String']['output']>;
  readonly underlyingCurrencyCode?: Maybe<Scalars['String']['output']>;
  readonly underlyingExchangeMic?: Maybe<ExchangeMic>;
  /** Display name for UnderlyingExchangeMic */
  readonly underlyingExchangeMicDisplayName?: Maybe<Scalars['String']['output']>;
  readonly underlyingStockSymbol?: Maybe<Scalars['String']['output']>;
};

export type DeliveryInstrumentPrivileged = {
  readonly __typename?: 'DeliveryInstrumentPrivileged';
  /** Null is returned if your firm does not have an active bookrunner relationship with this offering. */
  readonly countryCode: Scalars['String']['output'];
  /** Null is returned if your firm does not have an active bookrunner relationship with this offering. */
  readonly currencyCode: Scalars['String']['output'];
  readonly cusip?: Maybe<Scalars['String']['output']>;
  /** Null is returned if your firm does not have an active bookrunner relationship with this offering. */
  readonly depositaryReceiptConversionRatio?: Maybe<DepositaryReceiptConversionRatio>;
  readonly exchangeMic?: Maybe<ExchangeMic>;
  /** Display name for ExchangeMic */
  readonly exchangeMicDisplayName?: Maybe<Scalars['String']['output']>;
  readonly figi?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isDepositaryReceipt: Scalars['Boolean']['output'];
  readonly isin?: Maybe<Scalars['String']['output']>;
  readonly lastTradeBeforeFiling?: Maybe<Scalars['Decimal']['output']>;
  readonly lastTradeBeforeLaunch?: Maybe<Scalars['Decimal']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly rank?: Maybe<Rank>;
  readonly referencePrice?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingRestrictions?: Maybe<SellingRestrictions>;
  /** Display name for SellingRestrictions */
  readonly sellingRestrictionsDisplayName?: Maybe<Scalars['String']['output']>;
  readonly stockSymbol?: Maybe<Scalars['String']['output']>;
  readonly underlyingCurrencyCode?: Maybe<Scalars['String']['output']>;
  readonly underlyingExchangeMic?: Maybe<ExchangeMic>;
  /** Display name for UnderlyingExchangeMic */
  readonly underlyingExchangeMicDisplayName?: Maybe<Scalars['String']['output']>;
  readonly underlyingStockSymbol?: Maybe<Scalars['String']['output']>;
};

export type DemandCurrency = {
  readonly __typename?: 'DemandCurrency';
  readonly currencyCode: Scalars['String']['output'];
  readonly exchangeRate: Scalars['Decimal']['output'];
  readonly id: Scalars['ID']['output'];
  readonly recordStatus: RecordStatus;
};

export type DemandCurrencyDataInput = {
  readonly currencyCode: Scalars['String']['input'];
  readonly exchangeRate: Scalars['Decimal']['input'];
  readonly trancheId?: InputMaybe<Scalars['UUID']['input']>;
};

export type DemandCurrencyFull = {
  readonly __typename?: 'DemandCurrencyFull';
  readonly currencyCode: Scalars['String']['output'];
  readonly exchangeRate?: Maybe<Scalars['Decimal']['output']>;
};

export type DemandCurrencyFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<DemandCurrencyFullFilterInput>>;
  readonly currencyCode?: InputMaybe<StringOperationFilterInput>;
  readonly exchangeRate?: InputMaybe<DecimalOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<DemandCurrencyFullFilterInput>>;
};

export type DemandCurrencyProfile = {
  readonly __typename?: 'DemandCurrencyProfile';
  readonly currencyCode: Scalars['String']['output'];
  readonly exchangeRate?: Maybe<Scalars['Decimal']['output']>;
};

export type DemandGridChangeSet = {
  readonly __typename?: 'DemandGridChangeSet';
  readonly added: ReadonlyArray<DemandGridRow>;
  readonly fullRefreshRequired: Scalars['Boolean']['output'];
  readonly removedIds: ReadonlyArray<Scalars['UUID']['output']>;
  readonly updated: ReadonlyArray<DemandGridRow>;
};

export type DemandGridOfferingContext = {
  readonly __typename?: 'DemandGridOfferingContext';
  readonly convertibleParValue?: Maybe<Scalars['Decimal']['output']>;
  readonly demandCurrencies: ReadonlyArray<CurrencyExchangeRate>;
  readonly lastTradeBeforeLaunch?: Maybe<Scalars['Decimal']['output']>;
  readonly lastTradeBeforeOffer?: Maybe<Scalars['Decimal']['output']>;
  readonly offeringId: Scalars['UUID']['output'];
  readonly offeringSizeInCurrency?: Maybe<Scalars['Decimal']['output']>;
  readonly offeringSizeInShares?: Maybe<Scalars['Long']['output']>;
  readonly version?: Maybe<Scalars['Int']['output']>;
};

export type DemandGridRow = {
  readonly __typename?: 'DemandGridRow';
  readonly acknowledgedByUser?: Maybe<UserInfo>;
  readonly acknowledgements?: Maybe<ReadonlyArray<IndicationAcknowledgement>>;
  readonly alert: RowAlert;
  readonly allocations?: Maybe<ReadonlyArray<Allocation>>;
  readonly attestationStatus?: Maybe<AttestationFormStatus>;
  readonly auditInfo: AuditInformation;
  readonly bndAgent?: Maybe<FirmInfo>;
  readonly coveringManagers?: Maybe<ReadonlyArray<FirmInfo>>;
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  readonly duplicateOfIndicationId?: Maybe<Scalars['UUID']['output']>;
  readonly hasDuplicates: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly instrumentId?: Maybe<Scalars['UUID']['output']>;
  readonly interestLevels?: Maybe<ReadonlyArray<InterestLevel>>;
  readonly investor: InvestorInfo;
  readonly investorEngagements?: Maybe<InvestorEngagements>;
  readonly investorResponse?: Maybe<InvestorResponse>;
  readonly myIndicationContacts?: Maybe<ReadonlyArray<Contact>>;
  readonly notes?: Maybe<IndicationNotes>;
  readonly primarySalesCoverage?: Maybe<ReadonlyArray<InvestorCoveringEmployee>>;
  readonly prospectusDeliverySummary: ProspectusDeliverySummary;
  readonly qibStatus?: Maybe<AttestationFormStatus>;
  readonly secondarySalesCoverage?: Maybe<ReadonlyArray<InvestorCoveringEmployee>>;
  readonly status: IndicationStatus;
  readonly trancheId?: Maybe<Scalars['UUID']['output']>;
  readonly type: InstitutionalIndicationOrderType;
  readonly typeDisplayValue: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type DemandGridRowConnection = {
  readonly __typename?: 'DemandGridRowConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<DemandGridRowEdge>>;
  /** A flattened list of the nodes */
  readonly nodes?: Maybe<ReadonlyArray<DemandGridRow>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

export type DemandGridRowEdge = {
  readonly __typename?: 'DemandGridRowEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: DemandGridRow;
};

export type DemandGridRowFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<DemandGridRowFilterInput>>;
  readonly attestationStatus?: InputMaybe<NullableOfCertificateStatusOperationFilterInput>;
  readonly currencyCode?: InputMaybe<StringOperationFilterInput>;
  readonly duplicateOfIndicationId?: InputMaybe<UuidOperationFilterInput>;
  readonly hasDuplicates?: InputMaybe<BooleanOperationFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly instrumentId?: InputMaybe<UuidOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<DemandGridRowFilterInput>>;
  readonly qibStatus?: InputMaybe<NullableOfCertificateStatusOperationFilterInput>;
  readonly status?: InputMaybe<IndicationStatusFilterInput>;
  readonly trancheId?: InputMaybe<UuidOperationFilterInput>;
  readonly type?: InputMaybe<IndicationTypeOperationFilterInput>;
};

export type DemandLevel = {
  readonly __typename?: 'DemandLevel';
  readonly price: Scalars['Decimal']['output'];
  readonly shares: Scalars['Long']['output'];
};

export type DemandLevelFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<DemandLevelFilterInput>>;
  readonly or?: InputMaybe<ReadonlyArray<DemandLevelFilterInput>>;
  readonly price?: InputMaybe<DecimalOperationFilterInput>;
  readonly shares?: InputMaybe<LongOperationFilterInput>;
};

export type DemandLevelSortInput = {
  readonly price: Scalars['Decimal']['input'];
  readonly shares?: InputMaybe<SortEnumType>;
};

export type DemandRangeInput = {
  /** The increment range for calculation demand. */
  readonly increment: Scalars['Decimal']['input'];
  /** The max value for calculation demand. */
  readonly max: Scalars['Decimal']['input'];
  /** The min value for calculation demand. */
  readonly min: Scalars['Decimal']['input'];
  /** The reference price for indication demand. */
  readonly referencePrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DemandSettingsInput = {
  /** Used to specify the demand range for order book of offerings working with reference of coupon/premium/priceAsOfPar (e.g. Convertibles) */
  readonly convertibleDemandCollection?: InputMaybe<ConvertibleDemandCollectionInput>;
  /** Used to calculate the demand range for order book of offerings working with reference prices (e.g. IPOs and FOs) */
  readonly demandRange?: InputMaybe<DemandRangeInput>;
};

export type DepositaryReceiptConversionRatio = {
  readonly __typename?: 'DepositaryReceiptConversionRatio';
  readonly denominator: Scalars['Int']['output'];
  readonly numerator: Scalars['Int']['output'];
};

/** The Institutional Allocation */
export type DesignationAllocation = {
  readonly __typename?: 'DesignationAllocation';
  readonly id: Scalars['ID']['output'];
  readonly indicationId: Scalars['UUID']['output'];
  readonly investor: DesignationInvestor;
  readonly shares: Scalars['Long']['output'];
};

export type DesignationInvestor = {
  readonly __typename?: 'DesignationInvestor';
  readonly bankInvestorKey?: Maybe<Scalars['String']['output']>;
  readonly bankInvestorName?: Maybe<Scalars['String']['output']>;
  readonly cmgEntityKey: Scalars['ID']['output'];
  readonly cmgEntityName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
};

export type DesignationManager = {
  readonly __typename?: 'DesignationManager';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly cmgEntityName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly role: ExpensesManagerRole;
  /** Display name for Role */
  readonly roleDisplayName?: Maybe<Scalars['String']['output']>;
};

export type DesignationRecipientData = {
  readonly __typename?: 'DesignationRecipientData';
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly headerNote?: Maybe<Scalars['String']['output']>;
  readonly recipient: Scalars['String']['output'];
};

export type DesignationRecipientInputData = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly headerNote?: InputMaybe<Scalars['String']['input']>;
  readonly recipient: Scalars['String']['input'];
};

export enum DesignationStrategy {
  /** Operation type for applying fixed economics to all managers for an allocation. */
  FixedEconomics = 'FIXED_ECONOMICS',
  /** Operation type for manually assigning a designation to a manager for an allocation. */
  ManualDesignation = 'MANUAL_DESIGNATION',
}

export type DesignationUpdateInput = {
  /** The Institutional Indication Id. */
  readonly indicationId: Scalars['ID']['input'];
  /** The CMG Entity Key of given Manager. */
  readonly managerCmgEntityKey: Scalars['ID']['input'];
  /** The quantity of shares that the Manager will get. */
  readonly shares: Scalars['Long']['input'];
};

export type DesignationValidation = {
  readonly __typename?: 'DesignationValidation';
  readonly areFinalAllocationsReleased: Scalars['Boolean']['output'];
};

export enum DesignationWarning {
  AllocationIsRejected = 'ALLOCATION_IS_REJECTED',
  AllocationMustBeGreaterThanZero = 'ALLOCATION_MUST_BE_GREATER_THAN_ZERO',
  DesignationsAreOutOfBalance = 'DESIGNATIONS_ARE_OUT_OF_BALANCE',
  IndicationIsCancelled = 'INDICATION_IS_CANCELLED',
  IndicationIsDuplicate = 'INDICATION_IS_DUPLICATE',
  IndicationIsPass = 'INDICATION_IS_PASS',
}

export type DesignationWire = {
  readonly __typename?: 'DesignationWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly id: Scalars['ID']['output'];
  readonly recipientsUserData: ReadonlyArray<DesignationRecipientData>;
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

export type DesignationWireInput = {
  readonly userDataForRecipients: ReadonlyArray<DesignationRecipientInputData>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type DesignationWireResponseUnion = DesignationWire | ServiceError;

export type DesignationWireValidation = WireValidationBase & {
  readonly __typename?: 'DesignationWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<DesignationWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum DesignationWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  SecurityType = 'SECURITY_TYPE',
  SellingConcession = 'SELLING_CONCESSION',
  SettlementAgent = 'SETTLEMENT_AGENT',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
}

export type DesignationsGrid = {
  readonly __typename?: 'DesignationsGrid';
  readonly designations: ReadonlyArray<DesignationsGridItem>;
  readonly id: Scalars['ID']['output'];
  readonly syndicateManagers: ReadonlyArray<DesignationsGridManager>;
};

export type DesignationsGridAllocation = {
  readonly __typename?: 'DesignationsGridAllocation';
  readonly id: Scalars['ID']['output'];
  readonly indicationId: Scalars['UUID']['output'];
  readonly investorCmgEntityKey: Scalars['String']['output'];
  readonly investorName: Scalars['String']['output'];
  readonly shares: Scalars['Long']['output'];
};

export type DesignationsGridDesignation = {
  readonly __typename?: 'DesignationsGridDesignation';
  readonly fixedEconomicsShares: Scalars['Long']['output'];
  readonly id: Scalars['ID']['output'];
  readonly managerCmgEntityKey: Scalars['String']['output'];
  readonly sellingConcessionPercentageChanged: Scalars['Boolean']['output'];
  readonly shares?: Maybe<Scalars['Long']['output']>;
};

export type DesignationsGridItem = {
  readonly __typename?: 'DesignationsGridItem';
  readonly allocation: DesignationsGridAllocation;
  readonly designations: ReadonlyArray<DesignationsGridDesignation>;
  readonly id: Scalars['ID']['output'];
  readonly isPublished?: Maybe<Scalars['Boolean']['output']>;
  readonly version?: Maybe<Scalars['String']['output']>;
  readonly warnings: ReadonlyArray<DesignationWarning>;
};

export type DesignationsGridManager = {
  readonly __typename?: 'DesignationsGridManager';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export type DestinationInfo = {
  readonly __typename?: 'DestinationInfo';
  readonly destinationType: DestinationType;
  readonly tenantInfo?: Maybe<TenantDetails>;
};

export enum DestinationType {
  MultiTenant = 'MULTI_TENANT',
  Public = 'PUBLIC',
  SingleTenant = 'SINGLE_TENANT',
}

export type DiscardOfferingInput = {
  readonly offeringId: Scalars['UUID']['input'];
};

export type DiscardOfferingPayload = {
  readonly __typename?: 'DiscardOfferingPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type Disclaimers = {
  readonly __typename?: 'Disclaimers';
  readonly footnotes?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly registrationLinks: ReadonlyArray<Scalars['String']['output']>;
  readonly restrictions?: Maybe<Scalars['String']['output']>;
  readonly rule134Legend?: Maybe<Scalars['String']['output']>;
};

export type DisclaimersFull = {
  readonly __typename?: 'DisclaimersFull';
  readonly footnotes?: Maybe<Scalars['String']['output']>;
  readonly registrationLinks: ReadonlyArray<Scalars['String']['output']>;
  readonly restrictions?: Maybe<Scalars['String']['output']>;
  readonly rule134Legend?: Maybe<Scalars['String']['output']>;
};

export type DisclaimersFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<DisclaimersFullFilterInput>>;
  readonly footnotes?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<DisclaimersFullFilterInput>>;
  readonly registrationLinks?: InputMaybe<ListStringOperationFilterInput>;
  readonly restrictions?: InputMaybe<StringOperationFilterInput>;
  readonly rule134Legend?: InputMaybe<StringOperationFilterInput>;
};

export type DisclaimersProfile = {
  readonly __typename?: 'DisclaimersProfile';
  readonly footnotes?: Maybe<Scalars['String']['output']>;
  readonly registrationLinks: ReadonlyArray<Scalars['String']['output']>;
  readonly restrictions?: Maybe<Scalars['String']['output']>;
  readonly rule134Legend?: Maybe<Scalars['String']['output']>;
};

export type DraftAllocation = {
  readonly __typename?: 'DraftAllocation';
  readonly allocationSetId: Scalars['UUID']['output'];
  readonly auditInfo: AuditInfo;
  readonly id: Scalars['ID']['output'];
  /** The ID of the IOI to which this Allocation correlates. */
  readonly indicationId: Scalars['UUID']['output'];
  /** The number of shares for this Allocation. */
  readonly shareQuantity?: Maybe<Scalars['Long']['output']>;
  readonly version: Scalars['String']['output'];
};

export type DraftAllocationBatchUpdateInput = {
  readonly allocations: ReadonlyArray<DraftAllocationsUpdateInputAllocations>;
};

export type DraftAllocationSet = {
  readonly __typename?: 'DraftAllocationSet';
  readonly auditInfo: AuditInfo;
  readonly authorCmgEntityKey: Scalars['String']['output'];
  readonly dealLayout: DealLayout;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly recordStatus: OrderBookRecordStatus;
  readonly shareTimestamp?: Maybe<Scalars['Instant']['output']>;
  readonly sharedWithManagerCmgEntityKeys?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly version: Scalars['String']['output'];
};

export type DraftAllocationUpdateInput = {
  /** The number of shares being allocated. */
  readonly shareQuantity?: InputMaybe<Scalars['Long']['input']>;
};

export type DraftAllocationsUpdateInputAllocations = {
  readonly allocation: DraftAllocationUpdateInput;
  readonly indicationId: Scalars['UUID']['input'];
};

export enum EmailDeliveryStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotSent = 'NOT_SENT',
  Sent = 'SENT',
}

export enum EmailNotificationType {
  FinalAllocationAcknowledgedRejected = 'FINAL_ALLOCATION_ACKNOWLEDGED_REJECTED',
  FinalAllocationReleased = 'FINAL_ALLOCATION_RELEASED',
  FinalAllocationUpdated = 'FINAL_ALLOCATION_UPDATED',
  IndicationCancelled = 'INDICATION_CANCELLED',
  IndicationDuplicated = 'INDICATION_DUPLICATED',
  IndicationModified = 'INDICATION_MODIFIED',
  NewIndicationSubmitted = 'NEW_INDICATION_SUBMITTED',
  OfferingStatusChange = 'OFFERING_STATUS_CHANGE',
  OrderBookClosed = 'ORDER_BOOK_CLOSED',
  OrderBookOpened = 'ORDER_BOOK_OPENED',
  PrivatePlacementResponse = 'PRIVATE_PLACEMENT_RESPONSE',
  RetailDemandSubmitted = 'RETAIL_DEMAND_SUBMITTED',
}

export type EmptyMutationResponse = {
  readonly __typename?: 'EmptyMutationResponse';
  /** GraphQL doesn't allow empty object types, so here's something to soothe its rage */
  readonly placeholder: Scalars['Boolean']['output'];
};

export type Entitlements = {
  readonly __typename?: 'Entitlements';
  readonly id: Scalars['ID']['output'];
  readonly syndicateEntitlements: ReadonlyArray<SyndicateEntitlements>;
  readonly version: Scalars['String']['output'];
};

/**
 * Defines the allowed Actions for a Resource and human consumable descriptions for ease of consumption.
 * There may only be one Resource Entitlements Configuration per Resource
 */
export type EntitlementsConfiguration = {
  readonly __typename?: 'EntitlementsConfiguration';
  readonly actionConfigurations: ReadonlyArray<ActionConfiguration>;
  readonly boundedContext: BoundedContext;
  readonly description: Scalars['String']['output'];
  readonly displayName: Scalars['String']['output'];
  readonly resource: Resource;
};

export type EnumLabelOfCountry = {
  readonly __typename?: 'EnumLabelOfCountry';
  readonly displayName: Scalars['String']['output'];
  readonly id: Country;
  readonly region?: Maybe<EnumLabelOfRegion>;
  readonly value: Scalars['Int']['output'];
};

export type EnumLabelOfCountryFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<EnumLabelOfCountryFilterInput>>;
  readonly displayName?: InputMaybe<StringOperationFilterInput>;
  readonly id?: InputMaybe<CountryFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<EnumLabelOfCountryFilterInput>>;
  readonly value?: InputMaybe<IntOperationFilterInput>;
};

export type EnumLabelOfCountrySortInput = {
  readonly displayName?: InputMaybe<SortEnumType>;
  readonly id?: InputMaybe<CountrySortInput>;
  readonly value?: InputMaybe<SortEnumType>;
};

export type EnumLabelOfCurrency = {
  readonly __typename?: 'EnumLabelOfCurrency';
  readonly displayName: Scalars['String']['output'];
  readonly id: Currency;
  readonly value: Scalars['Int']['output'];
};

export type EnumLabelOfCurrencyFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<EnumLabelOfCurrencyFilterInput>>;
  readonly displayName?: InputMaybe<StringOperationFilterInput>;
  readonly id?: InputMaybe<CurrencyFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<EnumLabelOfCurrencyFilterInput>>;
  readonly value?: InputMaybe<IntOperationFilterInput>;
};

export type EnumLabelOfCurrencySortInput = {
  readonly displayName?: InputMaybe<SortEnumType>;
  readonly id?: InputMaybe<CurrencySortInput>;
  readonly value?: InputMaybe<SortEnumType>;
};

export type EnumLabelOfRegion = {
  readonly __typename?: 'EnumLabelOfRegion';
  readonly displayName: Scalars['String']['output'];
  readonly id: Region;
  readonly value: Scalars['Int']['output'];
};

/** Legacy Detail Error object for Apollo Compatibility */
export type ErrorDetail = {
  readonly __typename?: 'ErrorDetail';
  readonly code?: Maybe<Scalars['String']['output']>;
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly target?: Maybe<Scalars['String']['output']>;
};

export type ExceptionInfoDocument = {
  readonly __typename?: 'ExceptionInfoDocument';
  readonly exceptionType: Scalars['String']['output'];
  readonly innerException?: Maybe<ExceptionInfoDocument>;
  readonly message: Scalars['String']['output'];
  readonly source: Scalars['String']['output'];
  readonly stackTrace: Scalars['String']['output'];
};

export enum ExchangeMic {
  Aqse = 'AQSE',
  Bats = 'BATS',
  Bsex = 'BSEX',
  Bvca = 'BVCA',
  Bvmf = 'BVMF',
  Difx = 'DIFX',
  Dsmd = 'DSMD',
  Hstc = 'HSTC',
  Misx = 'MISX',
  Neoe = 'NEOE',
  Notc = 'NOTC',
  Rsex = 'RSEX',
  Xads = 'XADS',
  Xalg = 'XALG',
  Xamm = 'XAMM',
  Xams = 'XAMS',
  Xarm = 'XARM',
  Xasx = 'XASX',
  Xath = 'XATH',
  Xbaa = 'XBAA',
  Xbab = 'XBAB',
  Xbah = 'XBAH',
  Xbda = 'XBDA',
  Xbdv = 'XBDV',
  Xbel = 'XBEL',
  Xbey = 'XBEY',
  Xbkk = 'XBKK',
  Xbnv = 'XBNV',
  Xbog = 'XBOG',
  Xbol = 'XBOL',
  Xbom = 'XBOM',
  Xbot = 'XBOT',
  Xbra = 'XBRA',
  Xbru = 'XBRU',
  Xbrv = 'XBRV',
  Xbse = 'XBSE',
  Xbud = 'XBUD',
  Xbue = 'XBUE',
  Xbul = 'XBUL',
  Xbvm = 'XBVM',
  Xcai = 'XCAI',
  Xcas = 'XCAS',
  Xcnq = 'XCNQ',
  Xcol = 'XCOL',
  Xcse = 'XCSE',
  Xcsx = 'XCSX',
  Xcys = 'XCYS',
  Xdar = 'XDAR',
  Xdfm = 'XDFM',
  Xdha = 'XDHA',
  Xdse = 'XDSE',
  Xdub = 'XDUB',
  Xfra = 'XFRA',
  Xgha = 'XGHA',
  Xgse = 'XGSE',
  Xhel = 'XHEL',
  Xhkg = 'XHKG',
  Xice = 'XICE',
  Xidx = 'XIDX',
  Xiqs = 'XIQS',
  Xist = 'XIST',
  Xjam = 'XJAM',
  Xjse = 'XJSE',
  Xkar = 'XKAR',
  Xkaz = 'XKAZ',
  Xkls = 'XKLS',
  Xkrx = 'XKRX',
  Xkuw = 'XKUW',
  Xlao = 'XLAO',
  Xlim = 'XLIM',
  Xlis = 'XLIS',
  Xlit = 'XLIT',
  Xlju = 'XLJU',
  Xlon = 'XLON',
  Xlus = 'XLUS',
  Xlux = 'XLUX',
  Xmad = 'XMAD',
  Xmae = 'XMAE',
  Xmal = 'XMAL',
  Xmau = 'XMAU',
  Xmex = 'XMEX',
  Xmil = 'XMIL',
  Xmnx = 'XMNX',
  Xmsw = 'XMSW',
  Xmus = 'XMUS',
  Xnai = 'XNAI',
  Xnam = 'XNAM',
  Xnas = 'XNAS',
  Xnec = 'XNEC',
  Xnep = 'XNEP',
  Xngm = 'XNGM',
  Xnsa = 'XNSA',
  Xnse = 'XNSE',
  Xnys = 'XNYS',
  Xnze = 'XNZE',
  Xosl = 'XOSL',
  Xotc = 'XOTC',
  Xpae = 'XPAE',
  Xpar = 'XPAR',
  Xphs = 'XPHS',
  Xpom = 'XPOM',
  Xpra = 'XPRA',
  Xpty = 'XPTY',
  Xris = 'XRIS',
  Xsau = 'XSAU',
  Xses = 'XSES',
  Xsgo = 'XSGO',
  Xshe = 'XSHE',
  Xshg = 'XSHG',
  Xsps = 'XSPS',
  Xstc = 'XSTC',
  Xste = 'XSTE',
  Xsto = 'XSTO',
  Xswx = 'XSWX',
  Xtae = 'XTAE',
  Xtai = 'XTAI',
  Xtal = 'XTAL',
  Xtks = 'XTKS',
  Xtrn = 'XTRN',
  Xtse = 'XTSE',
  Xtsx = 'XTSX',
  Xtun = 'XTUN',
  Xuga = 'XUGA',
  Xula = 'XULA',
  Xvpa = 'XVPA',
  Xwar = 'XWAR',
  Xwbo = 'XWBO',
  Xzag = 'XZAG',
}

export enum ExpenseCategory {
  ClosingExpenses = 'CLOSING_EXPENSES',
  DtcCosts = 'DTC_COSTS',
  ExpensesSubjectTo_274N = 'EXPENSES_SUBJECT_TO_274N',
  FinancingSettlement = 'FINANCING_SETTLEMENT',
  LegalFees = 'LEGAL_FEES',
  Operational = 'OPERATIONAL',
  OtherExpenses = 'OTHER_EXPENSES',
  PrintCommunications = 'PRINT_COMMUNICATIONS',
  ProfessionalServices = 'PROFESSIONAL_SERVICES',
  Regulatory = 'REGULATORY',
  ReimbursementToIssuer = 'REIMBURSEMENT_TO_ISSUER',
  Roadshow = 'ROADSHOW',
  TechnologyData = 'TECHNOLOGY_DATA',
  ThirdPartyAdvisors = 'THIRD_PARTY_ADVISORS',
  TravelMeals = 'TRAVEL_MEALS',
}

export type Expenses = {
  readonly __typename?: 'Expenses';
  readonly dealRelatedExpenses: ReadonlyArray<DealRelatedExpense>;
  readonly id: Scalars['ID']['output'];
  readonly managerExpenses: ReadonlyArray<ManagerExpenses>;
  readonly managers: ReadonlyArray<ExpensesManager>;
  readonly notes?: Maybe<Scalars['String']['output']>;
};

export type ExpensesManager = {
  readonly __typename?: 'ExpensesManager';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly role: ExpensesManagerRole;
  /** Display name for Role */
  readonly roleDisplayName?: Maybe<Scalars['String']['output']>;
};

export enum ExpensesManagerRole {
  ActiveBookrunner = 'ACTIVE_BOOKRUNNER',
  Bookrunner = 'BOOKRUNNER',
  CoLead = 'CO_LEAD',
  CoManager = 'CO_MANAGER',
  GlobalCoordinator = 'GLOBAL_COORDINATOR',
  Invalid = 'INVALID',
  SellingGroupMember = 'SELLING_GROUP_MEMBER',
  Underwriter = 'UNDERWRITER',
}

export enum ExtendedDataCategory {
  Compliance = 'COMPLIANCE',
  InvestorComments = 'INVESTOR_COMMENTS',
  InvestorRegion = 'INVESTOR_REGION',
  InvestorType = 'INVESTOR_TYPE',
  OtherInvestorAttributes = 'OTHER_INVESTOR_ATTRIBUTES',
  Revenue = 'REVENUE',
}

export type FaultedDestination = {
  readonly __typename?: 'FaultedDestination';
  readonly destinationType: DestinationType;
  readonly exceptions: ReadonlyArray<ExceptionInfoDocument>;
  readonly tenantInfo?: Maybe<TenantDetails>;
};

export type FeesAndDiscounts = {
  readonly __typename?: 'FeesAndDiscounts';
  readonly grossSpreadBase: GrossSpreadBase;
  readonly incentiveFee: IncentiveFee;
  readonly sharesExcludedFromGrossSpread?: Maybe<Scalars['Long']['output']>;
};

export type Filing = {
  readonly __typename?: 'Filing';
  readonly conversionPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly coupon?: Maybe<Scalars['Decimal']['output']>;
  readonly couponTalkHigh?: Maybe<Scalars['Decimal']['output']>;
  readonly couponTalkLow?: Maybe<Scalars['Decimal']['output']>;
  readonly effectiveConversionPremium?: Maybe<Scalars['Decimal']['output']>;
  readonly effectiveConversionPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly filingType: FilingType;
  readonly id: Scalars['ID']['output'];
  readonly initialConversionRatio?: Maybe<Scalars['Decimal']['output']>;
  readonly initialRegistrationValue?: Maybe<Scalars['Decimal']['output']>;
  readonly ipoRangeHigh?: Maybe<Scalars['Decimal']['output']>;
  readonly ipoRangeLow?: Maybe<Scalars['Decimal']['output']>;
  /**
   * This field is deprecated. Please use the LockUpPeriod field in Terms instead.
   * @deprecated Use the LockUpPeriod field in Terms instead.
   */
  readonly lockUpPeriod?: Maybe<Scalars['Int']['output']>;
  readonly notionalOverAllotmentAuthorized?: Maybe<Scalars['Decimal']['output']>;
  /**
   * This field is deprecated. Please use the Notional field in OverAllotmentExercisedData instead.
   * @deprecated Use the Notional field in OverAllotmentExercisedData instead.
   */
  readonly notionalOverAllotmentExercised?: Maybe<Scalars['Decimal']['output']>;
  readonly numberOfBondsBaseOffering?: Maybe<Scalars['Long']['output']>;
  readonly numberOfBondsOverAllotmentAuthorized?: Maybe<Scalars['Long']['output']>;
  readonly offerPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly parValue?: Maybe<Scalars['Decimal']['output']>;
  readonly postOfferingShares?: Maybe<Scalars['Long']['output']>;
  readonly premium?: Maybe<Scalars['Decimal']['output']>;
  readonly premiumTalkHigh?: Maybe<Scalars['Decimal']['output']>;
  readonly premiumTalkLow?: Maybe<Scalars['Decimal']['output']>;
  readonly priceAsOfPar?: Maybe<Scalars['Decimal']['output']>;
  readonly primarySharesBaseOffering?: Maybe<Scalars['Long']['output']>;
  readonly primarySharesOverAllotmentAuthorized?: Maybe<Scalars['Long']['output']>;
  /**
   * This field is deprecated. Please use the PrimaryShares field in OverAllotmentExercisedData instead.
   * @deprecated Use the PrimaryShares field in OverAllotmentExercisedData instead.
   */
  readonly primarySharesOverAllotmentExercised?: Maybe<Scalars['Long']['output']>;
  readonly proceedsBaseOffering?: Maybe<Scalars['Decimal']['output']>;
  readonly proceedsOverAllotmentAuthorized?: Maybe<Scalars['Decimal']['output']>;
  readonly recordStatus: RecordStatus;
  readonly secondarySharesBaseOffering?: Maybe<Scalars['Long']['output']>;
  readonly secondarySharesOverAllotmentAuthorized?: Maybe<Scalars['Long']['output']>;
  /**
   * This field is deprecated. Please use the SecondaryShares field in OverAllotmentExercisedData instead.
   * @deprecated Use the SecondaryShares field in OverAllotmentExercisedData instead.
   */
  readonly secondarySharesOverAllotmentExercised?: Maybe<Scalars['Long']['output']>;
  readonly totalSharesBaseOffering?: Maybe<Scalars['Long']['output']>;
  readonly totalSharesOverAllotmentAuthorized?: Maybe<Scalars['Long']['output']>;
  readonly totalSharesOverAllotmentExercised?: Maybe<Scalars['Long']['output']>;
  /**
   * This field is deprecated. Please use the UseOfProceeds field in Terms instead.
   * @deprecated Use the UseOfProceeds field in Terms instead.
   */
  readonly useOfProceeds: ReadonlyArray<UseOfProceeds>;
};

export type FilingFull = {
  readonly __typename?: 'FilingFull';
  readonly conversionPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly coupon?: Maybe<Scalars['Decimal']['output']>;
  /** When selecting this field for published offerings, also select the following fields to ensure the field is not needlessly nullified: Status, PricingInstrumentId, Instruments.Id, Instruments.CountryCode */
  readonly couponTalkHigh?: Maybe<Scalars['Decimal']['output']>;
  /** When selecting this field for published offerings, also select the following fields to ensure the field is not needlessly nullified: Status, PricingInstrumentId, Instruments.Id, Instruments.CountryCode */
  readonly couponTalkLow?: Maybe<Scalars['Decimal']['output']>;
  readonly effectiveConversionPremium?: Maybe<Scalars['Decimal']['output']>;
  readonly effectiveConversionPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly filingType: FilingType;
  readonly id: Scalars['UUID']['output'];
  readonly initialConversionRatio?: Maybe<Scalars['Decimal']['output']>;
  readonly initialRegistrationValue?: Maybe<Scalars['Decimal']['output']>;
  /** When selecting this field for published offerings, also select the following fields to ensure the field is not needlessly nullified: Status, PricingInstrumentId, Instruments.Id, Instruments.CountryCode */
  readonly ipoRangeHigh?: Maybe<Scalars['Decimal']['output']>;
  /** When selecting this field for published offerings, also select the following fields to ensure the field is not needlessly nullified: Status, PricingInstrumentId, Instruments.Id, Instruments.CountryCode */
  readonly ipoRangeLow?: Maybe<Scalars['Decimal']['output']>;
  /**
   * This field is deprecated. Please use the LockUpPeriod field in TermsFull instead.
   * @deprecated Use the LockUpPeriod field in TermsFull instead.
   */
  readonly lockUpPeriod?: Maybe<Scalars['Int']['output']>;
  readonly notionalOverAllotmentAuthorized?: Maybe<Scalars['Decimal']['output']>;
  /**
   * This field is deprecated. Please use the NotionalOverAllotmentExercised field in OverAllotmentExercisedFull instead.
   * @deprecated Use the NotionalOverAllotmentExercised field in OverAllotmentExercisedFull instead.
   */
  readonly notionalOverAllotmentExercised?: Maybe<Scalars['Decimal']['output']>;
  readonly numberOfBondsBaseOffering?: Maybe<Scalars['Long']['output']>;
  readonly numberOfBondsOverAllotmentAuthorized?: Maybe<Scalars['Long']['output']>;
  readonly offerPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly parValue?: Maybe<Scalars['Decimal']['output']>;
  readonly postOfferingShares?: Maybe<Scalars['Long']['output']>;
  readonly premium?: Maybe<Scalars['Decimal']['output']>;
  readonly premiumTalkHigh?: Maybe<Scalars['Decimal']['output']>;
  readonly premiumTalkLow?: Maybe<Scalars['Decimal']['output']>;
  readonly priceAsOfPar?: Maybe<Scalars['Decimal']['output']>;
  readonly primarySharesBaseOffering?: Maybe<Scalars['Long']['output']>;
  readonly primarySharesOverAllotmentAuthorized?: Maybe<Scalars['Long']['output']>;
  /**
   * This field is deprecated. Please use the PrimarySharesOverAllotmentExercised field in OverAllotmentExercisedFull instead.
   * @deprecated Use the PrimarySharesOverAllotmentExercised field in OverAllotmentExercisedFull instead
   */
  readonly primarySharesOverAllotmentExercised?: Maybe<Scalars['Long']['output']>;
  readonly proceedsBaseOffering?: Maybe<Scalars['Decimal']['output']>;
  readonly proceedsOverAllotmentAuthorized?: Maybe<Scalars['Decimal']['output']>;
  readonly secondarySharesBaseOffering?: Maybe<Scalars['Long']['output']>;
  readonly secondarySharesOverAllotmentAuthorized?: Maybe<Scalars['Long']['output']>;
  /**
   * This field is deprecated. Please use the SecondarySharesOverAllotmentExercised field in OverAllotmentExercisedFull instead.
   * @deprecated Use the SecondarySharesOverAllotmentExercised field in OverAllotmentExercisedFull instead.
   */
  readonly secondarySharesOverAllotmentExercised?: Maybe<Scalars['Long']['output']>;
  readonly sizeInCurrency?: Maybe<Scalars['Decimal']['output']>;
  readonly totalSharesBaseOffering?: Maybe<Scalars['Long']['output']>;
  readonly totalSharesOverAllotmentAuthorized?: Maybe<Scalars['Long']['output']>;
  readonly totalSharesOverAllotmentExercised?: Maybe<Scalars['Long']['output']>;
  /**
   * This field is deprecated. Please use the UseOfProceeds field in TermsFull instead.
   * @deprecated Use the UseOfProceeds field in TermsFull instead.
   */
  readonly useOfProceeds?: Maybe<ReadonlyArray<UseOfProceeds>>;
};

export type FilingFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<FilingFullFilterInput>>;
  readonly conversionPrice?: InputMaybe<DecimalOperationFilterInput>;
  readonly coupon?: InputMaybe<DecimalOperationFilterInput>;
  readonly couponTalkHigh?: InputMaybe<DecimalOperationFilterInput>;
  readonly couponTalkLow?: InputMaybe<DecimalOperationFilterInput>;
  readonly effectiveConversionPremium?: InputMaybe<DecimalOperationFilterInput>;
  readonly effectiveConversionPrice?: InputMaybe<DecimalOperationFilterInput>;
  readonly filingType?: InputMaybe<FilingTypeFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly initialConversionRatio?: InputMaybe<DecimalOperationFilterInput>;
  readonly initialRegistrationValue?: InputMaybe<DecimalOperationFilterInput>;
  readonly ipoRangeHigh?: InputMaybe<DecimalOperationFilterInput>;
  readonly ipoRangeLow?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * This field is deprecated. Please use the LockUpPeriod field in TermsFull instead.
   * @deprecated Use the LockUpPeriod field in TermsFull instead.
   */
  readonly lockUpPeriod?: InputMaybe<IntOperationFilterInput>;
  readonly notionalOverAllotmentAuthorized?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * This field is deprecated. Please use the NotionalOverAllotmentExercised field in OverAllotmentExercisedFull instead.
   * @deprecated Use the NotionalOverAllotmentExercised field in OverAllotmentExercisedFull instead.
   */
  readonly notionalOverAllotmentExercised?: InputMaybe<DecimalOperationFilterInput>;
  readonly numberOfBondsBaseOffering?: InputMaybe<LongOperationFilterInput>;
  readonly numberOfBondsOverAllotmentAuthorized?: InputMaybe<LongOperationFilterInput>;
  readonly offerPrice?: InputMaybe<DecimalOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<FilingFullFilterInput>>;
  readonly parValue?: InputMaybe<DecimalOperationFilterInput>;
  readonly postOfferingShares?: InputMaybe<LongOperationFilterInput>;
  readonly premium?: InputMaybe<DecimalOperationFilterInput>;
  readonly premiumTalkHigh?: InputMaybe<DecimalOperationFilterInput>;
  readonly premiumTalkLow?: InputMaybe<DecimalOperationFilterInput>;
  readonly priceAsOfPar?: InputMaybe<DecimalOperationFilterInput>;
  readonly primarySharesBaseOffering?: InputMaybe<LongOperationFilterInput>;
  readonly primarySharesOverAllotmentAuthorized?: InputMaybe<LongOperationFilterInput>;
  /**
   * This field is deprecated. Please use the PrimarySharesOverAllotmentExercised field in OverAllotmentExercisedFull instead.
   * @deprecated Use the PrimarySharesOverAllotmentExercised field in OverAllotmentExercisedFull instead
   */
  readonly primarySharesOverAllotmentExercised?: InputMaybe<LongOperationFilterInput>;
  readonly proceedsBaseOffering?: InputMaybe<DecimalOperationFilterInput>;
  readonly proceedsOverAllotmentAuthorized?: InputMaybe<DecimalOperationFilterInput>;
  readonly secondarySharesBaseOffering?: InputMaybe<LongOperationFilterInput>;
  readonly secondarySharesOverAllotmentAuthorized?: InputMaybe<LongOperationFilterInput>;
  /**
   * This field is deprecated. Please use the SecondarySharesOverAllotmentExercised field in OverAllotmentExercisedFull instead.
   * @deprecated Use the SecondarySharesOverAllotmentExercised field in OverAllotmentExercisedFull instead.
   */
  readonly secondarySharesOverAllotmentExercised?: InputMaybe<LongOperationFilterInput>;
  readonly sizeInCurrency?: InputMaybe<DecimalOperationFilterInput>;
  readonly totalSharesBaseOffering?: InputMaybe<LongOperationFilterInput>;
  readonly totalSharesOverAllotmentAuthorized?: InputMaybe<LongOperationFilterInput>;
  readonly totalSharesOverAllotmentExercised?: InputMaybe<LongOperationFilterInput>;
  /**
   * This field is deprecated. Please use the UseOfProceeds field in TermsFull instead.
   * @deprecated Use the UseOfProceeds field in TermsFull instead.
   */
  readonly useOfProceeds?: InputMaybe<UseOfProceedsListFilterInput>;
};

export type FilingLastCommonValues = {
  readonly __typename?: 'FilingLastCommonValues';
  readonly contactName?: Maybe<Scalars['String']['output']>;
  readonly contactTitle?: Maybe<Scalars['String']['output']>;
  readonly emailAddress?: Maybe<Scalars['String']['output']>;
  readonly firmCrdNumber?: Maybe<Scalars['String']['output']>;
  readonly firmMpid?: Maybe<Scalars['String']['output']>;
  readonly firmName?: Maybe<Scalars['String']['output']>;
  readonly issuerSymbol?: Maybe<Scalars['String']['output']>;
  readonly telephoneNumber?: Maybe<Scalars['String']['output']>;
};

export type FilingProfile = {
  readonly __typename?: 'FilingProfile';
  readonly conversionPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly coupon?: Maybe<Scalars['Decimal']['output']>;
  readonly couponTalkHigh?: Maybe<Scalars['Decimal']['output']>;
  readonly couponTalkLow?: Maybe<Scalars['Decimal']['output']>;
  readonly effectiveConversionPremium?: Maybe<Scalars['Decimal']['output']>;
  readonly effectiveConversionPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly filingType: FilingType;
  readonly id: Scalars['ID']['output'];
  readonly initialConversionRatio?: Maybe<Scalars['Decimal']['output']>;
  readonly initialRegistrationValue?: Maybe<Scalars['Decimal']['output']>;
  readonly ipoRangeHigh?: Maybe<Scalars['Decimal']['output']>;
  readonly ipoRangeLow?: Maybe<Scalars['Decimal']['output']>;
  /**
   * This field is deprecated. Please use the LockUpPeriod field in Terms instead.
   * @deprecated Use the LockUpPeriod field in Terms instead.
   */
  readonly lockUpPeriod?: Maybe<Scalars['Int']['output']>;
  readonly notionalOverAllotmentAuthorized?: Maybe<Scalars['Decimal']['output']>;
  /**
   * This field is deprecated. Please use the Notional field in OverAllotmentExercisedData instead.
   * @deprecated Use the Notional field in OverAllotmentExercisedData instead.
   */
  readonly notionalOverAllotmentExercised?: Maybe<Scalars['Decimal']['output']>;
  readonly numberOfBondsBaseOffering?: Maybe<Scalars['Long']['output']>;
  readonly numberOfBondsOverAllotmentAuthorized?: Maybe<Scalars['Long']['output']>;
  readonly offerPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly parValue?: Maybe<Scalars['Decimal']['output']>;
  /** Always Null on the FilingProfile type, added here for compatibility with Apollo and Front-end Fragments. */
  readonly postOfferingShares?: Maybe<Scalars['Long']['output']>;
  readonly premium?: Maybe<Scalars['Decimal']['output']>;
  readonly premiumTalkHigh?: Maybe<Scalars['Decimal']['output']>;
  readonly premiumTalkLow?: Maybe<Scalars['Decimal']['output']>;
  readonly priceAsOfPar?: Maybe<Scalars['Decimal']['output']>;
  readonly primarySharesBaseOffering?: Maybe<Scalars['Long']['output']>;
  readonly primarySharesOverAllotmentAuthorized?: Maybe<Scalars['Long']['output']>;
  /**
   * This field is deprecated. Please use the PrimaryShares field in OverAllotmentExercisedData instead.
   * @deprecated Use the PrimaryShares field in OverAllotmentExercisedData instead.
   */
  readonly primarySharesOverAllotmentExercised?: Maybe<Scalars['Long']['output']>;
  readonly proceedsBaseOffering?: Maybe<Scalars['Decimal']['output']>;
  readonly proceedsOverAllotmentAuthorized?: Maybe<Scalars['Decimal']['output']>;
  readonly secondarySharesBaseOffering?: Maybe<Scalars['Long']['output']>;
  readonly secondarySharesOverAllotmentAuthorized?: Maybe<Scalars['Long']['output']>;
  /**
   * This field is deprecated. Please use the SecondaryShares field in OverAllotmentExercisedData instead.
   * @deprecated Use the SecondaryShares field in OverAllotmentExercisedData instead.
   */
  readonly secondarySharesOverAllotmentExercised?: Maybe<Scalars['Long']['output']>;
  readonly totalSharesBaseOffering?: Maybe<Scalars['Long']['output']>;
  readonly totalSharesOverAllotmentAuthorized?: Maybe<Scalars['Long']['output']>;
  readonly totalSharesOverAllotmentExercised?: Maybe<Scalars['Long']['output']>;
  /**
   * This field is deprecated. Please use the UseOfProceeds field in Terms instead.
   * @deprecated Use the UseOfProceeds field in Terms instead.
   */
  readonly useOfProceeds: ReadonlyArray<UseOfProceeds>;
};

export enum FilingStatus {
  Error = 'ERROR',
  MissingResponse = 'MISSING_RESPONSE',
  Processing = 'PROCESSING',
  SubmissionError = 'SUBMISSION_ERROR',
  Submitted = 'SUBMITTED',
}

export enum FilingType {
  Final = 'FINAL',
  Initial = 'INITIAL',
  Revised = 'REVISED',
}

export type FilingTypeFilterInput = {
  readonly eq?: InputMaybe<FilingType>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<FilingType>>>;
  readonly neq?: InputMaybe<FilingType>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<FilingType>>>;
};

export type FinalAllocation = {
  readonly __typename?: 'FinalAllocation';
  readonly acknowledgementStatus: AllocationAcknowledgement;
  readonly auditInfo: AuditInfo;
  readonly id: Scalars['ID']['output'];
  readonly indicationId: Scalars['UUID']['output'];
  readonly investorReply?: Maybe<InvestorReply>;
  readonly shareQuantity?: Maybe<Scalars['Long']['output']>;
  readonly version: Scalars['String']['output'];
};

export type FinalAllocationDiff = IndicationScopedDiffEntry &
  OrderBookDiffEntry & {
    readonly __typename?: 'FinalAllocationDiff';
    readonly authorCmgEntityKey?: Maybe<Scalars['String']['output']>;
    readonly indicationId: Scalars['UUID']['output'];
    readonly investorCmgEntityKey?: Maybe<Scalars['String']['output']>;
    readonly missingFrom: ReadonlyArray<OrderBookNode>;
    readonly presentAt: ReadonlyArray<OrderBookNode>;
    readonly status: AllocationStatus;
    readonly version: Scalars['String']['output'];
  };

export type FinalAllocationUpdateInput = {
  /** The number of shares being allocated. */
  readonly shareQuantity?: InputMaybe<Scalars['Long']['input']>;
};

export type FinalAllocations = {
  readonly __typename?: 'FinalAllocations';
  readonly finalAllocations: ReadonlyArray<FinalAllocation>;
};

export type FinalAllocationsSetCreateInput = {
  readonly allocations?: InputMaybe<ReadonlyArray<AllocationsInput>>;
  readonly draftAllocationsId?: InputMaybe<Scalars['String']['input']>;
};

export type FinalAllocationsUpdateInput = {
  readonly allocations: ReadonlyArray<FinalAllocationsUpdateInputAllocations>;
};

export type FinalAllocationsUpdateInputAllocations = {
  readonly allocation: FinalAllocationUpdateInput;
  readonly indicationId: Scalars['UUID']['input'];
};

export type FinalInstitutionalAllocationSet = {
  readonly __typename?: 'FinalInstitutionalAllocationSet';
  readonly auditInfo: AuditInfo;
  readonly authorCmgEntityKey: Scalars['String']['output'];
  readonly dealLayout: DealLayout;
  readonly id: Scalars['ID']['output'];
  readonly isReleased: Scalars['Boolean']['output'];
  readonly isVisibleToNonSyndicate: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly releaseTimestamp?: Maybe<Scalars['Instant']['output']>;
  readonly shareTimestamp?: Maybe<Scalars['Instant']['output']>;
  readonly status: AllocationStatus;
  /** Total number of final institutional allocations share quantity */
  readonly totalAllocatedShareQuantity: Scalars['Long']['output'];
  readonly version: Scalars['String']['output'];
};

export type FinalInstitutionalAllocationsUpdateResponse = FinalAllocations | ServiceError;

export enum FinraErrorType {
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  Unauthorized = 'UNAUTHORIZED',
}

export type FinraInfo = {
  readonly __typename?: 'FinraInfo';
  readonly crdNumber?: Maybe<Scalars['Long']['output']>;
  readonly displayName?: Maybe<Scalars['String']['output']>;
  readonly mpid?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type FinraManagerSnapshot = {
  readonly __typename?: 'FinraManagerSnapshot';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly firmName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly role: ManagerRole;
};

export type FinraOfferingManager = {
  readonly __typename?: 'FinraOfferingManager';
  readonly affiliates: ReadonlyArray<Affiliate>;
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly finraInfo?: Maybe<FinraInfo>;
  readonly firmCrdNumber?: Maybe<Scalars['String']['output']>;
  readonly firmMpid?: Maybe<Scalars['String']['output']>;
  readonly firmName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
};

export type FinraStatus = {
  readonly __typename?: 'FinraStatus';
  readonly finraErrorCode?: Maybe<FinraErrorType>;
  readonly isFailure: Scalars['Boolean']['output'];
  readonly isSuccess: Scalars['Boolean']['output'];
};

export type Firm = {
  readonly __typename?: 'Firm';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly crd?: Maybe<Scalars['String']['output']>;
  readonly displayName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly mpid?: Maybe<Scalars['String']['output']>;
  readonly ticker?: Maybe<Scalars['String']['output']>;
};

export type FirmAddressFull = {
  readonly __typename?: 'FirmAddressFull';
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly country?: Maybe<Scalars['String']['output']>;
  readonly faxNumber?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  readonly state?: Maybe<Scalars['String']['output']>;
  readonly streetLine1?: Maybe<Scalars['String']['output']>;
  readonly streetLine2?: Maybe<Scalars['String']['output']>;
  readonly streetLine3?: Maybe<Scalars['String']['output']>;
};

export enum FirmAddressType {
  Headquarters = 'HEADQUARTERS',
  Other = 'OTHER',
  Previous = 'PREVIOUS',
}

export enum FirmCertificateSource {
  Cmg = 'CMG',
  Crm = 'CRM',
}

export type FirmCertificates = {
  readonly __typename?: 'FirmCertificates';
  readonly bankInvestorKey?: Maybe<Scalars['String']['output']>;
  readonly certificates: ReadonlyArray<Certificate>;
  readonly crmInvestorId?: Maybe<Scalars['UUID']['output']>;
  readonly firmAddress?: Maybe<Scalars['String']['output']>;
  readonly firmCmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly firmName: Scalars['String']['output'];
  readonly hasRelationship: Scalars['Boolean']['output'];
  readonly lastUpdate?: Maybe<Scalars['Instant']['output']>;
};

export type FirmCertificatesFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<FirmCertificatesFilterInput>>;
  readonly bankInvestorKey?: InputMaybe<StringOperationFilterInput>;
  readonly certificates?: InputMaybe<ListFilterInputTypeOfCertificateFilterInput>;
  readonly crmInvestorId?: InputMaybe<UuidOperationFilterInput>;
  readonly firmAddress?: InputMaybe<StringOperationFilterInput>;
  readonly firmCmgEntityKey?: InputMaybe<CmgEntityKeyFilterInput>;
  readonly firmName?: InputMaybe<StringOperationFilterInput>;
  readonly hasRelationship?: InputMaybe<BooleanOperationFilterInput>;
  readonly lastUpdate?: InputMaybe<InstantOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<FirmCertificatesFilterInput>>;
};

export type FirmCertificatesSortInput = {
  readonly bankInvestorKey?: InputMaybe<SortEnumType>;
  readonly certificate51305131?: InputMaybe<CertificateSort51305131Input>;
  readonly certificateQib?: InputMaybe<CertificateSortQibInput>;
  readonly certificateRegS?: InputMaybe<CertificateSortRegSInput>;
  readonly crmInvestorId?: InputMaybe<SortEnumType>;
  readonly firmAddress?: InputMaybe<SortEnumType>;
  readonly firmCmgEntityKey?: InputMaybe<SortEnumType>;
  readonly firmName?: InputMaybe<SortEnumType>;
  readonly hasRelationship?: InputMaybe<SortEnumType>;
  readonly lastUpdate?: InputMaybe<SortEnumType>;
};

export type FirmDistributionList = {
  readonly __typename?: 'FirmDistributionList';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly distributionEmails: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
};

export type FirmEmployeeFull = {
  readonly __typename?: 'FirmEmployeeFull';
  readonly email: Scalars['String']['output'];
  readonly firmId: Scalars['UUID']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly recordStatus: RolodexRecordStatus;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type FirmEmployeeFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<FirmEmployeeFullFilterInput>>;
  readonly email?: InputMaybe<StringOperationFilterInput>;
  readonly firmId?: InputMaybe<UuidOperationFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly name?: InputMaybe<StringOperationFilterInput>;
  readonly notes?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<FirmEmployeeFullFilterInput>>;
  readonly recordStatus?: InputMaybe<RecordStatusOperationFilterInput>;
  readonly title?: InputMaybe<StringOperationFilterInput>;
};

export type FirmEmployeeFullSortInput = {
  readonly email?: InputMaybe<SortEnumType>;
  readonly firmId?: InputMaybe<SortEnumType>;
  readonly id?: InputMaybe<SortEnumType>;
  readonly name?: InputMaybe<SortEnumType>;
  readonly notes?: InputMaybe<SortEnumType>;
  readonly recordStatus?: InputMaybe<SortEnumType>;
  readonly title?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type FirmEmployeesCollectionSegment = {
  readonly __typename?: 'FirmEmployeesCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<FirmEmployeeFull>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type FirmFull = {
  readonly __typename?: 'FirmFull';
  readonly attestationCertificates: ReadonlyArray<Certificate>;
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly employees: ReadonlyArray<FirmEmployeeFull>;
  readonly id: Scalars['UUID']['output'];
  readonly indicationManagers: ReadonlyArray<User>;
  readonly investorFirmRelationship: ReadonlyArray<InvestorFirmRelationshipFull>;
  readonly isOnPlatform: Scalars['Boolean']['output'];
  readonly linkageSummary?: Maybe<LinkageSummary>;
  readonly profile?: Maybe<FirmProfileFull>;
};

export type FirmFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<FirmFullFilterInput>>;
  readonly cmgEntityKey?: InputMaybe<StringOperationFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<FirmFullFilterInput>>;
};

export type FirmFullSortInput = {
  readonly cmgEntityKey?: InputMaybe<SortEnumType>;
  readonly id?: InputMaybe<SortEnumType>;
};

export enum FirmIndustryType {
  /** Arbitrage */
  Ar = 'AR',
  /** Bank Investment Division */
  Bm = 'BM',
  /** Broker */
  Br = 'BR',
  /** Corporate */
  Cp = 'CP',
  /** Custodial */
  Cu = 'CU',
  /** Fund of Funds Manager */
  Ff = 'FF',
  /** Fund of Hedge Funds Manager */
  Fh = 'FH',
  /** Foundation/Endowment Manager */
  Fo = 'FO',
  /** Fund Distributor */
  Fs = 'FS',
  /** Fund */
  Fu = 'FU',
  /** Family Office */
  Fy = 'FY',
  /** Govt (Fed/Local/Agency) */
  Gv = 'GV',
  /** Hedge Fund Manager */
  Hf = 'HF',
  /** Investment Adviser */
  Ia = 'IA',
  /** Investment Banking */
  Ib = 'IB',
  /** Investment Company */
  Ic = 'IC',
  /** Insurance Company */
  In = 'IN',
  /** Mutual Fund Manager */
  Mf = 'MF',
  /** Master Ltd Part */
  Ml = 'ML',
  /** Market Maker */
  Mm = 'MM',
  /** Private Banking/Wealth Mgmt */
  Pb = 'PB',
  /** Pension Fund Manager */
  Pf = 'PF',
  /** Real Estate Manager */
  Pp = 'PP',
  /** Research Firm */
  Re = 'RE',
  /** Subsidiary Branch */
  Sb = 'SB',
  /** Stock Borrowing/Lending */
  St = 'ST',
  /** Sovereign Wealth Manager */
  Sv = 'SV',
  /** Venture Capital/Pvt Equity */
  Vc = 'VC',
}

export type FirmInfo = {
  readonly __typename?: 'FirmInfo';
  readonly firmDisplayName?: Maybe<Scalars['String']['output']>;
  readonly firmKey: Scalars['String']['output'];
  readonly firmName: Scalars['String']['output'];
  readonly firmNameAbbreviation?: Maybe<Scalars['String']['output']>;
};

export type FirmInfoFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<FirmInfoFilterInput>>;
  readonly firmDisplayName?: InputMaybe<StringOperationFilterInput>;
  readonly firmKey?: InputMaybe<StringOperationFilterInput>;
  readonly firmName?: InputMaybe<StringOperationFilterInput>;
  readonly firmNameAbbreviation?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<FirmInfoFilterInput>>;
};

export type FirmInfoSortInput = {
  readonly firmDisplayName?: InputMaybe<SortEnumType>;
  readonly firmKey?: InputMaybe<SortEnumType>;
  readonly firmName?: InputMaybe<SortEnumType>;
  readonly firmNameAbbreviation?: InputMaybe<SortEnumType>;
};

export enum FirmLegalEntityType {
  /** Asset-Backed */
  Abs = 'ABS',
  /** Aircraft */
  Air = 'AIR',
  /** Business Association (JP) */
  Bas = 'BAS',
  /** Bank Branch */
  Bra = 'BRA',
  /** Consolidated Accounting */
  Cac = 'CAC',
  /** Commodity */
  Cmd = 'CMD',
  /** College/University */
  Col = 'COL',
  /** Corporate Assets */
  Cor = 'COR',
  /** Currency */
  Cur = 'CUR',
  /** Emp Stk Ownership Plan */
  Esp = 'ESP',
  /** Extinct */
  Ext = 'EXT',
  /** Family of Fds (VC/Pvt EQ) */
  Faf = 'FAF',
  /** Foundation/Endowment */
  Fnd = 'FND',
  /** Financing Subsidiary/SPE */
  Fns = 'FNS',
  /** ForEx */
  Frx = 'FRX',
  /** Government */
  Gov = 'GOV',
  /** Hedge Fund */
  Hed = 'HED',
  /** Holding Company */
  Hol = 'HOL',
  /** Index */
  Idx = 'IDX',
  /** Individual */
  Ind = 'IND',
  /** Joint Venture */
  Jvt = 'JVT',
  /** Broadcast Call Sign */
  Med = 'MED',
  /** Mutual Fd-Closed End */
  Muc = 'MUC',
  /** Mutual Fd-ETF */
  Mue = 'MUE',
  /** Mutual Fd-Open End */
  Mut = 'MUT',
  /** Non-Profit Organization */
  Npo = 'NPO',
  /** Operating Division */
  Opd = 'OPD',
  /** Other */
  Oth = 'OTH',
  /** Pension Fund */
  Pef = 'PEF',
  /** Real Property */
  Pro = 'PRO',
  /** Port */
  Prt = 'PRT',
  /** Public Company */
  Pub = 'PUB',
  /** Private Eq Fd/Alt Invt */
  Pvf = 'PVF',
  /** Private Company */
  Pvt = 'PVT',
  /** Ship */
  Shp = 'SHP',
  /** Sovereign Wealth Fund */
  Sov = 'SOV',
  /** Subsidiary */
  Sub = 'SUB',
  /** Trust/Trustee */
  Tru = 'TRU',
  /** Mutual Fd-Unit Invt Tr */
  Uit = 'UIT',
  /** Umbrella Fund */
  Umb = 'UMB',
  /** Venture Capital Fund */
  Ven = 'VEN',
  /** Virtual */
  Vrt = 'VRT',
}

export type FirmLimited = {
  readonly __typename?: 'FirmLimited';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly crd?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly displayName?: Maybe<Scalars['String']['output']>;
  readonly entityType?: Maybe<FirmLegalEntityType>;
  readonly id: Scalars['ID']['output'];
  readonly industryType?: Maybe<FirmIndustryType>;
  readonly isOnPlatform: Scalars['Boolean']['output'];
  readonly mpid?: Maybe<Scalars['String']['output']>;
  readonly roles?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly status: FirmStatus;
};

export type FirmLimitedPagedList = {
  readonly __typename?: 'FirmLimitedPagedList';
  readonly data: ReadonlyArray<FirmLimited>;
  readonly pagination: PaginationData;
};

export type FirmMatchCollectionSegment = {
  readonly __typename?: 'FirmMatchCollectionSegment';
  readonly items?: Maybe<ReadonlyArray<Maybe<AdminFirmMatch>>>;
};

export enum FirmNameType {
  Common = 'COMMON',
  Former = 'FORMER',
  Legal = 'LEGAL',
  Other = 'OTHER',
  Short = 'SHORT',
  TradeDba = 'TRADE_DBA',
}

export type FirmProfileFull = {
  readonly __typename?: 'FirmProfileFull';
  readonly address?: Maybe<FirmAddressFull>;
  readonly cik?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly firmId: Scalars['UUID']['output'];
  readonly lei?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly phone?: Maybe<Scalars['String']['output']>;
};

export enum FirmRoleType {
  Advisor = 'ADVISOR',
  Auditor = 'AUDITOR',
  Counsel = 'COUNSEL',
  Investor = 'INVESTOR',
  Issuer = 'ISSUER',
  Lender = 'LENDER',
  Sponsor = 'SPONSOR',
  Underwriter = 'UNDERWRITER',
}

export type FirmSnapshot = {
  readonly __typename?: 'FirmSnapshot';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly firmName: Scalars['String']['output'];
  readonly offeringManagerRole?: Maybe<SyndicateWiresManagerRole>;
};

export enum FirmSource {
  Cmg = 'CMG',
  CustomerCreated = 'CUSTOMER_CREATED',
  FactSet = 'FACT_SET',
  MorningStar = 'MORNING_STAR',
}

export enum FirmStatus {
  Active = 'ACTIVE',
  Defunct = 'DEFUNCT',
}

/** A segment of a collection. */
export type FirmsCertificatesCollectionSegment = {
  readonly __typename?: 'FirmsCertificatesCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<FirmCertificates>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type FirmsCollectionSegment = {
  readonly __typename?: 'FirmsCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<FirmFull>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type FlagWithNotes = {
  readonly __typename?: 'FlagWithNotes';
  readonly enabled: Scalars['Boolean']['output'];
  readonly notes: Scalars['String']['output'];
};

export type FlagWithNotesFull = {
  readonly __typename?: 'FlagWithNotesFull';
  readonly enabled: Scalars['Boolean']['output'];
  readonly notes: Scalars['String']['output'];
};

export type FlagWithNotesFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<FlagWithNotesFullFilterInput>>;
  readonly enabled?: InputMaybe<BooleanOperationFilterInput>;
  readonly notes?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<FlagWithNotesFullFilterInput>>;
};

export type FlagWithNotesFullInput = {
  readonly enabled: Scalars['Boolean']['input'];
  readonly notes: Scalars['String']['input'];
};

export type FollowOnPricing = {
  readonly __typename?: 'FollowOnPricing';
  readonly id: Scalars['ID']['output'];
  readonly lastTradeBeforeFiling?: Maybe<Scalars['Decimal']['output']>;
  readonly lastTradeBeforeLaunch?: Maybe<Scalars['Decimal']['output']>;
  readonly lastTradeBeforeOffer?: Maybe<Scalars['Decimal']['output']>;
  readonly reOfferHigh?: Maybe<Scalars['Decimal']['output']>;
  readonly reOfferLow?: Maybe<Scalars['Decimal']['output']>;
};

export type FollowOnPricingFull = {
  readonly __typename?: 'FollowOnPricingFull';
  readonly lastTradeBeforeFiling?: Maybe<Scalars['Decimal']['output']>;
  readonly lastTradeBeforeLaunch?: Maybe<Scalars['Decimal']['output']>;
  readonly lastTradeBeforeOffer?: Maybe<Scalars['Decimal']['output']>;
  /** When selecting this field for published offerings, also select the following fields to ensure the field is not needlessly nullified: Status, PricingInstrumentId, Instruments.Id, Instruments.CountryCode */
  readonly reOfferHigh?: Maybe<Scalars['Decimal']['output']>;
  /** When selecting this field for published offerings, also select the following fields to ensure the field is not needlessly nullified: Status, PricingInstrumentId, Instruments.Id, Instruments.CountryCode */
  readonly reOfferLow?: Maybe<Scalars['Decimal']['output']>;
};

export type FollowOnPricingFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<FollowOnPricingFullFilterInput>>;
  readonly lastTradeBeforeFiling?: InputMaybe<DecimalOperationFilterInput>;
  readonly lastTradeBeforeLaunch?: InputMaybe<DecimalOperationFilterInput>;
  readonly lastTradeBeforeOffer?: InputMaybe<DecimalOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<FollowOnPricingFullFilterInput>>;
  readonly reOfferHigh?: InputMaybe<DecimalOperationFilterInput>;
  readonly reOfferLow?: InputMaybe<DecimalOperationFilterInput>;
};

export type FollowOnPricingProfile = {
  readonly __typename?: 'FollowOnPricingProfile';
  readonly lastTradeBeforeFiling?: Maybe<Scalars['Decimal']['output']>;
  readonly lastTradeBeforeLaunch?: Maybe<Scalars['Decimal']['output']>;
  readonly lastTradeBeforeOffer?: Maybe<Scalars['Decimal']['output']>;
  readonly reOfferHigh?: Maybe<Scalars['Decimal']['output']>;
  readonly reOfferLow?: Maybe<Scalars['Decimal']['output']>;
};

export type FreeFormWire = {
  readonly __typename?: 'FreeFormWire';
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['Instant']['output'];
  readonly header: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type FreeFormWireResponseUnion = FreeFormWire | ServiceError;

export type FreeFormWireValidation = WireValidationBase & {
  readonly __typename?: 'FreeFormWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<FreeFormWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum FreeFormWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
}

export type Fund = {
  readonly __typename?: 'Fund';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export type FundAllocation = {
  readonly __typename?: 'FundAllocation';
  readonly fillPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly fundId: Scalars['UUID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly pctOfFirmAllocation?: Maybe<Scalars['Decimal']['output']>;
  readonly shares?: Maybe<Scalars['Long']['output']>;
};

export type FundAllocationInput = {
  readonly fillPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly fundId: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly offeringId?: InputMaybe<Scalars['String']['input']>;
  readonly pctOfFirmAllocation?: InputMaybe<Scalars['Decimal']['input']>;
  readonly shares?: InputMaybe<Scalars['Long']['input']>;
};

export type FundIoi = {
  readonly __typename?: 'FundIoi';
  readonly calculateShares?: Maybe<Scalars['Long']['output']>;
  readonly dollars?: Maybe<Scalars['Decimal']['output']>;
  readonly fundId: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly limitPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly offeringId: Scalars['UUID']['output'];
  readonly percentage?: Maybe<Scalars['Decimal']['output']>;
  readonly pricingType: IoiPricingType;
  readonly realDemandDollars?: Maybe<Scalars['Decimal']['output']>;
  readonly realDemandPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly realDemandShares?: Maybe<Scalars['Long']['output']>;
  readonly shares?: Maybe<Scalars['Long']['output']>;
  readonly unitType: IoiUnitType;
};

export type FundIoiInput = {
  readonly calculateShares?: InputMaybe<Scalars['Decimal']['input']>;
  readonly dollars?: InputMaybe<Scalars['Decimal']['input']>;
  readonly fundId: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly limitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  readonly offeringId?: InputMaybe<Scalars['String']['input']>;
  readonly percentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly pricingType: IoiPricingType;
  readonly realDemandDollars?: InputMaybe<Scalars['Decimal']['input']>;
  readonly realDemandPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly realDemandShares?: InputMaybe<Scalars['Long']['input']>;
  readonly shares?: InputMaybe<Scalars['Long']['input']>;
  readonly unitType: IoiUnitType;
};

export type FundIois = {
  readonly __typename?: 'FundIois';
  readonly allocations: ReadonlyArray<FundAllocation>;
  readonly iois: ReadonlyArray<FundIoi>;
};

export type GreenShoeRecipientData = {
  readonly __typename?: 'GreenShoeRecipientData';
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly recipient: Scalars['String']['output'];
};

export type GreenShoeRecipientInputData = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly recipient: Scalars['String']['input'];
};

export type GreenShoeWire = {
  readonly __typename?: 'GreenShoeWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly id: Scalars['ID']['output'];
  readonly recipientsUserData: ReadonlyArray<GreenShoeRecipientData>;
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

export type GreenShoeWireInput = {
  readonly userDataForRecipients: ReadonlyArray<GreenShoeRecipientInputData>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type GreenShoeWireResponseUnion = GreenShoeWire | ServiceError;

export type GreenShoeWireValidation = WireValidationBase & {
  readonly __typename?: 'GreenShoeWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<GreenShoeWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum GreenShoeWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  Overallotment = 'OVERALLOTMENT',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
}

export enum GridTransitionSalesCreditReleaseStatus {
  BookedManual = 'BOOKED_MANUAL',
  CancelledManual = 'CANCELLED_MANUAL',
  CancelPending = 'CANCEL_PENDING',
  Released = 'RELEASED',
}

export type GrossSpreadBase = {
  readonly __typename?: 'GrossSpreadBase';
  readonly grossSpreadBase?: Maybe<Scalars['Decimal']['output']>;
  readonly grossSpreadBasePercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly managementFee?: Maybe<Scalars['Decimal']['output']>;
  readonly managementFeePercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcessionPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFee?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFeePercentage?: Maybe<Scalars['Decimal']['output']>;
};

export type GrossSpreadBaseFull = {
  readonly __typename?: 'GrossSpreadBaseFull';
  readonly grossSpreadBase?: Maybe<Scalars['Decimal']['output']>;
  readonly grossSpreadBasePercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly managementFee?: Maybe<Scalars['Decimal']['output']>;
  readonly managementFeePercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcessionPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFee?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFeePercentage?: Maybe<Scalars['Decimal']['output']>;
};

export type GrossSpreadBaseFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<GrossSpreadBaseFullFilterInput>>;
  readonly grossSpreadBase?: InputMaybe<DecimalOperationFilterInput>;
  readonly grossSpreadBasePercentage?: InputMaybe<DecimalOperationFilterInput>;
  readonly managementFee?: InputMaybe<DecimalOperationFilterInput>;
  readonly managementFeePercentage?: InputMaybe<DecimalOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<GrossSpreadBaseFullFilterInput>>;
  readonly sellingConcession?: InputMaybe<DecimalOperationFilterInput>;
  readonly sellingConcessionPercentage?: InputMaybe<DecimalOperationFilterInput>;
  readonly underwritingFee?: InputMaybe<DecimalOperationFilterInput>;
  readonly underwritingFeePercentage?: InputMaybe<DecimalOperationFilterInput>;
};

export type Group = {
  readonly __typename?: 'Group';
  readonly count: Scalars['Int']['output'];
  readonly groupKey?: Maybe<Scalars['String']['output']>;
};

export type HouseAccount = {
  readonly __typename?: 'HouseAccount';
  readonly bankInvestorKey?: Maybe<Scalars['String']['output']>;
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly firmId: Scalars['UUID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly investorAddress?: Maybe<Scalars['String']['output']>;
  readonly investorFirmName: Scalars['String']['output'];
};

export enum IdentityJobFunction {
  Administrator = 'ADMINISTRATOR',
  Analyst = 'ANALYST',
  Assistant = 'ASSISTANT',
  Ecm = 'ECM',
  EcmSurveillance = 'ECM_SURVEILLANCE',
  Invalid = 'INVALID',
  LegalCompliance = 'LEGAL_COMPLIANCE',
  Other = 'OTHER',
  PortfolioManager = 'PORTFOLIO_MANAGER',
  ProductControl = 'PRODUCT_CONTROL',
  Sales = 'SALES',
  SalesSupervisor = 'SALES_SUPERVISOR',
  SalesTrader = 'SALES_TRADER',
  SalesTraderSupervisor = 'SALES_TRADER_SUPERVISOR',
  Support = 'SUPPORT',
  Syndicate = 'SYNDICATE',
  SyndicateAccounting = 'SYNDICATE_ACCOUNTING',
  SyndicateOperations = 'SYNDICATE_OPERATIONS',
  Technology = 'TECHNOLOGY',
  Trader = 'TRADER',
}

export type ImportWallCrossInvestorInput = {
  readonly communicationLogs?: InputMaybe<
    ReadonlyArray<WallCrossInvestorCommunicationLogImportDataInput>
  >;
  readonly indication?: InputMaybe<WallCrossIndicationDataInput>;
  readonly investor: WallCrossInvestorDataInput;
  readonly investorId: InvestorInformationInput;
  readonly offeringId: Scalars['ID']['input'];
  readonly ownerCmgEntityKey?: InputMaybe<Scalars['String']['input']>;
};

export type ImportWallCrossInvestorPayload = {
  readonly __typename?: 'ImportWallCrossInvestorPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

export type IncentiveFee = {
  readonly __typename?: 'IncentiveFee';
  readonly incentiveFee?: Maybe<Scalars['Decimal']['output']>;
  readonly incentiveFeePercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly managementFee?: Maybe<Scalars['Decimal']['output']>;
  readonly managementFeePercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcessionPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFee?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFeePercentage?: Maybe<Scalars['Decimal']['output']>;
};

export type IncentiveFeeFull = {
  readonly __typename?: 'IncentiveFeeFull';
  readonly incentiveFee?: Maybe<Scalars['Decimal']['output']>;
  readonly incentiveFeePercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly managementFee?: Maybe<Scalars['Decimal']['output']>;
  readonly managementFeePercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcessionPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFee?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFeePercentage?: Maybe<Scalars['Decimal']['output']>;
};

export type IncentiveFeeFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<IncentiveFeeFullFilterInput>>;
  readonly incentiveFee?: InputMaybe<DecimalOperationFilterInput>;
  readonly incentiveFeePercentage?: InputMaybe<DecimalOperationFilterInput>;
  readonly managementFee?: InputMaybe<DecimalOperationFilterInput>;
  readonly managementFeePercentage?: InputMaybe<DecimalOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<IncentiveFeeFullFilterInput>>;
  readonly sellingConcession?: InputMaybe<DecimalOperationFilterInput>;
  readonly sellingConcessionPercentage?: InputMaybe<DecimalOperationFilterInput>;
  readonly underwritingFee?: InputMaybe<DecimalOperationFilterInput>;
  readonly underwritingFeePercentage?: InputMaybe<DecimalOperationFilterInput>;
};

export type IndicationAcknowledgement = {
  readonly __typename?: 'IndicationAcknowledgement';
  readonly isRevised: Scalars['Boolean']['output'];
  readonly manager: FirmInfo;
};

export type IndicationAcknowledgementDiff = IndicationScopedDiffEntry &
  OrderBookDiffEntry & {
    readonly __typename?: 'IndicationAcknowledgementDiff';
    readonly authorCmgEntityKey?: Maybe<Scalars['String']['output']>;
    readonly indicationId: Scalars['UUID']['output'];
    readonly indicationVersion: Scalars['String']['output'];
    readonly investorCmgEntityKey?: Maybe<Scalars['String']['output']>;
    readonly managerCmgEntityKey: Scalars['String']['output'];
    readonly missingFrom: ReadonlyArray<OrderBookNode>;
    readonly presentAt: ReadonlyArray<OrderBookNode>;
    readonly version: Scalars['String']['output'];
  };

export type IndicationAcknowledgementDtoFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<IndicationAcknowledgementDtoFilterInput>>;
  readonly isRevised?: InputMaybe<BooleanOperationFilterInput>;
  readonly manager?: InputMaybe<FirmInfoFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<IndicationAcknowledgementDtoFilterInput>>;
};

export type IndicationAttestation = {
  readonly __typename?: 'IndicationAttestation';
  readonly certificateType: CertificateType;
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly status: AttestationFormStatus;
};

export type IndicationChanged = {
  readonly __typename?: 'IndicationChanged';
  readonly batchId?: Maybe<Scalars['UUID']['output']>;
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly indicationId: Scalars['UUID']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly principalId: Scalars['UUID']['output'];
  readonly source: OrdersGridChangeSource;
  readonly timestamp: Scalars['DateTime']['output'];
  readonly version: Scalars['String']['output'];
};

export type IndicationDetail = {
  readonly __typename?: 'IndicationDetail';
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  readonly interestLevels?: Maybe<ReadonlyArray<InterestLevelDetail>>;
  readonly status?: Maybe<IndicationStatus>;
};

export type IndicationDiff = IndicationScopedDiffEntry &
  OrderBookDiffEntry & {
    readonly __typename?: 'IndicationDiff';
    readonly authorCmgEntityKey?: Maybe<Scalars['String']['output']>;
    readonly indicationId: Scalars['UUID']['output'];
    readonly investorCmgEntityKey?: Maybe<Scalars['String']['output']>;
    readonly missingFrom: ReadonlyArray<OrderBookNode>;
    readonly presentAt: ReadonlyArray<OrderBookNode>;
    readonly version: Scalars['String']['output'];
  };

export enum IndicationNoteType {
  SalesAndTradingNote = 'SALES_AND_TRADING_NOTE',
  SalesContactNote = 'SALES_CONTACT_NOTE',
  SalesDepartmentNote = 'SALES_DEPARTMENT_NOTE',
  SyndicateNote = 'SYNDICATE_NOTE',
}

export type IndicationNotes = {
  readonly __typename?: 'IndicationNotes';
  readonly salesAndTrading?: Maybe<Scalars['String']['output']>;
  readonly salesContact?: Maybe<Scalars['String']['output']>;
  readonly salesDepartment?: Maybe<Scalars['String']['output']>;
  readonly syndicate?: Maybe<Scalars['String']['output']>;
};

export type IndicationNotesFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<IndicationNotesFilterInput>>;
  readonly or?: InputMaybe<ReadonlyArray<IndicationNotesFilterInput>>;
  readonly salesAndTrading?: InputMaybe<StringOperationFilterInput>;
  readonly salesContact?: InputMaybe<StringOperationFilterInput>;
  readonly salesDepartment?: InputMaybe<StringOperationFilterInput>;
  readonly syndicate?: InputMaybe<StringOperationFilterInput>;
};

export type IndicationNotesSortInput = {
  readonly salesAndTrading?: InputMaybe<SortEnumType>;
  readonly salesContact?: InputMaybe<SortEnumType>;
  readonly salesDepartment?: InputMaybe<SortEnumType>;
  readonly syndicate?: InputMaybe<SortEnumType>;
};

export type IndicationScopedDiffEntry = {
  readonly authorCmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly indicationId: Scalars['UUID']['output'];
  readonly investorCmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly missingFrom: ReadonlyArray<OrderBookNode>;
  readonly presentAt: ReadonlyArray<OrderBookNode>;
  readonly version: Scalars['String']['output'];
};

export type IndicationSelectionInput = {
  readonly indicationIds?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  readonly mode: IndicationSelectionMode;
};

export enum IndicationSelectionMode {
  All = 'ALL',
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE',
}

export enum IndicationStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Duplicate = 'DUPLICATE',
}

export type IndicationStatusFilterInput = {
  readonly eq?: InputMaybe<IndicationStatus>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<IndicationStatus>>>;
  readonly neq?: InputMaybe<IndicationStatus>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<IndicationStatus>>>;
};

export type IndicationTrade = {
  readonly __typename?: 'IndicationTrade';
  readonly createdAt: Scalars['Instant']['output'];
  readonly createdByUserName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly statusDetails?: Maybe<Scalars['String']['output']>;
  readonly tradeId: Scalars['UUID']['output'];
  readonly tradeStatus: ReleaseStatus;
  readonly tradeVersion: Scalars['String']['output'];
};

export type IndicationTypeOperationFilterInput = {
  readonly eq?: InputMaybe<InstitutionalIndicationOrderType>;
  readonly in?: InputMaybe<ReadonlyArray<InstitutionalIndicationOrderType>>;
  readonly neq?: InputMaybe<InstitutionalIndicationOrderType>;
  readonly nin?: InputMaybe<ReadonlyArray<InstitutionalIndicationOrderType>>;
};

export type InstantOperationFilterInput = {
  readonly eq?: InputMaybe<Scalars['Instant']['input']>;
  readonly gt?: InputMaybe<Scalars['Instant']['input']>;
  readonly gte?: InputMaybe<Scalars['Instant']['input']>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Instant']['input']>>>;
  readonly lt?: InputMaybe<Scalars['Instant']['input']>;
  readonly lte?: InputMaybe<Scalars['Instant']['input']>;
  readonly neq?: InputMaybe<Scalars['Instant']['input']>;
  readonly ngt?: InputMaybe<Scalars['Instant']['input']>;
  readonly ngte?: InputMaybe<Scalars['Instant']['input']>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Instant']['input']>>>;
  readonly nlt?: InputMaybe<Scalars['Instant']['input']>;
  readonly nlte?: InputMaybe<Scalars['Instant']['input']>;
};

export type InstitutionalDemandSummaryMetrics = {
  readonly __typename?: 'InstitutionalDemandSummaryMetrics';
  readonly averageAllocation: Scalars['Decimal']['output'];
  readonly averageDemand: Scalars['Decimal']['output'];
  readonly averageDemandNotional: Scalars['Decimal']['output'];
  readonly fillRate: Scalars['Decimal']['output'];
  readonly limitToMarketRatio: Scalars['Decimal']['output'];
  readonly marketToLimitRatio: Scalars['Decimal']['output'];
  readonly subscription: Scalars['Decimal']['output'];
  readonly totalActiveNonPassIndicationCount: Scalars['Int']['output'];
  readonly totalAllocatedShares: Scalars['Long']['output'];
  readonly totalAllocationCount: Scalars['Int']['output'];
  readonly totalDemand: Scalars['Long']['output'];
  readonly totalDemandNotional: Scalars['Decimal']['output'];
};

export type InstitutionalIndication = {
  readonly __typename?: 'InstitutionalIndication';
  readonly attestationStatus?: Maybe<AttestationStatus>;
  readonly auditInfo: AuditInfo;
  readonly billingAndDeliveryAgentCmgEntityKey?: Maybe<Scalars['String']['output']>;
  /** The list of CMG Entity Keys for Managers that cover the Investor. */
  readonly coveringManagerCmgEntityKeys: ReadonlyArray<Scalars['String']['output']>;
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  /** For a surviving indication, this property contains the IDs of its duplicate indications */
  readonly duplicateIndicationIds: ReadonlyArray<Scalars['UUID']['output']>;
  /** For a duplicate indication, this property contains the indicationId of the surviving order */
  readonly duplicateOfIndicationId?: Maybe<Scalars['UUID']['output']>;
  /** Returns a Final Allocation for an Institutional Indication */
  readonly finalAllocation?: Maybe<FinalAllocation>;
  readonly id: Scalars['ID']['output'];
  /** An Instrument ID will not be present for Investors who have Passed on the offering. */
  readonly instrumentId?: Maybe<Scalars['UUID']['output']>;
  /** The demand expression of the indication. */
  readonly interestLevels: ReadonlyArray<InterestLevel>;
  /** Investor information fields capture buy-side information. */
  readonly investorInformation: InvestorInformation;
  readonly investorProspectusDeliveryStatus?: Maybe<InvestorDeliveryStatus>;
  /**
   * Describe if this Indication has been marked as a duplicate of another Indication.
   * Use `Status` instead.
   * @deprecated Deprecated. Use `status` instead.
   */
  readonly isMarkedAsDuplicate: Scalars['Boolean']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly status: IndicationStatus;
  /** The CMG entity key for the specific manager submitting this indication. */
  readonly submittedByCmgEntityKey: Scalars['String']['output'];
  /** A Tranche ID will not be present for Investors who have Passed on the offering. */
  readonly trancheId?: Maybe<Scalars['UUID']['output']>;
  readonly type: InstitutionalIndicationOrderType;
  readonly version: Scalars['String']['output'];
};

export type InstitutionalIndicationAcknowledgement = {
  readonly __typename?: 'InstitutionalIndicationAcknowledgement';
  readonly acknowledgedIndicationVersion: Scalars['String']['output'];
  readonly auditInfo: AuditInfo;
  readonly id: Scalars['ID']['output'];
  readonly indicationId: Scalars['UUID']['output'];
  readonly indicationVersion: Scalars['String']['output'];
  readonly managerCmgEntityKey: Scalars['String']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly version: Scalars['String']['output'];
};

export type InstitutionalIndicationAssignDupesInput = {
  readonly markAsDuplicateIds: ReadonlyArray<Scalars['UUID']['input']>;
  readonly survivorId: Scalars['UUID']['input'];
};

export type InstitutionalIndicationListFiltersInput = {
  readonly cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  readonly status?: InputMaybe<IndicationStatus>;
  readonly type?: InputMaybe<InstitutionalIndicationOrderType>;
};

/** This is a derived attribute for DTO's to help filter what kind of demand categories this indication falls into. */
export enum InstitutionalIndicationOrderType {
  Interested = 'INTERESTED',
  Limit = 'LIMIT',
  Market = 'MARKET',
  Pass = 'PASS',
  Scaled = 'SCALED',
}

export type InstitutionalIndicationSubmitInput = {
  readonly currencyCode?: InputMaybe<Scalars['String']['input']>;
  readonly instrumentId?: InputMaybe<Scalars['UUID']['input']>;
  /** The demand expression of the indication. */
  readonly interestLevels: ReadonlyArray<InterestLevelInput>;
  /** Investor information fields must be populated to capture buy-side information. */
  readonly investorInformation?: InputMaybe<InvestorInformationInput>;
  readonly trancheId: Scalars['UUID']['input'];
};

export type InstitutionalIndicationSubmitResponse = InstitutionalIndication | ServiceError;

export type InstitutionalIndicationTimelineActor = {
  readonly __typename?: 'InstitutionalIndicationTimelineActor';
  readonly actorFirmKey?: Maybe<Scalars['String']['output']>;
  readonly createdByAccountId: Scalars['UUID']['output'];
  readonly tenantSubdomain?: Maybe<Scalars['String']['output']>;
};

export type InstitutionalIndicationTimelineData = {
  readonly __typename?: 'InstitutionalIndicationTimelineData';
  readonly timelineEvents: ReadonlyArray<InstitutionalIndicationTimelineEvent>;
};

export type InstitutionalIndicationTimelineEvent = {
  readonly __typename?: 'InstitutionalIndicationTimelineEvent';
  readonly actor: InstitutionalIndicationTimelineActor;
  readonly eventType: OfferingDashboardOrderBookIndicationTimelineEventType;
  readonly indicationId: Scalars['UUID']['output'];
  readonly newValue?: Maybe<Scalars['Any']['output']>;
  readonly oldValue?: Maybe<Scalars['Any']['output']>;
  readonly timestamp: Scalars['DateTime']['output'];
  readonly version: Scalars['String']['output'];
};

export type InstitutionalIndicationUpdateInput = {
  readonly currencyCode?: InputMaybe<Scalars['String']['input']>;
  readonly instrumentId?: InputMaybe<Scalars['UUID']['input']>;
  /** The demand expression of the indication. */
  readonly interestLevels: ReadonlyArray<InterestLevelInput>;
  readonly investorInformation?: InputMaybe<InvestorInformationInput>;
};

export type InstitutionalIndicationUpdateResponse = InstitutionalIndication | ServiceError;

export type InstitutionalIndicationVersion = {
  readonly __typename?: 'InstitutionalIndicationVersion';
  readonly auditInfo: AuditInfo;
  /** The list of CMG Entity Keys for Managers that cover the Investor. */
  readonly coveringManagerCmgEntityKeys: ReadonlyArray<Scalars['String']['output']>;
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  /**
   * For a surviving indication, this property contains the IDs of its duplicate indications
   * @deprecated Deprecated. This property will be removed in the future.
   */
  readonly duplicateIndicationIds: ReadonlyArray<Scalars['UUID']['output']>;
  /** For a duplicate indication, this property contains the indicationId of the surviving order */
  readonly duplicateOfIndicationId?: Maybe<Scalars['UUID']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly indicationId: Scalars['UUID']['output'];
  /** An Instrument ID will not be present for Investors who have Passed on the offering. */
  readonly instrumentId?: Maybe<Scalars['UUID']['output']>;
  /** The demand expression of the indication. */
  readonly interestLevels: ReadonlyArray<InterestLevel>;
  /** Investor information fields capture buy-side information. */
  readonly investorInformation: InvestorInformation;
  readonly isBuySideRevision: Scalars['Boolean']['output'];
  /**
   * Describe if this Indication has been marked as a duplicate of another Indication.
   * Use `Status` instead.
   * @deprecated Deprecated. Use `status` instead.
   */
  readonly isMarkedAsDuplicate: Scalars['Boolean']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly recordStatus: OrderBookRecordStatus;
  readonly status: IndicationStatus;
  /** The CMG entity key for the specific manager submitting this indication. */
  readonly submittedByCmgEntityKey: Scalars['String']['output'];
  readonly tranche?: Maybe<TranchePrivileged>;
  /** A Tranche ID will not be present for Investors who have Passed on the offering. */
  readonly trancheId?: Maybe<Scalars['UUID']['output']>;
  readonly type: InstitutionalIndicationOrderType;
  readonly version: Scalars['String']['output'];
};

export type InstrumentFull = {
  readonly __typename?: 'InstrumentFull';
  readonly countryCode?: Maybe<Scalars['String']['output']>;
  readonly countryDisplayName?: Maybe<Scalars['String']['output']>;
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  readonly cusip?: Maybe<Scalars['String']['output']>;
  readonly depositaryReceiptConversionRatioDenominator?: Maybe<Scalars['Int']['output']>;
  readonly depositaryReceiptConversionRatioNumerator?: Maybe<Scalars['Int']['output']>;
  readonly exchangeMic?: Maybe<ExchangeMic>;
  /** Display name for ExchangeMic */
  readonly exchangeMicDisplayName?: Maybe<Scalars['String']['output']>;
  readonly figi?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isDepositaryReceipt?: Maybe<Scalars['Boolean']['output']>;
  readonly isin?: Maybe<Scalars['String']['output']>;
  readonly lastTradeBeforeFiling?: Maybe<Scalars['Decimal']['output']>;
  readonly lastTradeBeforeLaunch?: Maybe<Scalars['Decimal']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly rank?: Maybe<Rank>;
  readonly referencePrice?: Maybe<Scalars['Decimal']['output']>;
  readonly region?: Maybe<Scalars['String']['output']>;
  readonly sellingRestrictions?: Maybe<SellingRestrictions>;
  /** Display name for SellingRestrictions */
  readonly sellingRestrictionsDisplayName?: Maybe<Scalars['String']['output']>;
  readonly stockSymbol?: Maybe<Scalars['String']['output']>;
  readonly underlyingCurrencyCode?: Maybe<Scalars['String']['output']>;
  readonly underlyingExchangeMic?: Maybe<ExchangeMic>;
  /** Display name for UnderlyingExchangeMic */
  readonly underlyingExchangeMicDisplayName?: Maybe<Scalars['String']['output']>;
  readonly underlyingStockSymbol?: Maybe<Scalars['String']['output']>;
};

export type InstrumentFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<InstrumentFullFilterInput>>;
  readonly countryCode?: InputMaybe<StringOperationFilterInput>;
  readonly countryDisplayName?: InputMaybe<StringOperationFilterInput>;
  readonly currencyCode?: InputMaybe<StringOperationFilterInput>;
  readonly cusip?: InputMaybe<StringOperationFilterInput>;
  readonly depositaryReceiptConversionRatioDenominator?: InputMaybe<IntOperationFilterInput>;
  readonly depositaryReceiptConversionRatioNumerator?: InputMaybe<IntOperationFilterInput>;
  readonly exchangeMic?: InputMaybe<OfferingSetupExchangeMicFilterInput>;
  readonly figi?: InputMaybe<StringOperationFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly isDepositaryReceipt?: InputMaybe<BooleanOperationFilterInput>;
  readonly isin?: InputMaybe<StringOperationFilterInput>;
  readonly lastTradeBeforeFiling?: InputMaybe<DecimalOperationFilterInput>;
  readonly lastTradeBeforeLaunch?: InputMaybe<DecimalOperationFilterInput>;
  readonly name?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<InstrumentFullFilterInput>>;
  readonly rank?: InputMaybe<NullableOfRankOperationFilterInput>;
  readonly referencePrice?: InputMaybe<DecimalOperationFilterInput>;
  readonly region?: InputMaybe<StringOperationFilterInput>;
  readonly sellingRestrictions?: InputMaybe<SellingRestrictionsFilterInput>;
  readonly stockSymbol?: InputMaybe<StringOperationFilterInput>;
  readonly underlyingCurrencyCode?: InputMaybe<StringOperationFilterInput>;
  readonly underlyingExchangeMic?: InputMaybe<OfferingSetupExchangeMicFilterInput>;
  readonly underlyingStockSymbol?: InputMaybe<StringOperationFilterInput>;
};

export type InstrumentOrderEntryProfile = {
  readonly __typename?: 'InstrumentOrderEntryProfile';
  readonly countryCode?: Maybe<Scalars['String']['output']>;
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isDepositaryReceipt: Scalars['Boolean']['output'];
  readonly stockSymbol?: Maybe<Scalars['String']['output']>;
};

export type IntOperationFilterInput = {
  readonly eq?: InputMaybe<Scalars['Int']['input']>;
  readonly gt?: InputMaybe<Scalars['Int']['input']>;
  readonly gte?: InputMaybe<Scalars['Int']['input']>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']['input']>>>;
  readonly lt?: InputMaybe<Scalars['Int']['input']>;
  readonly lte?: InputMaybe<Scalars['Int']['input']>;
  readonly neq?: InputMaybe<Scalars['Int']['input']>;
  readonly ngt?: InputMaybe<Scalars['Int']['input']>;
  readonly ngte?: InputMaybe<Scalars['Int']['input']>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']['input']>>>;
  readonly nlt?: InputMaybe<Scalars['Int']['input']>;
  readonly nlte?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A specification of demand using a given unit and quantity combination.
 * Limit Prices are optional, and if not supplied, are considered market price.
 * Interests with a Price Limit are considered Limit Interests.
 */
export type InterestLevel = {
  readonly __typename?: 'InterestLevel';
  /** Percentage value that can only be provided for Convertible Offerings */
  readonly coupon?: Maybe<Scalars['Decimal']['output']>;
  /**
   * The InterestQuantity must be a positive non-zero number.
   * When indicating with InterestUnit of PERCENT, quantity value must be represented as a decimal representations (not whole number).
   * For example, 0.5 means 50%.
   */
  readonly interestQuantity: Scalars['Decimal']['output'];
  readonly interestUnit: InterestLevelInterestUnit;
  /**
   * The LimitPrice is considered in conjunction with LimitType.
   * Percentage values must be represented as their decimal representations (not whole numbers). For example, 0.5 means 50%.
   * Negative values will not be accepted for this field.
   */
  readonly limitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** If a LimitPrice is specified, a LimitType is also required. */
  readonly limitType?: Maybe<InterestLevelLimitType>;
  /** Percentage value that can only be provided for Convertible Offerings */
  readonly percentageOfPar?: Maybe<Scalars['Decimal']['output']>;
  /** Percentage value that can only be provided for Convertible Offerings */
  readonly premium?: Maybe<Scalars['Decimal']['output']>;
};

export type InterestLevelDetail = {
  readonly __typename?: 'InterestLevelDetail';
  readonly coupon?: Maybe<Scalars['Decimal']['output']>;
  readonly interestQuantity?: Maybe<Scalars['Decimal']['output']>;
  readonly interestUnit: InterestLevelInterestUnit;
  readonly limitPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly limitType?: Maybe<InterestLevelLimitType>;
  readonly percentageOfPar?: Maybe<Scalars['Decimal']['output']>;
  readonly premium?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * A specification of demand using a given unit and quantity combination.
 * Limit Prices are optional, and if not supplied, are considered market price.
 * Interests with a Price Limit are considered Limit Interests.
 */
export type InterestLevelFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<InterestLevelFilterInput>>;
  /** Percentage value that can only be provided for Convertible Offerings */
  readonly coupon?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * The InterestQuantity must be a positive non-zero number.
   * When indicating with InterestUnit of PERCENT, quantity value must be represented as a decimal representations (not whole number).
   * For example, 0.5 means 50%.
   */
  readonly interestQuantity?: InputMaybe<DecimalOperationFilterInput>;
  readonly interestUnit?: InputMaybe<InterestUnitOperationFilterInput>;
  /**
   * The LimitPrice is considered in conjunction with LimitType.
   * Percentage values must be represented as their decimal representations (not whole numbers). For example, 0.5 means 50%.
   * Negative values will not be accepted for this field.
   */
  readonly limitPrice?: InputMaybe<DecimalOperationFilterInput>;
  /** If a LimitPrice is specified, a LimitType is also required. */
  readonly limitType?: InputMaybe<NullableOfLimitTypeOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<InterestLevelFilterInput>>;
  /** Percentage value that can only be provided for Convertible Offerings */
  readonly percentageOfPar?: InputMaybe<DecimalOperationFilterInput>;
  /** Percentage value that can only be provided for Convertible Offerings */
  readonly premium?: InputMaybe<DecimalOperationFilterInput>;
};

/**
 * A specification of demand using a given unit and quantity combination.
 * Limit Prices are optional, and if not supplied, are considered market price.
 * Interests with a Price Limit are considered Limit Interests.
 */
export type InterestLevelInput = {
  /** Percentage value that can only be provided for Convertible Offerings */
  readonly coupon?: InputMaybe<Scalars['Decimal']['input']>;
  /**
   * The InterestQuantity must be a positive non-zero number.
   * When indicating with InterestUnit of PERCENT, quantity value must be represented as a decimal representations (not whole number).
   * For example, 0.5 means 50%.
   */
  readonly interestQuantity: Scalars['Decimal']['input'];
  readonly interestUnit: InterestLevelInterestUnit;
  /**
   * The LimitPrice is considered in conjunction with LimitType.
   * Percentage values must be represented as their decimal representations (not whole numbers). For example, 0.5 means 50%.
   * Negative values will not be accepted for this field.
   */
  readonly limitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** If a LimitPrice is specified, a LimitType is also required. */
  readonly limitType?: InputMaybe<InterestLevelLimitType>;
  /** Percentage value that can only be provided for Convertible Offerings */
  readonly percentageOfPar?: InputMaybe<Scalars['Decimal']['input']>;
  /** Percentage value that can only be provided for Convertible Offerings */
  readonly premium?: InputMaybe<Scalars['Decimal']['input']>;
};

export enum InterestLevelInterestUnit {
  Bonds = 'BONDS',
  Currency = 'CURRENCY',
  Percent = 'PERCENT',
  Shares = 'SHARES',
}

export enum InterestLevelLimitType {
  Discount = 'DISCOUNT',
  Premium = 'PREMIUM',
  Price = 'PRICE',
}

export type InterestLevelListFilterInput = {
  readonly all?: InputMaybe<InterestLevelFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<InterestLevelFilterInput>;
  readonly some?: InputMaybe<InterestLevelFilterInput>;
};

export type InterestUnitOperationFilterInput = {
  readonly eq?: InputMaybe<InterestLevelInterestUnit>;
  readonly in?: InputMaybe<ReadonlyArray<InterestLevelInterestUnit>>;
  readonly neq?: InputMaybe<InterestLevelInterestUnit>;
  readonly nin?: InputMaybe<ReadonlyArray<InterestLevelInterestUnit>>;
};

export enum InternalReleaseStatus {
  BookedManual = 'BOOKED_MANUAL',
  CancelledManual = 'CANCELLED_MANUAL',
  CancelPending = 'CANCEL_PENDING',
}

export enum InternalSalesCreditReleaseStatus {
  BookedManual = 'BOOKED_MANUAL',
  CancelledManual = 'CANCELLED_MANUAL',
  CancelPending = 'CANCEL_PENDING',
}

/** A segment of a collection. */
export type InvestorContactsCollectionSegment = {
  readonly __typename?: 'InvestorContactsCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<InvestorFirmContact>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type InvestorCoveringEmployee = {
  readonly __typename?: 'InvestorCoveringEmployee';
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly employeeKey: Scalars['String']['output'];
  readonly jobFunction?: Maybe<JobFunction>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type InvestorCoveringEmployeeFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<InvestorCoveringEmployeeFilterInput>>;
  readonly email?: InputMaybe<StringOperationFilterInput>;
  readonly employeeKey?: InputMaybe<StringOperationFilterInput>;
  readonly jobFunction?: InputMaybe<NullableOfJobFunctionOperationFilterInput>;
  readonly name?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<InvestorCoveringEmployeeFilterInput>>;
};

export type InvestorDeliveryStatus = {
  readonly __typename?: 'InvestorDeliveryStatus';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly failedEmailCount: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly inProgressEmailCount: Scalars['Int']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly overallDeliveryStatus: ProspectusDeliveryStatus;
  readonly sentEmailCount: Scalars['Int']['output'];
  readonly totalEmailCount: Scalars['Int']['output'];
};

export type InvestorDesignation = {
  readonly __typename?: 'InvestorDesignation';
  readonly allocation: DesignationAllocation;
  readonly designations: ReadonlyArray<ManagerDesignation>;
  readonly id: Scalars['ID']['output'];
  readonly isPublished?: Maybe<Scalars['Boolean']['output']>;
  readonly version?: Maybe<Scalars['String']['output']>;
};

export type InvestorEmployee = {
  readonly __typename?: 'InvestorEmployee';
  readonly address1?: Maybe<Scalars['String']['output']>;
  readonly address2?: Maybe<Scalars['String']['output']>;
  readonly createdByUserName?: Maybe<Scalars['String']['output']>;
  readonly createdOn: Scalars['Instant']['output'];
  readonly email1?: Maybe<Scalars['String']['output']>;
  readonly email2?: Maybe<Scalars['String']['output']>;
  readonly employeeKey?: Maybe<Scalars['String']['output']>;
  readonly faxNumber1?: Maybe<Scalars['String']['output']>;
  readonly faxNumber2?: Maybe<Scalars['String']['output']>;
  readonly freeTextSource?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly investorFirmId: Scalars['UUID']['output'];
  readonly isFreeText: Scalars['Boolean']['output'];
  readonly modifiedByUserName?: Maybe<Scalars['String']['output']>;
  readonly modifiedOn: Scalars['Instant']['output'];
  readonly name: Scalars['String']['output'];
  readonly phoneNumber1?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber2?: Maybe<Scalars['String']['output']>;
  readonly status: RolodexRecordStatus;
  readonly titles?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

export type InvestorEmployeeCreateDtoInput = {
  readonly address1?: InputMaybe<Scalars['String']['input']>;
  readonly address2?: InputMaybe<Scalars['String']['input']>;
  readonly email1: Scalars['String']['input'];
  readonly email2?: InputMaybe<Scalars['String']['input']>;
  readonly employeeKey: Scalars['String']['input'];
  readonly faxNumber1?: InputMaybe<Scalars['String']['input']>;
  readonly faxNumber2?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly phoneNumber1?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  readonly status: RolodexRecordStatus;
  readonly titles?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type InvestorEngagement = {
  readonly __typename?: 'InvestorEngagement';
  readonly hasTestingTheWatersOccurred?: Maybe<Scalars['Boolean']['output']>;
  readonly indicationId: Scalars['UUID']['output'];
  readonly isWallCrossed?: Maybe<Scalars['Boolean']['output']>;
  readonly offeringId: Scalars['UUID']['output'];
  readonly roadshowMeetingType?: Maybe<RoadshowMeetingType>;
};

export type InvestorEngagements = {
  readonly __typename?: 'InvestorEngagements';
  readonly hasTestingTheWatersOccurred?: Maybe<Scalars['Boolean']['output']>;
  readonly isWallCrossed?: Maybe<Scalars['Boolean']['output']>;
  readonly roadshowMeetingType?: Maybe<RoadshowMeetingType>;
};

export type InvestorEngagementsFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<InvestorEngagementsFilterInput>>;
  readonly hasTestingTheWatersOccurred?: InputMaybe<BooleanOperationFilterInput>;
  readonly isWallCrossed?: InputMaybe<BooleanOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<InvestorEngagementsFilterInput>>;
  readonly roadshowMeetingType?: InputMaybe<NullableOfRoadshowMeetingTypeOperationFilterInput>;
};

export type InvestorEngagementsSortInput = {
  readonly hasTestingTheWatersOccurred?: InputMaybe<SortEnumType>;
  readonly isWallCrossed?: InputMaybe<SortEnumType>;
  readonly roadshowMeetingType?: InputMaybe<SortEnumType>;
};

export type InvestorExtendedData = {
  readonly __typename?: 'InvestorExtendedData';
  readonly compliance: ReadonlyArray<StringExtendedData>;
  readonly firmKey: Scalars['ID']['output'];
  readonly investorComments: ReadonlyArray<StringExtendedData>;
  readonly investorRegion: ReadonlyArray<StringExtendedData>;
  readonly investorTypes: ReadonlyArray<StringExtendedData>;
  readonly otherInvestorAttributes: ReadonlyArray<StringExtendedData>;
  readonly revenues: ReadonlyArray<DecimalExtendedData>;
};

export type InvestorExtensionAttributes = {
  readonly __typename?: 'InvestorExtensionAttributes';
  readonly compliance1?: Maybe<Scalars['String']['output']>;
  readonly compliance2?: Maybe<Scalars['String']['output']>;
  readonly compliance3?: Maybe<Scalars['String']['output']>;
  readonly compliance4?: Maybe<Scalars['String']['output']>;
  readonly compliance5?: Maybe<Scalars['String']['output']>;
  readonly investorComments1?: Maybe<Scalars['String']['output']>;
  readonly investorComments2?: Maybe<Scalars['String']['output']>;
  readonly investorComments3?: Maybe<Scalars['String']['output']>;
  readonly investorComments4?: Maybe<Scalars['String']['output']>;
  readonly investorComments5?: Maybe<Scalars['String']['output']>;
  readonly investorCrmKey: Scalars['String']['output'];
  readonly investorRegion1?: Maybe<Scalars['String']['output']>;
  readonly investorRegion2?: Maybe<Scalars['String']['output']>;
  readonly investorRegion3?: Maybe<Scalars['String']['output']>;
  readonly investorRegion4?: Maybe<Scalars['String']['output']>;
  readonly investorRegion5?: Maybe<Scalars['String']['output']>;
  readonly investorType1?: Maybe<Scalars['String']['output']>;
  readonly investorType2?: Maybe<Scalars['String']['output']>;
  readonly investorType3?: Maybe<Scalars['String']['output']>;
  readonly investorType4?: Maybe<Scalars['String']['output']>;
  readonly investorType5?: Maybe<Scalars['String']['output']>;
  readonly others1?: Maybe<Scalars['String']['output']>;
  readonly others2?: Maybe<Scalars['String']['output']>;
  readonly others3?: Maybe<Scalars['String']['output']>;
  readonly others4?: Maybe<Scalars['String']['output']>;
  readonly others5?: Maybe<Scalars['String']['output']>;
  readonly revenue1?: Maybe<Scalars['Decimal']['output']>;
  readonly revenue2?: Maybe<Scalars['Decimal']['output']>;
  readonly revenue3?: Maybe<Scalars['Decimal']['output']>;
  readonly revenue4?: Maybe<Scalars['Decimal']['output']>;
  readonly revenue5?: Maybe<Scalars['Decimal']['output']>;
};

export type InvestorExtensionAttributesFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<InvestorExtensionAttributesFilterInput>>;
  readonly compliance1?: InputMaybe<StringOperationFilterInput>;
  readonly compliance2?: InputMaybe<StringOperationFilterInput>;
  readonly compliance3?: InputMaybe<StringOperationFilterInput>;
  readonly compliance4?: InputMaybe<StringOperationFilterInput>;
  readonly compliance5?: InputMaybe<StringOperationFilterInput>;
  readonly investorComments1?: InputMaybe<StringOperationFilterInput>;
  readonly investorComments2?: InputMaybe<StringOperationFilterInput>;
  readonly investorComments3?: InputMaybe<StringOperationFilterInput>;
  readonly investorComments4?: InputMaybe<StringOperationFilterInput>;
  readonly investorComments5?: InputMaybe<StringOperationFilterInput>;
  readonly investorCrmKey?: InputMaybe<StringOperationFilterInput>;
  readonly investorRegion1?: InputMaybe<StringOperationFilterInput>;
  readonly investorRegion2?: InputMaybe<StringOperationFilterInput>;
  readonly investorRegion3?: InputMaybe<StringOperationFilterInput>;
  readonly investorRegion4?: InputMaybe<StringOperationFilterInput>;
  readonly investorRegion5?: InputMaybe<StringOperationFilterInput>;
  readonly investorType1?: InputMaybe<StringOperationFilterInput>;
  readonly investorType2?: InputMaybe<StringOperationFilterInput>;
  readonly investorType3?: InputMaybe<StringOperationFilterInput>;
  readonly investorType4?: InputMaybe<StringOperationFilterInput>;
  readonly investorType5?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<InvestorExtensionAttributesFilterInput>>;
  readonly others1?: InputMaybe<StringOperationFilterInput>;
  readonly others2?: InputMaybe<StringOperationFilterInput>;
  readonly others3?: InputMaybe<StringOperationFilterInput>;
  readonly others4?: InputMaybe<StringOperationFilterInput>;
  readonly others5?: InputMaybe<StringOperationFilterInput>;
  readonly revenue1?: InputMaybe<DecimalOperationFilterInput>;
  readonly revenue2?: InputMaybe<DecimalOperationFilterInput>;
  readonly revenue3?: InputMaybe<DecimalOperationFilterInput>;
  readonly revenue4?: InputMaybe<DecimalOperationFilterInput>;
  readonly revenue5?: InputMaybe<DecimalOperationFilterInput>;
};

export type InvestorExtensionAttributesSortInput = {
  readonly compliance1?: InputMaybe<SortEnumType>;
  readonly compliance2?: InputMaybe<SortEnumType>;
  readonly compliance3?: InputMaybe<SortEnumType>;
  readonly compliance4?: InputMaybe<SortEnumType>;
  readonly compliance5?: InputMaybe<SortEnumType>;
  readonly investorComments1?: InputMaybe<SortEnumType>;
  readonly investorComments2?: InputMaybe<SortEnumType>;
  readonly investorComments3?: InputMaybe<SortEnumType>;
  readonly investorComments4?: InputMaybe<SortEnumType>;
  readonly investorComments5?: InputMaybe<SortEnumType>;
  readonly investorCrmKey?: InputMaybe<SortEnumType>;
  readonly investorRegion1?: InputMaybe<SortEnumType>;
  readonly investorRegion2?: InputMaybe<SortEnumType>;
  readonly investorRegion3?: InputMaybe<SortEnumType>;
  readonly investorRegion4?: InputMaybe<SortEnumType>;
  readonly investorRegion5?: InputMaybe<SortEnumType>;
  readonly investorType1?: InputMaybe<SortEnumType>;
  readonly investorType2?: InputMaybe<SortEnumType>;
  readonly investorType3?: InputMaybe<SortEnumType>;
  readonly investorType4?: InputMaybe<SortEnumType>;
  readonly investorType5?: InputMaybe<SortEnumType>;
  readonly others1?: InputMaybe<SortEnumType>;
  readonly others2?: InputMaybe<SortEnumType>;
  readonly others3?: InputMaybe<SortEnumType>;
  readonly others4?: InputMaybe<SortEnumType>;
  readonly others5?: InputMaybe<SortEnumType>;
  readonly revenue1?: InputMaybe<SortEnumType>;
  readonly revenue2?: InputMaybe<SortEnumType>;
  readonly revenue3?: InputMaybe<SortEnumType>;
  readonly revenue4?: InputMaybe<SortEnumType>;
  readonly revenue5?: InputMaybe<SortEnumType>;
};

export type InvestorExtensionSchema = {
  readonly __typename?: 'InvestorExtensionSchema';
  readonly category: ExtendedDataCategory;
  readonly columnName?: Maybe<Scalars['String']['output']>;
  readonly displayName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
};

export type InvestorFirmBasic = {
  readonly __typename?: 'InvestorFirmBasic';
  readonly address1?: Maybe<Scalars['String']['output']>;
  readonly address2?: Maybe<Scalars['String']['output']>;
  readonly cik1?: Maybe<Scalars['String']['output']>;
  readonly cik2?: Maybe<Scalars['String']['output']>;
  readonly cmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly cmgEntityName?: Maybe<Scalars['String']['output']>;
  readonly crd?: Maybe<Scalars['String']['output']>;
  readonly createdByUserName?: Maybe<Scalars['String']['output']>;
  readonly createdOn: Scalars['Instant']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly email1?: Maybe<Scalars['String']['output']>;
  readonly email2?: Maybe<Scalars['String']['output']>;
  readonly factSet?: Maybe<Scalars['String']['output']>;
  readonly faxNumber1?: Maybe<Scalars['String']['output']>;
  readonly faxNumber2?: Maybe<Scalars['String']['output']>;
  readonly firmKey?: Maybe<Scalars['String']['output']>;
  readonly firmType: RolodexFirmCategoryType;
  readonly id: Scalars['ID']['output'];
  readonly investorSubType?: Maybe<Scalars['String']['output']>;
  readonly investorType?: Maybe<Scalars['String']['output']>;
  readonly isOnPlatform: Scalars['Boolean']['output'];
  readonly lei?: Maybe<Scalars['String']['output']>;
  readonly modifiedByUserName?: Maybe<Scalars['String']['output']>;
  readonly modifiedOn: Scalars['Instant']['output'];
  readonly mpid?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly phoneNumber1?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber2?: Maybe<Scalars['String']['output']>;
  readonly status: RolodexRecordStatus;
  readonly website1?: Maybe<Scalars['String']['output']>;
  readonly website2?: Maybe<Scalars['String']['output']>;
};

export type InvestorFirmBasicPagedList = {
  readonly __typename?: 'InvestorFirmBasicPagedList';
  readonly data: ReadonlyArray<InvestorFirmBasic>;
  readonly pagination: PaginationData;
};

export type InvestorFirmBasicUnion = InvestorFirmBasic | ServiceError;

export type InvestorFirmContact = {
  readonly __typename?: 'InvestorFirmContact';
  readonly address1?: Maybe<Scalars['String']['output']>;
  readonly address2?: Maybe<Scalars['String']['output']>;
  readonly email1?: Maybe<Scalars['String']['output']>;
  readonly email2?: Maybe<Scalars['String']['output']>;
  readonly fax1?: Maybe<Scalars['String']['output']>;
  readonly fax2?: Maybe<Scalars['String']['output']>;
  readonly firmId: Scalars['UUID']['output'];
  readonly investorEmployeeId: Scalars['UUID']['output'];
  readonly investorEmployeeKey?: Maybe<Scalars['String']['output']>;
  readonly modifiedOn: Scalars['Instant']['output'];
  readonly name: Scalars['String']['output'];
  readonly phone1?: Maybe<Scalars['String']['output']>;
  readonly phone2?: Maybe<Scalars['String']['output']>;
  readonly source?: Maybe<Scalars['String']['output']>;
  readonly status: RolodexRecordStatus;
  readonly titles?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly titlesDisplayValue?: Maybe<Scalars['String']['output']>;
};

export type InvestorFirmContactFilterInput = {
  readonly address1?: InputMaybe<StringOperationFilterInput>;
  readonly address2?: InputMaybe<StringOperationFilterInput>;
  readonly and?: InputMaybe<ReadonlyArray<InvestorFirmContactFilterInput>>;
  readonly email1?: InputMaybe<StringOperationFilterInput>;
  readonly email2?: InputMaybe<StringOperationFilterInput>;
  readonly fax1?: InputMaybe<StringOperationFilterInput>;
  readonly fax2?: InputMaybe<StringOperationFilterInput>;
  readonly firmId?: InputMaybe<UuidOperationFilterInput>;
  readonly investorEmployeeId?: InputMaybe<UuidOperationFilterInput>;
  readonly investorEmployeeKey?: InputMaybe<StringOperationFilterInput>;
  readonly modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  readonly name?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<InvestorFirmContactFilterInput>>;
  readonly phone1?: InputMaybe<StringOperationFilterInput>;
  readonly phone2?: InputMaybe<StringOperationFilterInput>;
  readonly source?: InputMaybe<StringOperationFilterInput>;
  readonly status?: InputMaybe<RecordStatusOperationFilterInput>;
  readonly titles?: InputMaybe<ListStringOperationFilterInput>;
  readonly titlesDisplayValue?: InputMaybe<StringOperationFilterInput>;
};

export type InvestorFirmContactListFilterInput = {
  readonly all?: InputMaybe<InvestorFirmContactFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<InvestorFirmContactFilterInput>;
  readonly some?: InputMaybe<InvestorFirmContactFilterInput>;
};

export type InvestorFirmContactSortInput = {
  readonly address1?: InputMaybe<SortEnumType>;
  readonly address2?: InputMaybe<SortEnumType>;
  readonly email1?: InputMaybe<SortEnumType>;
  readonly email2?: InputMaybe<SortEnumType>;
  readonly fax1?: InputMaybe<SortEnumType>;
  readonly fax2?: InputMaybe<SortEnumType>;
  readonly firmId?: InputMaybe<SortEnumType>;
  readonly investorEmployeeId?: InputMaybe<SortEnumType>;
  readonly investorEmployeeKey?: InputMaybe<SortEnumType>;
  readonly modifiedOn?: InputMaybe<SortEnumType>;
  readonly name?: InputMaybe<SortEnumType>;
  readonly phone1?: InputMaybe<SortEnumType>;
  readonly phone2?: InputMaybe<SortEnumType>;
  readonly source?: InputMaybe<SortEnumType>;
  readonly status?: InputMaybe<SortEnumType>;
  readonly titlesDisplayValue?: InputMaybe<SortEnumType>;
};

export type InvestorFirmCreateDtoInput = {
  readonly address1?: InputMaybe<Scalars['String']['input']>;
  readonly address2?: InputMaybe<Scalars['String']['input']>;
  readonly cik1?: InputMaybe<Scalars['String']['input']>;
  readonly cik2?: InputMaybe<Scalars['String']['input']>;
  readonly crd?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly email1?: InputMaybe<Scalars['String']['input']>;
  readonly email2?: InputMaybe<Scalars['String']['input']>;
  readonly employees?: InputMaybe<ReadonlyArray<InputMaybe<InvestorEmployeeCreateDtoInput>>>;
  readonly factSet?: InputMaybe<Scalars['String']['input']>;
  readonly faxNumber1?: InputMaybe<Scalars['String']['input']>;
  readonly faxNumber2?: InputMaybe<Scalars['String']['input']>;
  readonly firmKey: Scalars['String']['input'];
  readonly investorSubType?: InputMaybe<Scalars['String']['input']>;
  readonly investorType?: InputMaybe<Scalars['String']['input']>;
  readonly lei?: InputMaybe<Scalars['String']['input']>;
  readonly mpid?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly phoneNumber1?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  readonly status: RolodexRecordStatus;
  readonly website1?: InputMaybe<Scalars['String']['input']>;
  readonly website2?: InputMaybe<Scalars['String']['input']>;
};

export type InvestorFirmEmployeeRelationship = {
  readonly __typename?: 'InvestorFirmEmployeeRelationship';
  readonly createdByUserName?: Maybe<Scalars['String']['output']>;
  readonly createdOn: Scalars['Instant']['output'];
  readonly modifiedByUserName?: Maybe<Scalars['String']['output']>;
  readonly modifiedOn: Scalars['Instant']['output'];
  readonly relationshipType: RelationshipType;
  readonly status: RolodexRecordStatus;
  readonly underwriterEmployeeId: Scalars['UUID']['output'];
  readonly underwriterEmployeeKey?: Maybe<Scalars['String']['output']>;
  readonly underwriterEmployeeName?: Maybe<Scalars['String']['output']>;
};

export type InvestorFirmFilterInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly cik?: InputMaybe<Scalars['String']['input']>;
  readonly crd?: InputMaybe<Scalars['String']['input']>;
  readonly lei?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly rolodexKey?: InputMaybe<Scalars['String']['input']>;
  readonly webDomain?: InputMaybe<Scalars['String']['input']>;
};

export type InvestorFirmGridFilterInput = {
  readonly address1?: InputMaybe<StringOperationFilterInput>;
  readonly address2?: InputMaybe<StringOperationFilterInput>;
  readonly and?: InputMaybe<ReadonlyArray<InvestorFirmGridFilterInput>>;
  readonly cik1?: InputMaybe<StringOperationFilterInput>;
  readonly cik2?: InputMaybe<StringOperationFilterInput>;
  readonly crd?: InputMaybe<StringOperationFilterInput>;
  readonly createdByUserName?: InputMaybe<StringOperationFilterInput>;
  readonly createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  readonly description?: InputMaybe<StringOperationFilterInput>;
  readonly emailAddress1?: InputMaybe<StringOperationFilterInput>;
  readonly emailAddress2?: InputMaybe<StringOperationFilterInput>;
  readonly factSet?: InputMaybe<StringOperationFilterInput>;
  readonly fax1?: InputMaybe<StringOperationFilterInput>;
  readonly fax2?: InputMaybe<StringOperationFilterInput>;
  readonly firmCategory?: InputMaybe<NullableOfFirmCategoryTypeOperationFilterInput>;
  readonly firmKey?: InputMaybe<StringOperationFilterInput>;
  readonly firmSubType?: InputMaybe<StringOperationFilterInput>;
  readonly firmType?: InputMaybe<StringOperationFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly investorContacts?: InputMaybe<InvestorFirmContactListFilterInput>;
  readonly investorContactsCount?: InputMaybe<IntOperationFilterInput>;
  readonly isLinked?: InputMaybe<BooleanOperationFilterInput>;
  readonly lei?: InputMaybe<StringOperationFilterInput>;
  readonly linkedCmgEntityKey?: InputMaybe<StringOperationFilterInput>;
  readonly linkedCmgEntityName?: InputMaybe<StringOperationFilterInput>;
  readonly modifiedByUserName?: InputMaybe<StringOperationFilterInput>;
  readonly modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  readonly mpid?: InputMaybe<StringOperationFilterInput>;
  readonly name?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<InvestorFirmGridFilterInput>>;
  readonly phone1?: InputMaybe<StringOperationFilterInput>;
  readonly phone2?: InputMaybe<StringOperationFilterInput>;
  readonly salesCoverage?: InputMaybe<InvestorFirmRelationshipListFilterInput>;
  readonly salesCoverageCount?: InputMaybe<IntOperationFilterInput>;
  readonly salesCoverageDisplayValue?: InputMaybe<StringOperationFilterInput>;
  readonly status?: InputMaybe<RecordStatusOperationFilterInput>;
  readonly website1?: InputMaybe<StringOperationFilterInput>;
  readonly website2?: InputMaybe<StringOperationFilterInput>;
};

export type InvestorFirmGridSortInput = {
  readonly address1?: InputMaybe<SortEnumType>;
  readonly address2?: InputMaybe<SortEnumType>;
  readonly cik1?: InputMaybe<SortEnumType>;
  readonly cik2?: InputMaybe<SortEnumType>;
  readonly crd?: InputMaybe<SortEnumType>;
  readonly createdByUserName?: InputMaybe<SortEnumType>;
  readonly createdOn?: InputMaybe<SortEnumType>;
  readonly description?: InputMaybe<SortEnumType>;
  readonly emailAddress1?: InputMaybe<SortEnumType>;
  readonly emailAddress2?: InputMaybe<SortEnumType>;
  readonly factSet?: InputMaybe<SortEnumType>;
  readonly fax1?: InputMaybe<SortEnumType>;
  readonly fax2?: InputMaybe<SortEnumType>;
  readonly firmCategory?: InputMaybe<SortEnumType>;
  readonly firmKey?: InputMaybe<SortEnumType>;
  readonly firmSubType?: InputMaybe<SortEnumType>;
  readonly firmType?: InputMaybe<SortEnumType>;
  readonly id?: InputMaybe<SortEnumType>;
  readonly investorContactsCount?: InputMaybe<SortEnumType>;
  readonly isLinked?: InputMaybe<SortEnumType>;
  readonly lei?: InputMaybe<SortEnumType>;
  readonly linkedCmgEntityKey?: InputMaybe<SortEnumType>;
  readonly linkedCmgEntityName?: InputMaybe<SortEnumType>;
  readonly modifiedByUserName?: InputMaybe<SortEnumType>;
  readonly modifiedOn?: InputMaybe<SortEnumType>;
  readonly mpid?: InputMaybe<SortEnumType>;
  readonly name?: InputMaybe<SortEnumType>;
  readonly phone1?: InputMaybe<SortEnumType>;
  readonly phone2?: InputMaybe<SortEnumType>;
  readonly salesCoverageCount?: InputMaybe<SortEnumType>;
  readonly salesCoverageDisplayValue?: InputMaybe<SortEnumType>;
  readonly status?: InputMaybe<SortEnumType>;
  readonly website1?: InputMaybe<SortEnumType>;
  readonly website2?: InputMaybe<SortEnumType>;
};

export type InvestorFirmMappedWithCmgEntityKey = {
  readonly __typename?: 'InvestorFirmMappedWithCmgEntityKey';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly investors: ReadonlyArray<InvestorFirmBasic>;
};

export type InvestorFirmRelationship = {
  readonly __typename?: 'InvestorFirmRelationship';
  readonly employeeEmail?: Maybe<Scalars['String']['output']>;
  readonly employeeId: Scalars['UUID']['output'];
  readonly employeeKey: Scalars['String']['output'];
  readonly employeeName?: Maybe<Scalars['String']['output']>;
  readonly employeeStatus: RolodexRecordStatus;
  readonly firmId: Scalars['UUID']['output'];
  readonly firmKey?: Maybe<Scalars['String']['output']>;
  readonly firmName: Scalars['String']['output'];
  readonly firmStatus: RolodexRecordStatus;
  readonly jobFunction?: Maybe<JobFunction>;
  readonly lastUpdated: Scalars['Instant']['output'];
  readonly location?: Maybe<Scalars['String']['output']>;
  readonly relationshipStatus: RolodexRecordStatus;
  readonly relationshipType: RelationshipType;
};

export type InvestorFirmRelationshipCreateInput = {
  readonly investorFirmId: Scalars['UUID']['input'];
  readonly relationshipType: RelationshipType;
  readonly status: RolodexRecordStatus;
  readonly underwriterEmployeeId: Scalars['UUID']['input'];
};

export type InvestorFirmRelationshipFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<InvestorFirmRelationshipFilterInput>>;
  readonly employeeEmail?: InputMaybe<StringOperationFilterInput>;
  readonly employeeId?: InputMaybe<UuidOperationFilterInput>;
  readonly employeeKey?: InputMaybe<StringOperationFilterInput>;
  readonly employeeName?: InputMaybe<StringOperationFilterInput>;
  readonly employeeStatus?: InputMaybe<RecordStatusOperationFilterInput>;
  readonly firmId?: InputMaybe<UuidOperationFilterInput>;
  readonly firmKey?: InputMaybe<StringOperationFilterInput>;
  readonly firmName?: InputMaybe<StringOperationFilterInput>;
  readonly firmStatus?: InputMaybe<RecordStatusOperationFilterInput>;
  readonly jobFunction?: InputMaybe<NullableOfJobFunctionOperationFilterInput>;
  readonly lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  readonly location?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<InvestorFirmRelationshipFilterInput>>;
  readonly relationshipStatus?: InputMaybe<RecordStatusOperationFilterInput>;
  readonly relationshipType?: InputMaybe<RelationshipTypeOperationFilterInput>;
};

export type InvestorFirmRelationshipFull = {
  readonly __typename?: 'InvestorFirmRelationshipFull';
  readonly firmId: Scalars['UUID']['output'];
  readonly firmName: Scalars['String']['output'];
};

export type InvestorFirmRelationshipListFilterInput = {
  readonly all?: InputMaybe<InvestorFirmRelationshipFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<InvestorFirmRelationshipFilterInput>;
  readonly some?: InputMaybe<InvestorFirmRelationshipFilterInput>;
};

export type InvestorFirmRelationshipSortInput = {
  readonly employeeEmail?: InputMaybe<SortEnumType>;
  readonly employeeId?: InputMaybe<SortEnumType>;
  readonly employeeKey?: InputMaybe<SortEnumType>;
  readonly employeeName?: InputMaybe<SortEnumType>;
  readonly employeeStatus?: InputMaybe<SortEnumType>;
  readonly firmId?: InputMaybe<SortEnumType>;
  readonly firmKey?: InputMaybe<SortEnumType>;
  readonly firmName?: InputMaybe<SortEnumType>;
  readonly firmStatus?: InputMaybe<SortEnumType>;
  readonly jobFunction?: InputMaybe<SortEnumType>;
  readonly lastUpdated?: InputMaybe<SortEnumType>;
  readonly location?: InputMaybe<SortEnumType>;
  readonly relationshipStatus?: InputMaybe<SortEnumType>;
  readonly relationshipType?: InputMaybe<SortEnumType>;
};

export type InvestorFirmsEmployeeRelationships = {
  readonly __typename?: 'InvestorFirmsEmployeeRelationships';
  readonly bankInvestorKey: Scalars['ID']['output'];
  readonly relationships: ReadonlyArray<InvestorFirmEmployeeRelationship>;
};

export type InvestorFirmsGrid = {
  readonly __typename?: 'InvestorFirmsGrid';
  readonly address1?: Maybe<Scalars['String']['output']>;
  readonly address2?: Maybe<Scalars['String']['output']>;
  readonly cik1?: Maybe<Scalars['String']['output']>;
  readonly cik2?: Maybe<Scalars['String']['output']>;
  readonly crd?: Maybe<Scalars['String']['output']>;
  readonly createdByUserName?: Maybe<Scalars['String']['output']>;
  readonly createdOn: Scalars['Instant']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly emailAddress1?: Maybe<Scalars['String']['output']>;
  readonly emailAddress2?: Maybe<Scalars['String']['output']>;
  readonly factSet?: Maybe<Scalars['String']['output']>;
  readonly fax1?: Maybe<Scalars['String']['output']>;
  readonly fax2?: Maybe<Scalars['String']['output']>;
  readonly firmCategory?: Maybe<RolodexFirmCategoryType>;
  readonly firmKey?: Maybe<Scalars['String']['output']>;
  readonly firmSubType?: Maybe<Scalars['String']['output']>;
  readonly firmType?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly investorContacts?: Maybe<InvestorContactsCollectionSegment>;
  readonly investorContactsCount: Scalars['Int']['output'];
  readonly isLinked: Scalars['Boolean']['output'];
  readonly isOnPlatform: Scalars['Boolean']['output'];
  readonly lei?: Maybe<Scalars['String']['output']>;
  readonly linkedCmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly linkedCmgEntityName?: Maybe<Scalars['String']['output']>;
  readonly modifiedByUserName?: Maybe<Scalars['String']['output']>;
  readonly modifiedOn: Scalars['Instant']['output'];
  readonly mpid?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly phone1?: Maybe<Scalars['String']['output']>;
  readonly phone2?: Maybe<Scalars['String']['output']>;
  readonly salesCoverage?: Maybe<SalesCoverageCollectionSegment>;
  readonly salesCoverageCount: Scalars['Int']['output'];
  readonly salesCoverageDisplayValue?: Maybe<Scalars['String']['output']>;
  readonly status: RolodexRecordStatus;
  readonly website1?: Maybe<Scalars['String']['output']>;
  readonly website2?: Maybe<Scalars['String']['output']>;
};

export type InvestorFirmsGridInvestorContactsArgs = {
  order?: InputMaybe<ReadonlyArray<InvestorFirmContactSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestorFirmContactFilterInput>;
};

export type InvestorFirmsGridSalesCoverageArgs = {
  order?: InputMaybe<ReadonlyArray<InvestorFirmRelationshipSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestorFirmRelationshipFilterInput>;
};

/** A segment of a collection. */
export type InvestorFirmsGridCollectionSegment = {
  readonly __typename?: 'InvestorFirmsGridCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<InvestorFirmsGrid>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type InvestorInfo = {
  readonly __typename?: 'InvestorInfo';
  readonly bankInvestorKey?: Maybe<Scalars['String']['output']>;
  readonly bankInvestorName?: Maybe<Scalars['String']['output']>;
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly contactEmail?: Maybe<Scalars['String']['output']>;
  readonly contactName?: Maybe<Scalars['String']['output']>;
  /** The display name of the Investor, calculated as BankInvestorName ?? FirmName */
  readonly displayName: Scalars['String']['output'];
  readonly extensions?: Maybe<InvestorExtensionAttributes>;
  readonly firmName: Scalars['String']['output'];
  readonly isOnPlatform: Scalars['Boolean']['output'];
};

export type InvestorInfoFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<InvestorInfoFilterInput>>;
  readonly bankInvestorKey?: InputMaybe<StringOperationFilterInput>;
  readonly bankInvestorName?: InputMaybe<StringOperationFilterInput>;
  readonly cmgEntityKey?: InputMaybe<StringOperationFilterInput>;
  readonly contactEmail?: InputMaybe<StringOperationFilterInput>;
  readonly contactName?: InputMaybe<StringOperationFilterInput>;
  /** The display name of the Investor, calculated as BankInvestorName ?? FirmName */
  readonly displayName?: InputMaybe<StringOperationFilterInput>;
  readonly extensions?: InputMaybe<InvestorExtensionAttributesFilterInput>;
  readonly firmName?: InputMaybe<StringOperationFilterInput>;
  readonly isOnPlatform?: InputMaybe<BooleanOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<InvestorInfoFilterInput>>;
};

export type InvestorInfoSortInput = {
  readonly bankInvestorKey?: InputMaybe<SortEnumType>;
  readonly bankInvestorName?: InputMaybe<SortEnumType>;
  readonly cmgEntityKey?: InputMaybe<SortEnumType>;
  readonly contactEmail?: InputMaybe<SortEnumType>;
  readonly contactName?: InputMaybe<SortEnumType>;
  /** The display name of the Investor, calculated as BankInvestorName ?? FirmName */
  readonly displayName?: InputMaybe<SortEnumType>;
  readonly extensions?: InputMaybe<InvestorExtensionAttributesSortInput>;
  readonly firmName?: InputMaybe<SortEnumType>;
  readonly isOnPlatform?: InputMaybe<SortEnumType>;
};

export type InvestorInformation = {
  readonly __typename?: 'InvestorInformation';
  /**
   * The CRM key for this investor's CmgEntityKey is looked up dynamically unless it is manually assigned and overridden.
   * If multiple matching firms are found, the oldest firm is returned.
   */
  readonly bankInvestorKey?: Maybe<Scalars['String']['output']>;
  /** The name of this investor, corresponds to the BankInvestorKey */
  readonly bankInvestorName?: Maybe<Scalars['String']['output']>;
  readonly cmgEntityKey: Scalars['String']['output'];
  /** The name of this entity, corresponds to the CmgEntityKey */
  readonly cmgEntityName: Scalars['String']['output'];
  readonly contactEmail?: Maybe<Scalars['String']['output']>;
  readonly contactName?: Maybe<Scalars['String']['output']>;
  readonly isOnPlatform: Scalars['Boolean']['output'];
};

/**
 * Used to submit an indication with one of 2 pieces of information: CmgEntityKey, or BankInvestorKey (via CRM/Rolodex).
 * Using both of these methods will result in a validation error.
 */
export type InvestorInformationInput = {
  /**
   * Submitting bank’s internal identifier for the investor.
   * This identifier value needs to be already reconciled to a CMG master record.
   */
  readonly bankInvestorKey?: InputMaybe<Scalars['String']['input']>;
  readonly cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
};

export type InvestorInformationSortInput = {
  /**
   * The CRM key for this investor's CmgEntityKey is looked up dynamically unless it is manually assigned and overridden.
   * If multiple matching firms are found, the oldest firm is returned.
   */
  readonly bankInvestorKey?: InputMaybe<SortEnumType>;
  /** The name of this investor, corresponds to the BankInvestorKey */
  readonly bankInvestorName?: InputMaybe<SortEnumType>;
  readonly cmgEntityKey?: InputMaybe<SortEnumType>;
  /** The name of this entity, corresponds to the CmgEntityKey */
  readonly cmgEntityName?: InputMaybe<SortEnumType>;
  readonly contactEmail?: InputMaybe<SortEnumType>;
  readonly contactName?: InputMaybe<SortEnumType>;
  readonly isOnPlatform?: InputMaybe<SortEnumType>;
};

export type InvestorRelationship = {
  readonly __typename?: 'InvestorRelationship';
  readonly relationshipType: InvestorRelationshipType;
  readonly status: InvestorRelationshipRecordStatus;
  readonly underwriterEmployeeName: Scalars['String']['output'];
};

export type InvestorRelationshipChanged = {
  readonly __typename?: 'InvestorRelationshipChanged';
  readonly investorFirmId: Scalars['UUID']['output'];
  readonly investorFirmKey?: Maybe<Scalars['String']['output']>;
  readonly relationships: ReadonlyArray<InvestorRelationship>;
};

export type InvestorRelationshipCreateDtoInput = {
  readonly investorFirmId: Scalars['UUID']['input'];
  readonly investorFirmKeyOrId?: InputMaybe<Scalars['String']['input']>;
  readonly relationshipType: RelationshipType;
  readonly status: RolodexRecordStatus;
};

export { InvestorRelationshipRecordStatus };

export { InvestorRelationshipType };

export type InvestorRelationshipUpdateDtoInput = {
  readonly relationshipType: RelationshipType;
  readonly status: RolodexRecordStatus;
};

export type InvestorReply = {
  readonly __typename?: 'InvestorReply';
  readonly auditInfo: AuditInfo;
  /** The acknowledgement status of this Allocation. */
  readonly status: AllocationAcknowledgement;
  readonly version: Scalars['String']['output'];
};

export enum InvestorReplyStatus {
  Confirmed = 'CONFIRMED',
  Rejected = 'REJECTED',
}

export type InvestorResponse = {
  readonly __typename?: 'InvestorResponse';
  readonly acknowledgementStatus: AllocationAcknowledgement;
  readonly allocationAcknowledgedBy?: Maybe<UserInfo>;
};

/** A segment of a collection. */
export type InvestorsCollectionSegment = {
  readonly __typename?: 'InvestorsCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<FirmFull>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type InvitationWireResponseInput = {
  readonly decisionTimeZone: Scalars['DateTimeZone']['input'];
};

export enum IoiPricingType {
  Limit = 'limit',
  Market = 'market',
}

export enum IoiUnitType {
  Dollars = 'dollars',
  Percentage = 'percentage',
  Shares = 'shares',
}

export type Issuer = {
  readonly __typename?: 'Issuer';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly businessDescription?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly lei?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly sector?: Maybe<Sector>;
  /** Display name for Sector */
  readonly sectorDisplayName?: Maybe<Scalars['String']['output']>;
  readonly website?: Maybe<Scalars['String']['output']>;
};

export enum IssuerAllocationReportValidationOfferingErrors {
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  TotalInstitutionalAllocations = 'TOTAL_INSTITUTIONAL_ALLOCATIONS',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
}

export type IssuerAllocationWire = {
  readonly __typename?: 'IssuerAllocationWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly emailAddresses: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

export type IssuerAllocationWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddresses: ReadonlyArray<Scalars['String']['input']>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type IssuerAllocationWireResponseUnion = IssuerAllocationWire | ServiceError;

export type IssuerAllocationWireValidation = WireValidationBase & {
  readonly __typename?: 'IssuerAllocationWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<IssuerAllocationReportValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export type IssuerFull = {
  readonly __typename?: 'IssuerFull';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly businessDescription?: Maybe<Scalars['String']['output']>;
  readonly lei?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly sector?: Maybe<Sector>;
  /** Display name for Sector */
  readonly sectorDisplayName?: Maybe<Scalars['String']['output']>;
  readonly subSector?: Maybe<Scalars['String']['output']>;
  readonly website?: Maybe<Scalars['String']['output']>;
};

export type IssuerFullFilterInput = {
  readonly address?: InputMaybe<StringOperationFilterInput>;
  readonly and?: InputMaybe<ReadonlyArray<IssuerFullFilterInput>>;
  readonly businessDescription?: InputMaybe<StringOperationFilterInput>;
  readonly lei?: InputMaybe<StringOperationFilterInput>;
  readonly name?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<IssuerFullFilterInput>>;
  readonly sector?: InputMaybe<SectorFilterInput>;
  readonly subSector?: InputMaybe<StringOperationFilterInput>;
  readonly website?: InputMaybe<StringOperationFilterInput>;
};

export type IssuerIndicationWire = {
  readonly __typename?: 'IssuerIndicationWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly emailAddresses: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

export type IssuerIndicationWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly emailAddresses: ReadonlyArray<Scalars['String']['input']>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type IssuerIndicationWireResponseUnion = IssuerIndicationWire | ServiceError;

export type IssuerIndicationWireValidation = WireValidationBase & {
  readonly __typename?: 'IssuerIndicationWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<IssuerIndicationWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum IssuerIndicationWireValidationOfferingErrors {
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
}

export type IssuerNameWithStockSymbol = {
  readonly __typename?: 'IssuerNameWithStockSymbol';
  readonly issuerName: Scalars['String']['output'];
  readonly stockSymbol?: Maybe<Scalars['String']['output']>;
};

export enum JobFunction {
  Sales = 'SALES',
  Syndicate = 'SYNDICATE',
  Trading = 'TRADING',
}

export type LastTnRestrictedPeriod = {
  readonly __typename?: 'LastTnRestrictedPeriod';
  readonly id: Scalars['ID']['output'];
  readonly restrictedPeriod: TnRestrictedPeriodType;
  /** Display name for RestrictedPeriod */
  readonly restrictedPeriodDisplayName?: Maybe<Scalars['String']['output']>;
};

export type LatestEmailStatus = {
  readonly __typename?: 'LatestEmailStatus';
  readonly isOwnedByCurrentTenant: Scalars['Boolean']['output'];
  readonly recipientEmail?: Maybe<Scalars['String']['output']>;
  readonly recipientName?: Maybe<Scalars['String']['output']>;
  readonly sendRequestedAt: Scalars['Instant']['output'];
  readonly status: EmailDeliveryStatus;
  readonly statusInfo?: Maybe<Scalars['String']['output']>;
};

export type Lender = {
  readonly __typename?: 'Lender';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly recordStatus: RecordStatus;
};

export type LetterDealRelatedExpenses = {
  readonly __typename?: 'LetterDealRelatedExpenses';
  readonly category: ExpenseCategory;
  /** Display name for Category */
  readonly categoryDisplayName?: Maybe<Scalars['String']['output']>;
  readonly value: Scalars['Decimal']['output'];
};

export type LinkFrequency = {
  readonly __typename?: 'LinkFrequency';
  readonly bankRelationships?: Maybe<ReadonlyArray<Maybe<LinkFrequencyBankRelationship>>>;
  readonly linkFrequency: Scalars['Int']['output'];
  readonly uniqueBankCount: Scalars['Int']['output'];
};

export type LinkFrequencyBankRelationship = {
  readonly __typename?: 'LinkFrequencyBankRelationship';
  readonly cmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type LinkageSummary = {
  readonly __typename?: 'LinkageSummary';
  readonly bankRelationships: ReadonlyArray<BankRelationship>;
  readonly linkFrequency: Scalars['Int']['output'];
  readonly uniqueBankCount: Scalars['Int']['output'];
};

export type LinkedUnderwriterFirm = {
  readonly __typename?: 'LinkedUnderwriterFirm';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly firmName: Scalars['String']['output'];
};

export type ListAllocationFilterInput = {
  readonly all?: InputMaybe<AllocationDtoFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<AllocationDtoFilterInput>;
  readonly some?: InputMaybe<AllocationDtoFilterInput>;
};

export type ListCustomOperationFilterInputTypeOfLocalDateTypeFilterInput = {
  readonly all?: InputMaybe<LocalDateOperationFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<LocalDateOperationFilterInput>;
  readonly some?: InputMaybe<LocalDateOperationFilterInput>;
};

export type ListFilterInputTypeOfCertificateFilterInput = {
  readonly all?: InputMaybe<CertificateFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<CertificateFilterInput>;
  readonly some?: InputMaybe<CertificateFilterInput>;
};

export type ListFilterInputTypeOfConvertibleDemandLevelFilterInput = {
  readonly all?: InputMaybe<ConvertibleDemandLevelFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<ConvertibleDemandLevelFilterInput>;
  readonly some?: InputMaybe<ConvertibleDemandLevelFilterInput>;
};

export type ListFilterInputTypeOfDemandCurrencyFullFilterInput = {
  readonly all?: InputMaybe<DemandCurrencyFullFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<DemandCurrencyFullFilterInput>;
  readonly some?: InputMaybe<DemandCurrencyFullFilterInput>;
};

export type ListFilterInputTypeOfDemandLevelFilterInput = {
  readonly all?: InputMaybe<DemandLevelFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<DemandLevelFilterInput>;
  readonly some?: InputMaybe<DemandLevelFilterInput>;
};

export type ListFilterInputTypeOfFilingFullFilterInput = {
  readonly all?: InputMaybe<FilingFullFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<FilingFullFilterInput>;
  readonly some?: InputMaybe<FilingFullFilterInput>;
};

export type ListFilterInputTypeOfFirmInfoFilterInput = {
  readonly all?: InputMaybe<FirmInfoFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<FirmInfoFilterInput>;
  readonly some?: InputMaybe<FirmInfoFilterInput>;
};

export type ListFilterInputTypeOfIndicationAcknowledgementDtoFilterInput = {
  readonly all?: InputMaybe<IndicationAcknowledgementDtoFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<IndicationAcknowledgementDtoFilterInput>;
  readonly some?: InputMaybe<IndicationAcknowledgementDtoFilterInput>;
};

export type ListFilterInputTypeOfInstrumentFullFilterInput = {
  readonly all?: InputMaybe<InstrumentFullFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<InstrumentFullFilterInput>;
  readonly some?: InputMaybe<InstrumentFullFilterInput>;
};

export type ListFilterInputTypeOfInvestorCoveringEmployeeFilterInput = {
  readonly all?: InputMaybe<InvestorCoveringEmployeeFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<InvestorCoveringEmployeeFilterInput>;
  readonly some?: InputMaybe<InvestorCoveringEmployeeFilterInput>;
};

export type ListFilterInputTypeOfInvestorRelationshipFullFilterInput = {
  readonly all?: InputMaybe<InvestorFirmRelationshipFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<InvestorFirmRelationshipFilterInput>;
  readonly some?: InputMaybe<InvestorFirmRelationshipFilterInput>;
};

export type ListFilterInputTypeOfManagerFullFilterInput = {
  readonly all?: InputMaybe<ManagerFullFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<ManagerFullFilterInput>;
  readonly some?: InputMaybe<ManagerFullFilterInput>;
};

export type ListFilterInputTypeOfPercentagePerCmgEntityFullFilterInput = {
  readonly all?: InputMaybe<PercentagePerCmgEntityFullFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<PercentagePerCmgEntityFullFilterInput>;
  readonly some?: InputMaybe<PercentagePerCmgEntityFullFilterInput>;
};

export type ListFilterInputTypeOfProspectusDocumentFullFilterInput = {
  readonly all?: InputMaybe<ProspectusDocumentFullFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<ProspectusDocumentFullFilterInput>;
  readonly some?: InputMaybe<ProspectusDocumentFullFilterInput>;
};

export type ListFilterInputTypeOfRoadshowsFullFilterInput = {
  readonly all?: InputMaybe<RoadshowsFullFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<RoadshowsFullFilterInput>;
  readonly some?: InputMaybe<RoadshowsFullFilterInput>;
};

export type ListFilterInputTypeOfShareHistoryFullFilterInput = {
  readonly all?: InputMaybe<ShareHistoryFullFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<ShareHistoryFullFilterInput>;
  readonly some?: InputMaybe<ShareHistoryFullFilterInput>;
};

export type ListFilterInputTypeOfSharesPerCmgEntityFullFilterInput = {
  readonly all?: InputMaybe<SharesPerCmgEntityFullFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<SharesPerCmgEntityFullFilterInput>;
  readonly some?: InputMaybe<SharesPerCmgEntityFullFilterInput>;
};

export type ListFilterInputTypeOfTrancheFullFilterInput = {
  readonly all?: InputMaybe<TrancheFullFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<TrancheFullFilterInput>;
  readonly some?: InputMaybe<TrancheFullFilterInput>;
};

export type ListFilterInputTypeOfWireMessageLimitedReadDtoFilterInput = {
  readonly all?: InputMaybe<WireMessageLimitedReadDtoFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<WireMessageLimitedReadDtoFilterInput>;
  readonly some?: InputMaybe<WireMessageLimitedReadDtoFilterInput>;
};

export type ListStringOperationFilterInput = {
  readonly all?: InputMaybe<StringOperationFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<StringOperationFilterInput>;
  readonly some?: InputMaybe<StringOperationFilterInput>;
};

export type ListUuidOperationFilterInput = {
  readonly all?: InputMaybe<UuidOperationFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<UuidOperationFilterInput>;
  readonly some?: InputMaybe<UuidOperationFilterInput>;
};

export type LiveOfferingsAffectedByFirmHierarchyUnlink = {
  readonly __typename?: 'LiveOfferingsAffectedByFirmHierarchyUnlink';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly issuerNamesWithStockSymbols: ReadonlyArray<IssuerNameWithStockSymbol>;
};

export type LivePublishedOfferingListFiltersInput = {
  readonly cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  readonly includeTestOfferings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalDateOperationFilterInput = {
  readonly eq?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly gt?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly gte?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['LocalDate']['input']>>>;
  readonly lt?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly lte?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly neq?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly ngt?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly ngte?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['LocalDate']['input']>>>;
  readonly nlt?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly nlte?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type LocalTimeOperationFilterInput = {
  readonly eq?: InputMaybe<Scalars['LocalTime']['input']>;
  readonly gt?: InputMaybe<Scalars['LocalTime']['input']>;
  readonly gte?: InputMaybe<Scalars['LocalTime']['input']>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['LocalTime']['input']>>>;
  readonly lt?: InputMaybe<Scalars['LocalTime']['input']>;
  readonly lte?: InputMaybe<Scalars['LocalTime']['input']>;
  readonly neq?: InputMaybe<Scalars['LocalTime']['input']>;
  readonly ngt?: InputMaybe<Scalars['LocalTime']['input']>;
  readonly ngte?: InputMaybe<Scalars['LocalTime']['input']>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['LocalTime']['input']>>>;
  readonly nlt?: InputMaybe<Scalars['LocalTime']['input']>;
  readonly nlte?: InputMaybe<Scalars['LocalTime']['input']>;
};

export type LongOperationFilterInput = {
  readonly eq?: InputMaybe<Scalars['Long']['input']>;
  readonly gt?: InputMaybe<Scalars['Long']['input']>;
  readonly gte?: InputMaybe<Scalars['Long']['input']>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Long']['input']>>>;
  readonly lt?: InputMaybe<Scalars['Long']['input']>;
  readonly lte?: InputMaybe<Scalars['Long']['input']>;
  readonly neq?: InputMaybe<Scalars['Long']['input']>;
  readonly ngt?: InputMaybe<Scalars['Long']['input']>;
  readonly ngte?: InputMaybe<Scalars['Long']['input']>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Long']['input']>>>;
  readonly nlt?: InputMaybe<Scalars['Long']['input']>;
  readonly nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type Manager = {
  readonly __typename?: 'Manager';
  readonly affiliates: ReadonlyArray<Affiliate>;
  readonly cmgEntityKey: Scalars['String']['output'];
  /**
   * Deprecated; Use `Underwriting Base Share Distribution` in Manager Economics instead
   * @deprecated Use `Underwriting Base Share Distribution` in Manager Economics instead
   */
  readonly economics?: Maybe<Scalars['Long']['output']>;
  readonly finraInfo?: Maybe<FinraInfo>;
  readonly firmName: Scalars['String']['output'];
  readonly firmNameAbbreviation?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isJuniorRole: Scalars['Boolean']['output'];
  readonly isParticipating: Scalars['Boolean']['output'];
  readonly recordStatus: RecordStatus;
  readonly role: ManagerRole;
};

export type ManagerBdRecipientInputData = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly payment: Scalars['Decimal']['input'];
  readonly recipient: Scalars['String']['input'];
  readonly recipientDtc?: InputMaybe<Scalars['String']['input']>;
  readonly senderDtc: Scalars['String']['input'];
};

export type ManagerBdRecipientUserData = {
  readonly __typename?: 'ManagerBdRecipientUserData';
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly payment: Scalars['Decimal']['output'];
  readonly recipient: Scalars['String']['output'];
  readonly recipientDtc?: Maybe<Scalars['String']['output']>;
  readonly senderDtc: Scalars['String']['output'];
};

export type ManagerBdWire = {
  readonly __typename?: 'ManagerBdWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly id: Scalars['ID']['output'];
  readonly recipientsUserData: ReadonlyArray<ManagerBdRecipientUserData>;
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

export type ManagerBdWireInput = {
  readonly userDataForRecipients: ReadonlyArray<ManagerBdRecipientInputData>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type ManagerBdWireResponseUnion = ManagerBdWire | ServiceError;

export type ManagerBdWireValidation = WireValidationBase & {
  readonly __typename?: 'ManagerBdWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<ManagerBillingAndDeliveryWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum ManagerBillingAndDeliveryWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  Cusip = 'CUSIP',
  ExchangeMic = 'EXCHANGE_MIC',
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  OfferPrice = 'OFFER_PRICE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  SettlementDate = 'SETTLEMENT_DATE',
  StockSymbol = 'STOCK_SYMBOL',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
  UnderlyingExchangeMic = 'UNDERLYING_EXCHANGE_MIC',
  UnderlyingStockSymbol = 'UNDERLYING_STOCK_SYMBOL',
}

export type ManagerDesignation = {
  readonly __typename?: 'ManagerDesignation';
  readonly fixedEconomicsShares?: Maybe<Scalars['Long']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly manager: DesignationManager;
  readonly sellingConcessionPercentageChanged: Scalars['Boolean']['output'];
  readonly shares?: Maybe<Scalars['Long']['output']>;
};

export type ManagerDtcNumber = {
  readonly __typename?: 'ManagerDtcNumber';
  readonly id: Scalars['ID']['output'];
  readonly managerDtcNumber?: Maybe<Scalars['String']['output']>;
  readonly managerKey: Scalars['String']['output'];
};

export type ManagerEconomics = {
  readonly __typename?: 'ManagerEconomics';
  readonly id: Scalars['ID']['output'];
  readonly incentiveFeeDistribution: ReadonlyArray<PercentagePerCmgEntity>;
  readonly managementFeeDistribution: ReadonlyArray<PercentagePerCmgEntity>;
  readonly overallotmentExercisedSharesDistribution: ReadonlyArray<SharesPerCmgEntity>;
  readonly sellingConcessionDistribution: ReadonlyArray<PercentagePerCmgEntity>;
  readonly underwritingBaseSharesDistribution: ReadonlyArray<SharesPerCmgEntity>;
  readonly underwritingFeeBaseDistribution: ReadonlyArray<PercentagePerCmgEntity>;
  readonly underwritingFeeTotalDistribution: ReadonlyArray<PercentagePerCmgEntity>;
  readonly underwritingTotalSharesDistribution: ReadonlyArray<SharesPerCmgEntity>;
};

export type ManagerEconomicsFull = {
  readonly __typename?: 'ManagerEconomicsFull';
  readonly incentiveFeeDistribution: ReadonlyArray<PercentagePerCmgEntityFull>;
  readonly managementFeeDistribution: ReadonlyArray<PercentagePerCmgEntityFull>;
  readonly overallotmentExercisedSharesDistribution: ReadonlyArray<SharesPerCmgEntityFull>;
  readonly sellingConcessionDistribution: ReadonlyArray<PercentagePerCmgEntityFull>;
  readonly underwritingBaseSharesDistribution: ReadonlyArray<SharesPerCmgEntityFull>;
  /** Underwriting commitments distribution for each manager in the syndicate. Intended for buy-side users with released allocation on the offering. */
  readonly underwritingCommitmentsDistribution?: Maybe<ReadonlyArray<PercentagePerCmgEntityFull>>;
  readonly underwritingFeeBaseDistribution: ReadonlyArray<PercentagePerCmgEntityFull>;
  readonly underwritingFeeTotalDistribution: ReadonlyArray<PercentagePerCmgEntityFull>;
};

export type ManagerEconomicsFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<ManagerEconomicsFullFilterInput>>;
  readonly incentiveFeeDistribution?: InputMaybe<ListFilterInputTypeOfPercentagePerCmgEntityFullFilterInput>;
  readonly managementFeeDistribution?: InputMaybe<ListFilterInputTypeOfPercentagePerCmgEntityFullFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<ManagerEconomicsFullFilterInput>>;
  readonly overallotmentExercisedSharesDistribution?: InputMaybe<ListFilterInputTypeOfSharesPerCmgEntityFullFilterInput>;
  readonly sellingConcessionDistribution?: InputMaybe<ListFilterInputTypeOfPercentagePerCmgEntityFullFilterInput>;
  readonly underwritingBaseSharesDistribution?: InputMaybe<ListFilterInputTypeOfSharesPerCmgEntityFullFilterInput>;
  readonly underwritingFeeBaseDistribution?: InputMaybe<ListFilterInputTypeOfPercentagePerCmgEntityFullFilterInput>;
  readonly underwritingFeeTotalDistribution?: InputMaybe<ListFilterInputTypeOfPercentagePerCmgEntityFullFilterInput>;
};

export type ManagerEconomicsProfile = {
  readonly __typename?: 'ManagerEconomicsProfile';
  readonly underwritingBaseSharesDistribution: ReadonlyArray<SharesPerCmgEntity>;
};

export enum ManagerErrorType {
  DistributionList = 'DISTRIBUTION_LIST',
  Economics = 'ECONOMICS',
  UnderwritingTotalShares = 'UNDERWRITING_TOTAL_SHARES',
}

export type ManagerExpenses = {
  readonly __typename?: 'ManagerExpenses';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly managerName: Scalars['String']['output'];
  readonly managerRole: ExpensesManagerRole;
  /** Display name for ManagerRole */
  readonly managerRoleDisplayName?: Maybe<Scalars['String']['output']>;
  readonly miscellaneous?: Maybe<Scalars['Decimal']['output']>;
  readonly reimbursement?: Maybe<Scalars['Decimal']['output']>;
  readonly technologyAndData?: Maybe<Scalars['Decimal']['output']>;
  readonly travelAndMeals?: Maybe<Scalars['Decimal']['output']>;
};

export type ManagerFull = {
  readonly __typename?: 'ManagerFull';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly entitlements?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly firmName: Scalars['String']['output'];
  readonly firmNameAbbreviation?: Maybe<Scalars['String']['output']>;
  /** For a published offering, returns true if the manager is an active bookrunner or global coordinator and has a relationship with the querying buy-side tenant; returns false otherwise. Returns null for sell-side tenants. */
  readonly hasActiveRelationship?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isJuniorRole?: Maybe<Scalars['Boolean']['output']>;
  readonly isParticipating: Scalars['Boolean']['output'];
  readonly linkedAccountCmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly role: ManagerRole;
};

export type ManagerFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<ManagerFullFilterInput>>;
  readonly cmgEntityKey?: InputMaybe<StringOperationFilterInput>;
  readonly firmName?: InputMaybe<StringOperationFilterInput>;
  readonly firmNameAbbreviation?: InputMaybe<StringOperationFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly isJuniorRole?: InputMaybe<BooleanOperationFilterInput>;
  readonly isParticipating?: InputMaybe<BooleanOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<ManagerFullFilterInput>>;
  readonly role?: InputMaybe<ManagerRoleFilterInput>;
};

export type ManagerLimited = {
  readonly __typename?: 'ManagerLimited';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly firmName: Scalars['String']['output'];
  readonly firmNameAbbreviation?: Maybe<Scalars['String']['output']>;
  readonly role: ManagerRole;
};

export type ManagerProfile = {
  readonly __typename?: 'ManagerProfile';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly firmName: Scalars['String']['output'];
  readonly firmNameAbbreviation?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly role: ManagerRole;
};

export type ManagerResponsibilities = {
  readonly __typename?: 'ManagerResponsibilities';
  readonly duplicateIoiManagers: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly leftLead?: Maybe<Scalars['String']['output']>;
  readonly logisticsAgent?: Maybe<Scalars['String']['output']>;
  readonly settlementAgent?: Maybe<Scalars['String']['output']>;
  readonly stabilizationAgent?: Maybe<Scalars['String']['output']>;
};

export type ManagerResponsibilitiesDataInput = {
  readonly duplicateIoiManagers?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly leftLead?: InputMaybe<Scalars['String']['input']>;
  readonly logisticsAgent?: InputMaybe<Scalars['String']['input']>;
  readonly settlementAgent?: InputMaybe<Scalars['String']['input']>;
  readonly stabilizationAgent?: InputMaybe<Scalars['String']['input']>;
};

export type ManagerResponsibilitiesFull = {
  readonly __typename?: 'ManagerResponsibilitiesFull';
  readonly duplicateIoiManagers?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly leftLead?: Maybe<Scalars['String']['output']>;
  readonly logisticsAgent?: Maybe<Scalars['String']['output']>;
  readonly settlementAgent?: Maybe<Scalars['String']['output']>;
  readonly stabilizationAgent?: Maybe<Scalars['String']['output']>;
};

export type ManagerResponsibilitiesFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<ManagerResponsibilitiesFullFilterInput>>;
  readonly duplicateIoiManagers?: InputMaybe<ListStringOperationFilterInput>;
  readonly leftLead?: InputMaybe<StringOperationFilterInput>;
  readonly logisticsAgent?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<ManagerResponsibilitiesFullFilterInput>>;
  readonly settlementAgent?: InputMaybe<StringOperationFilterInput>;
  readonly stabilizationAgent?: InputMaybe<StringOperationFilterInput>;
};

export type ManagerResponsibilitiesProfile = {
  readonly __typename?: 'ManagerResponsibilitiesProfile';
  readonly duplicateIoiManagers: ReadonlyArray<Scalars['String']['output']>;
  readonly leftLead?: Maybe<Scalars['String']['output']>;
  readonly logisticsAgent?: Maybe<Scalars['String']['output']>;
  readonly settlementAgent?: Maybe<Scalars['String']['output']>;
  readonly stabilizationAgent?: Maybe<Scalars['String']['output']>;
};

export enum ManagerResponsibility {
  DuplicateIoiManager = 'DUPLICATE_IOI_MANAGER',
  LeftLead = 'LEFT_LEAD',
  LogisticsAgent = 'LOGISTICS_AGENT',
  SettlementAgent = 'SETTLEMENT_AGENT',
  StabilizationAgent = 'STABILIZATION_AGENT',
}

export type ManagerRetailRetentionFees = {
  readonly __typename?: 'ManagerRetailRetentionFees';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly payment?: Maybe<Scalars['Long']['output']>;
  readonly retention?: Maybe<Scalars['Long']['output']>;
};

export type ManagerRevisedUnderwritingCommitment = {
  readonly __typename?: 'ManagerRevisedUnderwritingCommitment';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly revisedUnderwritingCommitment?: Maybe<Scalars['Long']['output']>;
};

export enum ManagerRole {
  ActiveBookrunner = 'ACTIVE_BOOKRUNNER',
  Bookrunner = 'BOOKRUNNER',
  CoLead = 'CO_LEAD',
  CoManager = 'CO_MANAGER',
  FacilitationAgent = 'FACILITATION_AGENT',
  GlobalCoordinator = 'GLOBAL_COORDINATOR',
  SellingGroupMember = 'SELLING_GROUP_MEMBER',
  Underwriter = 'UNDERWRITER',
}

export type ManagerRoleFilterInput = {
  readonly eq?: InputMaybe<ManagerRole>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<ManagerRole>>>;
  readonly neq?: InputMaybe<ManagerRole>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<ManagerRole>>>;
};

export type ManagerValidation = {
  readonly __typename?: 'ManagerValidation';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly fields: ReadonlyArray<ManagerErrorType>;
};

export type ManualAdjustment = {
  readonly __typename?: 'ManualAdjustment';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly managerCmgEntityKey: Scalars['ID']['output'];
  readonly manualAdjustment?: Maybe<Scalars['Decimal']['output']>;
};

export enum MarketTiming {
  IntraDay = 'INTRA_DAY',
  PostClose = 'POST_CLOSE',
  PreOpen = 'PRE_OPEN',
}

export type MarketTimingFilterInput = {
  readonly eq?: InputMaybe<MarketTiming>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<MarketTiming>>>;
  readonly neq?: InputMaybe<MarketTiming>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<MarketTiming>>>;
};

export type Marketing = {
  readonly __typename?: 'Marketing';
  readonly callDetails?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly managementTeam?: Maybe<Scalars['String']['output']>;
};

export type MarketingFull = {
  readonly __typename?: 'MarketingFull';
  readonly callDetails?: Maybe<Scalars['String']['output']>;
  readonly managementTeam?: Maybe<Scalars['String']['output']>;
};

export type MarketingFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<MarketingFullFilterInput>>;
  readonly callDetails?: InputMaybe<StringOperationFilterInput>;
  readonly managementTeam?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<MarketingFullFilterInput>>;
};

export type MarketingInput = {
  readonly callDetails?: InputMaybe<Scalars['String']['input']>;
  readonly managementTeam?: InputMaybe<Scalars['String']['input']>;
};

export type MdlAllocation = {
  readonly __typename?: 'MdlAllocation';
  readonly fillPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly investment?: Maybe<Scalars['Decimal']['output']>;
  readonly ioiType: MdlAllocationIoiType;
  readonly lastModified: MdlAllocationLastModified;
  readonly offeringId: Scalars['UUID']['output'];
  readonly ranking: MdlAllocationRanking;
  readonly salesConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly shares?: Maybe<Scalars['Long']['output']>;
};

export type MdlAllocationInput = {
  readonly shares?: InputMaybe<Scalars['Long']['input']>;
};

export enum MdlAllocationIoiType {
  Normal = 'NORMAL',
  Pass = 'PASS',
  RegM = 'REG_M',
}

export type MdlAllocationLastModified = {
  readonly __typename?: 'MdlAllocationLastModified';
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['ID']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export enum MdlAllocationRanking {
  NotIndicated = 'NOT_INDICATED',
  Over_50 = 'OVER_50',
  Top_5 = 'TOP_5',
  Top_10 = 'TOP_10',
  Top_15 = 'TOP_15',
  Top_25 = 'TOP_25',
  Top_50 = 'TOP_50',
}

export type MdlAllocationRankingResponse = {
  readonly __typename?: 'MdlAllocationRankingResponse';
  readonly id: Scalars['ID']['output'];
  readonly ranking: MdlAllocationRanking;
};

export type MdlAllocationResponse = {
  readonly __typename?: 'MdlAllocationResponse';
  readonly allocation?: Maybe<MdlAllocation>;
  readonly id: Scalars['ID']['output'];
};

export type MdlCommunicatedDemandIndications = {
  readonly __typename?: 'MdlCommunicatedDemandIndications';
  readonly id: Scalars['ID']['output'];
  readonly indications: ReadonlyArray<MdlIndication>;
};

export type MdlIndication = {
  readonly __typename?: 'MdlIndication';
  /** Calculated conversion to a number of shares when the indication is saved as a $USD or % of the total base offering size. */
  readonly calculateShares?: Maybe<Scalars['Long']['output']>;
  /** Indications entered as a $USD amount. */
  readonly dollars?: Maybe<Scalars['Decimal']['output']>;
  /** Unique internal identifier relating to the indication entered. */
  readonly id: Scalars['UUID']['output'];
  /** Denotes a premium or a discount percentage */
  readonly limitPercentage?: Maybe<Scalars['Decimal']['output']>;
  /** Offering price limit as submitted in an indication of interest. */
  readonly limitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** Denotes whether an indication of interest has limit prices specified in dollars or as a premium or a discount percentage */
  readonly limitType: MdlIndicationLimitType;
  /** Unique internal identifier for a specific offering. */
  readonly offeringId: Scalars['UUID']['output'];
  /** Indications entered as a % of the total base offering size. */
  readonly percentage?: Maybe<Scalars['Decimal']['output']>;
  /** Denotes whether an indication of interest is placed as an at market or limit price. */
  readonly pricingType: MdlIndicationPricingType;
  /** Firm level demand if different from indication of interest submitted in $USD amounts. */
  readonly realDemandDollars?: Maybe<Scalars['Decimal']['output']>;
  /** Firm level demand if different from indication of interest submitted as a % of the total base offering size. */
  readonly realDemandPercentage?: Maybe<Scalars['Decimal']['output']>;
  /** Firm level demand if different from indication of interest submitted as a number of shares. */
  readonly realDemandShares?: Maybe<Scalars['Long']['output']>;
  /** Indications entered as a number of shares quantity. */
  readonly shares?: Maybe<Scalars['Long']['output']>;
  /** Denotes whether an indication of interest is placed as a $USD amount, % of deal or number of shares. */
  readonly unitType: MdlIndicationUnitType;
};

export type MdlIndicationInput = {
  /** Indications entered as a $USD amount. */
  readonly dollars?: InputMaybe<Scalars['Decimal']['input']>;
  /** Denotes a premium or a discount percentage */
  readonly limitPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  /** Offering price limit as submitted in an indication of interest. */
  readonly limitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** Denotes whether an indication of interest has limit prices specified in dollars or as a premium or a discount percentage */
  readonly limitType: MdlIndicationLimitType;
  /** Indications entered as a % of the total base offering size. */
  readonly percentage?: InputMaybe<Scalars['Decimal']['input']>;
  /** Denotes whether an indication of interest is placed as an at market or limit price. */
  readonly pricingType: MdlIndicationPricingType;
  /** Firm level demand if different from indication of interest submitted in $USD amounts. */
  readonly realDemandDollars?: InputMaybe<Scalars['Decimal']['input']>;
  /** Firm level demand if different from indication of interest submitted as a % of the total base offering size. */
  readonly realDemandPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  /** Firm level demand if different from indication of interest submitted as a number of shares. */
  readonly realDemandShares?: InputMaybe<Scalars['Long']['input']>;
  /** Indications entered as a number of shares quantity. */
  readonly shares?: InputMaybe<Scalars['Long']['input']>;
  /** Denotes whether an indication of interest is placed as a $USD amount, % of deal or number of shares. */
  readonly unitType: MdlIndicationUnitType;
};

export enum MdlIndicationLimitType {
  Discount = 'DISCOUNT',
  Null = 'NULL',
  Premium = 'PREMIUM',
  Price = 'PRICE',
}

export enum MdlIndicationPricingType {
  Limit = 'LIMIT',
  Market = 'MARKET',
}

export enum MdlIndicationUnitType {
  Dollars = 'DOLLARS',
  Percentage = 'PERCENTAGE',
  Shares = 'SHARES',
}

export type MdlIndications = {
  readonly __typename?: 'MdlIndications';
  readonly indications: ReadonlyArray<MdlIndication>;
};

export type MdlInternalDemandIndications = {
  readonly __typename?: 'MdlInternalDemandIndications';
  readonly id: Scalars['ID']['output'];
  readonly indications: ReadonlyArray<MdlIndication>;
};

export type MdlOfferingNote = {
  readonly __typename?: 'MdlOfferingNote';
  readonly id: Scalars['ID']['output'];
  readonly lastEditedAt: Scalars['Instant']['output'];
  readonly lastEditedBy: Scalars['String']['output'];
  readonly note: Scalars['String']['output'];
  readonly subject: OfferingNoteSubject;
  /** Display name for Subject */
  readonly subjectDisplayName?: Maybe<Scalars['String']['output']>;
};

export type MdlOfferingNotes = {
  readonly __typename?: 'MdlOfferingNotes';
  readonly id: Scalars['ID']['output'];
  readonly notes: ReadonlyArray<MdlOfferingNote>;
};

export type MemberFirm = {
  readonly __typename?: 'MemberFirm';
  readonly affiliateMemberId?: Maybe<Scalars['UUID']['output']>;
  readonly cmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly excusedOrPassive: MemberFirmType;
  /** Display name for ExcusedOrPassive */
  readonly excusedOrPassiveDisplayName?: Maybe<Scalars['String']['output']>;
  readonly firmCrdNumber: Scalars['String']['output'];
  readonly firmMpid?: Maybe<Scalars['String']['output']>;
  readonly firmName: Scalars['String']['output'];
  readonly ownerCmgEntityKey?: Maybe<Scalars['String']['output']>;
};

export type MemberFirmInput = {
  readonly affiliateMemberId?: InputMaybe<Scalars['UUID']['input']>;
  readonly cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  readonly excusedOrPassive: MemberFirmType;
  readonly firmCrdNumber: Scalars['String']['input'];
  readonly firmMpid?: InputMaybe<Scalars['String']['input']>;
  readonly firmName: Scalars['String']['input'];
};

export enum MemberFirmType {
  Excused = 'EXCUSED',
  Passive = 'PASSIVE',
}

export enum MoodyRating {
  Aaa = 'AAA',
  Aa_1 = 'AA_1',
  Aa_2 = 'AA_2',
  Aa_3 = 'AA_3',
  A_1 = 'A_1',
  A_2 = 'A_2',
  A_3 = 'A_3',
  Baa_1 = 'BAA_1',
  Baa_2 = 'BAA_2',
  Baa_3 = 'BAA_3',
  Ba_1 = 'BA_1',
  Ba_2 = 'BA_2',
  Ba_3 = 'BA_3',
  B_1 = 'B_1',
  B_2 = 'B_2',
  B_3 = 'B_3',
  C = 'C',
  Ca = 'CA',
  Caa_1 = 'CAA_1',
  Caa_2 = 'CAA_2',
  Caa_3 = 'CAA_3',
}

export type MoodyRatingFilterInput = {
  readonly eq?: InputMaybe<MoodyRating>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<MoodyRating>>>;
  readonly neq?: InputMaybe<MoodyRating>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<MoodyRating>>>;
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  /** Accept sent Syndicate Wire invitation */
  readonly acceptWire: WireResponse;
  /** Acknowledge a Covered Indication */
  readonly acknowledgeCoveredIndication: ReadonlyArray<InstitutionalIndicationAcknowledgement>;
  /** Acknowledge a Final Institutional Allocation as Covered Sales and Trading */
  readonly acknowledgeCoveredInstitutionalIndication: CoveredInstitutionalIndication;
  /** Acknowledge an Institutional Indication */
  readonly acknowledgeInstitutionalIndication: ReadonlyArray<InstitutionalIndicationAcknowledgement>;
  readonly acknowledgeMyFinalInstitutionalAllocation: FinalAllocation;
  readonly activateInternalDemandOffering: MdlAllocationResponse;
  /** Add/Assign Currency to a Tranche */
  readonly addCurrencyToTranche?: Maybe<AddCurrencyToTranchePayload>;
  /** Add/Assign Instrument to a Tranche */
  readonly addInstrumentToTranche?: Maybe<AddInstrumentToTranchePayload>;
  readonly addViewSetting?: Maybe<AddViewSettingPayload>;
  readonly addWallCrossInvestor?: Maybe<AddWallCrossInvestorPayload>;
  readonly addWallCrossInvestorCommunicationLog?: Maybe<AddWallCrossInvestorCommunicationLogPayload>;
  readonly addWallCrossOwner?: Maybe<AddWallCrossOwnerPayload>;
  readonly adminCreateInvestorFirm?: Maybe<AdminCreateInvestorFirmPayload>;
  readonly adminCreateInvestorFirmEmployee?: Maybe<AdminCreateInvestorFirmEmployeePayload>;
  readonly adminCreateInvestorRelationships?: Maybe<AdminCreateInvestorRelationshipsPayload>;
  readonly adminCreateUnderwriterEmployee?: Maybe<AdminCreateUnderwriterEmployeePayload>;
  readonly adminUpdateInvestorFirm?: Maybe<AdminUpdateInvestorFirmPayload>;
  readonly adminUpdateInvestorFirmEmployee?: Maybe<AdminUpdateInvestorFirmEmployeePayload>;
  readonly adminUpdateInvestorRelationship?: Maybe<AdminUpdateInvestorRelationshipPayload>;
  readonly adminUpdateUnderwriterEmployee?: Maybe<AdminUpdateUnderwriterEmployeePayload>;
  readonly assignContacts: ContactCollection;
  readonly assignCoveredContacts: ContactCollection;
  /** Deletes/Removes Institutional Indication Acknowledgement. */
  readonly assignCoveredInvestorKey: UpdateInvestorCrmKeyResult;
  readonly assignDesignationToManager: DesignationsGrid;
  readonly assignFinalAllocationSetVisibility: FinalInstitutionalAllocationSet;
  readonly assignIndicationNote: ReadonlyArray<Note>;
  /** Assign private CRM investor key */
  readonly assignInvestorKey: UpdateInvestorCrmKeyResult;
  /** Assigns a Buy Side Firm's Institutional Indication for an On-Platform Offering */
  readonly assignMyInstitutionalIndication: MyInstitutionalIndication;
  readonly assignRetailDemand: TotalRetailSummaryItemDemand;
  readonly assignRetailRetention: TotalRetailSummaryItemRetention;
  readonly backfillViewSettings?: Maybe<BackfillViewSettingsPayload>;
  readonly batchAssignRoadshowMeetingTypeEngagement?: Maybe<BatchAssignRoadshowMeetingTypeEngagementPayload>;
  readonly batchAssignTestingTheWatersEngagement?: Maybe<BatchAssignTestingTheWatersEngagementPayload>;
  readonly batchAssignWallCrossEngagement?: Maybe<BatchAssignWallCrossEngagementPayload>;
  readonly batchUpdateBndAgent: BulkAssignBndAgentPayload;
  readonly bulkAssignBndAgent: BulkAssignBndAgentPayload;
  readonly bulkAssignBndAgentByIds: BulkAssignBndAgentPayload;
  readonly bulkUpdateAllocations: UpdatedAllocationSets;
  readonly bulkUpdateAllocationsByIds: UpdatedAllocationSets;
  readonly calculateFeesDistributions?: Maybe<CalculateFeesDistributionsPayload>;
  readonly calculateSharesDistributions?: Maybe<CalculateSharesDistributionsPayload>;
  readonly copyViewSetting?: Maybe<CopyViewSettingPayload>;
  /** Create new or activate existing deleted Delivery Instrument */
  readonly createDeliveryInstrument?: Maybe<CreateDeliveryInstrumentPayload>;
  /** Creates a demand currency for an offering */
  readonly createDemandCurrency?: Maybe<CreateDemandCurrencyPayload>;
  /** Create a DesignationWire */
  readonly createDesignationWire: DesignationWireResponseUnion;
  readonly createDraftAllocationSet: DraftAllocationSet;
  readonly createExpensesRevision: Expenses;
  /** Create new Filing or update existing deleted Filing */
  readonly createFiling?: Maybe<CreateFilingPayload>;
  readonly createFinalInstitutionalAllocationSet: FinalInstitutionalAllocationSet;
  readonly createFirmEmployee?: Maybe<CreateFirmEmployeePayload>;
  /** Create a FreeFormWire */
  readonly createFreeFormWire: FreeFormWireResponseUnion;
  /** Create a GreenShoeWire */
  readonly createGreenShoeWire: GreenShoeWireResponseUnion;
  readonly createInvestorFirm?: Maybe<CreateInvestorFirmPayload>;
  readonly createInvestorFirmBasic: InvestorFirmBasicUnion;
  readonly createInvestorFirmEmployee?: Maybe<CreateInvestorFirmEmployeePayload>;
  readonly createInvestorRelationships?: Maybe<CreateInvestorRelationshipsPayload>;
  /** Create a IssuerAllocationWire */
  readonly createIssuerAllocationWire: IssuerAllocationWireResponseUnion;
  /** Create a IssuerIndicationWire */
  readonly createIssuerIndicationWire: IssuerIndicationWireResponseUnion;
  /** Add a new Manager or update existing deleted Manager */
  readonly createManager?: Maybe<CreateManagerPayload>;
  /** Create a ManagerBdWire */
  readonly createManagerBdWire: ManagerBdWireResponseUnion;
  readonly createMyRetailBroker: RetailBrokerDealer;
  /** Create a NonSyndicateFreeFormWire */
  readonly createNonSyndicateFreeFormWire: NonSyndicateFreeFormWireResponseUnion;
  /** Create a NonSyndicatePaymentWire */
  readonly createNonSyndicatePaymentWire: NonSyndicatePaymentWireResponseUnion;
  /** Create a NonSyndicateSellingGroupInvitationWire */
  readonly createNonSyndicateSellingGroupInvitationWire: NonSyndicateSellingGroupInvitationWireResponseUnion;
  /** Create a NonSyndicateSellingGroupTermsRetentionWire */
  readonly createNonSyndicateSellingGroupTermsRetentionWire: NonSyndicateSellingGroupTermsRetentionWireResponseUnion;
  /** Create a NonSyndicateTerminationWire */
  readonly createNonSyndicateTerminationWire: NonSyndicateTerminationWireResponseUnion;
  /** Create an Offering Draft */
  readonly createOfferingDraft?: Maybe<CreateOfferingDraftPayload>;
  readonly createOfferingNote: MdlOfferingNotes;
  /** Creates or updates demand currencies for an offering */
  readonly createOrUpdateDemandCurrencies?: Maybe<CreateOrUpdateDemandCurrenciesPayload>;
  readonly createOrUpdateStabilization: Stabilization;
  /** Create a PaymentWire */
  readonly createPaymentWire: PaymentWireResponseUnion;
  /** Create a PotAccountWire */
  readonly createPotAccountWire: PotAccountWireResponseUnion;
  /** Create a PotAllocationWire */
  readonly createPotAllocationWire: PotAllocationWireResponseUnion;
  /** Create a PricingTermsRetentionWire */
  readonly createPricingTermsRetentionWire: PricingTermsRetentionWireResponseUnion;
  /** Create a PricingTermsWire */
  readonly createPricingTermsWire: PricingTermsWireResponseUnion;
  /** Create a RegMWire */
  readonly createRegMWire: RegMWireResponseUnion;
  /** Create a ResearchRestrictionWire */
  readonly createResearchRestrictionWire: ResearchRestrictionWireResponseUnion;
  /** Create a RetentionWire */
  readonly createRetentionWire: RetentionWireResponseUnion;
  /** Create Roadshow Schedules for an offering */
  readonly createRoadshowSchedule?: Maybe<CreateRoadshowSchedulePayload>;
  /** Create a SellingGroupInvitationWire */
  readonly createSellingGroupInvitationWire: SellingGroupInvitationWireResponseUnion;
  /** Create a SellingGroupTermsWire */
  readonly createSellingGroupTermsWire: SellingGroupTermsWireResponseUnion;
  /** Create a TerminationWire */
  readonly createTerminationWire: TerminationWireResponseUnion;
  readonly createUnderwriterEmployee?: Maybe<CreateUnderwriterEmployeePayload>;
  /** Create a UnderwriterInvitationWire */
  readonly createUnderwriterInvitationWire: UnderwriterInvitationWireResponseUnion;
  /** Decline sent Syndicate Wire invitation */
  readonly declineWire: WireResponse;
  /** Delete/Unassign Currency from a Tranche */
  readonly deleteCurrencyFromTranche?: Maybe<DeleteCurrencyFromTranchePayload>;
  /** Delete an Instrument by assigning a Record Status of Deleted */
  readonly deleteDeliveryInstrument?: Maybe<DeleteDeliveryInstrumentPayload>;
  /** Marks an existing demand currency as DELETED */
  readonly deleteDemandCurrency?: Maybe<DeleteDemandCurrencyPayload>;
  /** Delete a DesignationWire */
  readonly deleteDesignationWire: DeleteDesignationWireResponseUnion;
  readonly deleteDraftInstitutionalAllocationSet: DraftAllocationSet;
  /** Remove a Filing */
  readonly deleteFiling?: Maybe<DeleteFilingPayload>;
  readonly deleteFirmEmployee?: Maybe<DeleteFirmEmployeePayload>;
  /** Delete a FreeFormWire */
  readonly deleteFreeFormWire: DeleteFreeFormWireResponseUnion;
  /** Delete a GreenShoeWire */
  readonly deleteGreenShoeWire: DeleteGreenShoeWireResponseUnion;
  readonly deleteIndication: DeleteIndicationPayload;
  /** Deletes/Unassigns Billing and Delivery Agent. */
  readonly deleteInstitutionalIndicationBillingAndDeliveryAgent: DeleteBillingAndDeliveryAgentResult;
  /** Delete/Unassign Instrument from a Tranche */
  readonly deleteInstrumentFromTranche?: Maybe<DeleteInstrumentFromTranchePayload>;
  /** Delete a IssuerAllocationWire */
  readonly deleteIssuerAllocationWire: DeleteIssuerAllocationWireResponseUnion;
  /** Delete a IssuerIndicationWire */
  readonly deleteIssuerIndicationWire: DeleteIssuerIndicationWireResponseUnion;
  /** Set Manager status to Deleted */
  readonly deleteManager?: Maybe<DeleteManagerPayload>;
  /** Delete a ManagerBdWire */
  readonly deleteManagerBdWire: DeleteManagerBdWireResponseUnion;
  readonly deleteMyRetailBroker: DeleteMyRetailDemandBroker;
  /** Delete a NonSyndicateFreeFormWire */
  readonly deleteNonSyndicateFreeFormWire: DeleteNonSyndicateFreeFormWireResponseUnion;
  /** Delete a NonSyndicatePaymentWire */
  readonly deleteNonSyndicatePaymentWire: DeleteNonSyndicatePaymentWireResponseUnion;
  /** Delete a NonSyndicateSellingGroupInvitationWire */
  readonly deleteNonSyndicateSellingGroupInvitationWire: DeleteNonSyndicateSellingGroupInvitationWireResponseUnion;
  /** Delete a NonSyndicateSellingGroupTermsRetentionWire */
  readonly deleteNonSyndicateSellingGroupTermsRetentionWire: DeleteNonSyndicateSellingGroupTermsRetentionWireResponseUnion;
  /** Delete a NonSyndicateTerminationWire */
  readonly deleteNonSyndicateTerminationWire: DeleteNonSyndicateTerminationWireResponseUnion;
  readonly deleteOfferingNote: MdlOfferingNotes;
  /** Delete a PaymentWire */
  readonly deletePaymentWire: DeletePaymentWireResponseUnion;
  /** Delete a PotAccountWire */
  readonly deletePotAccountWire: DeletePotAccountWireResponseUnion;
  /** Delete a PotAllocationWire */
  readonly deletePotAllocationWire: DeletePotAllocationWireResponseUnion;
  /** Delete a PricingTermsRetentionWire */
  readonly deletePricingTermsRetentionWire: DeletePricingTermsRetentionWireResponseUnion;
  /** Delete a PricingTermsWire */
  readonly deletePricingTermsWire: DeletePricingTermsWireResponseUnion;
  /** Delete a RegMWire */
  readonly deleteRegMWire: DeleteRegMWireResponseUnion;
  /** Delete a ResearchRestrictionWire */
  readonly deleteResearchRestrictionWire: DeleteResearchRestrictionWireResponseUnion;
  /** Delete a RetentionWire */
  readonly deleteRetentionWire: DeleteRetentionWireResponseUnion;
  /** Delete the Roadshow Schedule for an offering */
  readonly deleteRoadshowSchedule?: Maybe<DeleteRoadshowSchedulePayload>;
  /** Delete a SellingGroupInvitationWire */
  readonly deleteSellingGroupInvitationWire: DeleteSellingGroupInvitationWireResponseUnion;
  /** Delete a SellingGroupTermsWire */
  readonly deleteSellingGroupTermsWire: DeleteSellingGroupTermsWireResponseUnion;
  /** Delete a TerminationWire */
  readonly deleteTerminationWire: DeleteTerminationWireResponseUnion;
  /** Delete a UnderwriterInvitationWire */
  readonly deleteUnderwriterInvitationWire: DeleteUnderwriterInvitationWireResponseUnion;
  readonly deleteViewSetting?: Maybe<DeleteViewSettingPayload>;
  readonly deleteWallCrossIndication?: Maybe<DeleteWallCrossIndicationPayload>;
  readonly deleteWallCrossInvestor?: Maybe<DeleteWallCrossInvestorPayload>;
  readonly deleteWallCrossInvestorCommunicationLog?: Maybe<DeleteWallCrossInvestorCommunicationLogPayload>;
  readonly deleteWallCrossOwner?: Maybe<DeleteWallCrossOwnerPayload>;
  /** Discard a Draft or Published Offering */
  readonly discardOffering?: Maybe<DiscardOfferingPayload>;
  readonly duplicateDraftAllocationSet: DraftAllocationSet;
  /** Copy Final Institutional Allocation Set to Draft */
  readonly duplicateFinalAllocationSet: DraftAllocationSet;
  readonly importWallCrossInvestor?: Maybe<ImportWallCrossInvestorPayload>;
  /** Batch - Mark Institutional Indications as duplicate */
  readonly markIndicationsAsDuplicate: InstitutionalIndication;
  readonly overwriteDraftAllocationSet: DraftAllocationSet;
  /** Pass an Offering with existing Covered Institutional Indication */
  readonly passCoveredInstitutionalIndication: InstitutionalIndicationSubmitResponse;
  /** Pass Institutional Indication */
  readonly passInstitutionalIndication: InstitutionalIndicationSubmitResponse;
  readonly passInternalDemandOffering: MdlAllocationResponse;
  readonly passOfferingWithoutCoveredInstitutionalIndication: InstitutionalIndicationSubmitResponse;
  /** Buy Side Firm has opted to pass on an On-Platform Offering */
  readonly passOnOffering: PassOnOfferingResponseUnion;
  /** Pass on Offering without Institutional Indication */
  readonly passOnOfferingWithoutInstitutionalIndication: InstitutionalIndicationSubmitResponse;
  readonly publishDesignations: EmptyMutationResponse;
  /** Publish an offering */
  readonly publishOffering?: Maybe<PublishOfferingPayload>;
  readonly refreshOrderBookSummary?: Maybe<RefreshOrderBookSummaryPayload>;
  readonly regMInternalDemandOffering: MdlAllocationResponse;
  readonly releaseFinalInstitutionalAllocationSet: FinalInstitutionalAllocationSet;
  readonly releaseRetailRetention: ReadonlyArray<ReleasedRetailRetention>;
  readonly releaseSalesCredits: SalesCreditGrid;
  readonly releaseTradesBatch: ReadonlyArray<TradeGridItem>;
  readonly renameViewSetting?: Maybe<RenameViewSettingPayload>;
  readonly resendProspectusAsSalesAndTrading: ResendProspectusResponseUnion;
  readonly resendProspectusAsSalesAndTradingByIndicationSelection?: Maybe<ResendProspectusAsSalesAndTradingByIndicationSelectionPayload>;
  readonly resendProspectusAsSyndicate: ResendProspectusResponseUnion;
  readonly resendProspectusAsSyndicateByIndicationSelection?: Maybe<ResendProspectusAsSyndicateByIndicationSelectionPayload>;
  /** Re-submits DS filing */
  readonly resubmitDSFiling: DsFiling;
  /** Re-submits NOI filing */
  readonly resubmitNOIFiling: NoiFiling;
  /** Re-submits RPN filing */
  readonly resubmitRPNFiling: RpnFiling;
  /** Re-submits TN filing */
  readonly resubmitTNFiling: TnFiling;
  /** Re-submits USDTN filing */
  readonly resubmitUSDTNFiling: UsdtnFiling;
  readonly retryDataSync?: Maybe<RetryDataSyncPayload>;
  readonly reviewSalesCreditsBankInvestorKeyChange: SalesCreditGrid;
  readonly sendDLSupportRequest: SendDlSupportRequestResponse;
  /** Send a DesignationWire */
  readonly sendDesignationWire: DesignationWireResponseUnion;
  /** Send a FreeFormWire */
  readonly sendFreeFormWire: FreeFormWireResponseUnion;
  /** Send a GreenShoeWire */
  readonly sendGreenShoeWire: GreenShoeWireResponseUnion;
  /** Send a IssuerAllocationWire */
  readonly sendIssuerAllocationWire: IssuerAllocationWireResponseUnion;
  /** Send a IssuerIndicationWire */
  readonly sendIssuerIndicationWire: IssuerIndicationWireResponseUnion;
  /** Send a ManagerBdWire */
  readonly sendManagerBdWire: ManagerBdWireResponseUnion;
  /** Send a NonSyndicateFreeFormWire */
  readonly sendNonSyndicateFreeFormWire: NonSyndicateFreeFormWireResponseUnion;
  /** Send a NonSyndicatePaymentWire */
  readonly sendNonSyndicatePaymentWire: NonSyndicatePaymentWireResponseUnion;
  /** Send a NonSyndicateSellingGroupInvitationWire */
  readonly sendNonSyndicateSellingGroupInvitationWire: NonSyndicateSellingGroupInvitationWireResponseUnion;
  /** Send a NonSyndicateSellingGroupTermsRetentionWire */
  readonly sendNonSyndicateSellingGroupTermsRetentionWire: NonSyndicateSellingGroupTermsRetentionWireResponseUnion;
  /** Send a NonSyndicateTerminationWire */
  readonly sendNonSyndicateTerminationWire: NonSyndicateTerminationWireResponseUnion;
  /** Send a PaymentWire */
  readonly sendPaymentWire: PaymentWireResponseUnion;
  /** Send a PotAccountWire */
  readonly sendPotAccountWire: PotAccountWireResponseUnion;
  /** Send a PotAllocationWire */
  readonly sendPotAllocationWire: PotAllocationWireResponseUnion;
  /** Send a PricingTermsRetentionWire */
  readonly sendPricingTermsRetentionWire: PricingTermsRetentionWireResponseUnion;
  /** Send a PricingTermsWire */
  readonly sendPricingTermsWire: PricingTermsWireResponseUnion;
  /** Send a RegMWire */
  readonly sendRegMWire: RegMWireResponseUnion;
  readonly sendRegulatoryFilingEmailNotification: ReadonlyArray<RegulatoryFilingNotificationMessage>;
  /** Send a ResearchRestrictionWire */
  readonly sendResearchRestrictionWire: ResearchRestrictionWireResponseUnion;
  /** Send a RetentionWire */
  readonly sendRetentionWire: RetentionWireResponseUnion;
  /** Send a SellingGroupInvitationWire */
  readonly sendSellingGroupInvitationWire: SellingGroupInvitationWireResponseUnion;
  /** Send a SellingGroupTermsWire */
  readonly sendSellingGroupTermsWire: SellingGroupTermsWireResponseUnion;
  /** Send a TerminationWire */
  readonly sendTerminationWire: TerminationWireResponseUnion;
  /** Send a UnderwriterInvitationWire */
  readonly sendUnderwriterInvitationWire: UnderwriterInvitationWireResponseUnion;
  readonly setAllocationRanking: MdlAllocationResponse;
  readonly setAllocationRankingOnOffering: MdlAllocationRankingResponse;
  /** Set Default Instrument for a Tranche */
  readonly setDefaultInstrumentForTranche?: Maybe<SetDefaultInstrumentForTranchePayload>;
  /** Set Pricing Currency on Offering */
  readonly setPricingCurrency?: Maybe<SetPricingCurrencyPayload>;
  /** Set the Pricing Instrument for an Offering */
  readonly setPricingInstrument?: Maybe<SetPricingInstrumentPayload>;
  readonly setViewSettingFavorite?: Maybe<SetViewSettingFavoritePayload>;
  /** Share offering draft with selected managers */
  readonly shareDraft?: Maybe<ShareDraftPayload>;
  readonly shareDraftAllocationSet: DraftAllocationSet;
  readonly shareFinalAllocationSet: FinalInstitutionalAllocationSet;
  /** Submits an Covered Institutional Indication */
  readonly submitCoveredInstitutionalIndication: InstitutionalIndicationSubmitResponse;
  /** Submit DS filing */
  readonly submitDSFiling: DsFiling;
  /** Submits an Covered Institutional Indication */
  readonly submitInstitutionalIndication: InstitutionalIndicationSubmitResponse;
  /** Submit NOI filing */
  readonly submitNOIFiling: NoiFiling;
  /** Submit RPN filing */
  readonly submitRPNFiling: RpnFiling;
  readonly submitRetailDemand: TotalSubmittedRetailDemandInfo;
  /** Submit TN filing */
  readonly submitTNFiling: TnFiling;
  /** Submit USDTN filing */
  readonly submitUSDTNFiling: UsdtnFiling;
  readonly submitWallCrossIndication?: Maybe<SubmitWallCrossIndicationPayload>;
  readonly submitWallCrossPass?: Maybe<SubmitWallCrossPassPayload>;
  readonly syncInstitutionalIndication?: Maybe<SyncInstitutionalIndicationPayload>;
  /** Deletes/Removes Institutional Indication Acknowledgement. */
  readonly unacknowledgeCoveredIndication: UnacknowledgeInstitutionalIndicationResult;
  /** Unacknowledgement Covered Institutional Final Allocation */
  readonly unacknowledgeCoveredInstitutionalFinalAllocation: CoveredInstitutionalIndication;
  readonly unacknowledgeInstitutionalFinalAllocation: FinalAllocation;
  /** Deletes/Removes Institutional Indication Acknowledgement. */
  readonly unacknowledgeInstitutionalIndication: UnacknowledgeInstitutionalIndicationResult;
  /** Unmark Institutional Indications as duplicate */
  readonly unmarkIndicationsAsDuplicate: InstitutionalIndication;
  readonly updateAccountingAdjustments: ReadonlyArray<ManualAdjustment>;
  readonly updateAccountingNotes: AccountingNotes;
  readonly updateAdditionalTerms?: Maybe<UpdateAdditionalTermsPayload>;
  readonly updateAttestationEnforcement?: Maybe<UpdateAttestationEnforcementPayload>;
  /** Update offering basic information */
  readonly updateBasicInfo?: Maybe<UpdateBasicInfoPayload>;
  /** Update Covered Indication */
  readonly updateCoveredIndication: InstitutionalIndication;
  /** Updates an Covered Institutional Indication status */
  readonly updateCoveredIndicationStatus: InstitutionalIndicationUpdateResponse;
  /** Update a Delivery Instrument */
  readonly updateDeliveryInstrument?: Maybe<UpdateDeliveryInstrumentPayload>;
  /** Updates a demand currency for an offering */
  readonly updateDemandCurrency?: Maybe<UpdateDemandCurrencyPayload>;
  /** Update a DesignationWire */
  readonly updateDesignationWire: DesignationWireResponseUnion;
  /** Updates the disclaimers for an offering */
  readonly updateDisclaimers?: Maybe<UpdateDisclaimersPayload>;
  readonly updateDraftAllocationSetDealLayout: DraftAllocationSet;
  readonly updateDraftAllocationSetName: DraftAllocationSet;
  readonly updateDraftInstitutionalAllocation: DraftAllocation;
  readonly updateDraftInstitutionalAllocations: Scalars['String']['output'];
  readonly updateFeesAndDiscounts?: Maybe<UpdateFeesAndDiscountsPayload>;
  /** Updates a Filing */
  readonly updateFiling?: Maybe<UpdateFilingPayload>;
  readonly updateFinalAllocationSetDealLayout: FinalInstitutionalAllocationSet;
  /** Updates a Final Institutional Allocation */
  readonly updateFinalInstitutionalAllocation: FinalAllocation;
  readonly updateFinalInstitutionalAllocationAcknowledgementStatus: FinalAllocation;
  readonly updateFinalInstitutionalAllocations: FinalInstitutionalAllocationsUpdateResponse;
  readonly updateFirmEmployee?: Maybe<UpdateFirmEmployeePayload>;
  /** Updates the Follow-On Pricing for an offering */
  readonly updateFollowOnPricing?: Maybe<UpdateFollowOnPricingPayload>;
  /** Update a FreeFormWire */
  readonly updateFreeFormWire: FreeFormWireResponseUnion;
  readonly updateFundIois: FundIois;
  /** Update a GreenShoeWire */
  readonly updateGreenShoeWire: GreenShoeWireResponseUnion;
  readonly updateIncentiveFeeDistribution?: Maybe<UpdateIncentiveFeeDistributionPayload>;
  /** Update Institutional Indication */
  readonly updateInstitutionalIndication: InstitutionalIndication;
  /** Updates a Billing and Delivery Agent. */
  readonly updateInstitutionalIndicationBillingAndDeliveryAgent: BillingAndDeliveryAgent;
  /** Batch - Updates a Billing and Delivery Agent for Multiple Indications. */
  readonly updateInstitutionalIndicationBillingAndDeliveryAgentForIndications: ReadonlyArray<
    Scalars['String']['output']
  >;
  /** Updates Institutional Indication status */
  readonly updateInstitutionalIndicationStatus: InstitutionalIndication;
  readonly updateInvestorFirm: UpdateInvestorFirmPayload;
  readonly updateInvestorFirmEmployee: UpdateInvestorFirmEmployeePayload;
  readonly updateInvestorRelationship?: Maybe<UpdateInvestorRelationshipPayload>;
  /** Update a IssuerAllocationWire */
  readonly updateIssuerAllocationWire: IssuerAllocationWireResponseUnion;
  /** Update a IssuerIndicationWire */
  readonly updateIssuerIndicationWire: IssuerIndicationWireResponseUnion;
  readonly updateManagementFeeDistribution?: Maybe<UpdateManagementFeeDistributionPayload>;
  /** Update a Manager */
  readonly updateManager?: Maybe<UpdateManagerPayload>;
  /** Update a ManagerBdWire */
  readonly updateManagerBdWire: ManagerBdWireResponseUnion;
  /** Update Manager Firm */
  readonly updateManagerFirm?: Maybe<UpdateManagerFirmPayload>;
  /** Update Manager Responsibilities on an Offering */
  readonly updateManagerResponsibilities?: Maybe<UpdateManagerResponsibilitiesPayload>;
  /** Update Manager Sequence Order on Offering */
  readonly updateManagerSequence?: Maybe<UpdateManagerSequencePayload>;
  /** Update Marketing info for an Offering */
  readonly updateMarketing?: Maybe<UpdateMarketingPayload>;
  /** Update my indication status */
  readonly updateMyIndicationStatus: MyInstitutionalIndication;
  readonly updateMyRetail: MyRetailSummary;
  readonly updateMyRetailBroker: RetailBrokerDealer;
  /** Update a NonSyndicateFreeFormWire */
  readonly updateNonSyndicateFreeFormWire: NonSyndicateFreeFormWireResponseUnion;
  /** Update a NonSyndicatePaymentWire */
  readonly updateNonSyndicatePaymentWire: NonSyndicatePaymentWireResponseUnion;
  /** Update a NonSyndicateSellingGroupInvitationWire */
  readonly updateNonSyndicateSellingGroupInvitationWire: NonSyndicateSellingGroupInvitationWireResponseUnion;
  /** Update a NonSyndicateSellingGroupTermsRetentionWire */
  readonly updateNonSyndicateSellingGroupTermsRetentionWire: NonSyndicateSellingGroupTermsRetentionWireResponseUnion;
  /** Update a NonSyndicateTerminationWire */
  readonly updateNonSyndicateTerminationWire: NonSyndicateTerminationWireResponseUnion;
  readonly updateOfferingNote: MdlOfferingNotes;
  /** Update offering status */
  readonly updateOfferingStatus?: Maybe<UpdateOfferingStatusPayload>;
  /** Updates the order book configuration for an offering */
  readonly updateOrderBookConfiguration?: Maybe<UpdateOrderBookConfigurationPayload>;
  readonly updateOrderBookSalesState?: Maybe<UpdateOrderBookSalesStatePayload>;
  readonly updateOrderBookState: OrderBook;
  readonly updateOverAllotmentExercise?: Maybe<UpdateOverAllotmentExercisePayload>;
  readonly updateOverallotmentExercisedSharesDistribution?: Maybe<UpdateOverallotmentExercisedSharesDistributionPayload>;
  /** Update a PaymentWire */
  readonly updatePaymentWire: PaymentWireResponseUnion;
  /** Update a PotAccountWire */
  readonly updatePotAccountWire: PotAccountWireResponseUnion;
  /** Update a PotAllocationWire */
  readonly updatePotAllocationWire: PotAllocationWireResponseUnion;
  /** Update a PricingTermsRetentionWire */
  readonly updatePricingTermsRetentionWire: PricingTermsRetentionWireResponseUnion;
  /** Update a PricingTermsWire */
  readonly updatePricingTermsWire: PricingTermsWireResponseUnion;
  readonly updatePrivateManagerEconomics?: Maybe<UpdatePrivateManagerEconomicsPayload>;
  /** Updates the Private Placement Terms for an offering */
  readonly updatePrivatePlacementTerms?: Maybe<UpdatePrivatePlacementTermsPayload>;
  /** Updates the prospectus documents for an offering */
  readonly updateProspectusDocumentsMetadata?: Maybe<UpdateProspectusDocumentsMetadataPayload>;
  /** Update a RegMWire */
  readonly updateRegMWire: RegMWireResponseUnion;
  /** Update a ResearchRestrictionWire */
  readonly updateResearchRestrictionWire: ResearchRestrictionWireResponseUnion;
  /** Update a RetentionWire */
  readonly updateRetentionWire: RetentionWireResponseUnion;
  /** Update the Roadshow Schedules for an offering */
  readonly updateRoadshowSchedule?: Maybe<UpdateRoadshowSchedulePayload>;
  readonly updateSalesCreditsAmount: SalesCreditGrid;
  readonly updateSalesCreditsBankInvestorKey: SalesCreditGrid;
  readonly updateSalesCreditsHouseAccounts: ReadonlyArray<HouseAccount>;
  readonly updateSalesCreditsStatus: SalesCreditGrid;
  readonly updateSellingConcessionDistribution?: Maybe<UpdateSellingConcessionDistributionPayload>;
  /** Update a SellingGroupInvitationWire */
  readonly updateSellingGroupInvitationWire: SellingGroupInvitationWireResponseUnion;
  /** Update a SellingGroupTermsWire */
  readonly updateSellingGroupTermsWire: SellingGroupTermsWireResponseUnion;
  /** Update Offering Syndicate */
  readonly updateSyndicate?: Maybe<UpdateSyndicatePayload>;
  /** Update a TerminationWire */
  readonly updateTerminationWire: TerminationWireResponseUnion;
  /** Update offering timing information */
  readonly updateTimingInfo?: Maybe<UpdateTimingInfoPayload>;
  readonly updateTotalRetailDemand: TotalRetailSummaryGrid;
  readonly updateTradeReleaseSettings: TradeReleaseSettings;
  readonly updateTradesStatusBatch: ReadonlyArray<TradeGridItem>;
  /** Update a Tranche */
  readonly updateTranche?: Maybe<UpdateTranchePayload>;
  readonly updateUnderwriterEmployee?: Maybe<UpdateUnderwriterEmployeePayload>;
  /** Update a UnderwriterInvitationWire */
  readonly updateUnderwriterInvitationWire: UnderwriterInvitationWireResponseUnion;
  readonly updateUnderwritingBaseSharesDistribution?: Maybe<UpdateUnderwritingBaseSharesDistributionPayload>;
  readonly updateUnderwritingFeeBaseDistribution?: Maybe<UpdateUnderwritingFeeBaseDistributionPayload>;
  readonly updateUnderwritingFeeTotalDistribution?: Maybe<UpdateUnderwritingFeeTotalDistributionPayload>;
  /** Update Underwriting Terms Fees and Discounts for an Offering */
  readonly updateUnderwritingTermsFeesAndDiscounts?: Maybe<UpdateUnderwritingTermsFeesAndDiscountsPayload>;
  readonly updateViewSettingData?: Maybe<UpdateViewSettingDataPayload>;
  readonly updateWallCrossIndication?: Maybe<UpdateWallCrossIndicationPayload>;
  readonly updateWallCrossIndicationToPass?: Maybe<UpdateWallCrossIndicationToPassPayload>;
  readonly updateWallCrossInvestor?: Maybe<UpdateWallCrossInvestorPayload>;
  readonly updateWallCrossInvestorCommunicationLog?: Maybe<UpdateWallCrossInvestorCommunicationLogPayload>;
  readonly updateWallCrossOwner?: Maybe<UpdateWallCrossOwnerPayload>;
  readonly updateXcNotificationSettings?: Maybe<UpdateXcNotificationSettingsPayload>;
  readonly updateXcNotificationSettingsForUser?: Maybe<UpdateXcNotificationSettingsForUserPayload>;
  readonly upsertCommunicatedDemandAllocation: MdlAllocationResponse;
  readonly upsertCommunicatedDemandIndications: MdlCommunicatedDemandIndications;
  readonly upsertInternalDemandIndications: MdlInternalDemandIndications;
};

export type MutationAcceptWireArgs = {
  body: InvitationWireResponseInput;
  sentWireId: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
};

export type MutationAcknowledgeCoveredIndicationArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
  version: Scalars['String']['input'];
};

export type MutationAcknowledgeCoveredInstitutionalIndicationArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
  versionId: Scalars['String']['input'];
};

export type MutationAcknowledgeInstitutionalIndicationArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
  version: Scalars['String']['input'];
};

export type MutationAcknowledgeMyFinalInstitutionalAllocationArgs = {
  offeringId: Scalars['UUID']['input'];
  versionId: Scalars['String']['input'];
};

export type MutationActivateInternalDemandOfferingArgs = {
  offeringId: Scalars['ID']['input'];
};

export type MutationAddCurrencyToTrancheArgs = {
  input: AddCurrencyToTrancheInput;
};

export type MutationAddInstrumentToTrancheArgs = {
  input: AddInstrumentToTrancheInput;
};

export type MutationAddViewSettingArgs = {
  input: AddViewSettingInput;
};

export type MutationAddWallCrossInvestorArgs = {
  input: AddWallCrossInvestorInput;
};

export type MutationAddWallCrossInvestorCommunicationLogArgs = {
  input: AddWallCrossInvestorCommunicationLogInput;
};

export type MutationAddWallCrossOwnerArgs = {
  input: AddWallCrossOwnerInput;
};

export type MutationAdminCreateInvestorFirmArgs = {
  input: AdminCreateInvestorFirmInput;
};

export type MutationAdminCreateInvestorFirmEmployeeArgs = {
  input: AdminCreateInvestorFirmEmployeeInput;
};

export type MutationAdminCreateInvestorRelationshipsArgs = {
  input: AdminCreateInvestorRelationshipsInput;
};

export type MutationAdminCreateUnderwriterEmployeeArgs = {
  input: AdminCreateUnderwriterEmployeeInput;
};

export type MutationAdminUpdateInvestorFirmArgs = {
  input: AdminUpdateInvestorFirmInput;
};

export type MutationAdminUpdateInvestorFirmEmployeeArgs = {
  input: AdminUpdateInvestorFirmEmployeeInput;
};

export type MutationAdminUpdateInvestorRelationshipArgs = {
  input: AdminUpdateInvestorRelationshipInput;
};

export type MutationAdminUpdateUnderwriterEmployeeArgs = {
  input: AdminUpdateUnderwriterEmployeeInput;
};

export type MutationAssignContactsArgs = {
  indicationId: Scalars['UUID']['input'];
  input: ReadonlyArray<AssignContactInput>;
  offeringId: Scalars['UUID']['input'];
};

export type MutationAssignCoveredContactsArgs = {
  indicationId: Scalars['UUID']['input'];
  input: ReadonlyArray<AssignContactInput>;
  offeringId: Scalars['UUID']['input'];
};

export type MutationAssignCoveredInvestorKeyArgs = {
  indicationId: Scalars['UUID']['input'];
  investorCrmKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
};

export type MutationAssignDesignationToManagerArgs = {
  input: OverwriteDesignationInput;
  offeringId: Scalars['ID']['input'];
};

export type MutationAssignFinalAllocationSetVisibilityArgs = {
  offeringId: Scalars['UUID']['input'];
  visibility: Scalars['Boolean']['input'];
};

export type MutationAssignIndicationNoteArgs = {
  indicationId: Scalars['UUID']['input'];
  input: AssignNoteInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationAssignInvestorKeyArgs = {
  indicationId: Scalars['UUID']['input'];
  investorCrmKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
};

export type MutationAssignMyInstitutionalIndicationArgs = {
  input: AssignInvestorInstitutionalIndicationInput;
  offeringId: Scalars['ID']['input'];
};

export type MutationAssignRetailDemandArgs = {
  cmgEntityKey: Scalars['String']['input'];
  offeringId: Scalars['UUID']['input'];
  payload: AssignRetailDemandInput;
};

export type MutationAssignRetailRetentionArgs = {
  cmgEntityKey: Scalars['String']['input'];
  offeringId: Scalars['UUID']['input'];
  payload: AssignRetailRetentionInput;
};

export type MutationBackfillViewSettingsArgs = {
  input: BackfillViewSettingsInput;
};

export type MutationBatchAssignRoadshowMeetingTypeEngagementArgs = {
  input: BatchAssignRoadshowMeetingTypeEngagementInput;
};

export type MutationBatchAssignTestingTheWatersEngagementArgs = {
  input: BatchAssignTestingTheWatersEngagementInput;
};

export type MutationBatchAssignWallCrossEngagementArgs = {
  input: BatchAssignWallCrossEngagementInput;
};

export type MutationBatchUpdateBndAgentArgs = {
  input: ReadonlyArray<BndAgentBatchUpdateInput>;
  offeringId: Scalars['UUID']['input'];
};

export type MutationBulkAssignBndAgentArgs = {
  applyTo?: InputMaybe<SyndicateGridQueryInput>;
  input: BndAgentUpdateInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationBulkAssignBndAgentByIdsArgs = {
  input: BndAgentUpdateInput;
  offeringId: Scalars['UUID']['input'];
  selection: IndicationSelectionInput;
};

export type MutationBulkUpdateAllocationsArgs = {
  allocation: AllocationUpdateInput;
  allocationSetIds: ReadonlyArray<Scalars['UUID']['input']>;
  applyTo?: InputMaybe<SyndicateGridQueryInput>;
  offeringId: Scalars['UUID']['input'];
};

export type MutationBulkUpdateAllocationsByIdsArgs = {
  allocation: AllocationUpdateInput;
  allocationSetIds: ReadonlyArray<Scalars['UUID']['input']>;
  offeringId: Scalars['UUID']['input'];
  selection: IndicationSelectionInput;
};

export type MutationCalculateFeesDistributionsArgs = {
  input: CalculateFeesDistributionsInput;
};

export type MutationCalculateSharesDistributionsArgs = {
  input: CalculateSharesDistributionsInput;
};

export type MutationCopyViewSettingArgs = {
  input: CopyViewSettingInput;
};

export type MutationCreateDeliveryInstrumentArgs = {
  input: CreateDeliveryInstrumentInput;
};

export type MutationCreateDemandCurrencyArgs = {
  input: CreateDemandCurrencyInput;
};

export type MutationCreateDesignationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: DesignationWireInput;
};

export type MutationCreateDraftAllocationSetArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateDraftAllocationInput;
};

export type MutationCreateExpensesRevisionArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateExpensesRevisionInput;
};

export type MutationCreateFilingArgs = {
  input: CreateFilingInput;
};

export type MutationCreateFinalInstitutionalAllocationSetArgs = {
  input: FinalAllocationsSetCreateInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationCreateFirmEmployeeArgs = {
  input: CreateFirmEmployeeInput;
};

export type MutationCreateFreeFormWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateFreeFormWireInput;
};

export type MutationCreateGreenShoeWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: GreenShoeWireInput;
};

export type MutationCreateInvestorFirmArgs = {
  input: CreateInvestorFirmInput;
};

export type MutationCreateInvestorFirmBasicArgs = {
  input: CreateInvestorFirmBasicInput;
};

export type MutationCreateInvestorFirmEmployeeArgs = {
  input: CreateInvestorFirmEmployeeInput;
};

export type MutationCreateInvestorRelationshipsArgs = {
  input: CreateInvestorRelationshipsInput;
};

export type MutationCreateIssuerAllocationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: IssuerAllocationWireInput;
};

export type MutationCreateIssuerIndicationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: IssuerIndicationWireInput;
};

export type MutationCreateManagerArgs = {
  input: CreateManagerInput;
};

export type MutationCreateManagerBdWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: ManagerBdWireInput;
};

export type MutationCreateMyRetailBrokerArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateMyRetailBrokerInput;
};

export type MutationCreateNonSyndicateFreeFormWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateNonSyndicateFreeFormWireInput;
};

export type MutationCreateNonSyndicatePaymentWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: NonSyndicatePaymentWireInput;
};

export type MutationCreateNonSyndicateSellingGroupInvitationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateNonSyndicateSellingGroupInvitationWireInput;
};

export type MutationCreateNonSyndicateSellingGroupTermsRetentionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateNonSyndicateSellingGroupTermsRetentionWireInput;
};

export type MutationCreateNonSyndicateTerminationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateNonSyndicateTerminationWireInput;
};

export type MutationCreateOfferingDraftArgs = {
  input: CreateOfferingDraftInput;
};

export type MutationCreateOfferingNoteArgs = {
  input: CreateMdlOfferingNoteInput;
  offeringId: Scalars['ID']['input'];
};

export type MutationCreateOrUpdateDemandCurrenciesArgs = {
  input: CreateOrUpdateDemandCurrenciesInput;
};

export type MutationCreateOrUpdateStabilizationArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateOrUpdateStabilizationInput;
};

export type MutationCreatePaymentWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: PaymentWireInput;
};

export type MutationCreatePotAccountWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreatePotAccountWireInput;
};

export type MutationCreatePotAllocationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreatePotAllocationWireInput;
};

export type MutationCreatePricingTermsRetentionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreatePricingTermsRetentionWireInput;
};

export type MutationCreatePricingTermsWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreatePricingTermsWireInput;
};

export type MutationCreateRegMWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateRegMWireInput;
};

export type MutationCreateResearchRestrictionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateResearchRestrictionWireInput;
};

export type MutationCreateRetentionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: RetentionWireInput;
};

export type MutationCreateRoadshowScheduleArgs = {
  input: CreateRoadshowScheduleInput;
};

export type MutationCreateSellingGroupInvitationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateSellingGroupInvitationWireInput;
};

export type MutationCreateSellingGroupTermsWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateSellingGroupTermsWireInput;
};

export type MutationCreateTerminationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateTerminationWireInput;
};

export type MutationCreateUnderwriterEmployeeArgs = {
  input: CreateUnderwriterEmployeeInput;
};

export type MutationCreateUnderwriterInvitationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: CreateUnderwriterInvitationWireInput;
};

export type MutationDeclineWireArgs = {
  body: InvitationWireResponseInput;
  sentWireId: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
};

export type MutationDeleteCurrencyFromTrancheArgs = {
  input: DeleteCurrencyFromTrancheInput;
};

export type MutationDeleteDeliveryInstrumentArgs = {
  input: DeleteDeliveryInstrumentInput;
};

export type MutationDeleteDemandCurrencyArgs = {
  input: DeleteDemandCurrencyInput;
};

export type MutationDeleteDesignationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteDraftInstitutionalAllocationSetArgs = {
  offeringId: Scalars['UUID']['input'];
  setId: Scalars['UUID']['input'];
};

export type MutationDeleteFilingArgs = {
  input: DeleteFilingInput;
};

export type MutationDeleteFirmEmployeeArgs = {
  input: DeleteFirmEmployeeInput;
};

export type MutationDeleteFreeFormWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteGreenShoeWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteIndicationArgs = {
  input: DeleteIndicationInput;
};

export type MutationDeleteInstitutionalIndicationBillingAndDeliveryAgentArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type MutationDeleteInstrumentFromTrancheArgs = {
  input: DeleteInstrumentFromTrancheInput;
};

export type MutationDeleteIssuerAllocationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteIssuerIndicationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteManagerArgs = {
  input: DeleteManagerInput;
};

export type MutationDeleteManagerBdWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteMyRetailBrokerArgs = {
  id: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type MutationDeleteNonSyndicateFreeFormWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteNonSyndicatePaymentWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteNonSyndicateSellingGroupInvitationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteNonSyndicateSellingGroupTermsRetentionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteNonSyndicateTerminationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteOfferingNoteArgs = {
  input: DeleteMdlOfferingNoteInput;
  offeringId: Scalars['ID']['input'];
};

export type MutationDeletePaymentWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeletePotAccountWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeletePotAllocationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeletePricingTermsRetentionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeletePricingTermsWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteRegMWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteResearchRestrictionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteRetentionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteRoadshowScheduleArgs = {
  input: DeleteRoadshowScheduleInput;
};

export type MutationDeleteSellingGroupInvitationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteSellingGroupTermsWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteTerminationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteUnderwriterInvitationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationDeleteViewSettingArgs = {
  input: DeleteViewSettingInput;
};

export type MutationDeleteWallCrossIndicationArgs = {
  input: DeleteWallCrossIndicationInput;
};

export type MutationDeleteWallCrossInvestorArgs = {
  input: DeleteWallCrossInvestorInput;
};

export type MutationDeleteWallCrossInvestorCommunicationLogArgs = {
  input: DeleteWallCrossInvestorCommunicationLogInput;
};

export type MutationDeleteWallCrossOwnerArgs = {
  input: DeleteWallCrossOwnerInput;
};

export type MutationDiscardOfferingArgs = {
  input: DiscardOfferingInput;
};

export type MutationDuplicateDraftAllocationSetArgs = {
  input?: InputMaybe<CreateDraftAllocationInput>;
  offeringId: Scalars['UUID']['input'];
  setId: Scalars['UUID']['input'];
};

export type MutationDuplicateFinalAllocationSetArgs = {
  input?: InputMaybe<CreateDraftAllocationInput>;
  offeringId: Scalars['UUID']['input'];
};

export type MutationImportWallCrossInvestorArgs = {
  input: ImportWallCrossInvestorInput;
};

export type MutationMarkIndicationsAsDuplicateArgs = {
  input: InstitutionalIndicationAssignDupesInput;
  offeringId: Scalars['ID']['input'];
};

export type MutationOverwriteDraftAllocationSetArgs = {
  offeringId: Scalars['UUID']['input'];
  sourceSetEdition: RevisionEdition;
  sourceSetId?: InputMaybe<Scalars['UUID']['input']>;
  targetSetId?: InputMaybe<Scalars['UUID']['input']>;
};

export type MutationPassCoveredInstitutionalIndicationArgs = {
  activateIfCancelled: Scalars['Boolean']['input'];
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type MutationPassInstitutionalIndicationArgs = {
  activateIfCancelled: Scalars['Boolean']['input'];
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type MutationPassInternalDemandOfferingArgs = {
  offeringId: Scalars['ID']['input'];
};

export type MutationPassOfferingWithoutCoveredInstitutionalIndicationArgs = {
  input: SubmitPassIndicationInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationPassOnOfferingArgs = {
  activateIfCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  offeringId: Scalars['ID']['input'];
};

export type MutationPassOnOfferingWithoutInstitutionalIndicationArgs = {
  input: SubmitPassIndicationInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationPublishDesignationsArgs = {
  offeringId: Scalars['ID']['input'];
};

export type MutationPublishOfferingArgs = {
  input: PublishOfferingInput;
};

export type MutationRefreshOrderBookSummaryArgs = {
  input: RefreshOrderBookSummaryInput;
};

export type MutationRegMInternalDemandOfferingArgs = {
  offeringId: Scalars['ID']['input'];
};

export type MutationReleaseFinalInstitutionalAllocationSetArgs = {
  offeringId: Scalars['UUID']['input'];
  setUnallocatedToZero?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationReleaseRetailRetentionArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type MutationReleaseSalesCreditsArgs = {
  investorFirmCmgEntityKeys: ReadonlyArray<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
};

export type MutationReleaseTradesBatchArgs = {
  indicationIds: ReadonlyArray<Scalars['UUID']['input']>;
  offeringId: Scalars['UUID']['input'];
};

export type MutationRenameViewSettingArgs = {
  input: RenameViewSettingInput;
};

export type MutationResendProspectusAsSalesAndTradingArgs = {
  investorKeys: ReadonlyArray<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
};

export type MutationResendProspectusAsSalesAndTradingByIndicationSelectionArgs = {
  input: ResendProspectusAsSalesAndTradingByIndicationSelectionInput;
};

export type MutationResendProspectusAsSyndicateArgs = {
  investorKeys: ReadonlyArray<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
};

export type MutationResendProspectusAsSyndicateByIndicationSelectionArgs = {
  input: ResendProspectusAsSyndicateByIndicationSelectionInput;
};

export type MutationResubmitDsFilingArgs = {
  filingId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type MutationResubmitNoiFilingArgs = {
  filingId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type MutationResubmitRpnFilingArgs = {
  filingId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type MutationResubmitTnFilingArgs = {
  filingId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type MutationResubmitUsdtnFilingArgs = {
  filingId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type MutationRetryDataSyncArgs = {
  input: RetryDataSyncInput;
};

export type MutationReviewSalesCreditsBankInvestorKeyChangeArgs = {
  cmgEntityKey: Scalars['String']['input'];
  offeringId: Scalars['UUID']['input'];
  payload: ReviewSalesCreditsBankInvestorKeyChangeInput;
};

export type MutationSendDlSupportRequestArgs = {
  description: Scalars['String']['input'];
  missingEmailsCmgEntityKeys: ReadonlyArray<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type MutationSendDesignationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendFreeFormWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendGreenShoeWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendIssuerAllocationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendReportInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendIssuerIndicationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendReportInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendManagerBdWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendNonSyndicateFreeFormWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendNonSyndicatePaymentWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendNonSyndicateSellingGroupInvitationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendNonSyndicateSellingGroupTermsRetentionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendNonSyndicateTerminationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendPaymentWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendPotAccountWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendPotAllocationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendPricingTermsRetentionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendPricingTermsWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendRegMWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendRegulatoryFilingEmailNotificationArgs = {
  filingId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
  recipients: ReadonlyArray<Scalars['String']['input']>;
  shouldAddSenderToBcc: Scalars['Boolean']['input'];
};

export type MutationSendResearchRestrictionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendRetentionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendSellingGroupInvitationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendSellingGroupTermsWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendTerminationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSendUnderwriterInvitationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SendWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationSetAllocationRankingArgs = {
  allocationId: Scalars['ID']['input'];
  ranking: MdlAllocationRanking;
  xcOfferingId: Scalars['ID']['input'];
};

export type MutationSetAllocationRankingOnOfferingArgs = {
  id: Scalars['ID']['input'];
  ranking: MdlAllocationRanking;
};

export type MutationSetDefaultInstrumentForTrancheArgs = {
  input: SetDefaultInstrumentForTrancheInput;
};

export type MutationSetPricingCurrencyArgs = {
  input: SetPricingCurrencyInput;
};

export type MutationSetPricingInstrumentArgs = {
  input: SetPricingInstrumentInput;
};

export type MutationSetViewSettingFavoriteArgs = {
  input: SetViewSettingFavoriteInput;
};

export type MutationShareDraftArgs = {
  input: ShareDraftInput;
};

export type MutationShareDraftAllocationSetArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: ReadonlyArray<Scalars['String']['input']>;
  setId: Scalars['String']['input'];
};

export type MutationShareFinalAllocationSetArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: ReadonlyArray<Scalars['String']['input']>;
};

export type MutationSubmitCoveredInstitutionalIndicationArgs = {
  input: InstitutionalIndicationSubmitInput;
  offeringId: Scalars['ID']['input'];
};

export type MutationSubmitDsFilingArgs = {
  input: CreateDsFilingInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationSubmitInstitutionalIndicationArgs = {
  input: InstitutionalIndicationSubmitInput;
  offeringId: Scalars['ID']['input'];
};

export type MutationSubmitNoiFilingArgs = {
  input: CreateNoiFilingInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationSubmitRpnFilingArgs = {
  input: CreateRpnFilingInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationSubmitRetailDemandArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: SubmitMyRetailInput;
};

export type MutationSubmitTnFilingArgs = {
  input: CreateTnFilingInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationSubmitUsdtnFilingArgs = {
  input: CreateUsdtnFilingInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationSubmitWallCrossIndicationArgs = {
  input: SubmitWallCrossIndicationInput;
};

export type MutationSubmitWallCrossPassArgs = {
  input: SubmitWallCrossPassInput;
};

export type MutationSyncInstitutionalIndicationArgs = {
  input: SyncInstitutionalIndicationInput;
};

export type MutationUnacknowledgeCoveredIndicationArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
  version: Scalars['String']['input'];
};

export type MutationUnacknowledgeCoveredInstitutionalFinalAllocationArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
  versionId: Scalars['String']['input'];
};

export type MutationUnacknowledgeInstitutionalFinalAllocationArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
  versionId: Scalars['String']['input'];
};

export type MutationUnacknowledgeInstitutionalIndicationArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
  version: Scalars['String']['input'];
};

export type MutationUnmarkIndicationsAsDuplicateArgs = {
  duplicateIndicationId: Scalars['UUID']['input'];
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['ID']['input'];
};

export type MutationUpdateAccountingAdjustmentsArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: ReadonlyArray<UpdateAccountingAdjustmentsInput>;
};

export type MutationUpdateAccountingNotesArgs = {
  notes: Scalars['String']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type MutationUpdateAdditionalTermsArgs = {
  input: UpdateAdditionalTermsInput;
};

export type MutationUpdateAttestationEnforcementArgs = {
  input: UpdateAttestationEnforcementInput;
};

export type MutationUpdateBasicInfoArgs = {
  input: UpdateBasicInfoInput;
};

export type MutationUpdateCoveredIndicationArgs = {
  indicationId: Scalars['ID']['input'];
  input: InstitutionalIndicationUpdateInput;
  offeringId: Scalars['ID']['input'];
};

export type MutationUpdateCoveredIndicationStatusArgs = {
  indicationId: Scalars['ID']['input'];
  offeringId: Scalars['ID']['input'];
  status: IndicationStatus;
};

export type MutationUpdateDeliveryInstrumentArgs = {
  input: UpdateDeliveryInstrumentInput;
};

export type MutationUpdateDemandCurrencyArgs = {
  input: UpdateDemandCurrencyInput;
};

export type MutationUpdateDesignationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: DesignationWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateDisclaimersArgs = {
  input: UpdateDisclaimersInput;
};

export type MutationUpdateDraftAllocationSetDealLayoutArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: AssignDealLayoutInput;
  setId: Scalars['String']['input'];
};

export type MutationUpdateDraftAllocationSetNameArgs = {
  name: Scalars['String']['input'];
  offeringId: Scalars['UUID']['input'];
  setId: Scalars['UUID']['input'];
};

export type MutationUpdateDraftInstitutionalAllocationArgs = {
  indicationId: Scalars['UUID']['input'];
  input: DraftAllocationUpdateInput;
  offeringId: Scalars['UUID']['input'];
  setId: Scalars['String']['input'];
};

export type MutationUpdateDraftInstitutionalAllocationsArgs = {
  input: DraftAllocationBatchUpdateInput;
  offeringId: Scalars['UUID']['input'];
  setId: Scalars['String']['input'];
};

export type MutationUpdateFeesAndDiscountsArgs = {
  input: UpdateFeesAndDiscountsInput;
};

export type MutationUpdateFilingArgs = {
  input: UpdateFilingInput;
};

export type MutationUpdateFinalAllocationSetDealLayoutArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: AssignDealLayoutInput;
};

export type MutationUpdateFinalInstitutionalAllocationArgs = {
  indicationId: Scalars['UUID']['input'];
  input: FinalAllocationUpdateInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationUpdateFinalInstitutionalAllocationAcknowledgementStatusArgs = {
  indicationId: Scalars['UUID']['input'];
  investorReplyStatus: AllocationAcknowledgementNewStatus;
  offeringId: Scalars['UUID']['input'];
  versionId: Scalars['String']['input'];
};

export type MutationUpdateFinalInstitutionalAllocationsArgs = {
  input: FinalAllocationsUpdateInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationUpdateFirmEmployeeArgs = {
  input: UpdateFirmEmployeeInput;
};

export type MutationUpdateFollowOnPricingArgs = {
  input: UpdateFollowOnPricingInput;
};

export type MutationUpdateFreeFormWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdateFreeFormWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateFundIoisArgs = {
  input: UpdateFundIoisInput;
  offeringId: Scalars['ID']['input'];
};

export type MutationUpdateGreenShoeWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: GreenShoeWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateIncentiveFeeDistributionArgs = {
  input: UpdateIncentiveFeeDistributionInput;
};

export type MutationUpdateInstitutionalIndicationArgs = {
  indicationId: Scalars['ID']['input'];
  input: InstitutionalIndicationUpdateInput;
  offeringId: Scalars['ID']['input'];
};

export type MutationUpdateInstitutionalIndicationBillingAndDeliveryAgentArgs = {
  indicationId: Scalars['UUID']['input'];
  input: BillingAndDeliveryAgentUpdateInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationUpdateInstitutionalIndicationBillingAndDeliveryAgentForIndicationsArgs = {
  input: BillingAndDeliveryAgentBatchUpdateInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationUpdateInstitutionalIndicationStatusArgs = {
  indicationId: Scalars['ID']['input'];
  offeringId: Scalars['ID']['input'];
  status: IndicationStatus;
};

export type MutationUpdateInvestorFirmArgs = {
  firmKeyOrId: Scalars['ID']['input'];
  input: UpdateInvestorFirmInput;
};

export type MutationUpdateInvestorFirmEmployeeArgs = {
  employeeKeyOrId: Scalars['ID']['input'];
  firmKeyOrId: Scalars['ID']['input'];
  input: UpdateInvestorFirmEmployeeInput;
};

export type MutationUpdateInvestorRelationshipArgs = {
  input: UpdateInvestorRelationshipInput;
};

export type MutationUpdateIssuerAllocationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: IssuerAllocationWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateIssuerIndicationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: IssuerIndicationWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateManagementFeeDistributionArgs = {
  input: UpdateManagementFeeDistributionInput;
};

export type MutationUpdateManagerArgs = {
  input: UpdateManagerInput;
};

export type MutationUpdateManagerBdWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: ManagerBdWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateManagerFirmArgs = {
  input: UpdateManagerFirmInput;
};

export type MutationUpdateManagerResponsibilitiesArgs = {
  input: UpdateManagerResponsibilitiesInput;
};

export type MutationUpdateManagerSequenceArgs = {
  input: UpdateManagerSequenceInput;
};

export type MutationUpdateMarketingArgs = {
  input: UpdateMarketingInput;
};

export type MutationUpdateMyIndicationStatusArgs = {
  offeringId: Scalars['UUID']['input'];
  status: IndicationStatus;
};

export type MutationUpdateMyRetailArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdateMyRetailInput;
};

export type MutationUpdateMyRetailBrokerArgs = {
  id: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
  payload: UpdateMyRetailBrokerInput;
};

export type MutationUpdateNonSyndicateFreeFormWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdateNonSyndicateFreeFormWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateNonSyndicatePaymentWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: NonSyndicatePaymentWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateNonSyndicateSellingGroupInvitationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdateNonSyndicateSellingGroupInvitationWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateNonSyndicateSellingGroupTermsRetentionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdateNonSyndicateSellingGroupTermsRetentionWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateNonSyndicateTerminationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdateNonSyndicateTerminationWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateOfferingNoteArgs = {
  input: UpdateMdlOfferingNoteInput;
  offeringId: Scalars['ID']['input'];
};

export type MutationUpdateOfferingStatusArgs = {
  input: UpdateOfferingStatusInput;
};

export type MutationUpdateOrderBookConfigurationArgs = {
  input: UpdateOrderBookConfigurationInput;
};

export type MutationUpdateOrderBookSalesStateArgs = {
  input: UpdateOrderBookSalesStateInput;
};

export type MutationUpdateOrderBookStateArgs = {
  offeringId: Scalars['ID']['input'];
  state: OrderBookState;
};

export type MutationUpdateOverAllotmentExerciseArgs = {
  input: UpdateOverAllotmentExerciseInput;
};

export type MutationUpdateOverallotmentExercisedSharesDistributionArgs = {
  input: UpdateOverallotmentExercisedSharesDistributionInput;
};

export type MutationUpdatePaymentWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: PaymentWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdatePotAccountWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdatePotAccountWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdatePotAllocationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdatePotAllocationWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdatePricingTermsRetentionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdatePricingTermsRetentionWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdatePricingTermsWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdatePricingTermsWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdatePrivateManagerEconomicsArgs = {
  input: UpdatePrivateManagerEconomicsInput;
};

export type MutationUpdatePrivatePlacementTermsArgs = {
  input: UpdatePrivatePlacementTermsInput;
};

export type MutationUpdateProspectusDocumentsMetadataArgs = {
  input: UpdateProspectusDocumentsMetadataInput;
};

export type MutationUpdateRegMWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdateRegMWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateResearchRestrictionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdateResearchRestrictionWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateRetentionWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: RetentionWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateRoadshowScheduleArgs = {
  input: UpdateRoadshowScheduleInput;
};

export type MutationUpdateSalesCreditsAmountArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: ReadonlyArray<UpdateSalesCreditsAmountInput>;
};

export type MutationUpdateSalesCreditsBankInvestorKeyArgs = {
  cmgEntityKey: Scalars['String']['input'];
  offeringId: Scalars['UUID']['input'];
  payload: UpdateSalesCreditsBankInvestorKeyInput;
};

export type MutationUpdateSalesCreditsHouseAccountsArgs = {
  investorsFirmIds: ReadonlyArray<Scalars['UUID']['input']>;
};

export type MutationUpdateSalesCreditsStatusArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdateSalesCreditsInput;
};

export type MutationUpdateSellingConcessionDistributionArgs = {
  input: UpdateSellingConcessionDistributionInput;
};

export type MutationUpdateSellingGroupInvitationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdateSellingGroupInvitationWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateSellingGroupTermsWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdateSellingGroupTermsWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateSyndicateArgs = {
  input: UpdateSyndicateInput;
};

export type MutationUpdateTerminationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdateTerminationWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateTimingInfoArgs = {
  input: UpdateTimingInfoInput;
};

export type MutationUpdateTotalRetailDemandArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: ReadonlyArray<UpdateTotalRetailInput>;
};

export type MutationUpdateTradeReleaseSettingsArgs = {
  isAutoreleaseEnabled: Scalars['Boolean']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type MutationUpdateTradesStatusBatchArgs = {
  input: UpdateTradesStatusBatchInput;
  offeringId: Scalars['UUID']['input'];
};

export type MutationUpdateTrancheArgs = {
  input: UpdateTrancheInput;
};

export type MutationUpdateUnderwriterEmployeeArgs = {
  input: UpdateUnderwriterEmployeeInput;
};

export type MutationUpdateUnderwriterInvitationWireArgs = {
  offeringId: Scalars['UUID']['input'];
  payload: UpdateUnderwriterInvitationWireInput;
  syndicateWireId: Scalars['UUID']['input'];
};

export type MutationUpdateUnderwritingBaseSharesDistributionArgs = {
  input: UpdateUnderwritingBaseSharesDistributionInput;
};

export type MutationUpdateUnderwritingFeeBaseDistributionArgs = {
  input: UpdateUnderwritingFeeBaseDistributionInput;
};

export type MutationUpdateUnderwritingFeeTotalDistributionArgs = {
  input: UpdateUnderwritingFeeTotalDistributionInput;
};

export type MutationUpdateUnderwritingTermsFeesAndDiscountsArgs = {
  input: UpdateUnderwritingTermsFeesAndDiscountsInput;
};

export type MutationUpdateViewSettingDataArgs = {
  input: UpdateViewSettingDataInput;
};

export type MutationUpdateWallCrossIndicationArgs = {
  input: UpdateWallCrossIndicationInput;
};

export type MutationUpdateWallCrossIndicationToPassArgs = {
  input: UpdateWallCrossIndicationToPassInput;
};

export type MutationUpdateWallCrossInvestorArgs = {
  input: UpdateWallCrossInvestorInput;
};

export type MutationUpdateWallCrossInvestorCommunicationLogArgs = {
  input: UpdateWallCrossInvestorCommunicationLogInput;
};

export type MutationUpdateWallCrossOwnerArgs = {
  input: UpdateWallCrossOwnerInput;
};

export type MutationUpdateXcNotificationSettingsArgs = {
  input: UpdateXcNotificationSettingsInput;
};

export type MutationUpdateXcNotificationSettingsForUserArgs = {
  input: UpdateXcNotificationSettingsForUserInput;
};

export type MutationUpsertCommunicatedDemandAllocationArgs = {
  input?: InputMaybe<MdlAllocationInput>;
  offeringId: Scalars['ID']['input'];
};

export type MutationUpsertCommunicatedDemandIndicationsArgs = {
  input?: InputMaybe<ReadonlyArray<MdlIndicationInput>>;
  offeringId: Scalars['ID']['input'];
};

export type MutationUpsertInternalDemandIndicationsArgs = {
  input: UpsertInternalDemandInput;
  offeringId: Scalars['ID']['input'];
};

export type MyInstitutionalIndication = {
  readonly __typename?: 'MyInstitutionalIndication';
  readonly acknowledgements: ReadonlyArray<InstitutionalIndicationAcknowledgement>;
  readonly auditInfo: AuditInfo;
  readonly billingAndDeliveryAgentCmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  readonly finalAllocation?: Maybe<FinalAllocation>;
  readonly id: Scalars['ID']['output'];
  /** An Instrument ID will not be present for Investors who have Passed on the offering. */
  readonly instrumentId?: Maybe<Scalars['UUID']['output']>;
  /** The demand expression of the indication. */
  readonly interestLevels: ReadonlyArray<InterestLevel>;
  readonly offeringId: Scalars['UUID']['output'];
  readonly status: IndicationStatus;
  readonly submittedByCmgEntityKey: Scalars['String']['output'];
  /** A Tranche ID will not be present for Investors who have Passed on the offering. */
  readonly trancheId?: Maybe<Scalars['UUID']['output']>;
  readonly type: InstitutionalIndicationOrderType;
  readonly version: Scalars['String']['output'];
};

export type MyInstitutionalIndicationVersion = {
  readonly __typename?: 'MyInstitutionalIndicationVersion';
  readonly auditInfo: AuditInfo;
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly indicationId: Scalars['UUID']['output'];
  /** An Instrument ID will not be present for Investors who have Passed on the offering. */
  readonly instrumentId?: Maybe<Scalars['UUID']['output']>;
  /** The demand expression of the indication. */
  readonly interestLevels: ReadonlyArray<InterestLevel>;
  readonly investorContactName?: Maybe<Scalars['String']['output']>;
  readonly isBuySideRevision: Scalars['Boolean']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly recordStatus: OrderBookRecordStatus;
  readonly status: IndicationStatus;
  /** The CMG entity key for the specific manager submitting this indication. */
  readonly submittedByCmgEntityKey: Scalars['String']['output'];
  readonly tranche?: Maybe<TranchePrivileged>;
  /** A Tranche ID will not be present for Investors who have Passed on the offering. */
  readonly trancheId?: Maybe<Scalars['UUID']['output']>;
  readonly type: InstitutionalIndicationOrderType;
  readonly version: Scalars['String']['output'];
};

export type MyRetailBrokerDemandInput = {
  readonly notionalQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  readonly roundLots?: InputMaybe<Scalars['Int']['input']>;
  readonly shareQuantity?: InputMaybe<Scalars['Long']['input']>;
};

export type MyRetailForBrokerDealer = {
  readonly __typename?: 'MyRetailForBrokerDealer';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly retentionAmount: Scalars['Long']['output'];
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
};

export type MyRetailRetentionInput = {
  readonly roundLots?: InputMaybe<Scalars['Int']['input']>;
  readonly shareQuantity?: InputMaybe<Scalars['Long']['input']>;
};

export type MyRetailSummary = {
  readonly __typename?: 'MyRetailSummary';
  readonly brokerDealers: ReadonlyArray<RetailBrokerDealer>;
  readonly id: Scalars['ID']['output'];
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly totalRetailInfo: TotalRetailInfo;
};

export type NoiActivity = {
  readonly __typename?: 'NOIActivity';
  readonly activityType: ActivityType;
  /** Display name for ActivityType */
  readonly activityTypeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly date: Scalars['LocalDate']['output'];
};

export type NoiActivityInput = {
  readonly activityType: ActivityType;
  readonly date: Scalars['LocalDate']['input'];
};

export type NoiFiling = {
  readonly __typename?: 'NOIFiling';
  readonly activities: ReadonlyArray<NoiActivity>;
  readonly additionalInformation?: Maybe<Scalars['String']['output']>;
  readonly contactName: Scalars['String']['output'];
  readonly contactTitle: Scalars['String']['output'];
  readonly emailAddress: Scalars['String']['output'];
  readonly filingCreatorEmail?: Maybe<Scalars['String']['output']>;
  readonly finraErrorMessages: ReadonlyArray<Scalars['String']['output']>;
  readonly firmCrdNumber: Scalars['String']['output'];
  readonly firmDealId: Scalars['String']['output'];
  readonly firmMpid: Scalars['String']['output'];
  readonly firmName: Scalars['String']['output'];
  readonly formUniqueId: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly issuerName: Scalars['String']['output'];
  readonly issuerSymbol: Scalars['String']['output'];
  readonly status: FilingStatus;
  readonly submittedDateTime: Scalars['Instant']['output'];
  readonly telephoneNumber: Scalars['String']['output'];
};

export type NoiFilingFormDataInput = {
  readonly activities: ReadonlyArray<NoiActivityInput>;
  readonly additionalInformation?: InputMaybe<Scalars['String']['input']>;
  readonly contactName: Scalars['String']['input'];
  readonly contactTitle: Scalars['String']['input'];
  readonly emailAddress: Scalars['String']['input'];
  readonly firmCrdNumber: Scalars['String']['input'];
  readonly firmMpid: Scalars['String']['input'];
  readonly firmName: Scalars['String']['input'];
  readonly issuerSymbol: Scalars['String']['input'];
  readonly telephoneNumber: Scalars['String']['input'];
};

export type NonMemberFirm = {
  readonly __typename?: 'NonMemberFirm';
  /** CmgEntityKey of the firm, not null when non member firm is a manager on the offering */
  readonly cmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly firmName: Scalars['String']['output'];
  /** CmgEntityKey of the manager this non-owner firm is affiliated with */
  readonly ownerCmgEntityKey?: Maybe<Scalars['String']['output']>;
};

export type NonMemberFirmInput = {
  /** CmgEntityKey of the firm, not null when non member firm is a manager on the offering */
  readonly cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  readonly firmName: Scalars['String']['input'];
  /** CmgEntityKey of the manager this non-owner firm is affiliated with */
  readonly ownerCmgEntityKey?: InputMaybe<Scalars['String']['input']>;
};

export type NonSyndicateFreeFormWire = {
  readonly __typename?: 'NonSyndicateFreeFormWire';
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['Instant']['output'];
  readonly header: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type NonSyndicateFreeFormWireResponseUnion = NonSyndicateFreeFormWire | ServiceError;

export type NonSyndicateFreeFormWireValidation = WireValidationBase & {
  readonly __typename?: 'NonSyndicateFreeFormWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<NonSyndicateFreeFormWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum NonSyndicateFreeFormWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
}

export type NonSyndicatePaymentRecipientInputData = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly dtcNumber: Scalars['String']['input'];
  readonly ipoPenaltyTracking: Scalars['Boolean']['input'];
  readonly payment: Scalars['Decimal']['input'];
  readonly recipient: Scalars['String']['input'];
  readonly sellingConcession: Scalars['Decimal']['input'];
};

export type NonSyndicatePaymentRecipientUserData = {
  readonly __typename?: 'NonSyndicatePaymentRecipientUserData';
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly dtcNumber: Scalars['String']['output'];
  readonly ipoPenaltyTracking: Scalars['Boolean']['output'];
  readonly payment: Scalars['Decimal']['output'];
  readonly recipient: Scalars['String']['output'];
  readonly sellingConcession: Scalars['Decimal']['output'];
};

export type NonSyndicatePaymentWire = {
  readonly __typename?: 'NonSyndicatePaymentWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly id: Scalars['ID']['output'];
  readonly recipientsUserData: ReadonlyArray<NonSyndicatePaymentRecipientUserData>;
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

export type NonSyndicatePaymentWireInput = {
  readonly userDataForRecipients: ReadonlyArray<NonSyndicatePaymentRecipientInputData>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type NonSyndicatePaymentWireResponseUnion = NonSyndicatePaymentWire | ServiceError;

export type NonSyndicatePaymentWireValidation = WireValidationBase & {
  readonly __typename?: 'NonSyndicatePaymentWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<NonSyndicatePaymentWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum NonSyndicatePaymentWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  Cusip = 'CUSIP',
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  PricePerUnit = 'PRICE_PER_UNIT',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  SettlementDate = 'SETTLEMENT_DATE',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
}

export type NonSyndicateSellingGroupInvitationDataForRecipient = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly masterSdaDate: Scalars['LocalDate']['input'];
  readonly recipient: Scalars['String']['input'];
  readonly retention: Scalars['Long']['input'];
};

export type NonSyndicateSellingGroupInvitationRecipientData = {
  readonly __typename?: 'NonSyndicateSellingGroupInvitationRecipientData';
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly masterSdaDate: Scalars['LocalDate']['output'];
  readonly recipient: Scalars['String']['output'];
  readonly retention: Scalars['Long']['output'];
};

export type NonSyndicateSellingGroupInvitationWire = {
  readonly __typename?: 'NonSyndicateSellingGroupInvitationWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly id: Scalars['ID']['output'];
  readonly recipientsUserData: ReadonlyArray<NonSyndicateSellingGroupInvitationRecipientData>;
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type NonSyndicateSellingGroupInvitationWireResponseUnion =
  | NonSyndicateSellingGroupInvitationWire
  | ServiceError;

export type NonSyndicateSellingGroupInvitationWireValidation = WireValidationBase & {
  readonly __typename?: 'NonSyndicateSellingGroupInvitationWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<NonSyndicateSellingGroupInvitationWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum NonSyndicateSellingGroupInvitationWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  CouponTalkHigh = 'COUPON_TALK_HIGH',
  CouponTalkLow = 'COUPON_TALK_LOW',
  ExchangeMic = 'EXCHANGE_MIC',
  IpoRangeHigh = 'IPO_RANGE_HIGH',
  IpoRangeLow = 'IPO_RANGE_LOW',
  IssuerName = 'ISSUER_NAME',
  LaunchDate = 'LAUNCH_DATE',
  OfferingType = 'OFFERING_TYPE',
  ParValue = 'PAR_VALUE',
  PercentageOfPar = 'PERCENTAGE_OF_PAR',
  PremiumTalkHigh = 'PREMIUM_TALK_HIGH',
  PremiumTalkLow = 'PREMIUM_TALK_LOW',
  PricingDate = 'PRICING_DATE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  SharesOrNotionalBaseOffering = 'SHARES_OR_NOTIONAL_BASE_OFFERING',
  StockSymbol = 'STOCK_SYMBOL',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  UnderlyingExchangeMic = 'UNDERLYING_EXCHANGE_MIC',
  UnderlyingStockSymbol = 'UNDERLYING_STOCK_SYMBOL',
}

export type NonSyndicateSellingGroupTermsRetentionRecipientData = {
  readonly __typename?: 'NonSyndicateSellingGroupTermsRetentionRecipientData';
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly recipient: Scalars['String']['output'];
  readonly sellingConcession: Scalars['Decimal']['output'];
};

export type NonSyndicateSellingGroupTermsRetentionWire = {
  readonly __typename?: 'NonSyndicateSellingGroupTermsRetentionWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly id: Scalars['ID']['output'];
  readonly recipientsUserData: ReadonlyArray<NonSyndicateSellingGroupTermsRetentionRecipientData>;
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type NonSyndicateSellingGroupTermsRetentionWireResponseUnion =
  | NonSyndicateSellingGroupTermsRetentionWire
  | ServiceError;

export type NonSyndicateSellingGroupTermsRetentionWireValidation = WireValidationBase & {
  readonly __typename?: 'NonSyndicateSellingGroupTermsRetentionWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<NonSyndicateSellingGroupTermsRetentionWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum NonSyndicateSellingGroupTermsRetentionWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  Cusip = 'CUSIP',
  ExchangeMic = 'EXCHANGE_MIC',
  FirstTradeDate = 'FIRST_TRADE_DATE',
  IssuerName = 'ISSUER_NAME',
  OfferingPrice = 'OFFERING_PRICE',
  OfferingType = 'OFFERING_TYPE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  SettlementDate = 'SETTLEMENT_DATE',
  StockSymbol = 'STOCK_SYMBOL',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
  UnderlyingExchangeMic = 'UNDERLYING_EXCHANGE_MIC',
  UnderlyingStockSymbol = 'UNDERLYING_STOCK_SYMBOL',
}

export type NonSyndicateTerminationWire = {
  readonly __typename?: 'NonSyndicateTerminationWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly terminationDate: TerminationDate;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type NonSyndicateTerminationWireResponseUnion = NonSyndicateTerminationWire | ServiceError;

export type NonSyndicateTerminationWireValidation = WireValidationBase & {
  readonly __typename?: 'NonSyndicateTerminationWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<NonSyndicateTerminationWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum NonSyndicateTerminationWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
}

export type Note = {
  readonly __typename?: 'Note';
  readonly auditInfo: AuditInfo;
  readonly id: Scalars['ID']['output'];
  readonly indicationId: Scalars['UUID']['output'];
  readonly text?: Maybe<Scalars['String']['output']>;
  readonly type: IndicationNoteType;
  readonly version: Scalars['String']['output'];
};

export enum NotificationMessageStatus {
  NotSent = 'NOT_SENT',
  Sent = 'SENT',
}

export type NullableOfCertificateStatusOperationFilterInput = {
  readonly eq?: InputMaybe<AttestationFormStatus>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<AttestationFormStatus>>>;
  readonly neq?: InputMaybe<AttestationFormStatus>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<AttestationFormStatus>>>;
};

export type NullableOfFirmCategoryTypeOperationFilterInput = {
  readonly eq?: InputMaybe<RolodexFirmCategoryType>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<RolodexFirmCategoryType>>>;
  readonly neq?: InputMaybe<RolodexFirmCategoryType>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<RolodexFirmCategoryType>>>;
};

export type NullableOfJobFunctionOperationFilterInput = {
  readonly eq?: InputMaybe<JobFunction>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<JobFunction>>>;
  readonly neq?: InputMaybe<JobFunction>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<JobFunction>>>;
};

export type NullableOfLimitTypeOperationFilterInput = {
  readonly eq?: InputMaybe<InterestLevelLimitType>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<InterestLevelLimitType>>>;
  readonly neq?: InputMaybe<InterestLevelLimitType>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<InterestLevelLimitType>>>;
};

export type NullableOfRankOperationFilterInput = {
  readonly eq?: InputMaybe<Rank>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Rank>>>;
  readonly neq?: InputMaybe<Rank>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Rank>>>;
};

export type NullableOfRoadshowMeetingTypeOperationFilterInput = {
  readonly eq?: InputMaybe<RoadshowMeetingType>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<RoadshowMeetingType>>>;
  readonly neq?: InputMaybe<RoadshowMeetingType>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<RoadshowMeetingType>>>;
};

export type Offering = {
  readonly __typename?: 'Offering';
  readonly advisors: ReadonlyArray<Advisor>;
  readonly countryCode?: Maybe<Scalars['String']['output']>;
  /** Filters the Demand Currencies for the offering */
  readonly currencies: ReadonlyArray<DemandCurrency>;
  /** Filters the Delivery Instruments for the Offering */
  readonly deliveryInstruments: ReadonlyArray<DeliveryInstrument>;
  readonly demandCurrencies: ReadonlyArray<DemandCurrency>;
  readonly disclaimers: Disclaimers;
  readonly dspAgent?: Maybe<Scalars['String']['output']>;
  readonly entitlements: Entitlements;
  /** Filters Filings for the Offering */
  readonly filings: ReadonlyArray<Filing>;
  /** Get Follow On Pricing for the Offering */
  readonly followOnPricing: FollowOnPricing;
  /** @deprecated Returns null, here for backwards compatibility */
  readonly hasForwardAgreement?: Maybe<Scalars['Boolean']['output']>;
  /** Returns hasUnpublishedChanges for a private offering when published and version mismatch */
  readonly hasUnpublishedChanges: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly instruments: ReadonlyArray<DeliveryInstrument>;
  readonly isAuthor: Scalars['Boolean']['output'];
  readonly isDiscarded: Scalars['Boolean']['output'];
  readonly isInternal: Scalars['Boolean']['output'];
  readonly isWallCrossEnabled: Scalars['Boolean']['output'];
  readonly issuer: Issuer;
  readonly lenders: ReadonlyArray<Lender>;
  readonly managerEconomics: ManagerEconomics;
  readonly marketing: Marketing;
  readonly orderBookConfiguration: OrderBookConfiguration;
  readonly pricingCurrencyCode: Scalars['String']['output'];
  readonly pricingInstrumentId?: Maybe<Scalars['UUID']['output']>;
  readonly pricingInstrumentStockSymbol?: Maybe<Scalars['String']['output']>;
  readonly prospectusDocuments: ReadonlyArray<ProspectusDocument>;
  readonly regulatoryFilings: RegulatoryFilings;
  /** Filters the Roadshow Schedules for the offering */
  readonly roadshowSchedules: ReadonlyArray<RoadshowSchedule>;
  readonly security: Security;
  readonly sizeInCurrency?: Maybe<Scalars['Decimal']['output']>;
  readonly sizeInShares?: Maybe<Scalars['Long']['output']>;
  readonly sponsors: ReadonlyArray<Sponsor>;
  readonly stage: OfferingStage;
  readonly status: OfferingStatus;
  /** Returns Offering Syndicate */
  readonly syndicate: Syndicate;
  readonly terms: Terms;
  readonly timing: Timing;
  /** Returns Tranches for an Offering */
  readonly tranches: ReadonlyArray<Tranche>;
  readonly type: OfferingType;
  /** Display name for Type */
  readonly typeDisplayName?: Maybe<Scalars['String']['output']>;
  /** Returns Offering validation errors and warnings before publish */
  readonly validation: OfferingValidation;
  readonly version: Scalars['String']['output'];
  /** Return the available versions for this offering */
  readonly versions: ReadonlyArray<OfferingVersion>;
};

export type OfferingCurrenciesArgs = {
  filters?: InputMaybe<RecordStatusFilterInput>;
};

export type OfferingDeliveryInstrumentsArgs = {
  filters?: InputMaybe<RecordStatusFilterInput>;
};

export type OfferingEntitlementsArgs = {
  filters?: InputMaybe<RecordStatusFilterInput>;
};

export type OfferingFilingsArgs = {
  filters?: InputMaybe<RecordStatusFilterInput>;
};

export type OfferingRoadshowSchedulesArgs = {
  filters?: InputMaybe<RecordStatusFilterInput>;
};

export type OfferingSyndicateArgs = {
  filters?: InputMaybe<RecordStatusFilterInput>;
};

export type OfferingTranchesArgs = {
  filters?: InputMaybe<RecordStatusFilterInput>;
};

export type OfferingDashboardDataSync = {
  readonly __typename?: 'OfferingDashboardDataSync';
  readonly buySideParticipants: ReadonlyArray<OfferingDashboardTenant>;
  readonly finalAllocationReleaseStatus: AllocationStatus;
  readonly lastSyncedIndications: ReadonlyArray<OfferingDashboardSyncedIndication>;
  readonly offeringAuthor: OfferingDashboardTenant;
  readonly sellSideParticipants: ReadonlyArray<OfferingDashboardTenant>;
};

export type OfferingDashboardIndicationVersion = {
  readonly __typename?: 'OfferingDashboardIndicationVersion';
  readonly allocationAcknowledgementVersion?: Maybe<Scalars['String']['output']>;
  readonly billingAndDeliveryVersion?: Maybe<Scalars['String']['output']>;
  readonly finalAllocationVersion?: Maybe<Scalars['String']['output']>;
  readonly indicationAcknowledgementVersion?: Maybe<Scalars['String']['output']>;
  readonly indicationVersion?: Maybe<Scalars['String']['output']>;
};

export type OfferingDashboardOfferingTimelineEvent = {
  readonly __typename?: 'OfferingDashboardOfferingTimelineEvent';
  readonly actor: OfferingDashboardTimelineActor;
  readonly eventType: OfferingDashboardOfferingTimelineEventType;
  readonly newValue?: Maybe<Scalars['Any']['output']>;
  readonly oldValue?: Maybe<Scalars['Any']['output']>;
  readonly publishedVersion?: Maybe<Scalars['Int']['output']>;
  readonly timestamp: Scalars['DateTime']['output'];
};

export enum OfferingDashboardOfferingTimelineEventType {
  OfferingCreated = 'OFFERING_CREATED',
  OfferingPublished = 'OFFERING_PUBLISHED',
}

export enum OfferingDashboardOrderBookIndicationTimelineEventType {
  BillingAndDeliveryAgentAssigned = 'BILLING_AND_DELIVERY_AGENT_ASSIGNED',
  BillingAndDeliveryAgentUnassigned = 'BILLING_AND_DELIVERY_AGENT_UNASSIGNED',
  FinalAllocationAcknowledged = 'FINAL_ALLOCATION_ACKNOWLEDGED',
  FinalAllocationCreated = 'FINAL_ALLOCATION_CREATED',
  FinalAllocationModified = 'FINAL_ALLOCATION_MODIFIED',
  FinalAllocationRejected = 'FINAL_ALLOCATION_REJECTED',
  FinalAllocationUnacknowledged = 'FINAL_ALLOCATION_UNACKNOWLEDGED',
  IndicationAcknowledged = 'INDICATION_ACKNOWLEDGED',
  IndicationCreated = 'INDICATION_CREATED',
  IndicationModified = 'INDICATION_MODIFIED',
  IndicationUnacknowledged = 'INDICATION_UNACKNOWLEDGED',
}

export type OfferingDashboardOrderBookTimelineEvent = {
  readonly __typename?: 'OfferingDashboardOrderBookTimelineEvent';
  readonly actor: OfferingDashboardTimelineActor;
  readonly eventType: OfferingDashboardOrderBookTimelineEventType;
  readonly newValue?: Maybe<Scalars['Any']['output']>;
  readonly oldValue?: Maybe<Scalars['Any']['output']>;
  readonly timestamp: Scalars['DateTime']['output'];
  readonly version: Scalars['Long']['output'];
};

export enum OfferingDashboardOrderBookTimelineEventType {
  FinalAllocationsStatusChanged = 'FINAL_ALLOCATIONS_STATUS_CHANGED',
  FinalAllocationSetModified = 'FINAL_ALLOCATION_SET_MODIFIED',
  OrderBookStatusChanged = 'ORDER_BOOK_STATUS_CHANGED',
}

export type OfferingDashboardSellSideIndicationVersion = {
  readonly __typename?: 'OfferingDashboardSellSideIndicationVersion';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly indicationFieldVersions: OfferingDashboardIndicationVersion;
};

export type OfferingDashboardSyncedIndication = {
  readonly __typename?: 'OfferingDashboardSyncedIndication';
  readonly indicationId: Scalars['UUID']['output'];
  readonly investorCmgEntityKey: Scalars['String']['output'];
  readonly lastAllocationAcknowledgementVersion?: Maybe<Scalars['String']['output']>;
  readonly lastBillingAndDeliveryVersion?: Maybe<Scalars['String']['output']>;
  readonly lastFinalAllocationVersion?: Maybe<Scalars['String']['output']>;
  readonly lastIndicationAcknowledgementVersion?: Maybe<Scalars['String']['output']>;
  readonly lastIndicationVersion?: Maybe<Scalars['String']['output']>;
  readonly versionsPerParticipant: OfferingDashboardSyncedVersions;
};

export type OfferingDashboardSyncedVersions = {
  readonly __typename?: 'OfferingDashboardSyncedVersions';
  readonly buySideVersion?: Maybe<OfferingDashboardIndicationVersion>;
  readonly sellSideVersions: ReadonlyArray<OfferingDashboardSellSideIndicationVersion>;
};

export type OfferingDashboardTenant = {
  readonly __typename?: 'OfferingDashboardTenant';
  readonly accountName?: Maybe<Scalars['String']['output']>;
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly tenantId?: Maybe<Scalars['UUID']['output']>;
};

export type OfferingDashboardTimeline = {
  readonly __typename?: 'OfferingDashboardTimeline';
  readonly offeringId: Scalars['UUID']['output'];
  readonly offeringTimeline: ReadonlyArray<OfferingDashboardOfferingTimelineEvent>;
  readonly orderBookTimeline: ReadonlyArray<OfferingDashboardOrderBookTimelineEvent>;
};

export type OfferingDashboardTimelineActor = {
  readonly __typename?: 'OfferingDashboardTimelineActor';
  readonly createdByAccountId: Scalars['UUID']['output'];
  readonly createdByUserId: Scalars['UUID']['output'];
  readonly firmKey?: Maybe<Scalars['String']['output']>;
  readonly userType: UserType;
  readonly username?: Maybe<Scalars['String']['output']>;
};

export type OfferingDealLayout = {
  readonly __typename?: 'OfferingDealLayout';
  readonly institutionalTarget?: Maybe<Scalars['Long']['output']>;
  readonly offeringSize?: Maybe<Scalars['Long']['output']>;
};

export type OfferingError = {
  readonly __typename?: 'OfferingError';
  readonly category: OfferingErrorCategory;
  readonly description: Scalars['String']['output'];
  readonly type: OfferingErrorType;
};

export enum OfferingErrorCategory {
  All = 'ALL',
  DemandCurrencies = 'DEMAND_CURRENCIES',
  Disclaimers = 'DISCLAIMERS',
  FilingsAndRevisions = 'FILINGS_AND_REVISIONS',
  FollowonPricing = 'FOLLOWON_PRICING',
  Instruments = 'INSTRUMENTS',
  Issuer = 'ISSUER',
  Managers = 'MANAGERS',
  ManagerResponsibilities = 'MANAGER_RESPONSIBILITIES',
  Orderbook = 'ORDERBOOK',
  Prospectus = 'PROSPECTUS',
  Roadshow = 'ROADSHOW',
  Security = 'SECURITY',
  SponsorsAndAdvisors = 'SPONSORS_AND_ADVISORS',
  Syndicate = 'SYNDICATE',
  Timing = 'TIMING',
  Tranches = 'TRANCHES',
  Type = 'TYPE',
  UnderwritingTerms = 'UNDERWRITING_TERMS',
}

export enum OfferingErrorType {
  Error = 'ERROR',
  Warning = 'WARNING',
}

export type OfferingFull = {
  readonly __typename?: 'OfferingFull';
  readonly authorCmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly dataLabFull: DataLabFull;
  readonly demandCurrencies: ReadonlyArray<DemandCurrencyFull>;
  readonly derivedOfferPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly disclaimers?: Maybe<DisclaimersFull>;
  readonly hasForwardAgreement?: Maybe<Scalars['Boolean']['output']>;
  readonly hasUnpublishedChanges?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly initialFilingPriceRangeHigh?: Maybe<Scalars['Decimal']['output']>;
  readonly initialFilingPriceRangeLow?: Maybe<Scalars['Decimal']['output']>;
  readonly instruments: ReadonlyArray<InstrumentFull>;
  readonly isAuthor: Scalars['Boolean']['output'];
  readonly isExecutingOnPlatform: Scalars['Boolean']['output'];
  readonly isInternal: Scalars['Boolean']['output'];
  readonly isObsolete: Scalars['Boolean']['output'];
  readonly isTest: Scalars['Boolean']['output'];
  readonly isWallCrossEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly issuer: IssuerFull;
  readonly latestFilingPriceRangeHigh?: Maybe<Scalars['Decimal']['output']>;
  readonly latestFilingPriceRangeLow?: Maybe<Scalars['Decimal']['output']>;
  readonly managerEconomics?: Maybe<ManagerEconomicsFull>;
  readonly marketing?: Maybe<MarketingFull>;
  /** When selecting this field, also select the following fields to ensure that the actual and not the default market rules (US) are returned: Instruments.Id, Instruments.CountryCode */
  readonly offeringMarketRules: OfferingMarketRules;
  readonly orderBookConfiguration?: Maybe<OrderBookConfigurationFull>;
  readonly orderBookFull: OrderBookFull;
  /** When selecting this field for published offerings, also select the following fields to ensure the field is not needlessly nullified: Status, PricingInstrumentId, Instruments.Id, Instruments.CountryCode */
  readonly priceRangeHigh?: Maybe<Scalars['Decimal']['output']>;
  /** When selecting this field for published offerings, also select the following fields to ensure the field is not needlessly nullified: Status, PricingInstrumentId, Instruments.Id, Instruments.CountryCode */
  readonly priceRangeLow?: Maybe<Scalars['Decimal']['output']>;
  readonly pricingCurrencyCode: Scalars['String']['output'];
  readonly pricingInstrumentId?: Maybe<Scalars['UUID']['output']>;
  readonly pricingInstrumentStockSymbol?: Maybe<Scalars['String']['output']>;
  readonly prospectusDocuments?: Maybe<ReadonlyArray<ProspectusDocumentFull>>;
  readonly roadshowSchedules?: Maybe<ReadonlyArray<RoadshowsFull>>;
  readonly security: SecurityFull;
  readonly securityUnitsDisplayName: Scalars['String']['output'];
  readonly shareHistory?: Maybe<ReadonlyArray<ShareHistoryFull>>;
  readonly sizeInCurrency?: Maybe<Scalars['Decimal']['output']>;
  /** When selecting this field for published offerings, also select the following fields to ensure the field is not needlessly nullified: Status, PricingInstrumentId, Instruments.Id, Instruments.CountryCode */
  readonly sizeInShares?: Maybe<Scalars['Long']['output']>;
  readonly stage: OfferingStage;
  readonly status: OfferingStatus;
  readonly supersededByOfferingId?: Maybe<Scalars['UUID']['output']>;
  readonly syndicate?: Maybe<SyndicateFull>;
  readonly terms: TermsFull;
  readonly timing: TimingFull;
  readonly tranches?: Maybe<ReadonlyArray<TrancheFull>>;
  readonly type: OfferingType;
  /** Display name for Type */
  readonly typeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly version: Scalars['String']['output'];
};

export type OfferingFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<OfferingFullFilterInput>>;
  readonly authorCmgEntityKey?: InputMaybe<StringOperationFilterInput>;
  readonly demandCurrencies?: InputMaybe<ListFilterInputTypeOfDemandCurrencyFullFilterInput>;
  readonly disclaimers?: InputMaybe<DisclaimersFullFilterInput>;
  readonly hasForwardAgreement?: InputMaybe<BooleanOperationFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly instruments?: InputMaybe<ListFilterInputTypeOfInstrumentFullFilterInput>;
  readonly isExecutingOnPlatform?: InputMaybe<BooleanOperationFilterInput>;
  readonly isInternal?: InputMaybe<BooleanOperationFilterInput>;
  readonly isObsolete?: InputMaybe<BooleanOperationFilterInput>;
  readonly isTest?: InputMaybe<BooleanOperationFilterInput>;
  readonly isWallCrossEnabled?: InputMaybe<BooleanOperationFilterInput>;
  readonly issuer?: InputMaybe<IssuerFullFilterInput>;
  readonly managerEconomics?: InputMaybe<ManagerEconomicsFullFilterInput>;
  readonly marketing?: InputMaybe<MarketingFullFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<OfferingFullFilterInput>>;
  readonly orderBookConfiguration?: InputMaybe<OrderBookConfigurationFullFilterInput>;
  readonly pricingCurrencyCode?: InputMaybe<StringOperationFilterInput>;
  readonly pricingInstrumentId?: InputMaybe<UuidOperationFilterInput>;
  readonly pricingInstrumentStockSymbol?: InputMaybe<StringOperationFilterInput>;
  readonly prospectusDocuments?: InputMaybe<ListFilterInputTypeOfProspectusDocumentFullFilterInput>;
  readonly roadshowSchedules?: InputMaybe<ListFilterInputTypeOfRoadshowsFullFilterInput>;
  readonly security?: InputMaybe<SecurityFullFilterInput>;
  readonly securityUnitsDisplayName?: InputMaybe<StringOperationFilterInput>;
  readonly shareHistory?: InputMaybe<ListFilterInputTypeOfShareHistoryFullFilterInput>;
  readonly stage?: InputMaybe<OfferingStageFilterInput>;
  readonly status?: InputMaybe<OfferingStatusOperationFilterInput>;
  readonly supersededByOfferingId?: InputMaybe<UuidOperationFilterInput>;
  readonly syndicate?: InputMaybe<SyndicateFullFilterInput>;
  readonly terms?: InputMaybe<TermsFullFilterInput>;
  readonly timing?: InputMaybe<TimingFullFilterInput>;
  readonly tranches?: InputMaybe<ListFilterInputTypeOfTrancheFullFilterInput>;
  readonly type?: InputMaybe<OfferingTypeFilterInput>;
  readonly version?: InputMaybe<StringOperationFilterInput>;
};

export type OfferingInvestorRelationship = {
  readonly __typename?: 'OfferingInvestorRelationship';
  readonly coveredActiveBookrunnerCmgEntityKeys: ReadonlyArray<Scalars['String']['output']>;
  readonly coveredSyndicateCmgEntityKeys: ReadonlyArray<Scalars['String']['output']>;
  readonly hasRelationshipWithActiveBookrunner: Scalars['Boolean']['output'];
  readonly hasRelationshipWithSyndicate: Scalars['Boolean']['output'];
};

export type OfferingLimited = {
  readonly __typename?: 'OfferingLimited';
  readonly bookCloseDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly bookCloseTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly bookOpenDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly bookOpenTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly finalAllocation?: Maybe<FinalAllocation>;
  readonly finalFilingOfferPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly firstTradeDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly fundIois?: Maybe<FundIois>;
  readonly funds?: Maybe<ReadonlyArray<Fund>>;
  readonly hasForwardAgreement?: Maybe<Scalars['Boolean']['output']>;
  readonly hasUnpublishedChanges?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isAuthor: Scalars['Boolean']['output'];
  readonly isExecutingOnPlatform: Scalars['Boolean']['output'];
  readonly isUsOffering?: Maybe<Scalars['Boolean']['output']>;
  readonly issuerName: Scalars['String']['output'];
  readonly issuerSector?: Maybe<Sector>;
  /** Display name for IssuerSector */
  readonly issuerSectorDisplayName?: Maybe<Scalars['String']['output']>;
  readonly launchDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly leftLead?: Maybe<Scalars['String']['output']>;
  readonly leftLeadFirmName?: Maybe<Scalars['String']['output']>;
  readonly managers: ReadonlyArray<ManagerLimited>;
  readonly mdlAllocation?: Maybe<MdlAllocationResponse>;
  readonly mdlIndications?: Maybe<MdlIndications>;
  readonly myInstitutionalIndication?: Maybe<MyInstitutionalIndication>;
  readonly orderBookConfiguration: OrderBookConfiguration;
  readonly postponedDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly priceRangeHigh?: Maybe<Scalars['Decimal']['output']>;
  readonly priceRangeLow?: Maybe<Scalars['Decimal']['output']>;
  readonly pricingCurrencyCode: Scalars['String']['output'];
  readonly pricingDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly pricingInstrumentCountryCode?: Maybe<Scalars['String']['output']>;
  readonly pricingInstrumentCountryDisplayName?: Maybe<Scalars['String']['output']>;
  readonly pricingInstrumentRegion?: Maybe<Scalars['String']['output']>;
  readonly pricingInstrumentStockSymbol?: Maybe<Scalars['String']['output']>;
  readonly publicFilingDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly revisedFilingsCount?: Maybe<Scalars['Int']['output']>;
  readonly securityDescription?: Maybe<Scalars['String']['output']>;
  readonly securityIsDepositaryReceipt?: Maybe<Scalars['Boolean']['output']>;
  readonly securityShareClass?: Maybe<Scalars['String']['output']>;
  readonly securityType: SecurityType;
  /** Display name for SecurityType */
  readonly securityTypeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly shareHistory: OfferingSharedDraftHistory;
  readonly sizeInCurrency?: Maybe<Scalars['Decimal']['output']>;
  readonly sizeInShares?: Maybe<Scalars['Long']['output']>;
  readonly stage: OfferingStage;
  readonly status: OfferingStatus;
  readonly supersededByOfferingId?: Maybe<Scalars['UUID']['output']>;
  readonly supersededOfferingId?: Maybe<Scalars['UUID']['output']>;
  readonly syndicateEntitlements: ReadonlyArray<SyndicateEntitlements>;
  readonly terminatedDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly timeZone?: Maybe<Scalars['DateTimeZone']['output']>;
  readonly tradeDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly type: OfferingType;
  /** Display name for Type */
  readonly typeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly version: Scalars['String']['output'];
  readonly withdrawnDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type OfferingList = {
  readonly __typename?: 'OfferingList';
  readonly data: ReadonlyArray<OfferingLimited>;
};

export type OfferingMarketRules = {
  readonly __typename?: 'OfferingMarketRules';
  readonly allowsGlobalCoordinator: Scalars['Boolean']['output'];
  readonly requiresProspectusForLiveOrPricedIpo: Scalars['Boolean']['output'];
};

export enum OfferingNoteSubject {
  Allocation = 'ALLOCATION',
  Compliance = 'COMPLIANCE',
  General = 'GENERAL',
  Indication = 'INDICATION',
  Messaging = 'MESSAGING',
}

export type OfferingOrderEntryProfile = {
  readonly __typename?: 'OfferingOrderEntryProfile';
  readonly id: Scalars['ID']['output'];
  readonly instruments: ReadonlyArray<InstrumentOrderEntryProfile>;
  readonly isExecutingOnPlatform: Scalars['Boolean']['output'];
  readonly tranches: ReadonlyArray<TranchePrivileged>;
};

export type OfferingProfile = {
  readonly __typename?: 'OfferingProfile';
  /**
   * Deprecated; Use DemandCurrenciesWithExchangeRates instead.
   * @deprecated Use DemandCurrenciesWithExchangeRates instead.
   */
  readonly demandCurrencies: ReadonlyArray<Scalars['String']['output']>;
  readonly demandCurrenciesWithExchangeRates: ReadonlyArray<DemandCurrencyProfile>;
  /** Returns a derived offering price */
  readonly derivedOfferPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly disclaimers: DisclaimersProfile;
  readonly entitlements: PublishedSyndicateEntitlements;
  readonly hasForwardAgreement?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['ID']['output'];
  /** Returns high end of price range for IPOs, Overnights, Registered and Unregistered Blocks from the Initial Filing */
  readonly initialFilingPriceRangeHigh?: Maybe<Scalars['Decimal']['output']>;
  /** Returns low end of price range for IPOs, Overnights, Registered and Unregistered Blocks from the Initial Filing */
  readonly initialFilingPriceRangeLow?: Maybe<Scalars['Decimal']['output']>;
  readonly instruments: ReadonlyArray<DeliveryInstrumentPrivileged>;
  readonly isAuthor: Scalars['Boolean']['output'];
  readonly isDiscarded: Scalars['Boolean']['output'];
  readonly isExecutingOnPlatform: Scalars['Boolean']['output'];
  readonly issuer: Issuer;
  /** Returns high end of price range for IPOs, Overnights, Registered and Unregistered Blocks from the most recent filing */
  readonly latestFilingPriceRangeHigh?: Maybe<Scalars['Decimal']['output']>;
  /** Returns low end of price range for IPOs, Overnights, Registered and Unregistered Blocks from the most recent filing */
  readonly latestFilingPriceRangeLow?: Maybe<Scalars['Decimal']['output']>;
  readonly managerEconomics?: Maybe<ManagerEconomicsProfile>;
  readonly marketing: Marketing;
  readonly orderBook: OrderBook;
  readonly orderBookConfiguration: OrderBookConfiguration;
  readonly pricingCurrencyCode: Scalars['String']['output'];
  readonly pricingInstrumentId: Scalars['UUID']['output'];
  /** Returns the pricing instrument stock symbol for an Offering */
  readonly pricingInstrumentStockSymbol?: Maybe<Scalars['String']['output']>;
  readonly prospectusDocuments: ReadonlyArray<ProspectusDocumentProfile>;
  readonly roadshowSchedules: ReadonlyArray<RoadshowScheduleProfile>;
  readonly security: SecurityProfile;
  readonly sizeInCurrency?: Maybe<Scalars['Decimal']['output']>;
  readonly sizeInShares?: Maybe<Scalars['Long']['output']>;
  readonly stage: OfferingStage;
  readonly status: OfferingStatus;
  readonly supersededByOfferingId?: Maybe<Scalars['UUID']['output']>;
  readonly supersededOfferingId?: Maybe<Scalars['UUID']['output']>;
  readonly syndicate: SyndicateProfile;
  readonly syndicateEntitlements: Entitlements;
  readonly terms: TermsProfile;
  readonly timing: TimingProfile;
  /** Null is returned if your firm does not have an active bookrunner relationship with this offering. */
  readonly tranches?: Maybe<ReadonlyArray<TranchePrivileged>>;
  readonly type: OfferingType;
  /** Display name for Type */
  readonly typeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly version: Scalars['String']['output'];
};

export type OfferingProfileSyndicateEntitlementsArgs = {
  filters?: InputMaybe<RecordStatusFilterInput>;
};

export type OfferingPublished = {
  readonly __typename?: 'OfferingPublished';
  readonly offeringId: Scalars['UUID']['output'];
};

export enum OfferingSecurityType {
  CommonOrdinaryShare = 'COMMON_ORDINARY_SHARE',
  ConvertibleBond = 'CONVERTIBLE_BOND',
  Fund = 'FUND',
  LimitedPartnershipUnit = 'LIMITED_PARTNERSHIP_UNIT',
  PreferredShare = 'PREFERRED_SHARE',
  UnitShareAndWarrants = 'UNIT_SHARE_AND_WARRANTS',
}

export enum OfferingSetupExchangeMic {
  Aqse = 'AQSE',
  Bats = 'BATS',
  Bsex = 'BSEX',
  Bvca = 'BVCA',
  Bvmf = 'BVMF',
  Difx = 'DIFX',
  Dsmd = 'DSMD',
  Hstc = 'HSTC',
  Misx = 'MISX',
  Neoe = 'NEOE',
  Notc = 'NOTC',
  Rsex = 'RSEX',
  Xads = 'XADS',
  Xalg = 'XALG',
  Xamm = 'XAMM',
  Xams = 'XAMS',
  Xarm = 'XARM',
  Xasx = 'XASX',
  Xath = 'XATH',
  Xbaa = 'XBAA',
  Xbab = 'XBAB',
  Xbah = 'XBAH',
  Xbda = 'XBDA',
  Xbdv = 'XBDV',
  Xbel = 'XBEL',
  Xbey = 'XBEY',
  Xbkk = 'XBKK',
  Xbnv = 'XBNV',
  Xbog = 'XBOG',
  Xbol = 'XBOL',
  Xbom = 'XBOM',
  Xbot = 'XBOT',
  Xbra = 'XBRA',
  Xbru = 'XBRU',
  Xbrv = 'XBRV',
  Xbse = 'XBSE',
  Xbud = 'XBUD',
  Xbue = 'XBUE',
  Xbul = 'XBUL',
  Xbvm = 'XBVM',
  Xcai = 'XCAI',
  Xcas = 'XCAS',
  Xcnq = 'XCNQ',
  Xcol = 'XCOL',
  Xcse = 'XCSE',
  Xcsx = 'XCSX',
  Xcys = 'XCYS',
  Xdar = 'XDAR',
  Xdfm = 'XDFM',
  Xdha = 'XDHA',
  Xdse = 'XDSE',
  Xdub = 'XDUB',
  Xfra = 'XFRA',
  Xgha = 'XGHA',
  Xgse = 'XGSE',
  Xhel = 'XHEL',
  Xhkg = 'XHKG',
  Xice = 'XICE',
  Xidx = 'XIDX',
  Xiqs = 'XIQS',
  Xist = 'XIST',
  Xjam = 'XJAM',
  Xjse = 'XJSE',
  Xkar = 'XKAR',
  Xkaz = 'XKAZ',
  Xkls = 'XKLS',
  Xkrx = 'XKRX',
  Xkuw = 'XKUW',
  Xlao = 'XLAO',
  Xlim = 'XLIM',
  Xlis = 'XLIS',
  Xlit = 'XLIT',
  Xlju = 'XLJU',
  Xlon = 'XLON',
  Xlus = 'XLUS',
  Xlux = 'XLUX',
  Xmad = 'XMAD',
  Xmae = 'XMAE',
  Xmal = 'XMAL',
  Xmau = 'XMAU',
  Xmex = 'XMEX',
  Xmil = 'XMIL',
  Xmnx = 'XMNX',
  Xmsw = 'XMSW',
  Xmus = 'XMUS',
  Xnai = 'XNAI',
  Xnam = 'XNAM',
  Xnas = 'XNAS',
  Xnec = 'XNEC',
  Xnep = 'XNEP',
  Xngm = 'XNGM',
  Xnsa = 'XNSA',
  Xnse = 'XNSE',
  Xnys = 'XNYS',
  Xnze = 'XNZE',
  Xosl = 'XOSL',
  Xotc = 'XOTC',
  Xpae = 'XPAE',
  Xpar = 'XPAR',
  Xphs = 'XPHS',
  Xpom = 'XPOM',
  Xpra = 'XPRA',
  Xpty = 'XPTY',
  Xris = 'XRIS',
  Xsau = 'XSAU',
  Xses = 'XSES',
  Xsgo = 'XSGO',
  Xshe = 'XSHE',
  Xshg = 'XSHG',
  Xsps = 'XSPS',
  Xstc = 'XSTC',
  Xste = 'XSTE',
  Xsto = 'XSTO',
  Xswx = 'XSWX',
  Xtae = 'XTAE',
  Xtai = 'XTAI',
  Xtal = 'XTAL',
  Xtks = 'XTKS',
  Xtrn = 'XTRN',
  Xtse = 'XTSE',
  Xtsx = 'XTSX',
  Xtun = 'XTUN',
  Xuga = 'XUGA',
  Xula = 'XULA',
  Xvpa = 'XVPA',
  Xwar = 'XWAR',
  Xwbo = 'XWBO',
  Xzag = 'XZAG',
}

export type OfferingSetupExchangeMicFilterInput = {
  readonly eq?: InputMaybe<OfferingSetupExchangeMic>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<OfferingSetupExchangeMic>>>;
  readonly neq?: InputMaybe<OfferingSetupExchangeMic>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<OfferingSetupExchangeMic>>>;
};

export type OfferingSharedDraftHistory = {
  readonly __typename?: 'OfferingSharedDraftHistory';
  readonly id: Scalars['ID']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly shareDraftHistories: ReadonlyArray<SharedDraftHistory>;
};

export enum OfferingStage {
  Discarded = 'DISCARDED',
  Draft = 'DRAFT',
  Erroneous = 'ERRONEOUS',
  Obsolete = 'OBSOLETE',
  Published = 'PUBLISHED',
}

export type OfferingStageFilterInput = {
  readonly eq?: InputMaybe<OfferingStage>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<OfferingStage>>>;
  readonly neq?: InputMaybe<OfferingStage>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<OfferingStage>>>;
};

export enum OfferingStatus {
  Confidential = 'CONFIDENTIAL',
  Filed = 'FILED',
  Live = 'LIVE',
  Postponed = 'POSTPONED',
  Priced = 'PRICED',
  Terminated = 'TERMINATED',
  Withdrawn = 'WITHDRAWN',
}

export type OfferingStatusOperationFilterInput = {
  readonly eq?: InputMaybe<OfferingStatus>;
  readonly in?: InputMaybe<ReadonlyArray<OfferingStatus>>;
  readonly neq?: InputMaybe<OfferingStatus>;
  readonly nin?: InputMaybe<ReadonlyArray<OfferingStatus>>;
};

export enum OfferingType {
  Abb = 'ABB',
  Convertible = 'CONVERTIBLE',
  FollowOn = 'FOLLOW_ON',
  Ipo = 'IPO',
  IpoSpac = 'IPO_SPAC',
  MarketedFo = 'MARKETED_FO',
  OvernightFo = 'OVERNIGHT_FO',
  PrivatePlacement = 'PRIVATE_PLACEMENT',
  RegisteredBlock = 'REGISTERED_BLOCK',
  RegisteredDirect = 'REGISTERED_DIRECT',
  Rights = 'RIGHTS',
  UnregisteredBlock = 'UNREGISTERED_BLOCK',
}

export type OfferingTypeFilterInput = {
  readonly eq?: InputMaybe<OfferingType>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<OfferingType>>>;
  readonly neq?: InputMaybe<OfferingType>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<OfferingType>>>;
};

export type OfferingValidation = {
  readonly __typename?: 'OfferingValidation';
  readonly errors: ReadonlyArray<OfferingError>;
};

export type OfferingVersion = {
  readonly __typename?: 'OfferingVersion';
  readonly description: Scalars['String']['output'];
  readonly timestamp: Scalars['Instant']['output'];
  readonly version: Scalars['String']['output'];
};

export type OrderBook = {
  readonly __typename?: 'OrderBook';
  readonly auditInfo: AuditInfo;
  readonly finalInstitutionalAllocations: ReadonlyArray<FinalAllocation>;
  readonly id: Scalars['ID']['output'];
  /**
   * *** This property is deprecated and will be removed in a future release. ***
   * @deprecated This property is deprecated and will be removed in a future release.
   */
  readonly indicationMaximum: Scalars['Decimal']['output'];
  readonly institutionalIndication?: Maybe<InstitutionalIndication>;
  readonly institutionalIndications: ReadonlyArray<InstitutionalIndication>;
  /** The ID of the Offering for which this Order Book accepts Indications. */
  readonly offeringId: Scalars['ID']['output'];
  /** The current state of this Order Book. */
  readonly state: OrderBookState;
  readonly version: Scalars['String']['output'];
};

export type OrderBookInstitutionalIndicationArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrderBookInstitutionalIndicationsArgs = {
  filters?: InputMaybe<InstitutionalIndicationListFiltersInput>;
};

export type OrderBookConfiguration = {
  readonly __typename?: 'OrderBookConfiguration';
  readonly isIndicationPriceAsPercentageParEnabled: Scalars['Boolean']['output'];
  readonly isLimitIndicationsOnlyEnabled: Scalars['Boolean']['output'];
  readonly isOnlySharesUnitOnIndicationsEnabled: Scalars['Boolean']['output'];
};

export type OrderBookConfigurationFull = {
  readonly __typename?: 'OrderBookConfigurationFull';
  readonly isIndicationPriceAsPercentageParEnabled: Scalars['Boolean']['output'];
  readonly isLimitIndicationsOnlyEnabled: Scalars['Boolean']['output'];
  readonly isOnlySharesUnitOnIndicationsEnabled: Scalars['Boolean']['output'];
};

export type OrderBookConfigurationFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<OrderBookConfigurationFullFilterInput>>;
  readonly isIndicationPriceAsPercentageParEnabled?: InputMaybe<BooleanOperationFilterInput>;
  readonly isLimitIndicationsOnlyEnabled?: InputMaybe<BooleanOperationFilterInput>;
  readonly isOnlySharesUnitOnIndicationsEnabled?: InputMaybe<BooleanOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<OrderBookConfigurationFullFilterInput>>;
};

export type OrderBookDiff = {
  readonly __typename?: 'OrderBookDiff';
  readonly cutoff: Scalars['DateTime']['output'];
  readonly entries: ReadonlyArray<OrderBookDiffEntry>;
  readonly nodes: ReadonlyArray<OrderBookNode>;
  readonly offeringId: Scalars['UUID']['output'];
};

export type OrderBookDiffEntry = {
  readonly authorCmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly missingFrom: ReadonlyArray<OrderBookNode>;
  readonly presentAt: ReadonlyArray<OrderBookNode>;
  readonly version: Scalars['String']['output'];
};

export enum OrderBookErrorType {
  BillingAndDelivery = 'BILLING_AND_DELIVERY',
  MyRetail = 'MY_RETAIL',
  NoFinalAllocations = 'NO_FINAL_ALLOCATIONS',
  NoIndications = 'NO_INDICATIONS',
  NoReleasedFinalAllocations = 'NO_RELEASED_FINAL_ALLOCATIONS',
  RetailDemand = 'RETAIL_DEMAND',
  RetailRetention = 'RETAIL_RETENTION',
}

export type OrderBookFull = {
  readonly __typename?: 'OrderBookFull';
  /** Returns Covered Indications for Sales and Trading users */
  readonly coveredIndications?: Maybe<ReadonlyArray<CoveredInstitutionalIndicationWithAttestation>>;
  readonly finalAllocation?: Maybe<FinalAllocation>;
  readonly myInstitutionalIndication?: Maybe<MyInstitutionalIndication>;
  readonly orderBookState?: Maybe<OrderBookState>;
};

export type OrderBookGraph = {
  readonly __typename?: 'OrderBookGraph';
  readonly auditInfo: AuditInformation;
  readonly enforceValidAttestationForSalesAndTrading: Scalars['Boolean']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly salesState: OrderBookState;
  readonly state: OrderBookState;
  readonly version: Scalars['String']['output'];
};

export enum OrderBookInvestorStatus {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
}

export enum OrderBookManagerRole {
  ActiveBookrunner = 'ACTIVE_BOOKRUNNER',
  Bookrunner = 'BOOKRUNNER',
  CoLead = 'CO_LEAD',
  CoManager = 'CO_MANAGER',
  FacilitationAgent = 'FACILITATION_AGENT',
  GlobalCoordinator = 'GLOBAL_COORDINATOR',
  Invalid = 'INVALID',
  SellingGroupMember = 'SELLING_GROUP_MEMBER',
  Underwriter = 'UNDERWRITER',
}

export type OrderBookNode = {
  readonly __typename?: 'OrderBookNode';
  /** Null for the primary node. */
  readonly tenantCmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly type: OrderBookNodeType;
};

export enum OrderBookNodeType {
  BuySide = 'BUY_SIDE',
  Primary = 'PRIMARY',
  SellSide = 'SELL_SIDE',
}

export enum OrderBookRecordStatus {
  Deleted = 'DELETED',
  Effective = 'EFFECTIVE',
}

export type OrderBookRevisionDiff = OrderBookDiffEntry & {
  readonly __typename?: 'OrderBookRevisionDiff';
  readonly authorCmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly missingFrom: ReadonlyArray<OrderBookNode>;
  readonly presentAt: ReadonlyArray<OrderBookNode>;
  readonly version: Scalars['String']['output'];
};

export type OrderBookSalesState = {
  readonly __typename?: 'OrderBookSalesState';
  readonly offeringId: Scalars['UUID']['output'];
  readonly salesState: OrderBookState;
};

export enum OrderBookState {
  /** The Closed state, which prevents anyone other than the Settlement Agent from modifying the Order Book. */
  Closed = 'CLOSED',
  /** The Never Opened state, which prevents an Order Book from accepting Indications from Investors. */
  NeverOpened = 'NEVER_OPENED',
  /** The Open state, which allows an Order Book to accept Indications from Investors. */
  Open = 'OPEN',
}

export type OrderBookStatus = {
  readonly __typename?: 'OrderBookStatus';
  readonly offeringId: Scalars['UUID']['output'];
  readonly state: OrderBookState;
};

export enum OrdersGridChangeSource {
  Allocation = 'ALLOCATION',
  Attestation = 'ATTESTATION',
  BillingAndDeliveryAgent = 'BILLING_AND_DELIVERY_AGENT',
  Indication = 'INDICATION',
  Offering = 'OFFERING',
  Prospectus = 'PROSPECTUS',
}

export type OverAllotmentExercisedData = {
  readonly __typename?: 'OverAllotmentExercisedData';
  readonly date?: Maybe<Scalars['LocalDate']['output']>;
  readonly notional?: Maybe<Scalars['Decimal']['output']>;
  readonly numberOfBonds?: Maybe<Scalars['Long']['output']>;
  readonly primaryShares?: Maybe<Scalars['Long']['output']>;
  readonly proceeds?: Maybe<Scalars['Decimal']['output']>;
  readonly secondaryShares?: Maybe<Scalars['Long']['output']>;
  readonly totalShares?: Maybe<Scalars['Long']['output']>;
};

export type OverAllotmentExercisedFull = {
  readonly __typename?: 'OverAllotmentExercisedFull';
  readonly date?: Maybe<Scalars['LocalDate']['output']>;
  readonly notional?: Maybe<Scalars['Decimal']['output']>;
  readonly numberOfBonds?: Maybe<Scalars['Long']['output']>;
  readonly primaryShares?: Maybe<Scalars['Long']['output']>;
  readonly proceeds?: Maybe<Scalars['Decimal']['output']>;
  readonly secondaryShares?: Maybe<Scalars['Long']['output']>;
  readonly totalShares?: Maybe<Scalars['Long']['output']>;
};

export type OverAllotmentExercisedFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<OverAllotmentExercisedFullFilterInput>>;
  readonly date?: InputMaybe<LocalDateOperationFilterInput>;
  readonly notional?: InputMaybe<DecimalOperationFilterInput>;
  readonly numberOfBonds?: InputMaybe<LongOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<OverAllotmentExercisedFullFilterInput>>;
  readonly primaryShares?: InputMaybe<LongOperationFilterInput>;
  readonly proceeds?: InputMaybe<DecimalOperationFilterInput>;
  readonly secondaryShares?: InputMaybe<LongOperationFilterInput>;
  readonly totalShares?: InputMaybe<LongOperationFilterInput>;
};

export type OverwriteDesignationInput = {
  /** Collection of manual designations. */
  readonly designations?: InputMaybe<ReadonlyArray<DesignationUpdateInput>>;
  /** Collection of allocated indications ids to be designated using fixed economics. */
  readonly indicationIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** The type of assign operation. */
  readonly operationType: DesignationStrategy;
};

/** A cursor that points to a specific page. */
export type PageCursor = {
  readonly __typename?: 'PageCursor';
  /** The cursor. */
  readonly cursor: Scalars['String']['output'];
  /** The page number. */
  readonly page: Scalars['Int']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  readonly __typename?: 'PageInfo';
  /** A list of cursors to continue paginating backwards. */
  readonly backwardCursors: ReadonlyArray<PageCursor>;
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** A list of cursors to continue paginating forwards. */
  readonly forwardCursors: ReadonlyArray<PageCursor>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationData = {
  readonly __typename?: 'PaginationData';
  /** Current page */
  readonly activePage: Scalars['Int']['output'];
  /** Indicate if there is a next page */
  readonly hasNext?: Maybe<Scalars['Boolean']['output']>;
  /** Indicate if there is a previous page */
  readonly hasPrevious: Scalars['Boolean']['output'];
  /** Number of records per page */
  readonly perPage: Scalars['Int']['output'];
  /** Total number of records */
  readonly totalCount?: Maybe<Scalars['Int']['output']>;
  /** Total pages */
  readonly totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PaginationDataInput = {
  readonly includeTotals?: InputMaybe<Scalars['Boolean']['input']>;
  readonly orderDirection?: InputMaybe<SortOrderDirection>;
  readonly orderField?: InputMaybe<Scalars['String']['input']>;
  readonly page?: InputMaybe<Scalars['Int']['input']>;
  readonly perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type PassOnOfferingResponseUnion = MyInstitutionalIndication | ServiceError;

export type PaymentRecipientInputData = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly dtcNumber: Scalars['String']['input'];
  readonly ipoPenaltyTracking: Scalars['Boolean']['input'];
  readonly payment: Scalars['Decimal']['input'];
  readonly recipient: Scalars['String']['input'];
};

export type PaymentRecipientUserData = {
  readonly __typename?: 'PaymentRecipientUserData';
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly dtcNumber: Scalars['String']['output'];
  readonly ipoPenaltyTracking: Scalars['Boolean']['output'];
  readonly payment: Scalars['Decimal']['output'];
  readonly recipient: Scalars['String']['output'];
};

export type PaymentWire = {
  readonly __typename?: 'PaymentWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly id: Scalars['ID']['output'];
  readonly recipientsUserData: ReadonlyArray<PaymentRecipientUserData>;
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

export type PaymentWireInput = {
  readonly userDataForRecipients: ReadonlyArray<PaymentRecipientInputData>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type PaymentWireResponseUnion = PaymentWire | ServiceError;

export type PaymentWireValidation = WireValidationBase & {
  readonly __typename?: 'PaymentWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<PaymentWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum PaymentWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  Cusip = 'CUSIP',
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  PricePerUnit = 'PRICE_PER_UNIT',
  SecurityType = 'SECURITY_TYPE',
  SellingConcessionPerUnit = 'SELLING_CONCESSION_PER_UNIT',
  SettlementAgent = 'SETTLEMENT_AGENT',
  SettlementDate = 'SETTLEMENT_DATE',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
}

export type PercentagePerCmgEntity = {
  readonly __typename?: 'PercentagePerCmgEntity';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly percentageValue: Scalars['Decimal']['output'];
};

export type PercentagePerCmgEntityDataInput = {
  readonly cmgEntityKey: Scalars['String']['input'];
  readonly percentageValue: Scalars['Decimal']['input'];
};

export type PercentagePerCmgEntityFull = {
  readonly __typename?: 'PercentagePerCmgEntityFull';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly percentageValue: Scalars['Decimal']['output'];
};

export type PercentagePerCmgEntityFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<PercentagePerCmgEntityFullFilterInput>>;
  readonly cmgEntityKey?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<PercentagePerCmgEntityFullFilterInput>>;
  readonly percentageValue?: InputMaybe<DecimalOperationFilterInput>;
};

export type PotAccountWire = {
  readonly __typename?: 'PotAccountWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly headerNote?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type PotAccountWireResponseUnion = PotAccountWire | ServiceError;

export type PotAccountWireValidation = WireValidationBase & {
  readonly __typename?: 'PotAccountWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<PotAccountWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum PotAccountWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
}

export type PotAllocationWire = {
  readonly __typename?: 'PotAllocationWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly headerNote?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type PotAllocationWireResponseUnion = PotAllocationWire | ServiceError;

export type PotAllocationWireValidation = WireValidationBase & {
  readonly __typename?: 'PotAllocationWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<PotAllocationWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum PotAllocationWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
}

export type PricedPublishedOfferingListFiltersInput = {
  readonly cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  readonly endPricingDate: Scalars['Date']['input'];
  readonly includeTestOfferings?: InputMaybe<Scalars['Boolean']['input']>;
  readonly startPricingDate: Scalars['Date']['input'];
};

export enum PricingBasisType {
  Atm = 'ATM',
  Dlsts = 'DLSTS',
  Lstsl = 'LSTSL',
  Ngttd = 'NGTTD',
  Other = 'OTHER',
}

export type PricingTermsRetentionRecipientUserData = {
  readonly __typename?: 'PricingTermsRetentionRecipientUserData';
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly recipient: Scalars['String']['output'];
};

export type PricingTermsRetentionUserDataForRecipientInputData = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly recipient: Scalars['String']['input'];
};

export type PricingTermsRetentionWire = {
  readonly __typename?: 'PricingTermsRetentionWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly id: Scalars['ID']['output'];
  readonly recipientsUserData: ReadonlyArray<PricingTermsRetentionRecipientUserData>;
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type PricingTermsRetentionWireResponseUnion = PricingTermsRetentionWire | ServiceError;

export type PricingTermsRetentionWireValidation = WireValidationBase & {
  readonly __typename?: 'PricingTermsRetentionWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<PricingTermsRetentionWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum PricingTermsRetentionWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  Coupon = 'COUPON',
  Cusip = 'CUSIP',
  ExchangeMic = 'EXCHANGE_MIC',
  FirstTradeDate = 'FIRST_TRADE_DATE',
  GrossSpread = 'GROSS_SPREAD',
  IssuerName = 'ISSUER_NAME',
  ManagementFee = 'MANAGEMENT_FEE',
  OfferingPrice = 'OFFERING_PRICE',
  OfferingType = 'OFFERING_TYPE',
  ParValue = 'PAR_VALUE',
  PercentageOfPar = 'PERCENTAGE_OF_PAR',
  Premium = 'PREMIUM',
  SecurityType = 'SECURITY_TYPE',
  SellingConcession = 'SELLING_CONCESSION',
  SettlementAgent = 'SETTLEMENT_AGENT',
  SettlementDate = 'SETTLEMENT_DATE',
  StockSymbol = 'STOCK_SYMBOL',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
  UnderlyingExchangeMic = 'UNDERLYING_EXCHANGE_MIC',
  UnderlyingStockSymbol = 'UNDERLYING_STOCK_SYMBOL',
  UnderwritingFee = 'UNDERWRITING_FEE',
}

export type PricingTermsWire = {
  readonly __typename?: 'PricingTermsWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type PricingTermsWireResponseUnion = PricingTermsWire | ServiceError;

export type PricingTermsWireValidation = WireValidationBase & {
  readonly __typename?: 'PricingTermsWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<PricingTermsWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum PricingTermsWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  Coupon = 'COUPON',
  Cusip = 'CUSIP',
  ExchangeMic = 'EXCHANGE_MIC',
  FirstTradeDate = 'FIRST_TRADE_DATE',
  GrossSpread = 'GROSS_SPREAD',
  IssuerName = 'ISSUER_NAME',
  ManagementFee = 'MANAGEMENT_FEE',
  OfferingPrice = 'OFFERING_PRICE',
  OfferingType = 'OFFERING_TYPE',
  ParValue = 'PAR_VALUE',
  PercentageOfPar = 'PERCENTAGE_OF_PAR',
  Premium = 'PREMIUM',
  SecurityType = 'SECURITY_TYPE',
  SellingConcession = 'SELLING_CONCESSION',
  SettlementAgent = 'SETTLEMENT_AGENT',
  SettlementDate = 'SETTLEMENT_DATE',
  StockSymbol = 'STOCK_SYMBOL',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
  UnderlyingExchangeMic = 'UNDERLYING_EXCHANGE_MIC',
  UnderlyingStockSymbol = 'UNDERLYING_STOCK_SYMBOL',
  UnderwritingFee = 'UNDERWRITING_FEE',
}

export type PrivateManagerEconomics = {
  readonly __typename?: 'PrivateManagerEconomics';
  readonly incentiveFeePercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly managementPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly overallotmentExercisedShares?: Maybe<Scalars['Long']['output']>;
  readonly sellingConcessionPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingBaseShares?: Maybe<Scalars['Long']['output']>;
  readonly underwritingPercentage?: Maybe<Scalars['Decimal']['output']>;
};

/** A segment of a collection. */
export type PrivateOfferingsCollectionSegment = {
  readonly __typename?: 'PrivateOfferingsCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<OfferingFull>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type PrivatePlacementTermsFull = {
  readonly __typename?: 'PrivatePlacementTermsFull';
  readonly annualFee?: Maybe<Scalars['Decimal']['output']>;
  readonly carry?: Maybe<Scalars['Decimal']['output']>;
  readonly commission?: Maybe<Scalars['Decimal']['output']>;
  readonly impliedValuation?: Maybe<Scalars['Decimal']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly price?: Maybe<Scalars['Decimal']['output']>;
  readonly primaryShares?: Maybe<Scalars['Long']['output']>;
  readonly secondaryShares?: Maybe<Scalars['Long']['output']>;
  readonly sizeNotional?: Maybe<Scalars['Decimal']['output']>;
  readonly sizeShares?: Maybe<Scalars['Long']['output']>;
};

export type PrivatePlacementTermsFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<PrivatePlacementTermsFullFilterInput>>;
  readonly annualFee?: InputMaybe<DecimalOperationFilterInput>;
  readonly carry?: InputMaybe<DecimalOperationFilterInput>;
  readonly commission?: InputMaybe<DecimalOperationFilterInput>;
  readonly impliedValuation?: InputMaybe<DecimalOperationFilterInput>;
  readonly notes?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<PrivatePlacementTermsFullFilterInput>>;
  readonly price?: InputMaybe<DecimalOperationFilterInput>;
  readonly primaryShares?: InputMaybe<LongOperationFilterInput>;
  readonly secondaryShares?: InputMaybe<LongOperationFilterInput>;
  readonly sizeNotional?: InputMaybe<DecimalOperationFilterInput>;
  readonly sizeShares?: InputMaybe<LongOperationFilterInput>;
};

export type ProspectusDelivery = {
  readonly __typename?: 'ProspectusDelivery';
  readonly documents: ReadonlyArray<ProspectusDocumentMetadata>;
  readonly id: Scalars['ID']['output'];
  readonly revisions: ReadonlyArray<LatestEmailStatus>;
  readonly version: Scalars['Long']['output'];
};

export type ProspectusDeliveryRoot = {
  readonly __typename?: 'ProspectusDeliveryRoot';
  readonly id: Scalars['UUID']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly onSendValidationAsSalesAndTrading: ProspectusOnSendValidationResult;
  readonly onSendValidationAsSyndicate: ProspectusOnSendValidationResult;
  readonly salesAndTradingHistory: ReadonlyArray<ProspectusDelivery>;
  readonly singleOnSendValidationAsSalesAndTrading: ProspectusOnSendValidationResult;
  readonly singleOnSendValidationAsSyndicate: ProspectusOnSendValidationResult;
  readonly syndicateHistory: ReadonlyArray<ProspectusDelivery>;
};

export type ProspectusDeliveryRootOnSendValidationAsSalesAndTradingArgs = {
  currentTenantOnly: Scalars['Boolean']['input'];
  investorKeys: ReadonlyArray<Scalars['String']['input']>;
};

export type ProspectusDeliveryRootOnSendValidationAsSyndicateArgs = {
  currentTenantOnly: Scalars['Boolean']['input'];
  investorKeys: ReadonlyArray<Scalars['String']['input']>;
};

export type ProspectusDeliveryRootSalesAndTradingHistoryArgs = {
  cmgEntityKey: Scalars['String']['input'];
};

export type ProspectusDeliveryRootSingleOnSendValidationAsSalesAndTradingArgs = {
  currentTenantOnly: Scalars['Boolean']['input'];
  investorKey: Scalars['String']['input'];
};

export type ProspectusDeliveryRootSingleOnSendValidationAsSyndicateArgs = {
  currentTenantOnly: Scalars['Boolean']['input'];
  investorKey: Scalars['String']['input'];
};

export type ProspectusDeliveryRootSyndicateHistoryArgs = {
  cmgEntityKey: Scalars['String']['input'];
};

export enum ProspectusDeliveryStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotSent = 'NOT_SENT',
  Sent = 'SENT',
}

export type ProspectusDeliveryStatusOperationFilterInput = {
  readonly eq?: InputMaybe<ProspectusDeliveryStatus>;
  readonly in?: InputMaybe<ReadonlyArray<ProspectusDeliveryStatus>>;
  readonly neq?: InputMaybe<ProspectusDeliveryStatus>;
  readonly nin?: InputMaybe<ReadonlyArray<ProspectusDeliveryStatus>>;
};

export type ProspectusDeliverySummary = {
  readonly __typename?: 'ProspectusDeliverySummary';
  readonly failedEmailCount: Scalars['Int']['output'];
  readonly inProgressEmailCount: Scalars['Int']['output'];
  readonly overallStatus: ProspectusDeliveryStatus;
  readonly overallStatusDisplayValue: Scalars['String']['output'];
  readonly sentEmailCount: Scalars['Int']['output'];
  readonly totalEmailCount: Scalars['Int']['output'];
};

export type ProspectusDeliverySummaryDtoFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<ProspectusDeliverySummaryDtoFilterInput>>;
  readonly failedEmailCount?: InputMaybe<IntOperationFilterInput>;
  readonly inProgressEmailCount?: InputMaybe<IntOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<ProspectusDeliverySummaryDtoFilterInput>>;
  readonly overallStatus?: InputMaybe<ProspectusDeliveryStatusOperationFilterInput>;
  readonly overallStatusDisplayValue?: InputMaybe<StringOperationFilterInput>;
  readonly sentEmailCount?: InputMaybe<IntOperationFilterInput>;
  readonly totalEmailCount?: InputMaybe<IntOperationFilterInput>;
};

export type ProspectusDeliverySummaryDtoSortInput = {
  readonly failedEmailCount?: InputMaybe<SortEnumType>;
  readonly inProgressEmailCount?: InputMaybe<SortEnumType>;
  readonly overallStatus?: InputMaybe<SortEnumType>;
  readonly overallStatusDisplayValue?: InputMaybe<SortEnumType>;
  readonly sentEmailCount?: InputMaybe<SortEnumType>;
  readonly totalEmailCount?: InputMaybe<SortEnumType>;
};

export type ProspectusDocument = {
  readonly __typename?: 'ProspectusDocument';
  readonly documentName: Scalars['String']['output'];
  readonly firstPublishedAt?: Maybe<Scalars['Instant']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly includeOnPublish: Scalars['Boolean']['output'];
  readonly publicUrl?: Maybe<Scalars['String']['output']>;
  readonly uploadedAt: Scalars['Instant']['output'];
};

export type ProspectusDocumentFull = {
  readonly __typename?: 'ProspectusDocumentFull';
  readonly documentName: Scalars['String']['output'];
  readonly firstPublishedAt?: Maybe<Scalars['Instant']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly includeOnPublish?: Maybe<Scalars['Boolean']['output']>;
  readonly publicUrl?: Maybe<Scalars['String']['output']>;
  readonly uploadedAt: Scalars['Instant']['output'];
};

export type ProspectusDocumentFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<ProspectusDocumentFullFilterInput>>;
  readonly documentName?: InputMaybe<StringOperationFilterInput>;
  readonly firstPublishedAt?: InputMaybe<InstantOperationFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly includeOnPublish?: InputMaybe<BooleanOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<ProspectusDocumentFullFilterInput>>;
  readonly publicUrl?: InputMaybe<StringOperationFilterInput>;
  readonly uploadedAt?: InputMaybe<InstantOperationFilterInput>;
};

export type ProspectusDocumentMetadata = {
  readonly __typename?: 'ProspectusDocumentMetadata';
  readonly fileName: Scalars['String']['output'];
  readonly publishedAt: Scalars['Instant']['output'];
  readonly url: Scalars['String']['output'];
};

export type ProspectusDocumentProfile = {
  readonly __typename?: 'ProspectusDocumentProfile';
  readonly documentName: Scalars['String']['output'];
  readonly firstPublishedAt?: Maybe<Scalars['Instant']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly publicUrl: Scalars['String']['output'];
};

export type ProspectusDocumentUpdateMetadataInput = {
  readonly documentName: Scalars['String']['input'];
  readonly id: Scalars['String']['input'];
  readonly includeOnPublish: Scalars['Boolean']['input'];
};

export enum ProspectusErrorType {
  DisclaimerMissing = 'DISCLAIMER_MISSING',
  ProspectusDocumentsMissing = 'PROSPECTUS_DOCUMENTS_MISSING',
  ProspectusMissing = 'PROSPECTUS_MISSING',
}

export enum ProspectusInvestorErrorType {
  IndicationNotAcknowledged = 'INDICATION_NOT_ACKNOWLEDGED',
  InvestorContactMissing = 'INVESTOR_CONTACT_MISSING',
}

export type ProspectusInvestorValidationError = {
  readonly __typename?: 'ProspectusInvestorValidationError';
  readonly errorType: ProspectusInvestorErrorType;
  readonly id: Scalars['ID']['output'];
  readonly investorKey: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
};

export type ProspectusOnSendValidationResult = {
  readonly __typename?: 'ProspectusOnSendValidationResult';
  readonly id: Scalars['ID']['output'];
  readonly investorErrors: ReadonlyArray<ProspectusInvestorValidationError>;
  readonly prospectusErrors: ReadonlyArray<ProspectusValidationError>;
};

export type ProspectusValidationError = {
  readonly __typename?: 'ProspectusValidationError';
  readonly errorType: ProspectusErrorType;
  readonly id: Scalars['ID']['output'];
  readonly message: Scalars['String']['output'];
};

export type Public = {
  readonly __typename?: 'Public';
  readonly syndicateWires: PublicWires;
};

export type PublicOrderBook = {
  readonly __typename?: 'PublicOrderBook';
  /** The ID of the Offering for which this Order Book accepts Indications. */
  readonly offeringId: Scalars['UUID']['output'];
  /** The current state of this Order Book. */
  readonly state: OrderBookState;
};

export type PublicWires = {
  readonly __typename?: 'PublicWires';
  readonly sentWire: SentWireStatus;
};

export type PublicWiresSentWireArgs = {
  sentWireId: Scalars['UUID']['input'];
};

export type PublishOfferingInput = {
  readonly offeringId: Scalars['UUID']['input'];
};

export type PublishOfferingPayload = {
  readonly __typename?: 'PublishOfferingPayload';
  readonly offering?: Maybe<OfferingFull>;
};

/** A segment of a collection. */
export type PublishedOfferingsCollectionSegment = {
  readonly __typename?: 'PublishedOfferingsCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<OfferingFull>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type PublishedOfferingsListFiltersInput = {
  readonly offeringId: Scalars['UUID']['input'];
};

export type PublishedSyndicateEntitlements = {
  readonly __typename?: 'PublishedSyndicateEntitlements';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly entitlements: ReadonlyArray<Scalars['String']['output']>;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly accountTraits: ReadonlyArray<AccountTrait>;
  readonly adminInvestorExtensionSchema: ReadonlyArray<InvestorExtensionSchema>;
  readonly adminInvestorFirmsGrid?: Maybe<AdminInvestorFirmsGridCollectionSegment>;
  readonly adminUnderwriterEmployees?: Maybe<AdminUnderwriterEmployeesCollectionSegment>;
  readonly allCoveredInvestorFirmsMappedToCmgEntityKey: ReadonlyArray<InvestorFirmBasic>;
  readonly allInvestorFirmsMappedToCmgEntityKey: ReadonlyArray<InvestorFirmBasic>;
  readonly allInvestorFirmsMappedToCmgEntityKeys: ReadonlyArray<InvestorFirmMappedWithCmgEntityKey>;
  readonly allocationSets: ReadonlyArray<AllocationSet>;
  readonly attestation: Attestation;
  readonly attestationStatuses: ReadonlyArray<Maybe<AttestationStatus>>;
  readonly basicPublishedOffering: BasicPublishedOfferingProfile;
  readonly communicatedAllocationDemand: MdlAllocationResponse;
  readonly communicatedIndicationsDemand: MdlCommunicatedDemandIndications;
  readonly contacts: ContactCollection;
  /** Country types */
  readonly countries?: Maybe<CountriesCollectionSegment>;
  readonly coveredAttestation: Attestation;
  readonly coveredAttestationStatuses: ReadonlyArray<Maybe<AttestationStatus>>;
  readonly coveredContacts: ContactCollection;
  /** Returns Covered Indication for S/T user */
  readonly coveredIndication?: Maybe<CoveredInstitutionalIndication>;
  /** Returns Covered Indications by cmgEntityKey for S/T user */
  readonly coveredIndicationByCmgEntityKey?: Maybe<CoveredInstitutionalIndication>;
  readonly coveredIndicationVersions: ReadonlyArray<CoveredInstitutionalIndicationVersion>;
  readonly coveredInvestorFirms: InvestorFirmBasicPagedList;
  readonly coveredInvestorFirmsEmployees: ReadonlyArray<InvestorEmployee>;
  readonly coveredInvestorFirmsGrid?: Maybe<CoveredInvestorFirmsGridCollectionSegment>;
  /** Currency types */
  readonly currencies?: Maybe<CurrenciesCollectionSegment>;
  readonly dataSyncSaga: DataSyncSaga;
  readonly datalabName: Scalars['String']['output'];
  readonly demandGridOfferingContext: DemandGridOfferingContext;
  readonly demandGridRows: DemandGridRowConnection;
  /** List all designations for given indication. */
  readonly designationByIndicationId: InvestorDesignation;
  /** Get Designation Validation */
  readonly designationValidation: DesignationValidation;
  /** Returns DesignationWire wire details */
  readonly designationWireDetails: DesignationWire;
  /** Returns a list of all DesignationWire wires */
  readonly designationWireList: ReadonlyArray<DesignationWire>;
  /** Returns DesignationWire wire template preview. A null syndicateWireId returns the default template. */
  readonly designationWirePreview: WirePreview;
  /** Returns DesignationWire wire validation */
  readonly designationWireValidation: DesignationWireValidation;
  readonly designationsGrid: DesignationsGrid;
  /** Returns an Entitlements Configuration */
  readonly entitlementsConfiguration: ReadonlyArray<EntitlementsConfiguration>;
  readonly expenses: Expenses;
  readonly feesAndDiscounts: FeesAndDiscounts;
  /** Returns common values, that were sent in last filing */
  readonly filingLastCommonValues: FilingLastCommonValues;
  /** Returns offering details for given regulatory filing' */
  readonly filingOfferingDetail: WireOfferingDetail;
  readonly finalInstitutionalAllocationSet?: Maybe<FinalInstitutionalAllocationSet>;
  /** Get FINRA server availability. */
  readonly finraStatus: FinraStatus;
  readonly firmCertificatesByCmgEntityKeyAndInvestorId?: Maybe<FirmCertificates>;
  readonly firmEmployees?: Maybe<FirmEmployeesCollectionSegment>;
  readonly firmInvestorExtendedData: InvestorExtendedData;
  readonly firmInvestorsExtendedData: ReadonlyArray<InvestorExtendedData>;
  readonly firmInvestorsRelationships: ReadonlyArray<InvestorFirmBasic>;
  readonly firmMatcher?: Maybe<FirmMatchCollectionSegment>;
  readonly firms?: Maybe<FirmsCollectionSegment>;
  readonly firmsCertificates?: Maybe<FirmsCertificatesCollectionSegment>;
  /** Returns FreeFormWire wire details */
  readonly freeFormWireDetails: FreeFormWire;
  /** Returns a list of all FreeFormWire wires */
  readonly freeFormWireList: ReadonlyArray<FreeFormWire>;
  /** Returns FreeFormWire wire template preview. A null syndicateWireId returns the default template. */
  readonly freeFormWirePreview: WirePreview;
  /** Returns FreeFormWire wire validation */
  readonly freeFormWireValidation: FreeFormWireValidation;
  readonly getFilings: ReadonlyArray<Filing>;
  readonly getInstitutionalIndicationNotes: ReadonlyArray<Note>;
  /** Returns GreenShoeWire wire details */
  readonly greenShoeWireDetails: GreenShoeWire;
  /** Returns a list of all GreenShoeWire wires */
  readonly greenShoeWireList: ReadonlyArray<GreenShoeWire>;
  /** Returns GreenShoeWire wire template preview. A null syndicateWireId returns the default template. */
  readonly greenShoeWirePreview: WirePreview;
  /** Returns GreenShoeWire wire validation */
  readonly greenShoeWireValidation: GreenShoeWireValidation;
  readonly identityName: Scalars['String']['output'];
  readonly indicationAttestation: IndicationAttestation;
  readonly indicationInvestorCmgEntityKeys: ReadonlyArray<Scalars['String']['output']>;
  readonly indicationTrades: ReadonlyArray<IndicationTrade>;
  readonly indicationVersions: ReadonlyArray<InstitutionalIndicationVersion>;
  /** Returns a single Institutional Indication by either indicationId or cmgEntityKey */
  readonly institutionalIndication?: Maybe<InstitutionalIndication>;
  /** Return Institutional Indication Acknowledgements */
  readonly institutionalIndicationAcknowledgements: ReadonlyArray<InstitutionalIndicationAcknowledgement>;
  /** Return Institutional Indication Billing And Delivery Agent */
  readonly institutionalIndicationBillingAndDeliveryAgent: BillingAndDeliveryAgent;
  readonly institutionalIndicationTimeline: InstitutionalIndicationTimelineData;
  /** Returns the Order Book's Institutional Indications */
  readonly institutionalIndications: ReadonlyArray<InstitutionalIndication>;
  readonly internalAllocationDemand: MdlAllocationResponse;
  readonly internalIndicationsDemand: MdlInternalDemandIndications;
  readonly investorExtensionSchema: ReadonlyArray<InvestorExtensionSchema>;
  readonly investorFirm: InvestorFirmBasic;
  readonly investorFirms: InvestorFirmBasicPagedList;
  readonly investorFirmsEmployeeRelationships: ReadonlyArray<InvestorFirmsEmployeeRelationships>;
  readonly investorFirmsEmployees: ReadonlyArray<InvestorEmployee>;
  readonly investorFirmsGrid?: Maybe<InvestorFirmsGridCollectionSegment>;
  readonly investors?: Maybe<InvestorsCollectionSegment>;
  /** Returns IssuerAllocationWire wire details */
  readonly issuerAllocationWireDetails: IssuerAllocationWire;
  /** Returns a list of all IssuerAllocationWire wires */
  readonly issuerAllocationWireList: ReadonlyArray<IssuerAllocationWire>;
  /** Returns IssuerAllocationWire wire template preview. A null syndicateWireId returns the default template. */
  readonly issuerAllocationWirePreview: WirePreview;
  /** Returns IssuerAllocationWire wire validation */
  readonly issuerAllocationWireValidation: IssuerAllocationWireValidation;
  /** Returns IssuerIndicationWire wire details */
  readonly issuerIndicationWireDetails: IssuerIndicationWire;
  /** Returns a list of all IssuerIndicationWire wires */
  readonly issuerIndicationWireList: ReadonlyArray<IssuerIndicationWire>;
  /** Returns IssuerIndicationWire wire template preview. A null syndicateWireId returns the default template. */
  readonly issuerIndicationWirePreview: WirePreview;
  /** Returns IssuerIndicationWire wire validation */
  readonly issuerIndicationWireValidation: IssuerIndicationWireValidation;
  /** Returns last Restricted Period for TN Filing */
  readonly lastTnRestrictedPeriod?: Maybe<LastTnRestrictedPeriod>;
  readonly letterEligibleManagers: ReadonlyArray<ExpensesManager>;
  /** Returns Limited Offering data for a given Published Offering ID */
  readonly limitedPublishedOffering: OfferingLimited;
  /** Lists the active underwriter firms sharing an ultimate parent with the provided firm, including the firm itself. */
  readonly linkedUnderwriterFirms: ReadonlyArray<LinkedUnderwriterFirm>;
  readonly listLiveOfferingsAffectedByFirmHierarchyUnlink: ReadonlyArray<LiveOfferingsAffectedByFirmHierarchyUnlink>;
  readonly livePublishedOfferings: OfferingList;
  /** Returns ManagerBdWire wire details */
  readonly managerBdWireDetails: ManagerBdWire;
  /** Returns a list of all ManagerBdWire wires */
  readonly managerBdWireList: ReadonlyArray<ManagerBdWire>;
  /** Returns ManagerBdWire wire template preview. A null syndicateWireId returns the default template. */
  readonly managerBdWirePreview: WirePreview;
  /** Returns ManagerBdWire wire validation */
  readonly managerBdWireValidation: ManagerBdWireValidation;
  readonly mdlAllocationRanking?: Maybe<MdlAllocationRankingResponse>;
  readonly myAttestation: Attestation;
  readonly myIndicationVersions: ReadonlyArray<MyInstitutionalIndicationVersion>;
  readonly myRetailSummary: MyRetailSummary;
  /** Returns NonSyndicateFreeFormWire wire details */
  readonly nonSyndicateFreeFormWireDetails: NonSyndicateFreeFormWire;
  /** Returns a list of all NonSyndicateFreeFormWire wires */
  readonly nonSyndicateFreeFormWireList: ReadonlyArray<NonSyndicateFreeFormWire>;
  /** Returns NonSyndicateFreeFormWire wire template preview. A null syndicateWireId returns the default template. */
  readonly nonSyndicateFreeFormWirePreview: WirePreview;
  /** Returns NonSyndicateFreeFormWire wire validation */
  readonly nonSyndicateFreeFormWireValidation: NonSyndicateFreeFormWireValidation;
  /** Returns NonSyndicatePaymentWire wire details */
  readonly nonSyndicatePaymentWireDetails: NonSyndicatePaymentWire;
  /** Returns a list of all NonSyndicatePaymentWire wires */
  readonly nonSyndicatePaymentWireList: ReadonlyArray<NonSyndicatePaymentWire>;
  /** Returns NonSyndicatePaymentWire wire template preview. A null syndicateWireId returns the default template. */
  readonly nonSyndicatePaymentWirePreview: WirePreview;
  /** Returns NonSyndicatePaymentWire wire validation */
  readonly nonSyndicatePaymentWireValidation: NonSyndicatePaymentWireValidation;
  /** Returns NonSyndicateSellingGroupInvitationWire wire details */
  readonly nonSyndicateSellingGroupInvitationWireDetails: NonSyndicateSellingGroupInvitationWire;
  /** Returns a list of all NonSyndicateSellingGroupInvitationWire wires */
  readonly nonSyndicateSellingGroupInvitationWireList: ReadonlyArray<NonSyndicateSellingGroupInvitationWire>;
  /** Returns NonSyndicateSellingGroupInvitationWire wire template preview. A null syndicateWireId returns the default template. */
  readonly nonSyndicateSellingGroupInvitationWirePreview: WirePreview;
  /** Returns NonSyndicateSellingGroupInvitationWire wire validation */
  readonly nonSyndicateSellingGroupInvitationWireValidation: NonSyndicateSellingGroupInvitationWireValidation;
  /** Returns NonSyndicateSellingGroupTermsRetentionWire wire details */
  readonly nonSyndicateSellingGroupTermsRetentionWireDetails: NonSyndicateSellingGroupTermsRetentionWire;
  /** Returns a list of all NonSyndicateSellingGroupTermsRetentionWire wires */
  readonly nonSyndicateSellingGroupTermsRetentionWireList: ReadonlyArray<NonSyndicateSellingGroupTermsRetentionWire>;
  /** Returns NonSyndicateSellingGroupTermsRetentionWire wire template preview. A null syndicateWireId returns the default template. */
  readonly nonSyndicateSellingGroupTermsRetentionWirePreview: WirePreview;
  /** Returns NonSyndicateSellingGroupTermsRetentionWire wire validation */
  readonly nonSyndicateSellingGroupTermsRetentionWireValidation: NonSyndicateSellingGroupTermsRetentionWireValidation;
  /** Returns NonSyndicateTerminationWire wire details */
  readonly nonSyndicateTerminationWireDetails: NonSyndicateTerminationWire;
  /** Returns a list of all NonSyndicateTerminationWire wires */
  readonly nonSyndicateTerminationWireList: ReadonlyArray<NonSyndicateTerminationWire>;
  /** Returns NonSyndicateTerminationWire wire template preview. A null syndicateWireId returns the default template. */
  readonly nonSyndicateTerminationWirePreview: WirePreview;
  /** Returns NonSyndicateTerminationWire wire validation */
  readonly nonSyndicateTerminationWireValidation: NonSyndicateTerminationWireValidation;
  /** Returns the offering with the given id */
  readonly offering: Offering;
  readonly offeringDashboardDataSync: OfferingDashboardDataSync;
  readonly offeringDashboardDemandGridRows: DemandGridRowConnection;
  readonly offeringDashboardTimeline?: Maybe<OfferingDashboardTimeline>;
  readonly offeringMarketRules: OfferingMarketRules;
  readonly offeringNotes: MdlOfferingNotes;
  readonly offeringPublishValidationErrors: ReadonlyArray<OfferingError>;
  readonly offeringSetupName: Scalars['String']['output'];
  readonly orderBook: OrderBook;
  readonly orderBookDiff: OrderBookDiff;
  readonly orderBookGraph?: Maybe<OrderBookGraph>;
  readonly orderBookName: Scalars['String']['output'];
  readonly pastFirmCertificatesByCmgEntityKey: ReadonlyArray<Certificate>;
  /** Returns PaymentWire wire details */
  readonly paymentWireDetails: PaymentWire;
  /** Returns a list of all PaymentWire wires */
  readonly paymentWireList: ReadonlyArray<PaymentWire>;
  /** Returns PaymentWire wire template preview. A null syndicateWireId returns the default template. */
  readonly paymentWirePreview: WirePreview;
  /** Returns PaymentWire wire validation */
  readonly paymentWireValidation: PaymentWireValidation;
  /** Returns PotAccountWire wire details */
  readonly potAccountWireDetails: PotAccountWire;
  /** Returns a list of all PotAccountWire wires */
  readonly potAccountWireList: ReadonlyArray<PotAccountWire>;
  /** Returns PotAccountWire wire template preview. A null syndicateWireId returns the default template. */
  readonly potAccountWirePreview: WirePreview;
  /** Returns PotAccountWire wire validation */
  readonly potAccountWireValidation: PotAccountWireValidation;
  /** Returns PotAllocationWire wire details */
  readonly potAllocationWireDetails: PotAllocationWire;
  /** Returns a list of all PotAllocationWire wires */
  readonly potAllocationWireList: ReadonlyArray<PotAllocationWire>;
  /** Returns PotAllocationWire wire template preview. A null syndicateWireId returns the default template. */
  readonly potAllocationWirePreview: WirePreview;
  /** Returns PotAllocationWire wire validation */
  readonly potAllocationWireValidation: PotAllocationWireValidation;
  readonly pricedPublishedOfferings: OfferingList;
  /** Returns PricingTermsRetentionWire wire details */
  readonly pricingTermsRetentionWireDetails: PricingTermsRetentionWire;
  /** Returns a list of all PricingTermsRetentionWire wires */
  readonly pricingTermsRetentionWireList: ReadonlyArray<PricingTermsRetentionWire>;
  /** Returns PricingTermsRetentionWire wire template preview. A null syndicateWireId returns the default template. */
  readonly pricingTermsRetentionWirePreview: WirePreview;
  /** Returns PricingTermsRetentionWire wire validation */
  readonly pricingTermsRetentionWireValidation: PricingTermsRetentionWireValidation;
  /** Returns PricingTermsWire wire details */
  readonly pricingTermsWireDetails: PricingTermsWire;
  /** Returns a list of all PricingTermsWire wires */
  readonly pricingTermsWireList: ReadonlyArray<PricingTermsWire>;
  /** Returns PricingTermsWire wire template preview. A null syndicateWireId returns the default template. */
  readonly pricingTermsWirePreview: WirePreview;
  /** Returns PricingTermsWire wire validation */
  readonly pricingTermsWireValidation: PricingTermsWireValidation;
  readonly privateManagerEconomics: PrivateManagerEconomics;
  readonly privateOfferings?: Maybe<PrivateOfferingsCollectionSegment>;
  readonly prospectusDelivery: ProspectusDeliveryRoot;
  readonly prospectusDeliverySummaries: ReadonlyArray<InvestorDeliveryStatus>;
  readonly public: Public;
  readonly publishedOffering: OfferingProfile;
  readonly publishedOfferings?: Maybe<PublishedOfferingsCollectionSegment>;
  /** Returns RegMWire wire details */
  readonly regMWireDetails: RegMWire;
  /** Returns a list of all RegMWire wires */
  readonly regMWireList: ReadonlyArray<RegMWire>;
  /** Returns RegMWire wire template preview. A null syndicateWireId returns the default template. */
  readonly regMWirePreview: WirePreview;
  /** Returns RegMWire wire validation */
  readonly regMWireValidation: RegMWireValidation;
  /** Returns ResearchRestrictionWire wire details */
  readonly researchRestrictionWireDetails: ResearchRestrictionWire;
  /** Returns a list of all ResearchRestrictionWire wires */
  readonly researchRestrictionWireList: ReadonlyArray<ResearchRestrictionWire>;
  /** Returns ResearchRestrictionWire wire template preview. A null syndicateWireId returns the default template. */
  readonly researchRestrictionWirePreview: WirePreview;
  /** Returns ResearchRestrictionWire wire validation */
  readonly researchRestrictionWireValidation: ResearchRestrictionWireValidation;
  readonly retailDemandHistory: ReadonlyArray<RetailDemandRevision>;
  /** Returns RetentionWire wire details */
  readonly retentionWireDetails: RetentionWire;
  /** Returns a list of all RetentionWire wires */
  readonly retentionWireList: ReadonlyArray<RetentionWire>;
  /** Returns RetentionWire wire template preview. A null syndicateWireId returns the default template. */
  readonly retentionWirePreview: WirePreview;
  /** Returns RetentionWire wire validation */
  readonly retentionWireValidation: RetentionWireValidation;
  readonly rolodexName: Scalars['String']['output'];
  readonly salesAndTradingOrderBook?: Maybe<OrderBookGraph>;
  readonly salesCredits: SalesCreditGrid;
  readonly salesCreditsHouseAccounts: ReadonlyArray<HouseAccount>;
  readonly salesCreditsInvestorHistory: ReadonlyArray<SalesCreditInvestorHistoryItem>;
  /** Returns SellingGroupInvitationWire wire details */
  readonly sellingGroupInvitationWireDetails: SellingGroupInvitationWire;
  /** Returns a list of all SellingGroupInvitationWire wires */
  readonly sellingGroupInvitationWireList: ReadonlyArray<SellingGroupInvitationWire>;
  /** Returns SellingGroupInvitationWire wire template preview. A null syndicateWireId returns the default template. */
  readonly sellingGroupInvitationWirePreview: WirePreview;
  /** Returns SellingGroupInvitationWire wire validation */
  readonly sellingGroupInvitationWireValidation: SellingGroupInvitationWireValidation;
  /** Returns SellingGroupTermsWire wire details */
  readonly sellingGroupTermsWireDetails: SellingGroupTermsWire;
  /** Returns a list of all SellingGroupTermsWire wires */
  readonly sellingGroupTermsWireList: ReadonlyArray<SellingGroupTermsWire>;
  /** Returns SellingGroupTermsWire wire template preview. A null syndicateWireId returns the default template. */
  readonly sellingGroupTermsWirePreview: WirePreview;
  /** Returns SellingGroupTermsWire wire validation */
  readonly sellingGroupTermsWireValidation: SellingGroupTermsWireValidation;
  readonly settlementAccounting: Accounting;
  readonly settlementLetter: SettlementLetter;
  readonly settlementName: Scalars['String']['output'];
  readonly sharedOfferings?: Maybe<SharedOfferingsCollectionSegment>;
  readonly stabilization: Stabilization;
  readonly stabilizationInformation: StabilizationInformation;
  readonly syndicateInstitutionalGrid?: Maybe<SyndicateInstitutionalGridCollectionSegment>;
  readonly syndicateInstitutionalGridGroupKeys: ReadonlyArray<Group>;
  readonly syndicateManagers: SyndicateManager;
  /** Returns offering details for given offering */
  readonly syndicateWireOfferingDetail: WireOfferingDetail;
  readonly syndicateWires: SyndicateWires;
  /** Returns TerminationWire wire details */
  readonly terminationWireDetails: TerminationWire;
  /** Returns a list of all TerminationWire wires */
  readonly terminationWireList: ReadonlyArray<TerminationWire>;
  /** Returns TerminationWire wire template preview. A null syndicateWireId returns the default template. */
  readonly terminationWirePreview: WirePreview;
  /** Returns TerminationWire wire validation */
  readonly terminationWireValidation: TerminationWireValidation;
  readonly totalRetailSummary: TotalRetailSummaryGrid;
  readonly tradeGridRows: ReadonlyArray<TradeGridItem>;
  readonly tradeReleaseSettings: TradeReleaseSettings;
  readonly tradeReleaseValidation: TradeReleaseValidation;
  readonly underwriter: Firm;
  readonly underwriterEmployees?: Maybe<UnderwriterEmployeesCollectionSegment>;
  /** Returns UnderwriterInvitationWire wire details */
  readonly underwriterInvitationWireDetails: UnderwriterInvitationWire;
  /** Returns a list of all UnderwriterInvitationWire wires */
  readonly underwriterInvitationWireList: ReadonlyArray<UnderwriterInvitationWire>;
  /** Returns UnderwriterInvitationWire wire template preview. A null syndicateWireId returns the default template. */
  readonly underwriterInvitationWirePreview: WirePreview;
  /** Returns UnderwriterInvitationWire wire validation */
  readonly underwriterInvitationWireValidation: UnderwriterInvitationWireValidation;
  readonly underwriters: FirmLimitedPagedList;
  readonly underwritingTermsFeesAndDiscounts: UnderwritingTermsFeesAndDiscounts;
  readonly viewSettings: ReadonlyArray<ViewSetting>;
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
  readonly wires: ReadonlyArray<Wire>;
  readonly wiresName: Scalars['String']['output'];
  readonly xcNotificationSettings: ReadonlyArray<XcNotificationSetting>;
  readonly xcNotificationSettingsForUser: ReadonlyArray<XcNotificationSetting>;
};

export type QueryAdminInvestorExtensionSchemaArgs = {
  tenantId: Scalars['UUID']['input'];
};

export type QueryAdminInvestorFirmsGridArgs = {
  order?: InputMaybe<ReadonlyArray<InvestorFirmGridSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['UUID']['input'];
  where?: InputMaybe<InvestorFirmGridFilterInput>;
};

export type QueryAdminUnderwriterEmployeesArgs = {
  order?: InputMaybe<ReadonlyArray<UnderwriterEmployeeSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['UUID']['input'];
  where?: InputMaybe<UnderwriterEmployeeFilterInput>;
};

export type QueryAllCoveredInvestorFirmsMappedToCmgEntityKeyArgs = {
  cmgEntityKey: Scalars['String']['input'];
  recordStatus?: InputMaybe<RolodexRecordStatus>;
};

export type QueryAllInvestorFirmsMappedToCmgEntityKeyArgs = {
  cmgEntityKey: Scalars['String']['input'];
  recordStatus?: InputMaybe<RolodexRecordStatus>;
};

export type QueryAllInvestorFirmsMappedToCmgEntityKeysArgs = {
  cmgEntityKeys: ReadonlyArray<Scalars['String']['input']>;
  recordStatus?: InputMaybe<RolodexRecordStatus>;
};

export type QueryAllocationSetsArgs = {
  offeringId: Scalars['UUID']['input'];
  order?: InputMaybe<ReadonlyArray<AllocationSetDtoSortInput>>;
  where?: InputMaybe<AllocationSetDtoFilterInput>;
};

export type QueryAttestationArgs = {
  certificateType?: InputMaybe<CertificateType>;
  cmgEntityKey: Scalars['String']['input'];
};

export type QueryAttestationStatusesArgs = {
  certificateType?: InputMaybe<CertificateType>;
  cmgEntityKeys: ReadonlyArray<Scalars['String']['input']>;
};

export type QueryBasicPublishedOfferingArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryCommunicatedAllocationDemandArgs = {
  xcOfferingId: Scalars['UUID']['input'];
};

export type QueryCommunicatedIndicationsDemandArgs = {
  xcOfferingId: Scalars['UUID']['input'];
};

export type QueryContactsArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QueryCountriesArgs = {
  order?: InputMaybe<ReadonlyArray<EnumLabelOfCountrySortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EnumLabelOfCountryFilterInput>;
};

export type QueryCoveredAttestationArgs = {
  certificateType?: InputMaybe<CertificateType>;
  cmgEntityKey: Scalars['String']['input'];
};

export type QueryCoveredAttestationStatusesArgs = {
  certificateType?: InputMaybe<CertificateType>;
  cmgEntityKeys: ReadonlyArray<Scalars['String']['input']>;
};

export type QueryCoveredContactsArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QueryCoveredIndicationArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  indicationId?: InputMaybe<Scalars['UUID']['input']>;
  offeringId: Scalars['UUID']['input'];
};

export type QueryCoveredIndicationByCmgEntityKeyArgs = {
  cmgEntityKey: Scalars['String']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QueryCoveredIndicationVersionsArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QueryCoveredInvestorFirmsArgs = {
  cik?: InputMaybe<Scalars['String']['input']>;
  crd?: InputMaybe<Scalars['String']['input']>;
  firmKey?: InputMaybe<Scalars['String']['input']>;
  lei?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationDataInput>;
  searchText: Scalars['String']['input'];
};

export type QueryCoveredInvestorFirmsEmployeesArgs = {
  firmKeyOrId: Scalars['String']['input'];
  freeTextSources?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  isFreeText?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCoveredInvestorFirmsGridArgs = {
  order?: InputMaybe<ReadonlyArray<InvestorFirmGridSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestorFirmGridFilterInput>;
};

export type QueryCurrenciesArgs = {
  order?: InputMaybe<ReadonlyArray<EnumLabelOfCurrencySortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EnumLabelOfCurrencyFilterInput>;
};

export type QueryDataSyncSagaArgs = {
  correlationId: Scalars['UUID']['input'];
};

export type QueryDemandGridOfferingContextArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryDemandGridRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offeringId: Scalars['UUID']['input'];
  where?: InputMaybe<DemandGridRowFilterInput>;
};

export type QueryDesignationByIndicationIdArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QueryDesignationValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryDesignationWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryDesignationWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryDesignationWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryDesignationWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryDesignationsGridArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryExpensesArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryFeesAndDiscountsArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryFilingLastCommonValuesArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryFilingOfferingDetailArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryFinalInstitutionalAllocationSetArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryFirmCertificatesByCmgEntityKeyAndInvestorIdArgs = {
  crmInvestorId?: InputMaybe<Scalars['UUID']['input']>;
  firmCmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  source: FirmCertificateSource;
};

export type QueryFirmEmployeesArgs = {
  order?: InputMaybe<ReadonlyArray<FirmEmployeeFullSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FirmEmployeeFullFilterInput>;
};

export type QueryFirmInvestorExtendedDataArgs = {
  firmKey: Scalars['String']['input'];
};

export type QueryFirmInvestorsExtendedDataArgs = {
  firmKeys: ReadonlyArray<Scalars['String']['input']>;
};

export type QueryFirmInvestorsRelationshipsArgs = {
  cmgEntityKeys: ReadonlyArray<Scalars['String']['input']>;
};

export type QueryFirmMatcherArgs = {
  source?: InputMaybe<FirmSource>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestorFirmFilterInput>;
};

export type QueryFirmsArgs = {
  order?: InputMaybe<ReadonlyArray<FirmFullSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FirmFullFilterInput>;
};

export type QueryFirmsCertificatesArgs = {
  order?: InputMaybe<ReadonlyArray<FirmCertificatesSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  source: FirmCertificateSource;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FirmCertificatesFilterInput>;
};

export type QueryFreeFormWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryFreeFormWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryFreeFormWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryFreeFormWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryGetFilingsArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryGetInstitutionalIndicationNotesArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QueryGreenShoeWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryGreenShoeWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryGreenShoeWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryGreenShoeWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryIndicationAttestationArgs = {
  certificateType: CertificateType;
  cmgEntityKey: Scalars['String']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QueryIndicationInvestorCmgEntityKeysArgs = {
  applyTo?: InputMaybe<SyndicateGridQueryInput>;
  offeringId: Scalars['UUID']['input'];
};

export type QueryIndicationTradesArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QueryIndicationVersionsArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QueryInstitutionalIndicationArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  indicationId?: InputMaybe<Scalars['UUID']['input']>;
  offeringId: Scalars['UUID']['input'];
};

export type QueryInstitutionalIndicationAcknowledgementsArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QueryInstitutionalIndicationBillingAndDeliveryAgentArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QueryInstitutionalIndicationTimelineArgs = {
  indicationId: Scalars['UUID']['input'];
  offeringId: Scalars['UUID']['input'];
  tenantCmgEntityKey?: InputMaybe<Scalars['String']['input']>;
};

export type QueryInstitutionalIndicationsArgs = {
  filters?: InputMaybe<InstitutionalIndicationListFiltersInput>;
  offeringId: Scalars['UUID']['input'];
};

export type QueryInternalAllocationDemandArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryInternalIndicationsDemandArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryInvestorFirmArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  firmKeyOrId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryInvestorFirmsArgs = {
  cik?: InputMaybe<Scalars['String']['input']>;
  crd?: InputMaybe<Scalars['String']['input']>;
  firmKey?: InputMaybe<Scalars['String']['input']>;
  lei?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationDataInput>;
  searchText: Scalars['String']['input'];
};

export type QueryInvestorFirmsEmployeeRelationshipsArgs = {
  bankInvestorKeys: ReadonlyArray<Scalars['String']['input']>;
};

export type QueryInvestorFirmsEmployeesArgs = {
  firmKeyOrId: Scalars['String']['input'];
  freeTextSources?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  isFreeText?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryInvestorFirmsGridArgs = {
  order?: InputMaybe<ReadonlyArray<InvestorFirmGridSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestorFirmGridFilterInput>;
};

export type QueryInvestorsArgs = {
  order?: InputMaybe<ReadonlyArray<FirmFullSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FirmFullFilterInput>;
};

export type QueryIssuerAllocationWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryIssuerAllocationWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryIssuerAllocationWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryIssuerAllocationWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryIssuerIndicationWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryIssuerIndicationWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryIssuerIndicationWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryIssuerIndicationWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryLastTnRestrictedPeriodArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryLetterEligibleManagersArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryLimitedPublishedOfferingArgs = {
  filters: PublishedOfferingsListFiltersInput;
};

export type QueryLinkedUnderwriterFirmsArgs = {
  cmgEntityKey: Scalars['CmgEntityKey']['input'];
};

export type QueryListLiveOfferingsAffectedByFirmHierarchyUnlinkArgs = {
  firmId: Scalars['UUID']['input'];
};

export type QueryLivePublishedOfferingsArgs = {
  filters?: InputMaybe<LivePublishedOfferingListFiltersInput>;
};

export type QueryManagerBdWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryManagerBdWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryManagerBdWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryManagerBdWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryMdlAllocationRankingArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryMyAttestationArgs = {
  certificateType?: InputMaybe<CertificateType>;
};

export type QueryMyIndicationVersionsArgs = {
  myCmgEntityKey: Scalars['String']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QueryMyRetailSummaryArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryNonSyndicateFreeFormWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryNonSyndicateFreeFormWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryNonSyndicateFreeFormWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryNonSyndicateFreeFormWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryNonSyndicatePaymentWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryNonSyndicatePaymentWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryNonSyndicatePaymentWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryNonSyndicatePaymentWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryNonSyndicateSellingGroupInvitationWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryNonSyndicateSellingGroupInvitationWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryNonSyndicateSellingGroupInvitationWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryNonSyndicateSellingGroupInvitationWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryNonSyndicateSellingGroupTermsRetentionWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryNonSyndicateSellingGroupTermsRetentionWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryNonSyndicateSellingGroupTermsRetentionWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryNonSyndicateSellingGroupTermsRetentionWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryNonSyndicateTerminationWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryNonSyndicateTerminationWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryNonSyndicateTerminationWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryNonSyndicateTerminationWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryOfferingArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryOfferingDashboardDataSyncArgs = {
  offeringId: Scalars['ID']['input'];
};

export type QueryOfferingDashboardDemandGridRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offeringId: Scalars['ID']['input'];
  tenantCmgEntityKey: Scalars['String']['input'];
  where?: InputMaybe<DemandGridRowFilterInput>;
};

export type QueryOfferingDashboardTimelineArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryOfferingMarketRulesArgs = {
  countryCode: Scalars['String']['input'];
};

export type QueryOfferingNotesArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryOfferingPublishValidationErrorsArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryOrderBookArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryOrderBookDiffArgs = {
  cutoff?: InputMaybe<Scalars['DateTime']['input']>;
  offeringId: Scalars['UUID']['input'];
};

export type QueryOrderBookGraphArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryPastFirmCertificatesByCmgEntityKeyArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPaymentWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryPaymentWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryPaymentWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryPaymentWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryPotAccountWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryPotAccountWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryPotAccountWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryPotAccountWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryPotAllocationWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryPotAllocationWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryPotAllocationWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryPotAllocationWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryPricedPublishedOfferingsArgs = {
  filters: PricedPublishedOfferingListFiltersInput;
};

export type QueryPricingTermsRetentionWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryPricingTermsRetentionWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryPricingTermsRetentionWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryPricingTermsRetentionWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryPricingTermsWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryPricingTermsWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryPricingTermsWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryPricingTermsWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryPrivateManagerEconomicsArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryPrivateOfferingsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OfferingFullFilterInput>;
};

export type QueryProspectusDeliveryArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryProspectusDeliverySummariesArgs = {
  investorKeys: ReadonlyArray<Scalars['String']['input']>;
  offeringIds: ReadonlyArray<Scalars['UUID']['input']>;
};

export type QueryPublishedOfferingArgs = {
  id: Scalars['UUID']['input'];
};

export type QueryPublishedOfferingsArgs = {
  includePrivatePlacementOfferings?: Scalars['Boolean']['input'];
  includeTestOfferings?: Scalars['Boolean']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OfferingFullFilterInput>;
};

export type QueryRegMWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryRegMWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryRegMWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryRegMWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryResearchRestrictionWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryResearchRestrictionWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryResearchRestrictionWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryResearchRestrictionWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryRetailDemandHistoryArgs = {
  cmgEntityKey: Scalars['String']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QueryRetentionWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryRetentionWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryRetentionWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryRetentionWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QuerySalesAndTradingOrderBookArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QuerySalesCreditsArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QuerySalesCreditsInvestorHistoryArgs = {
  investorCmgEntityKey: Scalars['String']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QuerySellingGroupInvitationWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QuerySellingGroupInvitationWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QuerySellingGroupInvitationWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QuerySellingGroupInvitationWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QuerySellingGroupTermsWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QuerySellingGroupTermsWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QuerySellingGroupTermsWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QuerySellingGroupTermsWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QuerySettlementAccountingArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QuerySettlementLetterArgs = {
  managerId: Scalars['String']['input'];
  offeringId: Scalars['UUID']['input'];
};

export type QuerySharedOfferingsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OfferingFullFilterInput>;
};

export type QueryStabilizationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryStabilizationInformationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QuerySyndicateInstitutionalGridArgs = {
  allocationSetIds?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  demandSettings: DemandSettingsInput;
  offeringId: Scalars['UUID']['input'];
  order?: InputMaybe<ReadonlyArray<SyndicateInstitutionalGridRowSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SyndicateInstitutionalGridRowFilterInput>;
};

export type QuerySyndicateInstitutionalGridGroupKeysArgs = {
  allocationSetIds?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  demandSettings: DemandSettingsInput;
  groupBy: SyndicateGridGroupingColumn;
  offeringId: Scalars['UUID']['input'];
  where?: InputMaybe<SyndicateInstitutionalGridRowFilterInput>;
};

export type QuerySyndicateManagersArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QuerySyndicateWireOfferingDetailArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QuerySyndicateWiresArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryTerminationWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryTerminationWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryTerminationWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryTerminationWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryTotalRetailSummaryArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryTradeGridRowsArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryTradeReleaseSettingsArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryTradeReleaseValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryUnderwriterArgs = {
  cmgEntityKey: Scalars['String']['input'];
};

export type QueryUnderwriterEmployeesArgs = {
  order?: InputMaybe<ReadonlyArray<UnderwriterEmployeeSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UnderwriterEmployeeFilterInput>;
};

export type QueryUnderwriterInvitationWireDetailsArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId: Scalars['UUID']['input'];
};

export type QueryUnderwriterInvitationWireListArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryUnderwriterInvitationWirePreviewArgs = {
  cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  offeringId: Scalars['UUID']['input'];
  syndicateWireId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QueryUnderwriterInvitationWireValidationArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryUnderwritersArgs = {
  name: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationDataInput>;
  status?: InputMaybe<FirmStatus>;
};

export type QueryUnderwritingTermsFeesAndDiscountsArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryViewSettingsArgs = {
  order?: InputMaybe<ReadonlyArray<ViewSettingSortInput>>;
  where?: InputMaybe<ViewSettingFilterInput>;
};

export type QueryWallCrossTrackerArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type QueryWiresArgs = {
  includeOnlyLatestWires?: InputMaybe<Scalars['Boolean']['input']>;
  isNonSyndicate: Scalars['Boolean']['input'];
  offeringId: Scalars['UUID']['input'];
  order?: InputMaybe<ReadonlyArray<WireReadDtoSortInput>>;
  where?: InputMaybe<WireReadDtoFilterInput>;
};

export type QueryXcNotificationSettingsForUserArgs = {
  accountSubdomain: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

export enum RpnBasisCodeType {
  AdtvPfv = 'ADTV_PFV',
  FiveDays = 'FIVE_DAYS',
  Other = 'OTHER',
  Uar = 'UAR',
}

export type RpnFiling = {
  readonly __typename?: 'RPNFiling';
  readonly adtvNumber?: Maybe<Scalars['Float']['output']>;
  readonly adtvSource?: Maybe<Scalars['String']['output']>;
  readonly anticipatedPricingDate: Scalars['LocalDate']['output'];
  readonly basisCode: RpnBasisCodeType;
  /** Display name for BasisCode */
  readonly basisCodeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly contactName: Scalars['String']['output'];
  readonly contactTitle: Scalars['String']['output'];
  readonly emailAddress: Scalars['String']['output'];
  readonly filingCreatorEmail?: Maybe<Scalars['String']['output']>;
  readonly finraErrorMessages: ReadonlyArray<Scalars['String']['output']>;
  readonly finraMemberFirms: ReadonlyArray<MemberFirm>;
  readonly firmCrdNumber: Scalars['String']['output'];
  readonly firmDealId: Scalars['String']['output'];
  readonly firmMpid: Scalars['String']['output'];
  readonly firmName: Scalars['String']['output'];
  readonly formUniqueId: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isConcurrentConvertible: Scalars['Boolean']['output'];
  readonly issuerName: Scalars['String']['output'];
  readonly issuerSymbol: Scalars['String']['output'];
  readonly nonMemberFirms: ReadonlyArray<NonMemberFirm>;
  readonly otherBasisDescription?: Maybe<Scalars['String']['output']>;
  readonly publicFloatValue?: Maybe<Scalars['Float']['output']>;
  readonly publicFloatValueSource?: Maybe<Scalars['String']['output']>;
  readonly restrictedPeriod: RpnRestrictedPeriodType;
  /** Display name for RestrictedPeriod */
  readonly restrictedPeriodDisplayName?: Maybe<Scalars['String']['output']>;
  readonly restrictionStartTime: Scalars['Instant']['output'];
  readonly restrictionStartTimezone: Scalars['DateTimeZone']['output'];
  readonly status: FilingStatus;
  readonly submittedDateTime: Scalars['Instant']['output'];
  readonly symbolsOfCoveredSecurities: ReadonlyArray<Scalars['String']['output']>;
  readonly telephoneNumber: Scalars['String']['output'];
  readonly transactionType: TransactionType;
  readonly transactionTypeDescription?: Maybe<Scalars['String']['output']>;
  /** Display name for TransactionType */
  readonly transactionTypeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly uarDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type RpnFilingFormDataInput = {
  readonly adtvNumber?: InputMaybe<Scalars['Float']['input']>;
  readonly adtvSource?: InputMaybe<Scalars['String']['input']>;
  readonly anticipatedPricingDate: Scalars['LocalDate']['input'];
  readonly basisCode: RpnBasisCodeType;
  readonly contactName: Scalars['String']['input'];
  readonly contactTitle: Scalars['String']['input'];
  readonly emailAddress: Scalars['String']['input'];
  readonly finraMemberFirms: ReadonlyArray<MemberFirmInput>;
  readonly firmCrdNumber: Scalars['String']['input'];
  readonly firmMpid: Scalars['String']['input'];
  readonly firmName: Scalars['String']['input'];
  readonly isConcurrentConvertible: Scalars['Boolean']['input'];
  readonly issuerSymbol: Scalars['String']['input'];
  readonly nonMemberFirms: ReadonlyArray<NonMemberFirmInput>;
  readonly otherBasisDescription?: InputMaybe<Scalars['String']['input']>;
  readonly publicFloatValue?: InputMaybe<Scalars['Float']['input']>;
  readonly publicFloatValueSource?: InputMaybe<Scalars['String']['input']>;
  readonly restrictedPeriod: RpnRestrictedPeriodType;
  readonly restrictionStartTime: Scalars['Instant']['input'];
  readonly restrictionStartTimezone: Scalars['DateTimeZone']['input'];
  readonly symbolsOfCoveredSecurities: ReadonlyArray<Scalars['String']['input']>;
  readonly telephoneNumber: Scalars['String']['input'];
  readonly transactionType: TransactionType;
  readonly transactionTypeDescription?: InputMaybe<Scalars['String']['input']>;
  readonly uarDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export enum RpnRestrictedPeriodType {
  FiveDays = 'FIVE_DAYS',
  OneDay = 'ONE_DAY',
}

export enum Rank {
  Preferred = 'PREFERRED',
  Senior = 'SENIOR',
  SeniorSecure = 'SENIOR_SECURE',
  SeniorSubordinated = 'SENIOR_SUBORDINATED',
  Subordinated = 'SUBORDINATED',
}

export enum RecordStatus {
  Deleted = 'DELETED',
  Effective = 'EFFECTIVE',
}

export type RecordStatusFilterInput = {
  readonly recordStatus?: InputMaybe<RecordStatus>;
};

export type RecordStatusOperationFilterInput = {
  readonly eq?: InputMaybe<RolodexRecordStatus>;
  readonly in?: InputMaybe<ReadonlyArray<RolodexRecordStatus>>;
  readonly neq?: InputMaybe<RolodexRecordStatus>;
  readonly nin?: InputMaybe<ReadonlyArray<RolodexRecordStatus>>;
};

export type RecordStatusSortInput = {
  readonly name?: InputMaybe<SortEnumType>;
  readonly value?: InputMaybe<SortEnumType>;
};

export type RefreshOrderBookSummariesResponse = {
  readonly __typename?: 'RefreshOrderBookSummariesResponse';
  readonly batchJobId: Scalars['String']['output'];
  readonly offeringIds?: Maybe<ReadonlyArray<Scalars['UUID']['output']>>;
  readonly tenantSubdomains: ReadonlyArray<Scalars['String']['output']>;
};

export type RefreshOrderBookSummaryInput = {
  readonly allSellSideTenants: Scalars['Boolean']['input'];
  readonly offeringIds?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  readonly tenantSubdomains?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type RefreshOrderBookSummaryPayload = {
  readonly __typename?: 'RefreshOrderBookSummaryPayload';
  readonly refreshOrderBookSummariesResponse?: Maybe<RefreshOrderBookSummariesResponse>;
};

export type RegMWire = {
  readonly __typename?: 'RegMWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly notificationPeriod: RegulationMNotificationPeriod;
  readonly offeringResult: Scalars['String']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type RegMWireResponseUnion = RegMWire | ServiceError;

export type RegMWireValidation = WireValidationBase & {
  readonly __typename?: 'RegMWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<RegulationMWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum Region {
  Apac = 'APAC',
  Emea = 'EMEA',
  Lamr = 'LAMR',
  Namr = 'NAMR',
}

export enum RegulationMNotificationPeriod {
  ActivelyTradedSecurity = 'ACTIVELY_TRADED_SECURITY',
  FiveDays = 'FIVE_DAYS',
  OneDay = 'ONE_DAY',
}

export enum RegulationMWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
}

export type RegulatoryFilingNotificationMessage = {
  readonly __typename?: 'RegulatoryFilingNotificationMessage';
  readonly bccEmailAddresses: ReadonlyArray<Scalars['String']['output']>;
  readonly distributionList: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly managerSnapshot: FinraManagerSnapshot;
  readonly sentAt?: Maybe<Scalars['Instant']['output']>;
  readonly status: NotificationMessageStatus;
};

export type RegulatoryFilingRecipient = {
  readonly __typename?: 'RegulatoryFilingRecipient';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly distributionList: ReadonlyArray<Scalars['String']['output']>;
  readonly firmName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly role: ManagerRole;
};

export type RegulatoryFilings = {
  readonly __typename?: 'RegulatoryFilings';
  /** Returns DS filing */
  readonly DSFiling: DsFiling;
  /** Returns all DS filings */
  readonly DSFilings: ReadonlyArray<BaseRegulatoryFiling>;
  /** Returns NOI filing */
  readonly NOIFiling: NoiFiling;
  /** Returns all NOI filings */
  readonly NOIFilings: ReadonlyArray<BaseRegulatoryFiling>;
  /** Returns RPN filing */
  readonly RPNFiling: RpnFiling;
  /** Returns all RPN filings */
  readonly RPNFilings: ReadonlyArray<BaseRegulatoryFiling>;
  /** Returns TN filing */
  readonly TNFiling: TnFiling;
  /** Returns all TN filings */
  readonly TNFilings: ReadonlyArray<BaseRegulatoryFiling>;
  /** Returns USDTN filing */
  readonly USDTNFiling: UsdtnFiling;
  /** Returns all USDTN filings */
  readonly USDTNFilings: ReadonlyArray<BaseRegulatoryFiling>;
  readonly id: Scalars['ID']['output'];
  readonly notifications: ReadonlyArray<RegulatoryFilingNotificationMessage>;
  readonly offeringId: Scalars['UUID']['output'];
  readonly recipients: ReadonlyArray<RegulatoryFilingRecipient>;
  readonly senderDistributionEmails: ReadonlyArray<Scalars['String']['output']>;
  /** Returns stabilization TN activities for an offering */
  readonly stabilizationTNActivities: StabilizationTnFilingActivityResponse;
};

export type RegulatoryFilingsDsFilingArgs = {
  filingId: Scalars['UUID']['input'];
};

export type RegulatoryFilingsNoiFilingArgs = {
  filingId: Scalars['UUID']['input'];
};

export type RegulatoryFilingsRpnFilingArgs = {
  filingId: Scalars['UUID']['input'];
};

export type RegulatoryFilingsTnFilingArgs = {
  filingId: Scalars['UUID']['input'];
};

export type RegulatoryFilingsUsdtnFilingArgs = {
  filingId: Scalars['UUID']['input'];
};

export type RegulatoryFilingsNotificationsArgs = {
  filingId: Scalars['UUID']['input'];
};

export { RelationshipType };

export type RelationshipTypeOperationFilterInput = {
  readonly eq?: InputMaybe<RelationshipType>;
  readonly in?: InputMaybe<ReadonlyArray<RelationshipType>>;
  readonly neq?: InputMaybe<RelationshipType>;
  readonly nin?: InputMaybe<ReadonlyArray<RelationshipType>>;
};

export enum ReleaseStatus {
  Booked = 'BOOKED',
  BookedManual = 'BOOKED_MANUAL',
  Cancelled = 'CANCELLED',
  CancelledManual = 'CANCELLED_MANUAL',
  CancelPending = 'CANCEL_PENDING',
  PartiallyBooked = 'PARTIALLY_BOOKED',
  Released = 'RELEASED',
  ReleaseFailed = 'RELEASE_FAILED',
}

export type ReleasedRetailRetention = {
  readonly __typename?: 'ReleasedRetailRetention';
  readonly id: Scalars['ID']['output'];
  readonly isReleased: Scalars['Boolean']['output'];
  readonly managerCmgEntityKey: Scalars['String']['output'];
  readonly modifiedAt: Scalars['Instant']['output'];
  readonly modifiedByFirmKey?: Maybe<Scalars['String']['output']>;
  readonly shareQuantity: Scalars['Long']['output'];
};

export type RenameViewSettingInput = {
  readonly id: Scalars['UUID']['input'];
  readonly name: Scalars['String']['input'];
};

export type RenameViewSettingPayload = {
  readonly __typename?: 'RenameViewSettingPayload';
  readonly viewSetting?: Maybe<ViewSetting>;
};

export type ResearchRestrictionWire = {
  readonly __typename?: 'ResearchRestrictionWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly masterAauDate: Scalars['LocalDate']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly underwriterInvitationSentDate: Scalars['LocalDate']['output'];
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type ResearchRestrictionWireResponseUnion = ResearchRestrictionWire | ServiceError;

export type ResearchRestrictionWireValidation = WireValidationBase & {
  readonly __typename?: 'ResearchRestrictionWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<ResearchRestrictionWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum ResearchRestrictionWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  CouponTalkHigh = 'COUPON_TALK_HIGH',
  CouponTalkLow = 'COUPON_TALK_LOW',
  ExchangeMic = 'EXCHANGE_MIC',
  IpoRangeHigh = 'IPO_RANGE_HIGH',
  IpoRangeLow = 'IPO_RANGE_LOW',
  IssuerName = 'ISSUER_NAME',
  LaunchDate = 'LAUNCH_DATE',
  OfferingType = 'OFFERING_TYPE',
  ParValue = 'PAR_VALUE',
  PercentageOfPar = 'PERCENTAGE_OF_PAR',
  PremiumTalkHigh = 'PREMIUM_TALK_HIGH',
  PremiumTalkLow = 'PREMIUM_TALK_LOW',
  PricingDate = 'PRICING_DATE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  StockSymbol = 'STOCK_SYMBOL',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
  UnderlyingExchangeMic = 'UNDERLYING_EXCHANGE_MIC',
  UnderlyingStockSymbol = 'UNDERLYING_STOCK_SYMBOL',
}

export type ResendProspectusAsSalesAndTradingByIndicationSelectionInput = {
  readonly offeringId: Scalars['UUID']['input'];
  readonly selection: IndicationSelectionInput;
};

export type ResendProspectusAsSalesAndTradingByIndicationSelectionPayload = {
  readonly __typename?: 'ResendProspectusAsSalesAndTradingByIndicationSelectionPayload';
  readonly emptyMutationResponse?: Maybe<EmptyMutationResponse>;
};

export type ResendProspectusAsSyndicateByIndicationSelectionInput = {
  readonly offeringId: Scalars['UUID']['input'];
  readonly selection: IndicationSelectionInput;
};

export type ResendProspectusAsSyndicateByIndicationSelectionPayload = {
  readonly __typename?: 'ResendProspectusAsSyndicateByIndicationSelectionPayload';
  readonly emptyMutationResponse?: Maybe<EmptyMutationResponse>;
};

export type ResendProspectusResponseUnion = EmptyMutationResponse | ServiceError;

/**
 * Resources model the domain of each bounded context.
 * Warning: If breaking changes are made to this enum, then we will need to write a custom migration to update all entitlements stored in the db.
 */
export enum Resource {
  BuySideIndication = 'BUY_SIDE_INDICATION',
  DeliveryInstructions = 'DELIVERY_INSTRUCTIONS',
  DspIndication = 'DSP_INDICATION',
  DspRetention = 'DSP_RETENTION',
  FinalSettlement = 'FINAL_SETTLEMENT',
  FinalSettlementOfferingData = 'FINAL_SETTLEMENT_OFFERING_DATA',
  FullSyndicateLineUp = 'FULL_SYNDICATE_LINE_UP',
  IncentiveFee = 'INCENTIVE_FEE',
  InstitutionalAllocationDraft = 'INSTITUTIONAL_ALLOCATION_DRAFT',
  InstitutionalAllocationFinal = 'INSTITUTIONAL_ALLOCATION_FINAL',
  InstitutionalAllocationSet = 'INSTITUTIONAL_ALLOCATION_SET',
  InstitutionalDuplicateIndication = 'INSTITUTIONAL_DUPLICATE_INDICATION',
  InstitutionalIndication = 'INSTITUTIONAL_INDICATION',
  ManagementFee = 'MANAGEMENT_FEE',
  MyRetail = 'MY_RETAIL',
  NonSyndicateCommunication = 'NON_SYNDICATE_COMMUNICATION',
  OfferingProfile = 'OFFERING_PROFILE',
  OrderBook = 'ORDER_BOOK',
  RetailIndication = 'RETAIL_INDICATION',
  RetailRetention = 'RETAIL_RETENTION',
  SalesCredits = 'SALES_CREDITS',
  SalesOrderBook = 'SALES_ORDER_BOOK',
  SellingConcession = 'SELLING_CONCESSION',
  SharedDrafts = 'SHARED_DRAFTS',
  SyndicateCommunication = 'SYNDICATE_COMMUNICATION',
  UnderwritingFee = 'UNDERWRITING_FEE',
}

export type RetailBrokerDealer = {
  readonly __typename?: 'RetailBrokerDealer';
  readonly demand: RetailBrokerDealerDemand;
  readonly firmCmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly firmName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isOnPlatform: Scalars['Boolean']['output'];
  readonly retention: RetailBrokerDealerRetention;
  readonly sellingConcessionPercentage?: Maybe<Scalars['Decimal']['output']>;
};

export type RetailBrokerDealerDemand = {
  readonly __typename?: 'RetailBrokerDealerDemand';
  readonly id: Scalars['ID']['output'];
  readonly notionalQuantity: Scalars['Decimal']['output'];
  readonly roundLots?: Maybe<Scalars['Int']['output']>;
  readonly shareQuantity: Scalars['Long']['output'];
};

export type RetailBrokerDealerRetention = {
  readonly __typename?: 'RetailBrokerDealerRetention';
  readonly id: Scalars['ID']['output'];
  readonly roundLots?: Maybe<Scalars['Int']['output']>;
  readonly shareQuantity?: Maybe<Scalars['Long']['output']>;
};

export type RetailDemandRevision = {
  readonly __typename?: 'RetailDemandRevision';
  readonly id: Scalars['ID']['output'];
  readonly modifiedAt: Scalars['Instant']['output'];
  readonly modifiedByFirmKey?: Maybe<Scalars['String']['output']>;
  readonly notionalQuantity: Scalars['Decimal']['output'];
  readonly roundLots?: Maybe<Scalars['Int']['output']>;
  readonly shareQuantity: Scalars['Long']['output'];
};

export type RetentionRecipientData = {
  readonly __typename?: 'RetentionRecipientData';
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly recipient: Scalars['String']['output'];
};

export type RetentionRecipientInputData = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly recipient: Scalars['String']['input'];
};

export type RetentionWire = {
  readonly __typename?: 'RetentionWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly id: Scalars['ID']['output'];
  readonly recipientsUserData: ReadonlyArray<RetentionRecipientData>;
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

export type RetentionWireInput = {
  readonly userDataForRecipients: ReadonlyArray<RetentionRecipientInputData>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type RetentionWireResponseUnion = RetentionWire | ServiceError;

export type RetentionWireValidation = WireValidationBase & {
  readonly __typename?: 'RetentionWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<RetentionWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum RetentionWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
}

export type RetryDataSyncInput = {
  readonly correlationIds: ReadonlyArray<Scalars['UUID']['input']>;
};

export type RetryDataSyncPayload = {
  readonly __typename?: 'RetryDataSyncPayload';
  readonly uuid?: Maybe<ReadonlyArray<Scalars['UUID']['output']>>;
};

export type ReviewSalesCreditsBankInvestorKeyChangeInput = {
  readonly bankInvestorKey: Scalars['String']['input'];
  readonly investorStatus: OrderBookInvestorStatus;
};

export enum RevisionEdition {
  Draft = 'DRAFT',
  Final = 'FINAL',
}

export type RevisionEditionFilterInput = {
  readonly eq?: InputMaybe<RevisionEdition>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<RevisionEdition>>>;
  readonly neq?: InputMaybe<RevisionEdition>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<RevisionEdition>>>;
};

export type RevisionEditionSortInput = {
  readonly name?: InputMaybe<SortEnumType>;
  readonly value?: InputMaybe<SortEnumType>;
};

export enum RoadshowMeetingType {
  LargeGroup = 'LARGE_GROUP',
  OneOnOne = 'ONE_ON_ONE',
  SmallGroup = 'SMALL_GROUP',
  TwoOnOne = 'TWO_ON_ONE',
}

export type RoadshowSchedule = {
  readonly __typename?: 'RoadshowSchedule';
  readonly date: Scalars['LocalDate']['output'];
  readonly details: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly recordStatus: RecordStatus;
};

export type RoadshowScheduleDataInput = {
  readonly date: Scalars['LocalDate']['input'];
  readonly details: Scalars['String']['input'];
};

export type RoadshowScheduleProfile = {
  readonly __typename?: 'RoadshowScheduleProfile';
  readonly date: Scalars['LocalDate']['output'];
  readonly details: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
};

export type RoadshowsFull = {
  readonly __typename?: 'RoadshowsFull';
  readonly date: Scalars['LocalDate']['output'];
  readonly details: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
};

export type RoadshowsFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<RoadshowsFullFilterInput>>;
  readonly date?: InputMaybe<LocalDateOperationFilterInput>;
  readonly details?: InputMaybe<StringOperationFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<RoadshowsFullFilterInput>>;
};

export enum RolodexFirmCategoryType {
  Extension = 'EXTENSION',
  FreeText = 'FREE_TEXT',
  Pwm = 'PWM',
  Regular = 'REGULAR',
}

export { RolodexRecordStatus };

export type RowAlert = {
  readonly __typename?: 'RowAlert';
  readonly alertCodes?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly severity: AlertSeverity;
  readonly sortValue?: Maybe<Scalars['String']['output']>;
};

export type RowAlertFilterInput = {
  readonly alertCodes?: InputMaybe<ListStringOperationFilterInput>;
  readonly and?: InputMaybe<ReadonlyArray<RowAlertFilterInput>>;
  readonly or?: InputMaybe<ReadonlyArray<RowAlertFilterInput>>;
  readonly severity?: InputMaybe<AlertSeverityOperationFilterInput>;
  readonly sortValue?: InputMaybe<StringOperationFilterInput>;
};

export type RowAlertSortInput = {
  readonly severity?: InputMaybe<SortEnumType>;
  readonly sortValue?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type SalesCoverageCollectionSegment = {
  readonly __typename?: 'SalesCoverageCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<InvestorFirmRelationship>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type SalesCreditGrid = {
  readonly __typename?: 'SalesCreditGrid';
  readonly id: Scalars['ID']['output'];
  readonly salesCredits: ReadonlyArray<SalesCreditItem>;
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly settlementCurrency: Scalars['String']['output'];
};

export type SalesCreditInvestorHistoryItem = {
  readonly __typename?: 'SalesCreditInvestorHistoryItem';
  readonly createdAt: Scalars['Instant']['output'];
  readonly createdByUserName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly salesCreditId: Scalars['UUID']['output'];
  readonly salesCreditStatus: SalesCreditReleaseStatus;
  readonly salesCreditVersion: Scalars['String']['output'];
  readonly statusDetails?: Maybe<Scalars['String']['output']>;
};

export type SalesCreditItem = {
  readonly __typename?: 'SalesCreditItem';
  readonly allocationShares?: Maybe<Scalars['Long']['output']>;
  readonly allowedStatusTransitions: ReadonlyArray<GridTransitionSalesCreditReleaseStatus>;
  readonly bankInvestorKey?: Maybe<Scalars['String']['output']>;
  readonly designationShares?: Maybe<Scalars['Long']['output']>;
  readonly firmId?: Maybe<Scalars['UUID']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly investorFirmCmgEntityKey: Scalars['String']['output'];
  readonly investorFirmName: Scalars['String']['output'];
  readonly orderBookBankInvestorFirmName?: Maybe<Scalars['String']['output']>;
  readonly orderBookBankInvestorKey?: Maybe<Scalars['String']['output']>;
  readonly salesCredits?: Maybe<Scalars['Decimal']['output']>;
  readonly salesCreditsId?: Maybe<Scalars['String']['output']>;
  readonly salesCreditsManual?: Maybe<Scalars['Decimal']['output']>;
  readonly salesCreditsReleased?: Maybe<Scalars['Decimal']['output']>;
  readonly status: SalesCreditReleaseStatus;
  readonly statusDetails?: Maybe<Scalars['String']['output']>;
  readonly warnings: ReadonlyArray<SalesCreditWarning>;
};

export enum SalesCreditReleaseStatus {
  Booked = 'BOOKED',
  BookedManual = 'BOOKED_MANUAL',
  Cancelled = 'CANCELLED',
  CancelledManual = 'CANCELLED_MANUAL',
  CancelPending = 'CANCEL_PENDING',
  Released = 'RELEASED',
  ReleaseFailed = 'RELEASE_FAILED',
  Unreleased = 'UNRELEASED',
}

export enum SalesCreditWarning {
  BankInvestorKeyChanged = 'BANK_INVESTOR_KEY_CHANGED',
  DesignationChanged = 'DESIGNATION_CHANGED',
  DesignationNotApplicable = 'DESIGNATION_NOT_APPLICABLE',
  OfferingChanged = 'OFFERING_CHANGED',
  OrderBookBankInvestorKeyChanged = 'ORDER_BOOK_BANK_INVESTOR_KEY_CHANGED',
  PublishedDesignationAmountIsZero = 'PUBLISHED_DESIGNATION_AMOUNT_IS_ZERO',
  SalesCreditChanged = 'SALES_CREDIT_CHANGED',
}

export enum ScalarSerializationType {
  Boolean = 'BOOLEAN',
  Float = 'FLOAT',
  Int = 'INT',
  List = 'LIST',
  Object = 'OBJECT',
  String = 'STRING',
}

export enum Sector {
  BasicMaterials = 'BASIC_MATERIALS',
  Consumer = 'CONSUMER',
  Energy = 'ENERGY',
  FinancialServices = 'FINANCIAL_SERVICES',
  Healthcare = 'HEALTHCARE',
  Industrials = 'INDUSTRIALS',
  Other = 'OTHER',
  RealEstate = 'REAL_ESTATE',
  Tmt = 'TMT',
  Utilities = 'UTILITIES',
}

export type SectorFilterInput = {
  readonly eq?: InputMaybe<Sector>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Sector>>>;
  readonly neq?: InputMaybe<Sector>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Sector>>>;
};

export type Security = {
  readonly __typename?: 'Security';
  readonly id: Scalars['ID']['output'];
  /**
   * Deprecated, use IsDepositaryReceipt field on Instrument.
   * @deprecated Deprecated. This will be removed in future versions.
   */
  readonly isDepositaryReceipt: Scalars['Boolean']['output'];
  readonly securityDescription?: Maybe<Scalars['String']['output']>;
  readonly shareClass?: Maybe<SecurityShareClass>;
  /** Display name for ShareClass */
  readonly shareClassDisplayName?: Maybe<Scalars['String']['output']>;
  readonly type: SecurityType;
  /** Display name for Type */
  readonly typeDisplayName?: Maybe<Scalars['String']['output']>;
};

export type SecurityFull = {
  readonly __typename?: 'SecurityFull';
  readonly isDepositaryReceipt: Scalars['Boolean']['output'];
  readonly securityDescription?: Maybe<Scalars['String']['output']>;
  readonly shareClass?: Maybe<SecurityShareClass>;
  /** Display name for ShareClass */
  readonly shareClassDisplayName?: Maybe<Scalars['String']['output']>;
  readonly type: SecurityType;
  /** Display name for Type */
  readonly typeDisplayName?: Maybe<Scalars['String']['output']>;
};

export type SecurityFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<SecurityFullFilterInput>>;
  readonly isDepositaryReceipt?: InputMaybe<BooleanOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<SecurityFullFilterInput>>;
  readonly securityDescription?: InputMaybe<StringOperationFilterInput>;
  readonly shareClass?: InputMaybe<ShareClassFilterInput>;
  readonly type?: InputMaybe<SecurityTypeFilterInput>;
};

export type SecurityProfile = {
  readonly __typename?: 'SecurityProfile';
  /**
   * Deprecated, use IsDepositaryReceipt field on Instrument.
   * @deprecated Deprecated. This will be removed in future versions.
   */
  readonly isDepositaryReceipt: Scalars['Boolean']['output'];
  readonly securityDescription?: Maybe<Scalars['String']['output']>;
  readonly shareClass?: Maybe<SecurityShareClass>;
  /** Display name for ShareClass */
  readonly shareClassDisplayName?: Maybe<Scalars['String']['output']>;
  readonly type: SecurityType;
  /** Display name for Type */
  readonly typeDisplayName?: Maybe<Scalars['String']['output']>;
};

export enum SecurityShareClass {
  A = 'A',
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  B = 'B',
  B1 = 'B1',
  B2 = 'B2',
  B3 = 'B3',
  C = 'C',
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  D = 'D',
  E = 'E',
  Eight = 'EIGHT',
  F = 'F',
  Five = 'FIVE',
  Four = 'FOUR',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J',
  K = 'K',
  L = 'L',
  M = 'M',
  N = 'N',
  Nine = 'NINE',
  O = 'O',
  One = 'ONE',
  P = 'P',
  Q = 'Q',
  R = 'R',
  S = 'S',
  Seven = 'SEVEN',
  Six = 'SIX',
  T = 'T',
  Three = 'THREE',
  Two = 'TWO',
  U = 'U',
  V = 'V',
  W = 'W',
  X = 'X',
  Y = 'Y',
  Z = 'Z',
}

export enum SecurityType {
  CommonOrdinaryShare = 'COMMON_ORDINARY_SHARE',
  ConvertibleBond = 'CONVERTIBLE_BOND',
  Fund = 'FUND',
  LimitedPartnershipUnit = 'LIMITED_PARTNERSHIP_UNIT',
  PreferredShare = 'PREFERRED_SHARE',
  UnitShareAndWarrants = 'UNIT_SHARE_AND_WARRANTS',
}

export type SecurityTypeFilterInput = {
  readonly eq?: InputMaybe<SecurityType>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<SecurityType>>>;
  readonly neq?: InputMaybe<SecurityType>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<SecurityType>>>;
};

export type SellingGroupInvitationWire = {
  readonly __typename?: 'SellingGroupInvitationWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly masterSdaDate: Scalars['LocalDate']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type SellingGroupInvitationWireResponseUnion = SellingGroupInvitationWire | ServiceError;

export type SellingGroupInvitationWireValidation = WireValidationBase & {
  readonly __typename?: 'SellingGroupInvitationWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<SellingGroupInvitationWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum SellingGroupInvitationWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  CouponTalkHigh = 'COUPON_TALK_HIGH',
  CouponTalkLow = 'COUPON_TALK_LOW',
  ExchangeMic = 'EXCHANGE_MIC',
  IpoRangeHigh = 'IPO_RANGE_HIGH',
  IpoRangeLow = 'IPO_RANGE_LOW',
  IssuerName = 'ISSUER_NAME',
  LaunchDate = 'LAUNCH_DATE',
  OfferingType = 'OFFERING_TYPE',
  ParValue = 'PAR_VALUE',
  PercentageOfPar = 'PERCENTAGE_OF_PAR',
  PremiumTalkHigh = 'PREMIUM_TALK_HIGH',
  PremiumTalkLow = 'PREMIUM_TALK_LOW',
  PricingDate = 'PRICING_DATE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  SharesOrNotionalBaseOffering = 'SHARES_OR_NOTIONAL_BASE_OFFERING',
  StockSymbol = 'STOCK_SYMBOL',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  UnderlyingExchangeMic = 'UNDERLYING_EXCHANGE_MIC',
  UnderlyingStockSymbol = 'UNDERLYING_STOCK_SYMBOL',
}

export type SellingGroupTermsWire = {
  readonly __typename?: 'SellingGroupTermsWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type SellingGroupTermsWireResponseUnion = SellingGroupTermsWire | ServiceError;

export type SellingGroupTermsWireValidation = WireValidationBase & {
  readonly __typename?: 'SellingGroupTermsWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<SellingGroupTermsWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum SellingGroupTermsWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  Coupon = 'COUPON',
  Cusip = 'CUSIP',
  ExchangeMic = 'EXCHANGE_MIC',
  FirstTradeDate = 'FIRST_TRADE_DATE',
  IssuerName = 'ISSUER_NAME',
  OfferingPrice = 'OFFERING_PRICE',
  OfferingType = 'OFFERING_TYPE',
  ParValue = 'PAR_VALUE',
  PercentageOfPar = 'PERCENTAGE_OF_PAR',
  Premium = 'PREMIUM',
  SecurityType = 'SECURITY_TYPE',
  SellingConcession = 'SELLING_CONCESSION',
  SettlementAgent = 'SETTLEMENT_AGENT',
  SettlementDate = 'SETTLEMENT_DATE',
  StockSymbol = 'STOCK_SYMBOL',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
  UnderlyingExchangeMic = 'UNDERLYING_EXCHANGE_MIC',
  UnderlyingStockSymbol = 'UNDERLYING_STOCK_SYMBOL',
}

export enum SellingRestrictions {
  None = 'NONE',
  Reg_144A = 'REG_144A',
}

export type SellingRestrictionsFilterInput = {
  readonly eq?: InputMaybe<SellingRestrictions>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<SellingRestrictions>>>;
  readonly neq?: InputMaybe<SellingRestrictions>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<SellingRestrictions>>>;
};

export type SendDlSupportRequestResponse = EmptyMutationResponse | ServiceError;

export type SendReportInput = {
  readonly emailAddresses: ReadonlyArray<Scalars['String']['input']>;
  readonly sendDateTimeZone: Scalars['String']['input'];
};

export type SendWireInput = {
  readonly sendDateTimeZone: Scalars['String']['input'];
  readonly shouldAddSenderToCc: Scalars['Boolean']['input'];
  readonly underwriterList: ReadonlyArray<Scalars['String']['input']>;
};

export enum SentWireResponseStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Obsolete = 'OBSOLETE',
  Pending = 'PENDING',
}

export type SentWireResponseStatusFilterInput = {
  readonly eq?: InputMaybe<SentWireResponseStatus>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<SentWireResponseStatus>>>;
  readonly neq?: InputMaybe<SentWireResponseStatus>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<SentWireResponseStatus>>>;
};

export type SentWireStatus = {
  readonly __typename?: 'SentWireStatus';
  readonly expiredAt?: Maybe<Scalars['Instant']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly legalAgreement?: Maybe<Scalars['String']['output']>;
  readonly respondedAt?: Maybe<Scalars['Instant']['output']>;
  readonly responseStatus?: Maybe<SentWireResponseStatus>;
  readonly senderEmails: ReadonlyArray<Scalars['String']['output']>;
  readonly sentAt: Scalars['Instant']['output'];
};

/** Legacy Service Error object for Apollo Compatibility */
export type ServiceError = {
  readonly __typename?: 'ServiceError';
  readonly code: ServiceErrorCode;
  readonly details?: Maybe<ReadonlyArray<ErrorDetail>>;
  readonly message: Scalars['String']['output'];
  readonly target?: Maybe<Scalars['String']['output']>;
};

export enum ServiceErrorCode {
  Duplicate = 'DUPLICATE',
  EditConflict = 'EDIT_CONFLICT',
  Forbidden = 'FORBIDDEN',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  IpBlocked = 'IP_BLOCKED',
  LockedOut = 'LOCKED_OUT',
  NetworkFailure = 'NETWORK_FAILURE',
  NotFound = 'NOT_FOUND',
  PasswordExpired = 'PASSWORD_EXPIRED',
  RateLimitExceeded = 'RATE_LIMIT_EXCEEDED',
  UnhandledError = 'UNHANDLED_ERROR',
  ValidationError = 'VALIDATION_ERROR',
}

export type SetDefaultInstrumentForTrancheInput = {
  readonly instrumentId: Scalars['UUID']['input'];
  readonly offeringId: Scalars['UUID']['input'];
  readonly trancheId: Scalars['UUID']['input'];
};

export type SetDefaultInstrumentForTranchePayload = {
  readonly __typename?: 'SetDefaultInstrumentForTranchePayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type SetPricingCurrencyInput = {
  readonly currencyCode: Scalars['String']['input'];
  readonly offeringId: Scalars['UUID']['input'];
};

export type SetPricingCurrencyPayload = {
  readonly __typename?: 'SetPricingCurrencyPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type SetPricingInstrumentInput = {
  readonly instrumentId: Scalars['UUID']['input'];
  readonly offeringId: Scalars['UUID']['input'];
};

export type SetPricingInstrumentPayload = {
  readonly __typename?: 'SetPricingInstrumentPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type SetViewSettingFavoriteInput = {
  readonly id: Scalars['UUID']['input'];
  readonly value: Scalars['Boolean']['input'];
};

export type SetViewSettingFavoritePayload = {
  readonly __typename?: 'SetViewSettingFavoritePayload';
  readonly viewSetting?: Maybe<ViewSetting>;
};

export enum SettlementErrorType {
  NoDesignations = 'NO_DESIGNATIONS',
}

export type SettlementLetter = {
  readonly __typename?: 'SettlementLetter';
  readonly adjustmentDescription?: Maybe<Scalars['String']['output']>;
  readonly adjustmentValue?: Maybe<Scalars['Decimal']['output']>;
  readonly dealRelatedExpenses: ReadonlyArray<LetterDealRelatedExpenses>;
  readonly designatedShares?: Maybe<Scalars['Long']['output']>;
  readonly finalSettlement?: Maybe<Scalars['Decimal']['output']>;
  readonly finalSettlementDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly issuerName: Scalars['String']['output'];
  readonly managementFee?: Maybe<Scalars['Decimal']['output']>;
  readonly managementPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly managerDealRelatedExpenses?: Maybe<Scalars['Decimal']['output']>;
  readonly managerExpensesReimbursements?: Maybe<Scalars['Decimal']['output']>;
  readonly managerGainLossOnOversale?: Maybe<Scalars['Decimal']['output']>;
  readonly managerName: Scalars['String']['output'];
  readonly managerRole: ExpensesManagerRole;
  /** Display name for ManagerRole */
  readonly managerRoleDisplayName?: Maybe<Scalars['String']['output']>;
  readonly netDealFee?: Maybe<Scalars['Decimal']['output']>;
  readonly offeringType: OfferingType;
  /** Display name for OfferingType */
  readonly offeringTypeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcessionSpread?: Maybe<Scalars['Decimal']['output']>;
  readonly totalLossOnOversale?: Maybe<Scalars['Decimal']['output']>;
  readonly totalManagerExpensesReimbursements?: Maybe<Scalars['Decimal']['output']>;
  readonly totalUnderwritingGroupExpense?: Maybe<Scalars['Decimal']['output']>;
  readonly tradeDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly trancheName?: Maybe<Scalars['String']['output']>;
  readonly underwritingFee?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingShares?: Maybe<Scalars['Long']['output']>;
  readonly underwritingSpread?: Maybe<Scalars['Decimal']['output']>;
  readonly userFirmName: Scalars['String']['output'];
};

export enum ShareClass {
  A = 'A',
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  B = 'B',
  B1 = 'B1',
  B2 = 'B2',
  B3 = 'B3',
  C = 'C',
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  D = 'D',
  E = 'E',
  Eight = 'EIGHT',
  F = 'F',
  Five = 'FIVE',
  Four = 'FOUR',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J',
  K = 'K',
  L = 'L',
  M = 'M',
  N = 'N',
  Nine = 'NINE',
  O = 'O',
  One = 'ONE',
  P = 'P',
  Q = 'Q',
  R = 'R',
  S = 'S',
  Seven = 'SEVEN',
  Six = 'SIX',
  T = 'T',
  Three = 'THREE',
  Two = 'TWO',
  U = 'U',
  V = 'V',
  W = 'W',
  X = 'X',
  Y = 'Y',
  Z = 'Z',
}

export type ShareClassFilterInput = {
  readonly eq?: InputMaybe<ShareClass>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<ShareClass>>>;
  readonly neq?: InputMaybe<ShareClass>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<ShareClass>>>;
};

export type ShareDraftInput = {
  readonly managerKeys: ReadonlyArray<Scalars['String']['input']>;
  readonly offeringId: Scalars['UUID']['input'];
};

export type ShareDraftPayload = {
  readonly __typename?: 'ShareDraftPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type ShareHistoryFull = {
  readonly __typename?: 'ShareHistoryFull';
  readonly id: Scalars['UUID']['output'];
  readonly managerKeys: ReadonlyArray<Scalars['String']['output']>;
  readonly sharedAt: Scalars['Instant']['output'];
  readonly version: Scalars['Int']['output'];
};

export type ShareHistoryFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<ShareHistoryFullFilterInput>>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly managerKeys?: InputMaybe<ListStringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<ShareHistoryFullFilterInput>>;
  readonly sharedAt?: InputMaybe<InstantOperationFilterInput>;
  readonly version?: InputMaybe<IntOperationFilterInput>;
};

export type SharedDraftHistory = {
  readonly __typename?: 'SharedDraftHistory';
  readonly managerKeys: ReadonlyArray<Scalars['String']['output']>;
  readonly sharedTime: Scalars['Instant']['output'];
  readonly version: Scalars['String']['output'];
};

/** A segment of a collection. */
export type SharedOfferingsCollectionSegment = {
  readonly __typename?: 'SharedOfferingsCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<OfferingFull>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type SharesPerCmgEntity = {
  readonly __typename?: 'SharesPerCmgEntity';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly sharesValue: Scalars['Long']['output'];
};

export type SharesPerCmgEntityDataInput = {
  readonly cmgEntityKey: Scalars['String']['input'];
  readonly sharesValue: Scalars['Int']['input'];
};

export type SharesPerCmgEntityFull = {
  readonly __typename?: 'SharesPerCmgEntityFull';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly sharesValue: Scalars['Long']['output'];
};

export type SharesPerCmgEntityFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<SharesPerCmgEntityFullFilterInput>>;
  readonly cmgEntityKey?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<SharesPerCmgEntityFullFilterInput>>;
  readonly sharesValue?: InputMaybe<LongOperationFilterInput>;
};

export type Signer = {
  readonly __typename?: 'Signer';
  readonly email: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly telephone: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum SortOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum SpRating {
  A = 'A',
  Aa = 'AA',
  Aaa = 'AAA',
  B = 'B',
  Bb = 'BB',
  Bbb = 'BBB',
  C = 'C',
  Cc = 'CC',
  Ccc = 'CCC',
  D = 'D',
}

export type SpRatingFilterInput = {
  readonly eq?: InputMaybe<SpRating>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<SpRating>>>;
  readonly neq?: InputMaybe<SpRating>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<SpRating>>>;
};

export type Sponsor = {
  readonly __typename?: 'Sponsor';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly postOfferingOwnership?: Maybe<Scalars['Long']['output']>;
  readonly postOfferingOwnershipIncludingShoe?: Maybe<Scalars['Long']['output']>;
  readonly preOfferingOwnership?: Maybe<Scalars['Long']['output']>;
  readonly recordStatus: RecordStatus;
};

export type Stabilization = {
  readonly __typename?: 'Stabilization';
  readonly id: Scalars['ID']['output'];
  readonly notes: Scalars['String']['output'];
  readonly trades: ReadonlyArray<StabilizationTrade>;
};

export type StabilizationInformation = {
  readonly __typename?: 'StabilizationInformation';
  readonly additionalShortPosition: Scalars['Long']['output'];
  readonly finalAuthorizedOverallotment: Scalars['Long']['output'];
  readonly id: Scalars['ID']['output'];
  readonly offeringPrice: Scalars['Decimal']['output'];
  readonly overallotmentExcercised?: Maybe<Scalars['Long']['output']>;
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
};

export type StabilizationTnFilingActivity = {
  readonly __typename?: 'StabilizationTNFilingActivity';
  readonly date: Scalars['LocalDate']['output'];
  readonly shares: Scalars['Long']['output'];
  readonly stabilizationActivityType: StabilizationTnActivityType;
  /** Display name for StabilizationActivityType */
  readonly stabilizationActivityTypeDisplayName?: Maybe<Scalars['String']['output']>;
};

export type StabilizationTnFilingActivityInput = {
  readonly date: Scalars['LocalDate']['input'];
  readonly shares: Scalars['Long']['input'];
  readonly stabilizationActivityType: StabilizationTnActivityType;
};

export type StabilizationTnFilingActivityResponse =
  | ServiceError
  | StabilizationTnFilingActivityWrapper;

export type StabilizationTnFilingActivityWrapper = {
  readonly __typename?: 'StabilizationTNFilingActivityWrapper';
  readonly activities: ReadonlyArray<StabilizationTnFilingActivity>;
};

export enum StabilizationTnActivityType {
  Sb = 'SB',
  Sct = 'SCT',
}

export type StabilizationTrade = {
  readonly __typename?: 'StabilizationTrade';
  readonly activityType?: Maybe<TradeActivityType>;
  /** Display name for ActivityType */
  readonly activityTypeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly averagePrice?: Maybe<Scalars['Decimal']['output']>;
  readonly date: Scalars['LocalDate']['output'];
  readonly shares: Scalars['Long']['output'];
  readonly type: TradeType;
  /** Display name for Type */
  readonly typeDisplayName?: Maybe<Scalars['String']['output']>;
};

export type StringExtendedData = {
  readonly __typename?: 'StringExtendedData';
  readonly key: Scalars['ID']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly value: Scalars['String']['output'];
};

export type StringOperationFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<StringOperationFilterInput>>;
  readonly contains?: InputMaybe<Scalars['String']['input']>;
  readonly endsWith?: InputMaybe<Scalars['String']['input']>;
  readonly eq?: InputMaybe<Scalars['String']['input']>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly like?: InputMaybe<Scalars['String']['input']>;
  readonly ncontains?: InputMaybe<Scalars['String']['input']>;
  readonly nendsWith?: InputMaybe<Scalars['String']['input']>;
  readonly neq?: InputMaybe<Scalars['String']['input']>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly nstartsWith?: InputMaybe<Scalars['String']['input']>;
  readonly or?: InputMaybe<ReadonlyArray<StringOperationFilterInput>>;
  readonly startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitMyRetailInput = {
  readonly instrumentId: Scalars['UUID']['input'];
  readonly trancheId: Scalars['UUID']['input'];
};

export type SubmitPassIndicationInput = {
  /** Investor information fields must be populated to capture buy-side information. */
  readonly investorInformation: InvestorInformationInput;
};

export type SubmitWallCrossIndicationInput = {
  readonly data: WallCrossIndicationDataInput;
  readonly investorId: Scalars['ID']['input'];
  readonly offeringId: Scalars['ID']['input'];
};

export type SubmitWallCrossIndicationPayload = {
  readonly __typename?: 'SubmitWallCrossIndicationPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

export type SubmitWallCrossPassInput = {
  readonly investorId: Scalars['ID']['input'];
  readonly offeringId: Scalars['ID']['input'];
};

export type SubmitWallCrossPassPayload = {
  readonly __typename?: 'SubmitWallCrossPassPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

export type Subscription = {
  readonly __typename?: 'Subscription';
  readonly attestationStatusChanged: AttestationStatus;
  readonly coveredIndicationChanged: CoveredIndicationChanged;
  readonly coveredIndicationsChanged: CoveredIndicationChangeSet;
  readonly demandGridChanged: DemandGridChangeSet;
  readonly indicationChanged: IndicationChanged;
  readonly investorRelationshipChanged: InvestorRelationshipChanged;
  readonly offeringPublished: OfferingPublished;
  readonly orderBookSalesStateChanged: OrderBookSalesState;
  readonly orderBookSalesStateChangedForSalesTrader: OrderBookSalesState;
  readonly orderBookStatusChanged: OrderBookStatus;
  readonly syndicateInstitutionalGridChanged: SyndicateInstitutionalGridChanged;
  readonly syndicateInstitutionalGridChangedSummaries: SyndicateGridChangeSummary;
};

export type SubscriptionAttestationStatusChangedArgs = {
  cmgEntityKeys: ReadonlyArray<Scalars['String']['input']>;
};

export type SubscriptionDemandGridChangedArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type SubscriptionIndicationChangedArgs = {
  indicationId?: InputMaybe<Scalars['UUID']['input']>;
  offeringId: Scalars['UUID']['input'];
};

export type SubscriptionInvestorRelationshipChangedArgs = {
  investorFirmKeysOrIds: ReadonlyArray<Scalars['String']['input']>;
};

export type SubscriptionOfferingPublishedArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type SubscriptionOrderBookSalesStateChangedArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type SubscriptionOrderBookSalesStateChangedForSalesTraderArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type SubscriptionOrderBookStatusChangedArgs = {
  offeringId: Scalars['UUID']['input'];
};

export type SubscriptionSyndicateInstitutionalGridChangedArgs = {
  investorFirmCmgEntityKeys?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  offeringId: Scalars['UUID']['input'];
};

export type SubscriptionSyndicateInstitutionalGridChangedSummariesArgs = {
  investorFirmCmgEntityKeys?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  offeringId: Scalars['UUID']['input'];
};

export type SyncInstitutionalIndicationInput = {
  readonly fromAccountSubdomain: Scalars['String']['input'];
  readonly investorCmgEntityKey: Scalars['String']['input'];
  readonly offeringId: Scalars['UUID']['input'];
};

export type SyncInstitutionalIndicationPayload = {
  readonly __typename?: 'SyncInstitutionalIndicationPayload';
  readonly uuid?: Maybe<Scalars['UUID']['output']>;
};

export type Syndicate = {
  readonly __typename?: 'Syndicate';
  /**
   * Deprecated; Use attributes in Underwriting Fees and Discounts under Terms.
   * @deprecated Use attributes in Underwriting Fees and Discounts under Terms.
   */
  readonly grossSpread?: Maybe<Scalars['Decimal']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly managerEconomics: ManagerEconomics;
  readonly managerResponsibilities: ManagerResponsibilities;
  readonly managers: ReadonlyArray<Manager>;
};

export type SyndicateEntitlements = {
  readonly __typename?: 'SyndicateEntitlements';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly entitlements: ReadonlyArray<Scalars['String']['output']>;
  readonly recordStatus: RecordStatus;
};

export type SyndicateFull = {
  readonly __typename?: 'SyndicateFull';
  /** For a published offering, returns the list of managers in the syndicate that are eligible to be billing or delivery agents. */
  readonly eligibleBillingAndDeliveryAgents?: Maybe<ReadonlyArray<ManagerFull>>;
  readonly managerResponsibilities: ManagerResponsibilitiesFull;
  readonly managerSequence: ReadonlyArray<Scalars['String']['output']>;
  readonly managers: ReadonlyArray<ManagerFull>;
};

export type SyndicateFullManagersArgs = {
  includeSellingGroupMembers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SyndicateFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<SyndicateFullFilterInput>>;
  readonly managerResponsibilities?: InputMaybe<ManagerResponsibilitiesFullFilterInput>;
  readonly managerSequence?: InputMaybe<ListStringOperationFilterInput>;
  readonly managers?: InputMaybe<ListFilterInputTypeOfManagerFullFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<SyndicateFullFilterInput>>;
};

export type SyndicateGridChangeSummary = {
  readonly __typename?: 'SyndicateGridChangeSummary';
  readonly affectedIndicationCount: Scalars['Int']['output'];
  readonly allocationRevisions?: Maybe<ReadonlyArray<Maybe<AllocationChangeDetail>>>;
  readonly batchId?: Maybe<Scalars['UUID']['output']>;
  readonly changeType: SyndicateGridChangeType;
  readonly investorFirm?: Maybe<Scalars['String']['output']>;
  readonly itemId: Scalars['UUID']['output'];
  readonly manager?: Maybe<Scalars['String']['output']>;
  readonly newAllocation?: Maybe<AllocationRevisionDetail>;
  readonly newAllocationSet?: Maybe<AllocationSetDetail>;
  readonly newIndication?: Maybe<IndicationDetail>;
  readonly offeringId: Scalars['UUID']['output'];
  readonly oldAllocation?: Maybe<AllocationRevisionDetail>;
  readonly oldAllocationSet?: Maybe<AllocationSetDetail>;
  readonly oldIndication?: Maybe<IndicationDetail>;
  readonly principalId: Scalars['UUID']['output'];
  readonly timestamp: Scalars['DateTime']['output'];
};

export enum SyndicateGridChangeType {
  AllocationBulkChanged = 'ALLOCATION_BULK_CHANGED',
  AllocationChanged = 'ALLOCATION_CHANGED',
  AllocationSetShared = 'ALLOCATION_SET_SHARED',
  DuplicationStatusChanged = 'DUPLICATION_STATUS_CHANGED',
  IndicationCreated = 'INDICATION_CREATED',
  IndicationDeleted = 'INDICATION_DELETED',
  IndicationInterestLevelChanged = 'INDICATION_INTEREST_LEVEL_CHANGED',
  IndicationStatusChanged = 'INDICATION_STATUS_CHANGED',
}

export enum SyndicateGridGroupingColumn {
  AttestationStatus = 'ATTESTATION_STATUS',
  BndAgentFirmDisplayName = 'BND_AGENT_FIRM_DISPLAY_NAME',
  InvestorCompliance1 = 'INVESTOR_COMPLIANCE1',
  InvestorCompliance2 = 'INVESTOR_COMPLIANCE2',
  InvestorCompliance3 = 'INVESTOR_COMPLIANCE3',
  InvestorCompliance4 = 'INVESTOR_COMPLIANCE4',
  InvestorCompliance5 = 'INVESTOR_COMPLIANCE5',
  InvestorRegion1 = 'INVESTOR_REGION1',
  InvestorRegion2 = 'INVESTOR_REGION2',
  InvestorRegion3 = 'INVESTOR_REGION3',
  InvestorRegion4 = 'INVESTOR_REGION4',
  InvestorRegion5 = 'INVESTOR_REGION5',
  InvestorType1 = 'INVESTOR_TYPE1',
  InvestorType2 = 'INVESTOR_TYPE2',
  InvestorType3 = 'INVESTOR_TYPE3',
  InvestorType4 = 'INVESTOR_TYPE4',
  InvestorType5 = 'INVESTOR_TYPE5',
  ProspectusDeliveryStatus = 'PROSPECTUS_DELIVERY_STATUS',
  QibStatus = 'QIB_STATUS',
  SubmittedOn = 'SUBMITTED_ON',
}

export type SyndicateGridQueryInput = {
  readonly allocationSetIds?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  readonly demandSettings: DemandSettingsInput;
  readonly where?: InputMaybe<SyndicateInstitutionalGridRowFilterInput>;
};

export type SyndicateGridTotalsRow = {
  readonly __typename?: 'SyndicateGridTotalsRow';
  readonly allocations: ReadonlyArray<AllocationTotalRow>;
  readonly convertibleDemandLevels: ReadonlyArray<ConvertibleDemandLevelTotalRow>;
  readonly demandAtMarket: Scalars['Long']['output'];
  readonly demandAtMarketNotional: Scalars['Decimal']['output'];
  readonly demandLevels: ReadonlyArray<DemandLevel>;
  readonly demandMax: Scalars['Long']['output'];
  readonly demandMaxNotional: Scalars['Decimal']['output'];
  readonly indicationCount: Scalars['Int']['output'];
};

export enum SyndicateInstitutionalGridChangeType {
  Allocation = 'ALLOCATION',
  BillingAndDeliveryAgent = 'BILLING_AND_DELIVERY_AGENT',
  Indication = 'INDICATION',
  IndicationAcknowledgement = 'INDICATION_ACKNOWLEDGEMENT',
  Investor = 'INVESTOR',
  InvestorEngagement = 'INVESTOR_ENGAGEMENT',
  Offering = 'OFFERING',
  OrderBook = 'ORDER_BOOK',
  OrderBookState = 'ORDER_BOOK_STATE',
  SalesAndTradingNote = 'SALES_AND_TRADING_NOTE',
  SyndicateNote = 'SYNDICATE_NOTE',
}

export type SyndicateInstitutionalGridChanged = {
  readonly __typename?: 'SyndicateInstitutionalGridChanged';
  readonly changeType: SyndicateInstitutionalGridChangeType;
  readonly eventSource?: Maybe<Scalars['String']['output']>;
  readonly offeringId: Scalars['UUID']['output'];
};

/** A segment of a collection. */
export type SyndicateInstitutionalGridCollectionSegment = {
  readonly __typename?: 'SyndicateInstitutionalGridCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<SyndicateInstitutionalGridRow>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly summaries: SyndicateInstitutionalGridSummaries;
};

export type SyndicateInstitutionalGridRow = {
  readonly __typename?: 'SyndicateInstitutionalGridRow';
  /** A comma separated list of acknowledging managers' display names, sorted alphabetically, but with my firm's display name always first. */
  readonly acknowledgedByFirmNames?: Maybe<Scalars['String']['output']>;
  readonly acknowledgedByUser?: Maybe<UserInfo>;
  readonly acknowledgements?: Maybe<ReadonlyArray<IndicationAcknowledgement>>;
  readonly alert: RowAlert;
  readonly allocationAcknowledgedBy?: Maybe<UserInfo>;
  readonly allocations?: Maybe<ReadonlyArray<Allocation>>;
  readonly attestationStatus?: Maybe<AttestationFormStatus>;
  readonly auditInfo: AuditInformation;
  readonly bndAgent?: Maybe<FirmInfo>;
  readonly convertibleDemandLevels: ReadonlyArray<ConvertibleDemandLevel>;
  /** A comma separated list of covering managers' display names, sorted alphabetically, but with my firm's display name always first. */
  readonly coveringManagerNames?: Maybe<Scalars['String']['output']>;
  readonly coveringManagers?: Maybe<ReadonlyArray<FirmInfo>>;
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  readonly demandAtMarket: Scalars['Long']['output'];
  readonly demandAtMarketNotional: Scalars['Decimal']['output'];
  readonly demandCurrency?: Maybe<Scalars['String']['output']>;
  readonly demandLevels: ReadonlyArray<DemandLevel>;
  readonly demandMax: Scalars['Long']['output'];
  readonly demandMaxNotional: Scalars['Decimal']['output'];
  readonly duplicateOfIndicationId?: Maybe<Scalars['UUID']['output']>;
  readonly hasBndAgent: Scalars['Boolean']['output'];
  readonly hasDuplicates: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly instrumentId?: Maybe<Scalars['UUID']['output']>;
  readonly interestLevels?: Maybe<ReadonlyArray<InterestLevel>>;
  readonly investor: InvestorInfo;
  readonly investorEngagements?: Maybe<InvestorEngagements>;
  readonly investorReplyStatus: AllocationAcknowledgement;
  readonly myIndicationContacts?: Maybe<ReadonlyArray<Contact>>;
  /**
   * A comma separated list of indication contacts.
   * This can be used for display and sorting in the grid.
   */
  readonly myIndicationContactsDisplayValue?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<IndicationNotes>;
  readonly offeringId: Scalars['UUID']['output'];
  /** A list of primary sales users in the current firm who are covering the investor on this indication */
  readonly primarySalesCoverage?: Maybe<ReadonlyArray<InvestorCoveringEmployee>>;
  readonly prospectusDeliverySummary: ProspectusDeliverySummary;
  readonly qibStatus?: Maybe<AttestationFormStatus>;
  /** A list of secondary sales users in the current firm who are covering the investor on this indication */
  readonly secondarySalesCoverage?: Maybe<ReadonlyArray<InvestorCoveringEmployee>>;
  readonly status: IndicationStatus;
  readonly trancheId?: Maybe<Scalars['UUID']['output']>;
  readonly type: InstitutionalIndicationOrderType;
  /** Indication type display value. For 'Limit' type, it's formatted as "Limit @ $12.34". */
  readonly typeDisplayValue: Scalars['String']['output'];
};

export type SyndicateInstitutionalGridRowFilterInput = {
  /** A comma separated list of acknowledging managers' display names, sorted alphabetically, but with my firm's display name always first. */
  readonly acknowledgedByFirmNames?: InputMaybe<StringOperationFilterInput>;
  readonly acknowledgedByUser?: InputMaybe<UserInfoFilterInput>;
  readonly acknowledgements?: InputMaybe<ListFilterInputTypeOfIndicationAcknowledgementDtoFilterInput>;
  readonly alert?: InputMaybe<RowAlertFilterInput>;
  readonly allocationAcknowledgedBy?: InputMaybe<UserInfoFilterInput>;
  readonly allocations?: InputMaybe<ListAllocationFilterInput>;
  readonly and?: InputMaybe<ReadonlyArray<SyndicateInstitutionalGridRowFilterInput>>;
  readonly attestationStatus?: InputMaybe<NullableOfCertificateStatusOperationFilterInput>;
  readonly auditInfo?: InputMaybe<AuditInformationFilterInput>;
  readonly bndAgent?: InputMaybe<FirmInfoFilterInput>;
  readonly convertibleDemandLevels?: InputMaybe<ListFilterInputTypeOfConvertibleDemandLevelFilterInput>;
  /** A comma separated list of covering managers' display names, sorted alphabetically, but with my firm's display name always first. */
  readonly coveringManagerNames?: InputMaybe<StringOperationFilterInput>;
  readonly coveringManagers?: InputMaybe<ListFilterInputTypeOfFirmInfoFilterInput>;
  readonly currencyCode?: InputMaybe<StringOperationFilterInput>;
  readonly demandAtMarket?: InputMaybe<LongOperationFilterInput>;
  readonly demandAtMarketNotional?: InputMaybe<DecimalOperationFilterInput>;
  readonly demandCurrency?: InputMaybe<StringOperationFilterInput>;
  readonly demandLevels?: InputMaybe<ListFilterInputTypeOfDemandLevelFilterInput>;
  readonly demandMax?: InputMaybe<LongOperationFilterInput>;
  readonly demandMaxNotional?: InputMaybe<DecimalOperationFilterInput>;
  readonly duplicateOfIndicationId?: InputMaybe<UuidOperationFilterInput>;
  readonly hasBndAgent?: InputMaybe<BooleanOperationFilterInput>;
  readonly hasDuplicates?: InputMaybe<BooleanOperationFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly instrumentId?: InputMaybe<UuidOperationFilterInput>;
  readonly interestLevels?: InputMaybe<InterestLevelListFilterInput>;
  readonly investor?: InputMaybe<InvestorInfoFilterInput>;
  readonly investorEngagements?: InputMaybe<InvestorEngagementsFilterInput>;
  readonly investorReplyStatus?: InputMaybe<AllocationAcknowledgementOperationFilterInput>;
  readonly myIndicationContacts?: InputMaybe<ContactListFilterInput>;
  /**
   * A comma separated list of indication contacts.
   * This can be used for display and sorting in the grid.
   */
  readonly myIndicationContactsDisplayValue?: InputMaybe<StringOperationFilterInput>;
  readonly notes?: InputMaybe<IndicationNotesFilterInput>;
  readonly offeringId?: InputMaybe<UuidOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<SyndicateInstitutionalGridRowFilterInput>>;
  /** A list of primary sales users in the current firm who are covering the investor on this indication */
  readonly primarySalesCoverage?: InputMaybe<ListFilterInputTypeOfInvestorCoveringEmployeeFilterInput>;
  readonly prospectusDeliverySummary?: InputMaybe<ProspectusDeliverySummaryDtoFilterInput>;
  readonly qibStatus?: InputMaybe<NullableOfCertificateStatusOperationFilterInput>;
  /** A list of secondary sales users in the current firm who are covering the investor on this indication */
  readonly secondarySalesCoverage?: InputMaybe<ListFilterInputTypeOfInvestorCoveringEmployeeFilterInput>;
  readonly status?: InputMaybe<IndicationStatusFilterInput>;
  readonly trancheId?: InputMaybe<UuidOperationFilterInput>;
  readonly type?: InputMaybe<IndicationTypeOperationFilterInput>;
  /** Indication type display value. For 'Limit' type, it's formatted as "Limit @ $12.34". */
  readonly typeDisplayValue?: InputMaybe<StringOperationFilterInput>;
};

export type SyndicateInstitutionalGridRowSortInput = {
  /** A comma separated list of acknowledging managers' display names, sorted alphabetically, but with my firm's display name always first. */
  readonly acknowledgedByFirmNames?: InputMaybe<SortEnumType>;
  readonly acknowledgedByUser?: InputMaybe<UserInfoSortInput>;
  readonly alert?: InputMaybe<RowAlertSortInput>;
  readonly allocationAcknowledgedBy?: InputMaybe<UserInfoSortInput>;
  readonly allocations_1?: InputMaybe<AllocationDtoSortInput>;
  readonly allocations_2?: InputMaybe<AllocationDtoSortInput>;
  readonly allocations_3?: InputMaybe<AllocationDtoSortInput>;
  readonly attestationStatus?: InputMaybe<SortEnumType>;
  readonly auditInfo?: InputMaybe<AuditInformationSortInput>;
  readonly bndAgent?: InputMaybe<FirmInfoSortInput>;
  readonly convertibleDemandLevel_1?: InputMaybe<ConvertibleDemandLevelSortInput>;
  readonly convertibleDemandLevel_2?: InputMaybe<ConvertibleDemandLevelSortInput>;
  readonly convertibleDemandLevel_3?: InputMaybe<ConvertibleDemandLevelSortInput>;
  /** A comma separated list of covering managers' display names, sorted alphabetically, but with my firm's display name always first. */
  readonly coveringManagerNames?: InputMaybe<SortEnumType>;
  readonly currencyCode?: InputMaybe<SortEnumType>;
  readonly demandAtMarket?: InputMaybe<SortEnumType>;
  readonly demandAtMarketNotional?: InputMaybe<SortEnumType>;
  readonly demandCurrency?: InputMaybe<SortEnumType>;
  readonly demandLevelAtPrice_1?: InputMaybe<DemandLevelSortInput>;
  readonly demandLevelAtPrice_2?: InputMaybe<DemandLevelSortInput>;
  readonly demandLevelAtPrice_3?: InputMaybe<DemandLevelSortInput>;
  readonly demandMax?: InputMaybe<SortEnumType>;
  readonly demandMaxNotional?: InputMaybe<SortEnumType>;
  readonly duplicateOfIndicationId?: InputMaybe<SortEnumType>;
  readonly hasBndAgent?: InputMaybe<SortEnumType>;
  readonly hasDuplicates?: InputMaybe<SortEnumType>;
  readonly id?: InputMaybe<SortEnumType>;
  readonly instrumentId?: InputMaybe<SortEnumType>;
  readonly investor?: InputMaybe<InvestorInfoSortInput>;
  readonly investorEngagements?: InputMaybe<InvestorEngagementsSortInput>;
  readonly investorReplyStatus?: InputMaybe<SortEnumType>;
  /**
   * A comma separated list of indication contacts.
   * This can be used for display and sorting in the grid.
   */
  readonly myIndicationContactsDisplayValue?: InputMaybe<SortEnumType>;
  readonly notes?: InputMaybe<IndicationNotesSortInput>;
  readonly offeringId?: InputMaybe<SortEnumType>;
  readonly prospectusDeliverySummary?: InputMaybe<ProspectusDeliverySummaryDtoSortInput>;
  readonly qibStatus?: InputMaybe<SortEnumType>;
  readonly status?: InputMaybe<SortEnumType>;
  readonly trancheId?: InputMaybe<SortEnumType>;
  readonly type?: InputMaybe<SortEnumType>;
  /** Indication type display value. For 'Limit' type, it's formatted as "Limit @ $12.34". */
  readonly typeDisplayValue?: InputMaybe<SortEnumType>;
};

export type SyndicateInstitutionalGridSummaries = {
  readonly __typename?: 'SyndicateInstitutionalGridSummaries';
  readonly summaryMetrics: InstitutionalDemandSummaryMetrics;
  readonly totals: SyndicateGridTotalsRow;
};

export type SyndicateManager = {
  readonly __typename?: 'SyndicateManager';
  readonly managerResponsibilities: ManagerResponsibilities;
  readonly managers: ReadonlyArray<SyndicateManagerProfile>;
};

export type SyndicateManagerProfile = {
  readonly __typename?: 'SyndicateManagerProfile';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly firmName: Scalars['String']['output'];
  readonly firmNameAbbreviation?: Maybe<Scalars['String']['output']>;
  readonly isJuniorRole: Scalars['Boolean']['output'];
  readonly isParticipating: Scalars['Boolean']['output'];
  readonly role: ManagerRole;
};

export type SyndicateProfile = {
  readonly __typename?: 'SyndicateProfile';
  readonly managerResponsibilities: ManagerResponsibilitiesProfile;
  readonly managers: ReadonlyArray<ManagerProfile>;
};

export type SyndicateWires = {
  readonly __typename?: 'SyndicateWires';
  readonly billAndDeliverPayments: ReadonlyArray<BillingAndDeliveryPayment>;
  readonly brokerDealersMyRetail: ReadonlyArray<MyRetailForBrokerDealer>;
  readonly brokerDealersMyRetailFees: ReadonlyArray<BrokerDealerMyRetailFees>;
  readonly customVariables: ReadonlyArray<CustomVariableGroup>;
  readonly firmDistributionLists: ReadonlyArray<FirmDistributionList>;
  readonly id: Scalars['ID']['output'];
  readonly managerDtcNumbers: ReadonlyArray<ManagerDtcNumber>;
  readonly managerRetailRetentionFees: ReadonlyArray<ManagerRetailRetentionFees>;
  readonly managerRevisedUnderwritingCommitment: ReadonlyArray<ManagerRevisedUnderwritingCommitment>;
  readonly managers: ReadonlyArray<SyndicateWiresManager>;
  readonly masterAauDate?: Maybe<Scalars['Date']['output']>;
  readonly masterSdaDate?: Maybe<Scalars['Date']['output']>;
  readonly offeringId: Scalars['UUID']['output'];
  readonly publishedOrPrivateOffering: SyndicateWiresOffering;
  readonly wiresDisclaimer?: Maybe<Scalars['String']['output']>;
};

export type SyndicateWiresCustomVariablesArgs = {
  wireTemplateType: WireTemplateType;
};

export type SyndicateWiresFirmDistributionListsArgs = {
  cmgEntityKeys: ReadonlyArray<Scalars['String']['input']>;
};

export type SyndicateWiresWiresDisclaimerArgs = {
  offeringType: OfferingType;
  templateType: WireTemplateType;
};

export type SyndicateWiresManager = {
  readonly __typename?: 'SyndicateWiresManager';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly economics?: Maybe<Scalars['Long']['output']>;
  readonly firmName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly role: SyndicateWiresManagerRole;
};

export enum SyndicateWiresManagerRole {
  ActiveBookrunner = 'ACTIVE_BOOKRUNNER',
  Bookrunner = 'BOOKRUNNER',
  CoLead = 'CO_LEAD',
  CoManager = 'CO_MANAGER',
  FacilitationAgent = 'FACILITATION_AGENT',
  GlobalCoordinator = 'GLOBAL_COORDINATOR',
  SellingGroupMember = 'SELLING_GROUP_MEMBER',
  Underwriter = 'UNDERWRITER',
}

export type SyndicateWiresOffering = {
  readonly __typename?: 'SyndicateWiresOffering';
  readonly id: Scalars['ID']['output'];
  readonly stage: OfferingStage;
};

export type TnFiling = {
  readonly __typename?: 'TNFiling';
  readonly activities: ReadonlyArray<TnFilingActivity>;
  readonly adtvNumber?: Maybe<Scalars['Float']['output']>;
  readonly adtvSource?: Maybe<Scalars['String']['output']>;
  readonly atmTrades: ReadonlyArray<TnFilingAtmTrade>;
  readonly basisCode?: Maybe<TnBasisCodeType>;
  /** Display name for BasisCode */
  readonly basisCodeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly contactName: Scalars['String']['output'];
  readonly contactTitle: Scalars['String']['output'];
  readonly emailAddress: Scalars['String']['output'];
  readonly filingCreatorEmail?: Maybe<Scalars['String']['output']>;
  readonly finraErrorMessages: ReadonlyArray<Scalars['String']['output']>;
  readonly finraMemberFirms: ReadonlyArray<TnFilingMemberFirm>;
  readonly firmCrdNumber: Scalars['String']['output'];
  readonly firmDealId: Scalars['String']['output'];
  readonly firmMpid: Scalars['String']['output'];
  readonly firmName: Scalars['String']['output'];
  readonly formUniqueId: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isConcurrentConvertible: Scalars['Boolean']['output'];
  readonly issuerName: Scalars['String']['output'];
  readonly issuerSymbol: Scalars['String']['output'];
  readonly nonAtmTradeInfo?: Maybe<TnFilingNonAtmTrade>;
  readonly nonMemberFirms: ReadonlyArray<TnFilingNonMemberFirm>;
  readonly otherBasisDescription?: Maybe<Scalars['String']['output']>;
  readonly pricingBasisDescription?: Maybe<Scalars['String']['output']>;
  readonly pricingBasisType: PricingBasisType;
  /** Display name for PricingBasisType */
  readonly pricingBasisTypeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly publicFloatValue?: Maybe<Scalars['Float']['output']>;
  readonly publicFloatValueSource?: Maybe<Scalars['String']['output']>;
  readonly restrictedPeriod: TnRestrictedPeriodType;
  /** Display name for RestrictedPeriod */
  readonly restrictedPeriodDisplayName?: Maybe<Scalars['String']['output']>;
  readonly restrictedPeriodEndDateTime?: Maybe<Scalars['Instant']['output']>;
  readonly restrictedPeriodEndTimezone?: Maybe<Scalars['DateTimeZone']['output']>;
  readonly restrictedPeriodStartDateTime?: Maybe<Scalars['Instant']['output']>;
  readonly restrictedPeriodStartTimezone?: Maybe<Scalars['DateTimeZone']['output']>;
  readonly securityType: TnSecurityType;
  readonly securityTypeDescription?: Maybe<Scalars['String']['output']>;
  /** Display name for SecurityType */
  readonly securityTypeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly stabilizationActivities: ReadonlyArray<StabilizationTnFilingActivity>;
  readonly status: FilingStatus;
  readonly submittedDateTime: Scalars['Instant']['output'];
  readonly symbolsOfCoveredSecurities: ReadonlyArray<Scalars['String']['output']>;
  readonly telephoneNumber: Scalars['String']['output'];
  readonly transactionType: TransactionType;
  readonly transactionTypeDescription?: Maybe<Scalars['String']['output']>;
  /** Display name for TransactionType */
  readonly transactionTypeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly uarDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type TnFilingActivity = {
  readonly __typename?: 'TNFilingActivity';
  readonly activityType: ActivityType;
  /** Display name for ActivityType */
  readonly activityTypeDisplayName?: Maybe<Scalars['String']['output']>;
  readonly aggregateNumberOfShares?: Maybe<Scalars['Long']['output']>;
  readonly date: Scalars['LocalDate']['output'];
};

export type TnFilingActivityInput = {
  readonly activityType: ActivityType;
  readonly aggregateNumberOfShares?: InputMaybe<Scalars['Long']['input']>;
  readonly date: Scalars['LocalDate']['input'];
};

export type TnFilingAtmTrade = {
  readonly __typename?: 'TNFilingAtmTrade';
  readonly averagePrice: Scalars['Decimal']['output'];
  readonly currency: TradeCurrencyType;
  readonly numberOfShares: Scalars['Long']['output'];
  readonly tradeDate: Scalars['LocalDate']['output'];
};

export type TnFilingAtmTradeInput = {
  readonly averagePrice: Scalars['Decimal']['input'];
  readonly currency: TradeCurrencyType;
  readonly numberOfShares: Scalars['Long']['input'];
  readonly tradeDate: Scalars['LocalDate']['input'];
};

export type TnFilingFormDataInput = {
  readonly activities: ReadonlyArray<TnFilingActivityInput>;
  readonly adtvNumber?: InputMaybe<Scalars['Float']['input']>;
  readonly adtvSource?: InputMaybe<Scalars['String']['input']>;
  readonly atmTrades: ReadonlyArray<TnFilingAtmTradeInput>;
  readonly basisCode?: InputMaybe<TnBasisCodeType>;
  readonly contactName: Scalars['String']['input'];
  readonly contactTitle: Scalars['String']['input'];
  readonly emailAddress: Scalars['String']['input'];
  readonly firmCrdNumber: Scalars['String']['input'];
  readonly firmMpid: Scalars['String']['input'];
  readonly firmName: Scalars['String']['input'];
  readonly isConcurrentConvertible: Scalars['Boolean']['input'];
  readonly issuerSymbol: Scalars['String']['input'];
  readonly memberFirms: ReadonlyArray<TnFilingMemberFirmInput>;
  readonly nonAtmTradeInfo?: InputMaybe<TnFilingNonAtmTradeInput>;
  readonly nonMemberFirms: ReadonlyArray<TnFilingNonMemberFirmInput>;
  readonly otherBasisDescription?: InputMaybe<Scalars['String']['input']>;
  readonly pricingBasisDescription?: InputMaybe<Scalars['String']['input']>;
  readonly pricingBasisType: PricingBasisType;
  readonly publicFloatValue?: InputMaybe<Scalars['Float']['input']>;
  readonly publicFloatValueSource?: InputMaybe<Scalars['String']['input']>;
  readonly restrictedPeriod: TnRestrictedPeriodType;
  readonly restrictedPeriodEndDateTime?: InputMaybe<Scalars['Instant']['input']>;
  readonly restrictedPeriodEndTimezone?: InputMaybe<Scalars['DateTimeZone']['input']>;
  readonly restrictedPeriodStartDateTime?: InputMaybe<Scalars['Instant']['input']>;
  readonly restrictedPeriodStartTimezone?: InputMaybe<Scalars['DateTimeZone']['input']>;
  readonly securityType: TnSecurityType;
  readonly securityTypeDescription?: InputMaybe<Scalars['String']['input']>;
  readonly stabilizationActivities: ReadonlyArray<StabilizationTnFilingActivityInput>;
  readonly symbolsOfCoveredSecurities: ReadonlyArray<Scalars['String']['input']>;
  readonly telephoneNumber: Scalars['String']['input'];
  readonly transactionType: TransactionType;
  readonly transactionTypeDescription?: InputMaybe<Scalars['String']['input']>;
  readonly uarDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type TnFilingMemberFirm = {
  readonly __typename?: 'TNFilingMemberFirm';
  readonly affiliateMemberId?: Maybe<Scalars['UUID']['output']>;
  readonly cmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly firmCrdNumber: Scalars['String']['output'];
  readonly firmMpid?: Maybe<Scalars['String']['output']>;
  readonly firmName: Scalars['String']['output'];
  readonly ownerCmgEntityKey?: Maybe<Scalars['String']['output']>;
};

export type TnFilingMemberFirmInput = {
  readonly affiliateMemberId?: InputMaybe<Scalars['UUID']['input']>;
  readonly cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  readonly firmCrdNumber: Scalars['String']['input'];
  readonly firmMpid?: InputMaybe<Scalars['String']['input']>;
  readonly firmName: Scalars['String']['input'];
};

export type TnFilingNonAtmTrade = {
  readonly __typename?: 'TNFilingNonAtmTrade';
  readonly currency: TradeCurrencyType;
  readonly lastSaleBeforeDistributionCurrency?: Maybe<TradeCurrencyType>;
  readonly lastSaleBeforeDistributionDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly lastSaleBeforeDistributionPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly numberOfShares: Scalars['Long']['output'];
  readonly offeringPrice: Scalars['Decimal']['output'];
  readonly pricingDate: Scalars['LocalDate']['output'];
  readonly secEffectiveDateTime?: Maybe<Scalars['Instant']['output']>;
  readonly secEffectiveTimezone?: Maybe<Scalars['DateTimeZone']['output']>;
  readonly tradeDate: Scalars['LocalDate']['output'];
};

export type TnFilingNonAtmTradeInput = {
  readonly currency: TradeCurrencyType;
  readonly lastSaleBeforeDistributionCurrency?: InputMaybe<TradeCurrencyType>;
  readonly lastSaleBeforeDistributionDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly lastSaleBeforeDistributionPrice?: InputMaybe<Scalars['Decimal']['input']>;
  readonly numberOfShares: Scalars['Long']['input'];
  readonly offeringPrice: Scalars['Decimal']['input'];
  readonly pricingDate: Scalars['LocalDate']['input'];
  readonly secEffectiveDateTime?: InputMaybe<Scalars['Instant']['input']>;
  readonly secEffectiveTimezone?: InputMaybe<Scalars['DateTimeZone']['input']>;
  readonly tradeDate: Scalars['LocalDate']['input'];
};

export type TnFilingNonMemberFirm = {
  readonly __typename?: 'TNFilingNonMemberFirm';
  /** CmgEntityKey of the firm, not null when non member firm is a manager on the offering */
  readonly cmgEntityKey?: Maybe<Scalars['String']['output']>;
  readonly firmName: Scalars['String']['output'];
  /** CmgEntityKey of the manager this non-owner firm is affiliated with */
  readonly ownerCmgEntityKey?: Maybe<Scalars['String']['output']>;
};

export type TnFilingNonMemberFirmInput = {
  /** CmgEntityKey of the firm, not null when non member firm is a manager on the offering */
  readonly cmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  readonly firmName: Scalars['String']['input'];
  /** CmgEntityKey of the manager this non-owner firm is affiliated with */
  readonly ownerCmgEntityKey?: InputMaybe<Scalars['String']['input']>;
};

export type TenantDetails = {
  readonly __typename?: 'TenantDetails';
  readonly subdomain: Scalars['String']['output'];
  readonly tenantId: Scalars['UUID']['output'];
};

export type TerminationDate = {
  readonly __typename?: 'TerminationDate';
  readonly dateTime: Scalars['Instant']['output'];
  readonly timeZone: Scalars['DateTimeZone']['output'];
};

export type TerminationWire = {
  readonly __typename?: 'TerminationWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly terminationDate: TerminationDate;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type TerminationWireResponseUnion = ServiceError | TerminationWire;

export type TerminationWireValidation = WireValidationBase & {
  readonly __typename?: 'TerminationWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<TerminationWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum TerminationWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  IssuerName = 'ISSUER_NAME',
  OfferingType = 'OFFERING_TYPE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  TotalSharesBaseOffering = 'TOTAL_SHARES_BASE_OFFERING',
}

export type Terms = {
  readonly __typename?: 'Terms';
  readonly callDates?: Maybe<ReadonlyArray<Scalars['LocalDate']['output']>>;
  readonly callable?: Maybe<Scalars['Boolean']['output']>;
  readonly changeOfControl?: Maybe<FlagWithNotes>;
  readonly contingentConversion?: Maybe<FlagWithNotes>;
  readonly contingentPayment?: Maybe<FlagWithNotes>;
  readonly couponFrequency?: Maybe<Scalars['String']['output']>;
  readonly dividendProtection?: Maybe<FlagWithNotes>;
  /** An ordered collections of filings beginning with INITIAL -> REVISED -> FINAL */
  readonly filings: ReadonlyArray<Filing>;
  readonly followOnPricing?: Maybe<FollowOnPricing>;
  readonly hedging?: Maybe<FlagWithNotes>;
  readonly lockUpPeriod?: Maybe<Scalars['Int']['output']>;
  readonly maturityDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly moodyRating?: Maybe<MoodyRating>;
  readonly overAllotmentExercisedData?: Maybe<OverAllotmentExercisedData>;
  readonly perpetual?: Maybe<FlagWithNotes>;
  readonly provisionCall?: Maybe<FlagWithNotes>;
  readonly puttable?: Maybe<FlagWithNotes>;
  readonly spRating?: Maybe<SpRating>;
  readonly tenor?: Maybe<Scalars['Int']['output']>;
  readonly underwritingFeesAndDiscounts?: Maybe<UnderwritingFeesAndDiscounts>;
  readonly useOfProceeds: ReadonlyArray<UseOfProceeds>;
};

export type TermsFull = {
  readonly __typename?: 'TermsFull';
  readonly callDates?: Maybe<ReadonlyArray<Scalars['LocalDate']['output']>>;
  readonly callable?: Maybe<Scalars['Boolean']['output']>;
  readonly changeOfControl?: Maybe<FlagWithNotesFull>;
  readonly contingentConversion?: Maybe<FlagWithNotesFull>;
  readonly contingentPayment?: Maybe<FlagWithNotesFull>;
  readonly couponFrequency?: Maybe<Scalars['String']['output']>;
  readonly dividendProtection?: Maybe<FlagWithNotesFull>;
  /** An ordered collections of filings beginning with INITIAL -> REVISED -> FINAL */
  readonly filings: ReadonlyArray<FilingFull>;
  readonly followOnPricing?: Maybe<FollowOnPricingFull>;
  readonly hedging?: Maybe<FlagWithNotesFull>;
  readonly lockUpPeriod?: Maybe<Scalars['Int']['output']>;
  readonly maturityDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly moodyRating?: Maybe<MoodyRating>;
  readonly overAllotmentExercisedData?: Maybe<OverAllotmentExercisedFull>;
  readonly perpetual?: Maybe<FlagWithNotesFull>;
  readonly privatePlacementTerms?: Maybe<PrivatePlacementTermsFull>;
  readonly provisionCall?: Maybe<FlagWithNotesFull>;
  readonly puttable?: Maybe<FlagWithNotesFull>;
  readonly spRating?: Maybe<SpRating>;
  readonly tenor?: Maybe<Scalars['Int']['output']>;
  readonly underwritingFeesAndDiscounts?: Maybe<UnderwritingFeesAndDiscountsFull>;
  readonly useOfProceeds?: Maybe<ReadonlyArray<UseOfProceeds>>;
};

export type TermsFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<TermsFullFilterInput>>;
  readonly callDates?: InputMaybe<ListCustomOperationFilterInputTypeOfLocalDateTypeFilterInput>;
  readonly callable?: InputMaybe<BooleanOperationFilterInput>;
  readonly changeOfControl?: InputMaybe<FlagWithNotesFullFilterInput>;
  readonly contingentConversion?: InputMaybe<FlagWithNotesFullFilterInput>;
  readonly contingentPayment?: InputMaybe<FlagWithNotesFullFilterInput>;
  readonly couponFrequency?: InputMaybe<StringOperationFilterInput>;
  readonly dividendProtection?: InputMaybe<FlagWithNotesFullFilterInput>;
  /** An ordered collections of filings beginning with INITIAL -> REVISED -> FINAL */
  readonly filings?: InputMaybe<ListFilterInputTypeOfFilingFullFilterInput>;
  readonly followOnPricing?: InputMaybe<FollowOnPricingFullFilterInput>;
  readonly hedging?: InputMaybe<FlagWithNotesFullFilterInput>;
  readonly lockUpPeriod?: InputMaybe<IntOperationFilterInput>;
  readonly maturityDate?: InputMaybe<LocalDateOperationFilterInput>;
  readonly moodyRating?: InputMaybe<MoodyRatingFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<TermsFullFilterInput>>;
  readonly overAllotmentExercisedData?: InputMaybe<OverAllotmentExercisedFullFilterInput>;
  readonly perpetual?: InputMaybe<FlagWithNotesFullFilterInput>;
  readonly privatePlacementTerms?: InputMaybe<PrivatePlacementTermsFullFilterInput>;
  readonly provisionCall?: InputMaybe<FlagWithNotesFullFilterInput>;
  readonly puttable?: InputMaybe<FlagWithNotesFullFilterInput>;
  readonly spRating?: InputMaybe<SpRatingFilterInput>;
  readonly tenor?: InputMaybe<IntOperationFilterInput>;
  readonly underwritingFeesAndDiscounts?: InputMaybe<UnderwritingFeesAndDiscountsFullFilterInput>;
  readonly useOfProceeds?: InputMaybe<UseOfProceedsListFilterInput>;
};

export type TermsProfile = {
  readonly __typename?: 'TermsProfile';
  readonly callDates?: Maybe<ReadonlyArray<Scalars['LocalDate']['output']>>;
  readonly callable?: Maybe<Scalars['Boolean']['output']>;
  readonly changeOfControl?: Maybe<FlagWithNotes>;
  readonly contingentConversion?: Maybe<FlagWithNotes>;
  readonly contingentPayment?: Maybe<FlagWithNotes>;
  readonly couponFrequency?: Maybe<Scalars['String']['output']>;
  readonly dividendProtection?: Maybe<FlagWithNotes>;
  /** An ordered collections of filings beginning with INITIAL -> REVISED -> FINAL */
  readonly filings: ReadonlyArray<FilingProfile>;
  readonly followOnPricing?: Maybe<FollowOnPricingProfile>;
  readonly hedging?: Maybe<FlagWithNotes>;
  readonly lockUpPeriod?: Maybe<Scalars['Int']['output']>;
  readonly maturityDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly moodyRating?: Maybe<MoodyRating>;
  readonly overAllotmentExercisedData?: Maybe<OverAllotmentExercisedData>;
  readonly perpetual?: Maybe<FlagWithNotes>;
  readonly provisionCall?: Maybe<FlagWithNotes>;
  readonly puttable?: Maybe<FlagWithNotes>;
  readonly spRating?: Maybe<SpRating>;
  readonly tenor?: Maybe<Scalars['Int']['output']>;
  readonly useOfProceeds: ReadonlyArray<UseOfProceeds>;
};

export type Timing = {
  readonly __typename?: 'Timing';
  readonly bookCloseDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly bookCloseTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly bookOpenDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly bookOpenTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly confidentialFilingDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly filingOccurred?: Maybe<MarketTiming>;
  readonly firstTradeDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly launchDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly launchOccurred?: Maybe<MarketTiming>;
  readonly postponedDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly pricingDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly publicFilingDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly settlementDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly terminatedDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly timeZone?: Maybe<Scalars['DateTimeZone']['output']>;
  readonly tradeDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly withdrawnDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type TimingFull = {
  readonly __typename?: 'TimingFull';
  readonly bookCloseDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly bookCloseTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly bookOpenDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly bookOpenTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly confidentialFilingDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly filingOccurred?: Maybe<MarketTiming>;
  readonly firstTradeDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly launchDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly launchOccurred?: Maybe<MarketTiming>;
  readonly postponedDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly pricingDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly publicFilingDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly settlementDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly terminatedDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly timeZone?: Maybe<Scalars['DateTimeZone']['output']>;
  readonly tradeDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly withdrawnDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type TimingFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<TimingFullFilterInput>>;
  readonly bookCloseDate?: InputMaybe<LocalDateOperationFilterInput>;
  readonly bookCloseTime?: InputMaybe<LocalTimeOperationFilterInput>;
  readonly bookOpenDate?: InputMaybe<LocalDateOperationFilterInput>;
  readonly bookOpenTime?: InputMaybe<LocalTimeOperationFilterInput>;
  readonly confidentialFilingDate?: InputMaybe<LocalDateOperationFilterInput>;
  readonly filingOccurred?: InputMaybe<MarketTimingFilterInput>;
  readonly firstTradeDate?: InputMaybe<LocalDateOperationFilterInput>;
  readonly launchDate?: InputMaybe<LocalDateOperationFilterInput>;
  readonly launchOccurred?: InputMaybe<MarketTimingFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<TimingFullFilterInput>>;
  readonly postponedDate?: InputMaybe<LocalDateOperationFilterInput>;
  readonly pricingDate?: InputMaybe<LocalDateOperationFilterInput>;
  readonly publicFilingDate?: InputMaybe<LocalDateOperationFilterInput>;
  readonly settlementDate?: InputMaybe<LocalDateOperationFilterInput>;
  readonly terminatedDate?: InputMaybe<LocalDateOperationFilterInput>;
  readonly timeZone?: InputMaybe<DateTimeZoneOperationFilterInput>;
  readonly tradeDate?: InputMaybe<LocalDateOperationFilterInput>;
  readonly withdrawnDate?: InputMaybe<LocalDateOperationFilterInput>;
};

export type TimingProfile = {
  readonly __typename?: 'TimingProfile';
  readonly bookCloseDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly bookCloseTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly bookOpenDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly bookOpenTime?: Maybe<Scalars['LocalTime']['output']>;
  readonly confidentialFilingDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly filingOccurred?: Maybe<MarketTiming>;
  readonly firstTradeDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly launchDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly launchOccurred?: Maybe<MarketTiming>;
  readonly pricingDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly publicFilingDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly settlementDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly terminatedDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly timeZone?: Maybe<Scalars['DateTimeZone']['output']>;
  readonly tradeDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly withdrawnDate?: Maybe<Scalars['LocalDate']['output']>;
};

export enum TnBasisCodeType {
  AdtvPfv = 'ADTV_PFV',
  Other = 'OTHER',
  Uar = 'UAR',
}

export enum TnRestrictedPeriodType {
  FiveDays = 'FIVE_DAYS',
  Na = 'NA',
  OneDay = 'ONE_DAY',
}

export enum TnSecurityType {
  Cnvrb = 'CNVRB',
  Eqty = 'EQTY',
  Other = 'OTHER',
  Prfrd = 'PRFRD',
  Wrrnt = 'WRRNT',
}

export type TotalRetailInfo = {
  readonly __typename?: 'TotalRetailInfo';
  readonly id: Scalars['ID']['output'];
  readonly releasedRetailRetention?: Maybe<TotalRetentionInfo>;
  readonly submittedRetailDemand?: Maybe<TotalSubmittedRetailDemandInfo>;
};

export type TotalRetailSummaryGrid = {
  readonly __typename?: 'TotalRetailSummaryGrid';
  readonly id: Scalars['ID']['output'];
  readonly items: ReadonlyArray<TotalRetailSummaryItem>;
  readonly retailTarget?: Maybe<Scalars['Long']['output']>;
};

export type TotalRetailSummaryItem = {
  readonly __typename?: 'TotalRetailSummaryItem';
  readonly demand: TotalRetailSummaryItemDemand;
  readonly id: Scalars['ID']['output'];
  readonly manager: TotalRetailSummaryItemManager;
  readonly retention: TotalRetailSummaryItemRetention;
};

export type TotalRetailSummaryItemDemand = {
  readonly __typename?: 'TotalRetailSummaryItemDemand';
  readonly id: Scalars['ID']['output'];
  readonly isSubmitted: Scalars['Boolean']['output'];
  readonly modifiedAt?: Maybe<Scalars['String']['output']>;
  readonly modifiedByFirmKey?: Maybe<Scalars['String']['output']>;
  readonly notionalQuantity?: Maybe<Scalars['Decimal']['output']>;
  readonly roundLots?: Maybe<Scalars['Int']['output']>;
  readonly shareQuantity?: Maybe<Scalars['Long']['output']>;
};

export type TotalRetailSummaryItemManager = {
  readonly __typename?: 'TotalRetailSummaryItemManager';
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isOnPlatform: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly role: OrderBookManagerRole;
  /** Display name for Role */
  readonly roleDisplayName?: Maybe<Scalars['String']['output']>;
};

export type TotalRetailSummaryItemRetention = {
  readonly __typename?: 'TotalRetailSummaryItemRetention';
  readonly id: Scalars['ID']['output'];
  readonly isReleased: Scalars['Boolean']['output'];
  readonly modifiedAt?: Maybe<Scalars['String']['output']>;
  readonly modifiedByFirmKey?: Maybe<Scalars['String']['output']>;
  readonly shareQuantity?: Maybe<Scalars['Long']['output']>;
};

export type TotalRetentionInfo = {
  readonly __typename?: 'TotalRetentionInfo';
  readonly id: Scalars['ID']['output'];
  readonly releasedDateTime: Scalars['Instant']['output'];
  readonly shareQuantity: Scalars['Long']['output'];
};

export type TotalSubmittedRetailDemandInfo = {
  readonly __typename?: 'TotalSubmittedRetailDemandInfo';
  readonly id: Scalars['ID']['output'];
  readonly notionalQuantity: Scalars['Decimal']['output'];
  readonly shareQuantity: Scalars['Long']['output'];
  readonly submittedDateTime: Scalars['Instant']['output'];
};

export enum TradeAction {
  Cancelled = 'CANCELLED',
  New = 'NEW',
}

export enum TradeActivityType {
  NotRule_104Reportable = 'NOT_RULE_104_REPORTABLE',
  StabilizingBid = 'STABILIZING_BID',
  SyndicateCovering = 'SYNDICATE_COVERING',
}

export enum TradeCurrencyType {
  Cad = 'CAD',
  Usd = 'USD',
}

export type TradeGridItem = {
  readonly __typename?: 'TradeGridItem';
  readonly allocationShares?: Maybe<Scalars['Long']['output']>;
  readonly allowedStatusTransitions: ReadonlyArray<TradeReleaseGridStatusTransition>;
  readonly cusip?: Maybe<Scalars['String']['output']>;
  readonly exchange?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly indicationAcknowledgedByEmail?: Maybe<Scalars['String']['output']>;
  readonly indicationAcknowledgedByName?: Maybe<Scalars['String']['output']>;
  readonly indicationId: Scalars['UUID']['output'];
  readonly indicationInvestorContactEmail?: Maybe<Scalars['String']['output']>;
  readonly indicationInvestorContactName?: Maybe<Scalars['String']['output']>;
  readonly indicationStatus: IndicationStatus;
  readonly indicationSubmittedBy: Scalars['String']['output'];
  readonly investorBankKey?: Maybe<Scalars['String']['output']>;
  readonly investorCmgEntityKey: Scalars['String']['output'];
  readonly investorContactEmail?: Maybe<Scalars['String']['output']>;
  readonly investorContactName?: Maybe<Scalars['String']['output']>;
  readonly investorFirmName: Scalars['String']['output'];
  readonly investorReplyEmail?: Maybe<Scalars['String']['output']>;
  readonly investorReplyName?: Maybe<Scalars['String']['output']>;
  readonly investorReplyStatus?: Maybe<InvestorReplyStatus>;
  readonly isin?: Maybe<Scalars['String']['output']>;
  readonly offeringCurrency: Scalars['String']['output'];
  readonly offeringIssuerName: Scalars['String']['output'];
  readonly offeringType: OfferingType;
  readonly parValue?: Maybe<Scalars['Decimal']['output']>;
  readonly priceAsOfPar?: Maybe<Scalars['Decimal']['output']>;
  readonly releasedAt?: Maybe<Scalars['Instant']['output']>;
  readonly releasedByEmail?: Maybe<Scalars['String']['output']>;
  readonly releasedByName?: Maybe<Scalars['String']['output']>;
  readonly securityType: OfferingSecurityType;
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly settlementCurrency: Scalars['String']['output'];
  readonly settlementDate: Scalars['LocalDate']['output'];
  readonly sharesReleased?: Maybe<Scalars['Long']['output']>;
  readonly status: TradeReleaseStatus;
  readonly statusDetails?: Maybe<Scalars['String']['output']>;
  readonly symbol?: Maybe<Scalars['String']['output']>;
  readonly tradeAction?: Maybe<TradeAction>;
  readonly tradeDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly tradeId?: Maybe<Scalars['UUID']['output']>;
  readonly tradePrice: Scalars['Decimal']['output'];
  readonly warnings: ReadonlyArray<TradeReleaseGridWarning>;
};

export enum TradeReleaseGridStatusTransition {
  BookedManual = 'BOOKED_MANUAL',
  CancelledManual = 'CANCELLED_MANUAL',
  CancelPending = 'CANCEL_PENDING',
  Released = 'RELEASED',
}

export enum TradeReleaseGridWarning {
  AllocationResponseChanged = 'ALLOCATION_RESPONSE_CHANGED',
  IndicationCancelled = 'INDICATION_CANCELLED',
  IndicationDuplicated = 'INDICATION_DUPLICATED',
  IndicationPassed = 'INDICATION_PASSED',
  QuantityToReleaseChanged = 'QUANTITY_TO_RELEASE_CHANGED',
  QuantityToReleaseChangedToZero = 'QUANTITY_TO_RELEASE_CHANGED_TO_ZERO',
  RereleaseRequired = 'RERELEASE_REQUIRED',
  TradeDetailsChanged = 'TRADE_DETAILS_CHANGED',
  TradeReassigned = 'TRADE_REASSIGNED',
  UnassignedBndAgent = 'UNASSIGNED_BND_AGENT',
}

export type TradeReleaseSettings = {
  readonly __typename?: 'TradeReleaseSettings';
  readonly id: Scalars['ID']['output'];
  readonly isAutoreleaseEnabled: Scalars['Boolean']['output'];
};

export enum TradeReleaseStatus {
  Booked = 'BOOKED',
  BookedManual = 'BOOKED_MANUAL',
  Cancelled = 'CANCELLED',
  CancelledManual = 'CANCELLED_MANUAL',
  CancelPending = 'CANCEL_PENDING',
  PartiallyBooked = 'PARTIALLY_BOOKED',
  Released = 'RELEASED',
  ReleaseFailed = 'RELEASE_FAILED',
  Unreleased = 'UNRELEASED',
}

export type TradeReleaseValidation = {
  readonly __typename?: 'TradeReleaseValidation';
  readonly id: Scalars['ID']['output'];
  /** Whether or not Allocations have been released. */
  readonly isInstitutionalAllocationSetReleased: Scalars['Boolean']['output'];
};

export enum TradeType {
  Buy = 'BUY',
  Sell = 'SELL',
}

export type Tranche = {
  readonly __typename?: 'Tranche';
  /** Returns the list of Demand Currencies for a Tranche */
  readonly currencies: ReadonlyArray<DemandCurrency>;
  readonly currencyIds: ReadonlyArray<Scalars['String']['output']>;
  readonly defaultInstrumentId?: Maybe<Scalars['UUID']['output']>;
  readonly deliveryInstrumentIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Returns the list of Delivery Instruments for a Tranche */
  readonly deliveryInstruments: ReadonlyArray<DeliveryInstrument>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly recordStatus: RecordStatus;
  readonly region?: Maybe<Scalars['String']['output']>;
};

export type TrancheCurrenciesArgs = {
  filters?: InputMaybe<RecordStatusFilterInput>;
};

export type TrancheDeliveryInstrumentsArgs = {
  filters?: InputMaybe<RecordStatusFilterInput>;
};

export type TrancheFull = {
  readonly __typename?: 'TrancheFull';
  readonly defaultInstrumentId?: Maybe<Scalars['UUID']['output']>;
  readonly demandCurrencies: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly instruments: ReadonlyArray<Scalars['UUID']['output']>;
  readonly name: Scalars['String']['output'];
  readonly region?: Maybe<Scalars['String']['output']>;
};

export type TrancheFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<TrancheFullFilterInput>>;
  readonly defaultInstrumentId?: InputMaybe<UuidOperationFilterInput>;
  readonly demandCurrencies?: InputMaybe<ListStringOperationFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly instruments?: InputMaybe<ListUuidOperationFilterInput>;
  readonly name?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<TrancheFullFilterInput>>;
  readonly region?: InputMaybe<StringOperationFilterInput>;
};

export type TranchePrivileged = {
  readonly __typename?: 'TranchePrivileged';
  readonly defaultInstrumentId?: Maybe<Scalars['UUID']['output']>;
  readonly deliveryInstrumentIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Returns the list of Delivery Instruments for a Privileged Tranche */
  readonly deliveryInstruments: ReadonlyArray<DeliveryInstrumentPrivileged>;
  readonly demandCurrencies: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly region?: Maybe<Scalars['String']['output']>;
};

export type Transaction = {
  readonly __typename?: 'Transaction';
  readonly counterPartyFirmCrdNumber?: Maybe<Scalars['String']['output']>;
  readonly counterPartyFirmName?: Maybe<Scalars['String']['output']>;
  readonly executionDatetime: Scalars['Instant']['output'];
  readonly executionPrice: Scalars['Decimal']['output'];
  readonly executionPriceCurrency: TradeCurrencyType;
  readonly executionTimezone: Scalars['DateTimeZone']['output'];
  readonly indicator: BuySellType;
  readonly shares: Scalars['Long']['output'];
};

export type TransactionInput = {
  readonly counterPartyFirmCrdNumber?: InputMaybe<Scalars['String']['input']>;
  readonly counterPartyFirmName?: InputMaybe<Scalars['String']['input']>;
  readonly executionDatetime: Scalars['Instant']['input'];
  readonly executionPrice: Scalars['Decimal']['input'];
  readonly executionPriceCurrency: TradeCurrencyType;
  readonly executionTimezone: Scalars['DateTimeZone']['input'];
  readonly indicator: BuySellType;
  readonly shares: Scalars['Long']['input'];
};

export enum TransactionType {
  Acqsn = 'ACQSN',
  Atm = 'ATM',
  Bgtdl = 'BGTDL',
  Block = 'BLOCK',
  Bnkcv = 'BNKCV',
  Bstef = 'BSTEF',
  Cnvdt = 'CNVDT',
  Cnveq = 'CNVEQ',
  Excof = 'EXCOF',
  Flwon = 'FLWON',
  Ipo = 'IPO',
  Mergr = 'MERGR',
  Ncvdt = 'NCVDT',
  Ncvpr = 'NCVPR',
  Other = 'OTHER',
  Pipe = 'PIPE',
  Regd = 'REGD',
  Rgstd = 'RGSTD',
  Rgtof = 'RGTOF',
}

export type UsdtnFiling = {
  readonly __typename?: 'USDTNFiling';
  readonly contactName: Scalars['String']['output'];
  readonly contactTitle: Scalars['String']['output'];
  readonly emailAddress: Scalars['String']['output'];
  readonly filingCreatorEmail?: Maybe<Scalars['String']['output']>;
  readonly finraErrorMessages: ReadonlyArray<Scalars['String']['output']>;
  readonly firmCrdNumber: Scalars['String']['output'];
  readonly firmDealId: Scalars['String']['output'];
  readonly firmMpid: Scalars['String']['output'];
  readonly firmName: Scalars['String']['output'];
  readonly formUniqueId: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly issuerName: Scalars['String']['output'];
  readonly issuerSymbol: Scalars['String']['output'];
  readonly status: FilingStatus;
  readonly submittedDateTime: Scalars['Instant']['output'];
  readonly telephoneNumber: Scalars['String']['output'];
  readonly transactions: ReadonlyArray<Transaction>;
};

export type UsdtnFilingFormDataInput = {
  readonly contactName: Scalars['String']['input'];
  readonly contactTitle: Scalars['String']['input'];
  readonly emailAddress: Scalars['String']['input'];
  readonly firmCrdNumber: Scalars['String']['input'];
  readonly firmMpid: Scalars['String']['input'];
  readonly firmName: Scalars['String']['input'];
  readonly issuerSymbol: Scalars['String']['input'];
  readonly telephoneNumber: Scalars['String']['input'];
  readonly transactions: ReadonlyArray<TransactionInput>;
};

export type UnacknowledgeInstitutionalIndicationResult = {
  readonly __typename?: 'UnacknowledgeInstitutionalIndicationResult';
  readonly indicationId: Scalars['String']['output'];
};

export type UnderwriterEmployee = {
  readonly __typename?: 'UnderwriterEmployee';
  readonly address1?: Maybe<Scalars['String']['output']>;
  readonly address2?: Maybe<Scalars['String']['output']>;
  readonly coveredAccountsCount: Scalars['Int']['output'];
  readonly createdByUserName?: Maybe<Scalars['String']['output']>;
  readonly createdOn: Scalars['Instant']['output'];
  readonly department?: Maybe<Scalars['String']['output']>;
  readonly email1?: Maybe<Scalars['String']['output']>;
  readonly email2?: Maybe<Scalars['String']['output']>;
  readonly employeeKey: Scalars['String']['output'];
  readonly faxNumber1?: Maybe<Scalars['String']['output']>;
  readonly faxNumber2?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly jobFunction?: Maybe<JobFunction>;
  readonly modifiedByUserName?: Maybe<Scalars['String']['output']>;
  readonly modifiedOn: Scalars['Instant']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber1?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber2?: Maybe<Scalars['String']['output']>;
  readonly salesCoverage: ReadonlyArray<InvestorFirmRelationship>;
  readonly status: RolodexRecordStatus;
  readonly titles?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly userAccount?: Maybe<UserAccount>;
};

export type UnderwriterEmployeeSalesCoverageArgs = {
  order?: InputMaybe<ReadonlyArray<InvestorFirmRelationshipSortInput>>;
  where?: InputMaybe<InvestorFirmRelationshipFilterInput>;
};

export type UnderwriterEmployeeCreateInput = {
  readonly address1?: InputMaybe<Scalars['String']['input']>;
  readonly address2?: InputMaybe<Scalars['String']['input']>;
  readonly department?: InputMaybe<Scalars['String']['input']>;
  readonly email1?: InputMaybe<Scalars['String']['input']>;
  readonly email2?: InputMaybe<Scalars['String']['input']>;
  readonly employeeKey: Scalars['String']['input'];
  readonly faxNumber1?: InputMaybe<Scalars['String']['input']>;
  readonly faxNumber2?: InputMaybe<Scalars['String']['input']>;
  readonly investorRelationships?: InputMaybe<
    ReadonlyArray<InputMaybe<InvestorRelationshipCreateDtoInput>>
  >;
  readonly jobFunction?: InputMaybe<JobFunction>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber1?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  readonly status: RolodexRecordStatus;
  readonly titles?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type UnderwriterEmployeeFilterInput = {
  readonly address1?: InputMaybe<StringOperationFilterInput>;
  readonly address2?: InputMaybe<StringOperationFilterInput>;
  readonly and?: InputMaybe<ReadonlyArray<UnderwriterEmployeeFilterInput>>;
  readonly coveredAccountsCount?: InputMaybe<IntOperationFilterInput>;
  readonly createdByUserName?: InputMaybe<StringOperationFilterInput>;
  readonly createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  readonly department?: InputMaybe<StringOperationFilterInput>;
  readonly email1?: InputMaybe<StringOperationFilterInput>;
  readonly email2?: InputMaybe<StringOperationFilterInput>;
  readonly employeeKey?: InputMaybe<StringOperationFilterInput>;
  readonly faxNumber1?: InputMaybe<StringOperationFilterInput>;
  readonly faxNumber2?: InputMaybe<StringOperationFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly jobFunction?: InputMaybe<NullableOfJobFunctionOperationFilterInput>;
  readonly modifiedByUserName?: InputMaybe<StringOperationFilterInput>;
  readonly modifiedOn?: InputMaybe<DateTimeOperationFilterInput>;
  readonly name?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<UnderwriterEmployeeFilterInput>>;
  readonly phoneNumber1?: InputMaybe<StringOperationFilterInput>;
  readonly phoneNumber2?: InputMaybe<StringOperationFilterInput>;
  readonly salesCoverage?: InputMaybe<ListFilterInputTypeOfInvestorRelationshipFullFilterInput>;
  readonly status?: InputMaybe<RecordStatusOperationFilterInput>;
  readonly titles?: InputMaybe<ListStringOperationFilterInput>;
  readonly userAccount?: InputMaybe<UserAccountFilterInput>;
};

export type UnderwriterEmployeeSortInput = {
  readonly address1?: InputMaybe<SortEnumType>;
  readonly address2?: InputMaybe<SortEnumType>;
  readonly coveredAccountsCount?: InputMaybe<SortEnumType>;
  readonly createdByUserName?: InputMaybe<SortEnumType>;
  readonly createdOn?: InputMaybe<SortEnumType>;
  readonly department?: InputMaybe<SortEnumType>;
  readonly email1?: InputMaybe<SortEnumType>;
  readonly email2?: InputMaybe<SortEnumType>;
  readonly employeeKey?: InputMaybe<SortEnumType>;
  readonly faxNumber1?: InputMaybe<SortEnumType>;
  readonly faxNumber2?: InputMaybe<SortEnumType>;
  readonly id?: InputMaybe<SortEnumType>;
  readonly jobFunction?: InputMaybe<SortEnumType>;
  readonly modifiedByUserName?: InputMaybe<SortEnumType>;
  readonly modifiedOn?: InputMaybe<SortEnumType>;
  readonly name?: InputMaybe<SortEnumType>;
  readonly phoneNumber1?: InputMaybe<SortEnumType>;
  readonly phoneNumber2?: InputMaybe<SortEnumType>;
  readonly status?: InputMaybe<SortEnumType>;
  readonly userAccount?: InputMaybe<UserAccountSortInput>;
};

export type UnderwriterEmployeeUpdateInput = {
  readonly address1?: InputMaybe<Scalars['String']['input']>;
  readonly address2?: InputMaybe<Scalars['String']['input']>;
  readonly department?: InputMaybe<Scalars['String']['input']>;
  readonly email1?: InputMaybe<Scalars['String']['input']>;
  readonly email2?: InputMaybe<Scalars['String']['input']>;
  readonly faxNumber1?: InputMaybe<Scalars['String']['input']>;
  readonly faxNumber2?: InputMaybe<Scalars['String']['input']>;
  readonly jobFunction?: InputMaybe<JobFunction>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber1?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  readonly status: RolodexRecordStatus;
  readonly titles?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

/** A segment of a collection. */
export type UnderwriterEmployeesCollectionSegment = {
  readonly __typename?: 'UnderwriterEmployeesCollectionSegment';
  /** A flattened list of the items. */
  readonly items?: Maybe<ReadonlyArray<UnderwriterEmployee>>;
  /** Information to aid in pagination. */
  readonly pageInfo: CollectionSegmentInfo;
  readonly totalCount: Scalars['Int']['output'];
};

export type UnderwriterInvitationWire = {
  readonly __typename?: 'UnderwriterInvitationWire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly masterAauDate: Scalars['LocalDate']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly wireMessages: ReadonlyArray<WireMessage>;
};

/** Union of Wire and ServiceError, either a Wire or ServiceError is returned */
export type UnderwriterInvitationWireResponseUnion = ServiceError | UnderwriterInvitationWire;

export type UnderwriterInvitationWireValidation = WireValidationBase & {
  readonly __typename?: 'UnderwriterInvitationWireValidation';
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly offeringErrors: ReadonlyArray<UnderwriterInvitationWireValidationOfferingErrors>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export enum UnderwriterInvitationWireValidationOfferingErrors {
  ConvertibleBaseOfferingSize = 'CONVERTIBLE_BASE_OFFERING_SIZE',
  CouponTalkHigh = 'COUPON_TALK_HIGH',
  CouponTalkLow = 'COUPON_TALK_LOW',
  ExchangeMic = 'EXCHANGE_MIC',
  IpoRangeHigh = 'IPO_RANGE_HIGH',
  IpoRangeLow = 'IPO_RANGE_LOW',
  IssuerName = 'ISSUER_NAME',
  LaunchDate = 'LAUNCH_DATE',
  OfferingType = 'OFFERING_TYPE',
  ParValue = 'PAR_VALUE',
  PercentageOfPar = 'PERCENTAGE_OF_PAR',
  PremiumTalkHigh = 'PREMIUM_TALK_HIGH',
  PremiumTalkLow = 'PREMIUM_TALK_LOW',
  PricingDate = 'PRICING_DATE',
  SecurityType = 'SECURITY_TYPE',
  SettlementAgent = 'SETTLEMENT_AGENT',
  SharesOrNotionalBaseOffering = 'SHARES_OR_NOTIONAL_BASE_OFFERING',
  StockSymbol = 'STOCK_SYMBOL',
  TotalNotionalBaseOffering = 'TOTAL_NOTIONAL_BASE_OFFERING',
  UnderlyingExchangeMic = 'UNDERLYING_EXCHANGE_MIC',
  UnderlyingStockSymbol = 'UNDERLYING_STOCK_SYMBOL',
}

export type UnderwritingFeesAndDiscounts = {
  readonly __typename?: 'UnderwritingFeesAndDiscounts';
  readonly brokerage?: Maybe<Scalars['Decimal']['output']>;
  readonly grossSpreadBaseData?: Maybe<GrossSpreadBase>;
  readonly grossSpreadTotal?: Maybe<Scalars['Decimal']['output']>;
  readonly incentiveFeeData?: Maybe<IncentiveFee>;
  readonly managementFee?: Maybe<Scalars['Decimal']['output']>;
  readonly netPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly reallowance?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly sharesExcludedFromGrossSpread?: Maybe<Scalars['Long']['output']>;
  readonly stampFee?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFee?: Maybe<Scalars['Decimal']['output']>;
};

export type UnderwritingFeesAndDiscountsFull = {
  readonly __typename?: 'UnderwritingFeesAndDiscountsFull';
  readonly brokerage?: Maybe<Scalars['Decimal']['output']>;
  readonly grossSpreadBaseData?: Maybe<GrossSpreadBaseFull>;
  readonly grossSpreadTotal?: Maybe<Scalars['Decimal']['output']>;
  readonly incentiveFeeData?: Maybe<IncentiveFeeFull>;
  readonly managementFee?: Maybe<Scalars['Decimal']['output']>;
  readonly netPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly reallowance?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly sharesExcludedFromGrossSpread?: Maybe<Scalars['Long']['output']>;
  readonly stampFee?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFee?: Maybe<Scalars['Decimal']['output']>;
};

export type UnderwritingFeesAndDiscountsFullFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<UnderwritingFeesAndDiscountsFullFilterInput>>;
  readonly brokerage?: InputMaybe<DecimalOperationFilterInput>;
  readonly grossSpreadBaseData?: InputMaybe<GrossSpreadBaseFullFilterInput>;
  readonly grossSpreadTotal?: InputMaybe<DecimalOperationFilterInput>;
  readonly incentiveFeeData?: InputMaybe<IncentiveFeeFullFilterInput>;
  readonly managementFee?: InputMaybe<DecimalOperationFilterInput>;
  readonly netPrice?: InputMaybe<DecimalOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<UnderwritingFeesAndDiscountsFullFilterInput>>;
  readonly reallowance?: InputMaybe<DecimalOperationFilterInput>;
  readonly sellingConcession?: InputMaybe<DecimalOperationFilterInput>;
  readonly sharesExcludedFromGrossSpread?: InputMaybe<LongOperationFilterInput>;
  readonly stampFee?: InputMaybe<DecimalOperationFilterInput>;
  readonly underwritingFee?: InputMaybe<DecimalOperationFilterInput>;
};

export type UnderwritingTermsFeesAndDiscounts = {
  readonly __typename?: 'UnderwritingTermsFeesAndDiscounts';
  readonly brokerage?: Maybe<Scalars['Decimal']['output']>;
  readonly grossSpreadBaseData?: Maybe<UnderwritingTermsGrossSpreadBase>;
  readonly grossSpreadTotal?: Maybe<Scalars['Decimal']['output']>;
  readonly incentiveFeeData?: Maybe<UnderwritingTermsIncentiveFee>;
  readonly managementFee?: Maybe<Scalars['Decimal']['output']>;
  readonly netPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly reallowance?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly sharesExcludedFromGrossSpread?: Maybe<Scalars['Long']['output']>;
  readonly stampFee?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFee?: Maybe<Scalars['Decimal']['output']>;
};

export type UnderwritingTermsGrossSpreadBase = {
  readonly __typename?: 'UnderwritingTermsGrossSpreadBase';
  readonly grossSpreadBase?: Maybe<Scalars['Decimal']['output']>;
  readonly grossSpreadBasePercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly managementFee?: Maybe<Scalars['Decimal']['output']>;
  readonly managementFeePercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcessionPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFee?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFeePercentage?: Maybe<Scalars['Decimal']['output']>;
};

export type UnderwritingTermsIncentiveFee = {
  readonly __typename?: 'UnderwritingTermsIncentiveFee';
  readonly incentiveFee?: Maybe<Scalars['Decimal']['output']>;
  readonly incentiveFeePercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly managementFee?: Maybe<Scalars['Decimal']['output']>;
  readonly managementFeePercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcession?: Maybe<Scalars['Decimal']['output']>;
  readonly sellingConcessionPercentage?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFee?: Maybe<Scalars['Decimal']['output']>;
  readonly underwritingFeePercentage?: Maybe<Scalars['Decimal']['output']>;
};

export type UpdateAccountingAdjustmentsInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly managerCmgEntityKey: Scalars['String']['input'];
  readonly manualAdjustment?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateAdditionalTermsDataInput = {
  readonly callDates?: InputMaybe<ReadonlyArray<Scalars['LocalDate']['input']>>;
  readonly callable?: InputMaybe<Scalars['Boolean']['input']>;
  readonly changeOfControl?: InputMaybe<FlagWithNotesFullInput>;
  readonly contingentConversion?: InputMaybe<FlagWithNotesFullInput>;
  readonly contingentPayment?: InputMaybe<FlagWithNotesFullInput>;
  readonly couponFrequency?: InputMaybe<Scalars['String']['input']>;
  readonly dividendProtection?: InputMaybe<FlagWithNotesFullInput>;
  readonly hedging?: InputMaybe<FlagWithNotesFullInput>;
  readonly lockUpPeriod?: InputMaybe<Scalars['Int']['input']>;
  readonly maturityDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly moodyRating?: InputMaybe<MoodyRating>;
  readonly perpetual?: InputMaybe<FlagWithNotesFullInput>;
  readonly provisionCall?: InputMaybe<FlagWithNotesFullInput>;
  readonly puttable?: InputMaybe<FlagWithNotesFullInput>;
  readonly spRating?: InputMaybe<SpRating>;
  readonly tenor?: InputMaybe<Scalars['Int']['input']>;
  readonly useOfProceeds?: InputMaybe<ReadonlyArray<UseOfProceeds>>;
};

export type UpdateAdditionalTermsInput = {
  readonly data: UpdateAdditionalTermsDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateAdditionalTermsPayload = {
  readonly __typename?: 'UpdateAdditionalTermsPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateAttestationEnforcementInput = {
  readonly enforceValidAttestationForSalesAndTrading: Scalars['Boolean']['input'];
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateAttestationEnforcementPayload = {
  readonly __typename?: 'UpdateAttestationEnforcementPayload';
  readonly enforceValidAttestationForSalesAndTrading?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateBasicInfoInput = {
  readonly isWallCrossEnabled?: Scalars['Boolean']['input'];
  readonly issuer: UpdateIssuerInput;
  readonly offeringId: Scalars['UUID']['input'];
  readonly security: UpdateSecurityInput;
  readonly type: OfferingType;
};

export type UpdateBasicInfoPayload = {
  readonly __typename?: 'UpdateBasicInfoPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateDeliveryInstrumentDataInput = {
  readonly countryCode?: InputMaybe<Scalars['String']['input']>;
  readonly currencyCode: Scalars['String']['input'];
  readonly cusip?: InputMaybe<Scalars['String']['input']>;
  readonly depositaryReceiptConversionRatioDenominator?: InputMaybe<Scalars['Int']['input']>;
  readonly depositaryReceiptConversionRatioNumerator?: InputMaybe<Scalars['Int']['input']>;
  readonly exchangeMic?: InputMaybe<ExchangeMic>;
  readonly figi?: InputMaybe<Scalars['String']['input']>;
  readonly isDepositaryReceipt: Scalars['Boolean']['input'];
  readonly isin?: InputMaybe<Scalars['String']['input']>;
  readonly lastTradeBeforeFiling?: InputMaybe<Scalars['Decimal']['input']>;
  readonly lastTradeBeforeLaunch?: InputMaybe<Scalars['Decimal']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly rank?: InputMaybe<Rank>;
  readonly referencePrice?: InputMaybe<Scalars['Decimal']['input']>;
  readonly sellingRestrictions?: InputMaybe<SellingRestrictions>;
  readonly stockSymbol?: InputMaybe<Scalars['String']['input']>;
  readonly underlyingCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  readonly underlyingExchangeMic?: InputMaybe<ExchangeMic>;
  readonly underlyingStockSymbol?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeliveryInstrumentInput = {
  readonly data: UpdateDeliveryInstrumentDataInput;
  readonly instrumentId: Scalars['UUID']['input'];
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateDeliveryInstrumentPayload = {
  readonly __typename?: 'UpdateDeliveryInstrumentPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateDemandCurrencyInput = {
  readonly data: DemandCurrencyDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateDemandCurrencyPayload = {
  readonly __typename?: 'UpdateDemandCurrencyPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateDisclaimersDataInput = {
  readonly footnotes?: InputMaybe<Scalars['String']['input']>;
  readonly registrationLinks?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly restrictions?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDisclaimersInput = {
  readonly data: UpdateDisclaimersDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateDisclaimersPayload = {
  readonly __typename?: 'UpdateDisclaimersPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateFeesAndDiscountsDataInput = {
  readonly baseGrossSpread?: InputMaybe<UpdateGrossSpreadBaseInput>;
  readonly incentiveFee?: InputMaybe<UpdateIncentiveFeeInput>;
  readonly sharesExcludedFromGrossSpread?: InputMaybe<Scalars['Long']['input']>;
};

export type UpdateFeesAndDiscountsInput = {
  readonly input: UpdateFeesAndDiscountsDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateFeesAndDiscountsPayload = {
  readonly __typename?: 'UpdateFeesAndDiscountsPayload';
  readonly feesAndDiscounts?: Maybe<FeesAndDiscounts>;
};

export type UpdateFilingDataInput = {
  readonly conversionPrice?: InputMaybe<Scalars['Decimal']['input']>;
  readonly coupon?: InputMaybe<Scalars['Decimal']['input']>;
  readonly couponTalkHigh?: InputMaybe<Scalars['Decimal']['input']>;
  readonly couponTalkLow?: InputMaybe<Scalars['Decimal']['input']>;
  readonly effectiveConversionPremium?: InputMaybe<Scalars['Decimal']['input']>;
  readonly effectiveConversionPrice?: InputMaybe<Scalars['Decimal']['input']>;
  readonly initialConversionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  readonly initialRegistrationValue?: InputMaybe<Scalars['Decimal']['input']>;
  readonly ipoRangeHigh?: InputMaybe<Scalars['Decimal']['input']>;
  readonly ipoRangeLow?: InputMaybe<Scalars['Decimal']['input']>;
  /**
   * This field is deprecated. Please use the LockUpPeriod field in Terms instead.
   * @deprecated Use the LockUpPeriod field in Terms instead
   */
  readonly lockUpPeriod?: InputMaybe<Scalars['Int']['input']>;
  readonly notionalOverAllotmentAuthorized?: InputMaybe<Scalars['Decimal']['input']>;
  /**
   * This field is deprecated. Please use the NotionalOverAllotmentExercised field in Terms instead.
   * @deprecated Use the NotionalOverAllotmentExercised field in Terms instead
   */
  readonly notionalOverAllotmentExercised?: InputMaybe<Scalars['Decimal']['input']>;
  readonly numberOfBondsBaseOffering?: InputMaybe<Scalars['Long']['input']>;
  readonly numberOfBondsOverAllotmentAuthorized?: InputMaybe<Scalars['Long']['input']>;
  readonly offerPrice?: InputMaybe<Scalars['Decimal']['input']>;
  readonly parValue?: InputMaybe<Scalars['Decimal']['input']>;
  readonly postOfferingShares?: InputMaybe<Scalars['Long']['input']>;
  readonly premium?: InputMaybe<Scalars['Decimal']['input']>;
  readonly premiumTalkHigh?: InputMaybe<Scalars['Decimal']['input']>;
  readonly premiumTalkLow?: InputMaybe<Scalars['Decimal']['input']>;
  readonly priceAsOfPar?: InputMaybe<Scalars['Decimal']['input']>;
  readonly primarySharesBaseOffering?: InputMaybe<Scalars['Long']['input']>;
  readonly primarySharesOverAllotmentAuthorized?: InputMaybe<Scalars['Long']['input']>;
  /**
   * This field is deprecated. Please use the PrimarySharesOverAllotmentExercised field in Terms instead.
   * @deprecated Use the PrimarySharesOverAllotmentExercised field in Terms instead
   */
  readonly primarySharesOverAllotmentExercised?: InputMaybe<Scalars['Long']['input']>;
  readonly secondarySharesBaseOffering?: InputMaybe<Scalars['Long']['input']>;
  readonly secondarySharesOverAllotmentAuthorized?: InputMaybe<Scalars['Long']['input']>;
  /**
   * This field is deprecated. Please use the SecondarySharesOverAllotmentExercised field in Terms instead.
   * @deprecated Use the SecondarySharesOverAllotmentExercised field in Terms instead
   */
  readonly secondarySharesOverAllotmentExercised?: InputMaybe<Scalars['Long']['input']>;
  /**
   * This field is deprecated. Please use the UseOfProceeds field in Terms instead.
   * @deprecated Use the UseOfProceeds field in Terms instead
   */
  readonly useOfProceeds?: InputMaybe<ReadonlyArray<UseOfProceeds>>;
};

export type UpdateFilingInput = {
  readonly data: UpdateFilingDataInput;
  readonly filingId: Scalars['UUID']['input'];
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateFilingPayload = {
  readonly __typename?: 'UpdateFilingPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateFirmEmployeeInput = {
  readonly data: AdminFirmEmployeeInput;
  readonly employeeId: Scalars['UUID']['input'];
  readonly firmId: Scalars['UUID']['input'];
};

export type UpdateFirmEmployeePayload = {
  readonly __typename?: 'UpdateFirmEmployeePayload';
  readonly firmEmployee?: Maybe<FirmEmployeeFull>;
};

export type UpdateFollowOnPricingDataInput = {
  readonly lastTradeBeforeFiling?: InputMaybe<Scalars['Decimal']['input']>;
  readonly lastTradeBeforeLaunch?: InputMaybe<Scalars['Decimal']['input']>;
  readonly lastTradeBeforeOffer?: InputMaybe<Scalars['Decimal']['input']>;
  readonly reOfferHigh?: InputMaybe<Scalars['Decimal']['input']>;
  readonly reOfferLow?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateFollowOnPricingInput = {
  readonly data: UpdateFollowOnPricingDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateFollowOnPricingPayload = {
  readonly __typename?: 'UpdateFollowOnPricingPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateFreeFormWireInput = {
  readonly body: Scalars['String']['input'];
  readonly header: Scalars['String']['input'];
};

export type UpdateFundIoisInput = {
  readonly allocations: ReadonlyArray<FundAllocationInput>;
  readonly iois: ReadonlyArray<FundIoiInput>;
};

export type UpdateGrossSpreadBaseDtoInput = {
  readonly grossSpreadBase?: InputMaybe<Scalars['Decimal']['input']>;
  readonly grossSpreadBasePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly managementFee?: InputMaybe<Scalars['Decimal']['input']>;
  readonly managementFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly sellingConcession?: InputMaybe<Scalars['Decimal']['input']>;
  readonly sellingConcessionPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly underwritingFee?: InputMaybe<Scalars['Decimal']['input']>;
  readonly underwritingFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateGrossSpreadBaseInput = {
  readonly grossSpreadBase?: InputMaybe<Scalars['Decimal']['input']>;
  readonly grossSpreadBasePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly managementFee?: InputMaybe<Scalars['Decimal']['input']>;
  readonly managementFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly sellingConcession?: InputMaybe<Scalars['Decimal']['input']>;
  readonly sellingConcessionPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly underwritingFee?: InputMaybe<Scalars['Decimal']['input']>;
  readonly underwritingFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateIncentiveFeeDistributionInput = {
  readonly data: ReadonlyArray<PercentagePerCmgEntityDataInput>;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateIncentiveFeeDistributionPayload = {
  readonly __typename?: 'UpdateIncentiveFeeDistributionPayload';
  readonly percentagePerCmgEntity?: Maybe<ReadonlyArray<PercentagePerCmgEntity>>;
};

export type UpdateIncentiveFeeDtoInput = {
  readonly incentiveFee?: InputMaybe<Scalars['Decimal']['input']>;
  readonly incentiveFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly managementFee?: InputMaybe<Scalars['Decimal']['input']>;
  readonly managementFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly sellingConcession?: InputMaybe<Scalars['Decimal']['input']>;
  readonly sellingConcessionPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly underwritingFee?: InputMaybe<Scalars['Decimal']['input']>;
  readonly underwritingFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateIncentiveFeeInput = {
  readonly incentiveFee?: InputMaybe<Scalars['Decimal']['input']>;
  readonly incentiveFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly managementFee?: InputMaybe<Scalars['Decimal']['input']>;
  readonly managementFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly sellingConcession?: InputMaybe<Scalars['Decimal']['input']>;
  readonly sellingConcessionPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly underwritingFee?: InputMaybe<Scalars['Decimal']['input']>;
  readonly underwritingFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateInvestorCrmKeyResult = {
  readonly __typename?: 'UpdateInvestorCrmKeyResult';
  readonly indicationId: Scalars['String']['output'];
};

export type UpdateInvestorFirmEmployeeInput = {
  readonly address1?: InputMaybe<Scalars['String']['input']>;
  readonly address2?: InputMaybe<Scalars['String']['input']>;
  readonly email1: Scalars['String']['input'];
  readonly email2?: InputMaybe<Scalars['String']['input']>;
  readonly faxNumber1?: InputMaybe<Scalars['String']['input']>;
  readonly faxNumber2?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly phoneNumber1?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  readonly status: RolodexRecordStatus;
  readonly titles?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type UpdateInvestorFirmEmployeePayload = {
  readonly __typename?: 'UpdateInvestorFirmEmployeePayload';
  readonly investorFirmContact?: Maybe<InvestorFirmContact>;
};

export type UpdateInvestorFirmInput = {
  readonly address1?: InputMaybe<Scalars['String']['input']>;
  readonly address2?: InputMaybe<Scalars['String']['input']>;
  readonly cik1?: InputMaybe<Scalars['String']['input']>;
  readonly cik2?: InputMaybe<Scalars['String']['input']>;
  readonly crd?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly email1?: InputMaybe<Scalars['String']['input']>;
  readonly email2?: InputMaybe<Scalars['String']['input']>;
  readonly factSet?: InputMaybe<Scalars['String']['input']>;
  readonly faxNumber1?: InputMaybe<Scalars['String']['input']>;
  readonly faxNumber2?: InputMaybe<Scalars['String']['input']>;
  readonly investorSubType?: InputMaybe<Scalars['String']['input']>;
  readonly investorType?: InputMaybe<Scalars['String']['input']>;
  readonly lei?: InputMaybe<Scalars['String']['input']>;
  readonly mpid?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly phoneNumber1?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  readonly status: RolodexRecordStatus;
  readonly website1?: InputMaybe<Scalars['String']['input']>;
  readonly website2?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInvestorFirmPayload = {
  readonly __typename?: 'UpdateInvestorFirmPayload';
  readonly investorFirmsGrid?: Maybe<InvestorFirmsGrid>;
};

export type UpdateInvestorRelationshipInput = {
  readonly firmId: Scalars['UUID']['input'];
  readonly input: InvestorRelationshipUpdateDtoInput;
  readonly underwriterEmployeeId: Scalars['UUID']['input'];
};

export type UpdateInvestorRelationshipPayload = {
  readonly __typename?: 'UpdateInvestorRelationshipPayload';
  readonly investorFirmRelationship?: Maybe<InvestorFirmRelationship>;
};

export type UpdateIssuerInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly businessDescription?: InputMaybe<Scalars['String']['input']>;
  readonly lei?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly sector?: InputMaybe<Sector>;
  readonly subSector?: InputMaybe<Scalars['String']['input']>;
  readonly website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManagementFeeDistributionInput = {
  readonly data: ReadonlyArray<PercentagePerCmgEntityDataInput>;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateManagementFeeDistributionPayload = {
  readonly __typename?: 'UpdateManagementFeeDistributionPayload';
  readonly percentagePerCmgEntity?: Maybe<ReadonlyArray<PercentagePerCmgEntity>>;
};

export type UpdateManagerDataInput = {
  /**
   * Deprecated; Use `Underwriting Base Share Distribution` in Manager Economics instead
   * @deprecated Use Underwriting Base Share Distribution under Manager Economics.
   */
  readonly economics?: InputMaybe<Scalars['Long']['input']>;
  readonly isJuniorRole: Scalars['Boolean']['input'];
  readonly isParticipating: Scalars['Boolean']['input'];
  readonly role: ManagerRole;
};

export type UpdateManagerFirmDataInput = {
  readonly newCmgEntityKey: Scalars['String']['input'];
};

export type UpdateManagerFirmInput = {
  readonly cmgEntityKey: Scalars['String']['input'];
  readonly data: UpdateManagerFirmDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateManagerFirmPayload = {
  readonly __typename?: 'UpdateManagerFirmPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateManagerInput = {
  readonly cmgEntityKey: Scalars['String']['input'];
  readonly data: UpdateManagerDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateManagerPayload = {
  readonly __typename?: 'UpdateManagerPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateManagerResponsibilitiesInput = {
  readonly data: ManagerResponsibilitiesDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateManagerResponsibilitiesPayload = {
  readonly __typename?: 'UpdateManagerResponsibilitiesPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateManagerSequenceDataInput = {
  readonly cmgEntityKeys: ReadonlyArray<Scalars['String']['input']>;
};

export type UpdateManagerSequenceInput = {
  readonly data: UpdateManagerSequenceDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateManagerSequencePayload = {
  readonly __typename?: 'UpdateManagerSequencePayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateMarketingInput = {
  readonly data: MarketingInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateMarketingPayload = {
  readonly __typename?: 'UpdateMarketingPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateMdlOfferingNoteInput = {
  readonly id: Scalars['ID']['input'];
  readonly note: Scalars['String']['input'];
  readonly subject: OfferingNoteSubject;
};

export type UpdateMyRetailBroker = {
  readonly demand: MyRetailBrokerDemandInput;
  readonly firmCmgEntityKey?: InputMaybe<Scalars['String']['input']>;
  readonly firmName: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly retention: MyRetailRetentionInput;
  readonly sellingConcessionPercentage?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateMyRetailBrokerInput = {
  readonly demand: MyRetailBrokerDemandInput;
  readonly retention: MyRetailRetentionInput;
  readonly sellingConcessionPercentage?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateMyRetailInput = {
  readonly brokerDealers: ReadonlyArray<UpdateMyRetailBroker>;
  readonly instrumentId?: InputMaybe<Scalars['UUID']['input']>;
  readonly trancheId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateNonSyndicateFreeFormWireInput = {
  readonly body: Scalars['String']['input'];
  readonly header: Scalars['String']['input'];
};

export type UpdateNonSyndicateSellingGroupInvitationWireInput = {
  readonly userDataForRecipients: ReadonlyArray<NonSyndicateSellingGroupInvitationDataForRecipient>;
};

export type UpdateNonSyndicateSellingGroupTermsRetentionWireInput = {
  readonly userDataForRecipients: ReadonlyArray<CreateNonSyndicateSellingGroupTermsRetentionWireInputData>;
};

export type UpdateNonSyndicateTerminationWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly terminationDate: Scalars['Instant']['input'];
  readonly terminationTimeZone: Scalars['DateTimeZone']['input'];
};

export type UpdateOfferingStatusInput = {
  readonly offeringId: Scalars['UUID']['input'];
  readonly status: OfferingStatus;
};

export type UpdateOfferingStatusPayload = {
  readonly __typename?: 'UpdateOfferingStatusPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateOrderBookConfigurationDataInput = {
  readonly isIndicationPriceAsPercentageParEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isLimitIndicationsOnlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isOnlySharesUnitOnIndicationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrderBookConfigurationInput = {
  readonly data: UpdateOrderBookConfigurationDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateOrderBookConfigurationPayload = {
  readonly __typename?: 'UpdateOrderBookConfigurationPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateOrderBookSalesStateInput = {
  readonly offeringId: Scalars['UUID']['input'];
  readonly state: OrderBookState;
};

export type UpdateOrderBookSalesStatePayload = {
  readonly __typename?: 'UpdateOrderBookSalesStatePayload';
  readonly orderBookState?: Maybe<OrderBookState>;
};

export type UpdateOverAllotmentExerciseDataInput = {
  readonly dateOverAllotmentExercised?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly notionalOverAllotmentExercised?: InputMaybe<Scalars['Decimal']['input']>;
  readonly numberOfBondsOverAllotmentExercised?: InputMaybe<Scalars['Long']['input']>;
  readonly primarySharesOverAllotmentExercised?: InputMaybe<Scalars['Long']['input']>;
  readonly secondarySharesOverAllotmentExercised?: InputMaybe<Scalars['Long']['input']>;
};

export type UpdateOverAllotmentExerciseInput = {
  readonly data: UpdateOverAllotmentExerciseDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateOverAllotmentExercisePayload = {
  readonly __typename?: 'UpdateOverAllotmentExercisePayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateOverallotmentExercisedSharesDistributionInput = {
  readonly data: ReadonlyArray<SharesPerCmgEntityDataInput>;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateOverallotmentExercisedSharesDistributionPayload = {
  readonly __typename?: 'UpdateOverallotmentExercisedSharesDistributionPayload';
  readonly sharesPerCmgEntity?: Maybe<ReadonlyArray<SharesPerCmgEntity>>;
};

export type UpdatePotAccountWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly headerNote?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePotAllocationWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly headerNote?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePricingTermsRetentionWireInput = {
  readonly userDataForRecipients: ReadonlyArray<PricingTermsRetentionUserDataForRecipientInputData>;
};

export type UpdatePricingTermsWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePrivateManagerEconomicsInput = {
  readonly input: UpdatePrivateManagerEconomicsDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdatePrivateManagerEconomicsPayload = {
  readonly __typename?: 'UpdatePrivateManagerEconomicsPayload';
  readonly privateManagerEconomics?: Maybe<PrivateManagerEconomics>;
};

export type UpdatePrivatePlacementTermsDataInput = {
  readonly annualFee?: InputMaybe<Scalars['Decimal']['input']>;
  readonly carry?: InputMaybe<Scalars['Decimal']['input']>;
  readonly commission?: InputMaybe<Scalars['Decimal']['input']>;
  readonly impliedValuation?: InputMaybe<Scalars['Decimal']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly price?: InputMaybe<Scalars['Decimal']['input']>;
  readonly primaryShares?: InputMaybe<Scalars['Long']['input']>;
  readonly secondaryShares?: InputMaybe<Scalars['Long']['input']>;
  readonly sizeNotional?: InputMaybe<Scalars['Decimal']['input']>;
  readonly sizeShares?: InputMaybe<Scalars['Long']['input']>;
};

export type UpdatePrivatePlacementTermsInput = {
  readonly data: UpdatePrivatePlacementTermsDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdatePrivatePlacementTermsPayload = {
  readonly __typename?: 'UpdatePrivatePlacementTermsPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateProspectusDocumentsMetadataInput = {
  readonly offeringId: Scalars['UUID']['input'];
  readonly prospectusDocuments: ReadonlyArray<ProspectusDocumentUpdateMetadataInput>;
};

export type UpdateProspectusDocumentsMetadataPayload = {
  readonly __typename?: 'UpdateProspectusDocumentsMetadataPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateRegMWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly notificationPeriod: RegulationMNotificationPeriod;
};

export type UpdateResearchRestrictionWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly masterAauDate: Scalars['LocalDate']['input'];
  readonly underwriterInvitationSentDate: Scalars['LocalDate']['input'];
};

export type UpdateRoadshowScheduleInput = {
  readonly data: RoadshowScheduleDataInput;
  readonly offeringId: Scalars['UUID']['input'];
  readonly roadshowScheduleId: Scalars['UUID']['input'];
};

export type UpdateRoadshowSchedulePayload = {
  readonly __typename?: 'UpdateRoadshowSchedulePayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateSalesCreditsAmountInput = {
  readonly investorFirmCmgEntityKey: Scalars['String']['input'];
  readonly salesCreditAmount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateSalesCreditsBankInvestorKeyInput = {
  readonly firmId: Scalars['UUID']['input'];
};

export type UpdateSalesCreditsInput = {
  readonly salesCreditIds: ReadonlyArray<Scalars['UUID']['input']>;
  readonly status: InternalSalesCreditReleaseStatus;
};

export type UpdateSecurityInput = {
  /**
   * Deprecated. This will be removed in future versions.
   * @deprecated Deprecated. This will be removed in future versions.
   */
  readonly isDepositaryReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  readonly securityDescription?: InputMaybe<Scalars['String']['input']>;
  readonly shareClass?: InputMaybe<SecurityShareClass>;
  readonly type: SecurityType;
};

export type UpdateSellingConcessionDistributionInput = {
  readonly data: ReadonlyArray<PercentagePerCmgEntityDataInput>;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateSellingConcessionDistributionPayload = {
  readonly __typename?: 'UpdateSellingConcessionDistributionPayload';
  readonly percentagePerCmgEntity?: Maybe<ReadonlyArray<PercentagePerCmgEntity>>;
};

export type UpdateSellingGroupInvitationWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly masterSdaDate: Scalars['LocalDate']['input'];
};

export type UpdateSellingGroupTermsWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSyndicateDataInput = {
  /** Updating this will also update Gross Spread Base in Underwriting Fees and Discounts */
  readonly grossSpread?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateSyndicateInput = {
  readonly data: UpdateSyndicateDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateSyndicatePayload = {
  readonly __typename?: 'UpdateSyndicatePayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateTerminationWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly terminationDate: Scalars['Instant']['input'];
  readonly terminationTimeZone: Scalars['DateTimeZone']['input'];
};

export type UpdateTimingInfoDataInput = {
  readonly bookCloseDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly bookCloseTime?: InputMaybe<Scalars['LocalTime']['input']>;
  readonly bookOpenDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly bookOpenTime?: InputMaybe<Scalars['LocalTime']['input']>;
  readonly confidentialFilingDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly filingOccurred?: InputMaybe<MarketTiming>;
  readonly firstTradeDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly launchDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly launchOccurred?: InputMaybe<MarketTiming>;
  readonly postponedDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly pricingDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly publicFilingDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly settlementDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly terminatedDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly timeZone?: InputMaybe<Scalars['DateTimeZone']['input']>;
  readonly tradeDate?: InputMaybe<Scalars['LocalDate']['input']>;
  readonly withdrawnDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type UpdateTimingInfoInput = {
  readonly data: UpdateTimingInfoDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateTimingInfoPayload = {
  readonly __typename?: 'UpdateTimingInfoPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateTotalRetailInput = {
  readonly demandNotionalQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  readonly demandShareQuantity?: InputMaybe<Scalars['Long']['input']>;
  readonly instrumentId: Scalars['UUID']['input'];
  readonly managerCmgEntityKey: Scalars['String']['input'];
  readonly retentionShareQuantity: Scalars['Long']['input'];
  readonly roundLots?: InputMaybe<Scalars['Int']['input']>;
  readonly trancheId: Scalars['UUID']['input'];
};

export type UpdateTradesStatusBatchInput = {
  readonly status: InternalReleaseStatus;
  readonly tradeIds: ReadonlyArray<Scalars['UUID']['input']>;
};

export type UpdateTrancheDataInput = {
  readonly name: Scalars['String']['input'];
  readonly region?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTrancheInput = {
  readonly data: UpdateTrancheDataInput;
  readonly offeringId: Scalars['UUID']['input'];
  readonly trancheId: Scalars['UUID']['input'];
};

export type UpdateTranchePayload = {
  readonly __typename?: 'UpdateTranchePayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateUnderwriterEmployeeInput = {
  readonly employeeKeyOrId: Scalars['ID']['input'];
  readonly input: UnderwriterEmployeeUpdateInput;
};

export type UpdateUnderwriterEmployeePayload = {
  readonly __typename?: 'UpdateUnderwriterEmployeePayload';
  readonly underwriterEmployee?: Maybe<UnderwriterEmployee>;
};

export type UpdateUnderwriterInvitationWireInput = {
  readonly disclaimer?: InputMaybe<Scalars['String']['input']>;
  readonly masterAauDate: Scalars['LocalDate']['input'];
};

export type UpdateUnderwritingBaseSharesDistributionInput = {
  readonly data: ReadonlyArray<SharesPerCmgEntityDataInput>;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateUnderwritingBaseSharesDistributionPayload = {
  readonly __typename?: 'UpdateUnderwritingBaseSharesDistributionPayload';
  readonly sharesPerCmgEntity?: Maybe<ReadonlyArray<SharesPerCmgEntity>>;
};

export type UpdateUnderwritingFeeBaseDistributionInput = {
  readonly data: ReadonlyArray<PercentagePerCmgEntityDataInput>;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateUnderwritingFeeBaseDistributionPayload = {
  readonly __typename?: 'UpdateUnderwritingFeeBaseDistributionPayload';
  readonly percentagePerCmgEntity?: Maybe<ReadonlyArray<PercentagePerCmgEntity>>;
};

export type UpdateUnderwritingFeeTotalDistributionInput = {
  readonly data: ReadonlyArray<PercentagePerCmgEntityDataInput>;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateUnderwritingFeeTotalDistributionPayload = {
  readonly __typename?: 'UpdateUnderwritingFeeTotalDistributionPayload';
  readonly percentagePerCmgEntity?: Maybe<ReadonlyArray<PercentagePerCmgEntity>>;
};

export type UpdateUnderwritingTermsFeesAndDiscountsDataInput = {
  readonly baseGrossSpread?: InputMaybe<UpdateGrossSpreadBaseDtoInput>;
  readonly brokerage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly incentiveFee?: InputMaybe<UpdateIncentiveFeeDtoInput>;
  readonly reallowance?: InputMaybe<Scalars['Decimal']['input']>;
  readonly sharesExcludedFromGrossSpread?: InputMaybe<Scalars['Long']['input']>;
  readonly stampFee?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateUnderwritingTermsFeesAndDiscountsInput = {
  readonly data: UpdateUnderwritingTermsFeesAndDiscountsDataInput;
  readonly offeringId: Scalars['UUID']['input'];
};

export type UpdateUnderwritingTermsFeesAndDiscountsPayload = {
  readonly __typename?: 'UpdateUnderwritingTermsFeesAndDiscountsPayload';
  readonly offering?: Maybe<OfferingFull>;
};

export type UpdateViewSettingDataInput = {
  readonly id: Scalars['UUID']['input'];
  readonly viewData: Scalars['String']['input'];
};

export type UpdateViewSettingDataPayload = {
  readonly __typename?: 'UpdateViewSettingDataPayload';
  readonly viewSetting?: Maybe<ViewSetting>;
};

export type UpdateWallCrossIndicationInput = {
  readonly data: WallCrossIndicationDataInput;
  readonly indicationId: Scalars['ID']['input'];
  readonly offeringId: Scalars['ID']['input'];
};

export type UpdateWallCrossIndicationPayload = {
  readonly __typename?: 'UpdateWallCrossIndicationPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

export type UpdateWallCrossIndicationToPassInput = {
  readonly indicationId: Scalars['ID']['input'];
  readonly offeringId: Scalars['ID']['input'];
};

export type UpdateWallCrossIndicationToPassPayload = {
  readonly __typename?: 'UpdateWallCrossIndicationToPassPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

export type UpdateWallCrossInvestorCommunicationLogInput = {
  readonly communicationLogId: Scalars['ID']['input'];
  readonly data: WallCrossInvestorCommunicationLogDataInput;
  readonly offeringId: Scalars['ID']['input'];
};

export type UpdateWallCrossInvestorCommunicationLogPayload = {
  readonly __typename?: 'UpdateWallCrossInvestorCommunicationLogPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

export type UpdateWallCrossInvestorInput = {
  readonly data: WallCrossInvestorDataInput;
  readonly investorId: Scalars['ID']['input'];
  readonly offeringId: Scalars['ID']['input'];
};

export type UpdateWallCrossInvestorPayload = {
  readonly __typename?: 'UpdateWallCrossInvestorPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

export type UpdateWallCrossOwnerInput = {
  readonly data: WallCrossOwnerDataInput;
  readonly investorId: Scalars['ID']['input'];
  readonly offeringId: Scalars['ID']['input'];
};

export type UpdateWallCrossOwnerPayload = {
  readonly __typename?: 'UpdateWallCrossOwnerPayload';
  readonly wallCrossTracker?: Maybe<WallCrossTrackerFull>;
};

export type UpdateXcNotificationSettingsForUserInput = {
  readonly accountSubdomain: Scalars['String']['input'];
  readonly notifications: ReadonlyArray<UpdateNotificationSettings>;
  readonly userId: Scalars['UUID']['input'];
};

export type UpdateXcNotificationSettingsForUserPayload = {
  readonly __typename?: 'UpdateXcNotificationSettingsForUserPayload';
  readonly xcNotificationSetting?: Maybe<ReadonlyArray<XcNotificationSetting>>;
};

export type UpdateXcNotificationSettingsInput = {
  readonly notifications: ReadonlyArray<UpdateNotificationSettings>;
};

export type UpdateXcNotificationSettingsPayload = {
  readonly __typename?: 'UpdateXcNotificationSettingsPayload';
  readonly xcNotificationSetting?: Maybe<ReadonlyArray<XcNotificationSetting>>;
};

export type UpdatedAllocationSets = {
  readonly __typename?: 'UpdatedAllocationSets';
  readonly updatedAllocationSetIds: ReadonlyArray<Scalars['UUID']['output']>;
  readonly updatedIndicationIds: ReadonlyArray<Scalars['UUID']['output']>;
};

export type UpsertInternalDemandInput = {
  readonly indications: ReadonlyArray<MdlIndicationInput>;
};

export enum UseOfProceeds {
  Acquisitions = 'ACQUISITIONS',
  CapitalExpenditures = 'CAPITAL_EXPENDITURES',
  DebtRepayment = 'DEBT_REPAYMENT',
  FutureAcquisitions = 'FUTURE_ACQUISITIONS',
  GeneralCorporatePurposes = 'GENERAL_CORPORATE_PURPOSES',
  GrowthCapital = 'GROWTH_CAPITAL',
  Investments = 'INVESTMENTS',
  NoProceedsToIssuer = 'NO_PROCEEDS_TO_ISSUER',
  ResearchAndDevelopment = 'RESEARCH_AND_DEVELOPMENT',
  ShareholderDividends = 'SHAREHOLDER_DIVIDENDS',
  ShareRepurchase = 'SHARE_REPURCHASE',
  WorkingCapital = 'WORKING_CAPITAL',
}

export type UseOfProceedsFilterInput = {
  readonly eq?: InputMaybe<UseOfProceeds>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<UseOfProceeds>>>;
  readonly neq?: InputMaybe<UseOfProceeds>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<UseOfProceeds>>>;
};

export type UseOfProceedsListFilterInput = {
  readonly all?: InputMaybe<UseOfProceedsFilterInput>;
  readonly any?: InputMaybe<Scalars['Boolean']['input']>;
  readonly none?: InputMaybe<UseOfProceedsFilterInput>;
  readonly some?: InputMaybe<UseOfProceedsFilterInput>;
};

export type User = {
  readonly __typename?: 'User';
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly jobFunction?: Maybe<UserJobFunction>;
  readonly lastName: Scalars['String']['output'];
};

export type UserAccount = {
  readonly __typename?: 'UserAccount';
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly employeeKey: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly jobFunction?: Maybe<IdentityJobFunction>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type UserAccountFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<UserAccountFilterInput>>;
  readonly email?: InputMaybe<StringOperationFilterInput>;
  readonly employeeKey?: InputMaybe<StringOperationFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly isActive?: InputMaybe<BooleanOperationFilterInput>;
  readonly name?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<UserAccountFilterInput>>;
};

export type UserAccountSortInput = {
  readonly email?: InputMaybe<SortEnumType>;
  readonly employeeKey?: InputMaybe<SortEnumType>;
  readonly id?: InputMaybe<SortEnumType>;
  readonly isActive?: InputMaybe<SortEnumType>;
  readonly name?: InputMaybe<SortEnumType>;
};

export type UserInfo = {
  readonly __typename?: 'UserInfo';
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
};

export type UserInfoFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<UserInfoFilterInput>>;
  readonly email?: InputMaybe<StringOperationFilterInput>;
  readonly name?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<UserInfoFilterInput>>;
};

export type UserInfoSortInput = {
  readonly email?: InputMaybe<SortEnumType>;
  readonly name?: InputMaybe<SortEnumType>;
};

/**
 * JobFunction indicates user's function within an organization.
 * Note, values without [ValidFor] attribute indicates the value is valid for both accounts (buy-side and sell-side).
 * * Buy-Side Only Job Functions: ANALYST, PORTFOLIO_MANAGER, TRADER
 * * Sell-Side Only Job Functions:  ECM, ECM_SURVEILLANCE, SALES, SALES_SUPERVISOR, SALES_TRADER, SALES_TRADER_SUPERVISOR, SYNDICATE_OPERATIONS, SYNDICATE_ACCOUNTING, PRODUCT_CONTROL
 * * Job Functions for Both: ADMINISTRATOR, ASSISTANT, LEGAL_COMPLIANCE, OTHER, SUPPORT, SYNDICATE, TECHNOLOGY
 */
export enum UserJobFunction {
  Administrator = 'ADMINISTRATOR',
  Analyst = 'ANALYST',
  Assistant = 'ASSISTANT',
  Ecm = 'ECM',
  EcmSurveillance = 'ECM_SURVEILLANCE',
  LegalCompliance = 'LEGAL_COMPLIANCE',
  Other = 'OTHER',
  PortfolioManager = 'PORTFOLIO_MANAGER',
  ProductControl = 'PRODUCT_CONTROL',
  Sales = 'SALES',
  SalesSupervisor = 'SALES_SUPERVISOR',
  SalesTrader = 'SALES_TRADER',
  SalesTraderSupervisor = 'SALES_TRADER_SUPERVISOR',
  Support = 'SUPPORT',
  Syndicate = 'SYNDICATE',
  SyndicateAccounting = 'SYNDICATE_ACCOUNTING',
  SyndicateOperations = 'SYNDICATE_OPERATIONS',
  Technology = 'TECHNOLOGY',
  Trader = 'TRADER',
}

export enum UserType {
  Api = 'API',
  Interactive = 'INTERACTIVE',
  System = 'SYSTEM',
  Unknown = 'UNKNOWN',
}

export type UuidOperationFilterInput = {
  readonly eq?: InputMaybe<Scalars['UUID']['input']>;
  readonly gt?: InputMaybe<Scalars['UUID']['input']>;
  readonly gte?: InputMaybe<Scalars['UUID']['input']>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  readonly lt?: InputMaybe<Scalars['UUID']['input']>;
  readonly lte?: InputMaybe<Scalars['UUID']['input']>;
  readonly neq?: InputMaybe<Scalars['UUID']['input']>;
  readonly ngt?: InputMaybe<Scalars['UUID']['input']>;
  readonly ngte?: InputMaybe<Scalars['UUID']['input']>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  readonly nlt?: InputMaybe<Scalars['UUID']['input']>;
  readonly nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type ViewSetting = {
  readonly __typename?: 'ViewSetting';
  readonly id: Scalars['UUID']['output'];
  readonly isFavorite: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly viewData: Scalars['String']['output'];
  readonly viewName: Scalars['String']['output'];
};

export type ViewSettingFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<ViewSettingFilterInput>>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly isFavorite?: InputMaybe<BooleanOperationFilterInput>;
  readonly name?: InputMaybe<StringOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<ViewSettingFilterInput>>;
  readonly viewName?: InputMaybe<StringOperationFilterInput>;
};

export type ViewSettingSortInput = {
  readonly id?: InputMaybe<SortEnumType>;
  readonly isFavorite?: InputMaybe<SortEnumType>;
  readonly name?: InputMaybe<SortEnumType>;
  readonly viewName?: InputMaybe<SortEnumType>;
};

export type WallCrossContact = {
  readonly __typename?: 'WallCrossContact';
  readonly email: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly role?: Maybe<Scalars['String']['output']>;
};

export type WallCrossContactInput = {
  readonly email: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly role?: InputMaybe<Scalars['String']['input']>;
};

export type WallCrossIndicationDataInput = {
  readonly currencyCode?: InputMaybe<Scalars['String']['input']>;
  readonly instrumentId?: InputMaybe<Scalars['UUID']['input']>;
  readonly interestLevels: ReadonlyArray<InterestLevelInput>;
  readonly trancheId?: InputMaybe<Scalars['UUID']['input']>;
};

export type WallCrossIndicationFull = {
  readonly __typename?: 'WallCrossIndicationFull';
  readonly auditInfo: AuditInfo;
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly instrumentId?: Maybe<Scalars['UUID']['output']>;
  readonly interestLevels: ReadonlyArray<InterestLevel>;
  readonly investorId: Scalars['UUID']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly recordStatus: OrderBookRecordStatus;
  readonly trancheId?: Maybe<Scalars['UUID']['output']>;
  readonly type: InstitutionalIndicationOrderType;
  readonly version: Scalars['String']['output'];
};

export type WallCrossInvestorCommunicationLogDataInput = {
  readonly contacts?: InputMaybe<ReadonlyArray<WallCrossContactInput>>;
  readonly note?: InputMaybe<Scalars['String']['input']>;
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  readonly title: Scalars['String']['input'];
};

export type WallCrossInvestorCommunicationLogFull = {
  readonly __typename?: 'WallCrossInvestorCommunicationLogFull';
  readonly auditInfo: AuditInfo;
  readonly contacts: ReadonlyArray<WallCrossContact>;
  readonly id: Scalars['UUID']['output'];
  readonly investorId: Scalars['UUID']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly offeringId: Scalars['UUID']['output'];
  readonly recordStatus: OrderBookRecordStatus;
  readonly tags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly timestamp?: Maybe<Scalars['DateTime']['output']>;
  readonly title: Scalars['String']['output'];
  readonly version: Scalars['String']['output'];
};

export type WallCrossInvestorCommunicationLogFullSortInput = {
  readonly auditInfo?: InputMaybe<AuditInfoSortInput>;
  readonly id?: InputMaybe<SortEnumType>;
  readonly investorId?: InputMaybe<SortEnumType>;
  readonly note?: InputMaybe<SortEnumType>;
  readonly offeringId?: InputMaybe<SortEnumType>;
  readonly recordStatus?: InputMaybe<RecordStatusSortInput>;
  readonly timestamp?: InputMaybe<SortEnumType>;
  readonly title?: InputMaybe<SortEnumType>;
  readonly version?: InputMaybe<SortEnumType>;
};

export type WallCrossInvestorCommunicationLogImportDataInput = {
  readonly data: WallCrossInvestorCommunicationLogDataInput;
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
};

export type WallCrossInvestorDataInput = {
  readonly wallCrossMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  readonly wallCrossStatus: WallCrossStatus;
};

export type WallCrossInvestorFull = {
  readonly __typename?: 'WallCrossInvestorFull';
  readonly auditInfo: AuditInfo;
  readonly id: Scalars['UUID']['output'];
  readonly investorCommunicationLogs: ReadonlyArray<WallCrossInvestorCommunicationLogFull>;
  readonly investorGraphModifiedAt: Scalars['DateTime']['output'];
  readonly investorIndication?: Maybe<WallCrossIndicationFull>;
  readonly investorInformation: InvestorInformation;
  readonly offeringId: Scalars['UUID']['output'];
  readonly owner?: Maybe<WallCrossOwner>;
  readonly recordStatus: OrderBookRecordStatus;
  readonly version: Scalars['String']['output'];
  readonly wallCrossMeeting?: Maybe<Scalars['Boolean']['output']>;
  readonly wallCrossStatus: WallCrossStatus;
};

export type WallCrossInvestorFullInvestorCommunicationLogsArgs = {
  order?: InputMaybe<ReadonlyArray<WallCrossInvestorCommunicationLogFullSortInput>>;
};

export type WallCrossInvestorFullSortInput = {
  readonly auditInfo?: InputMaybe<AuditInfoSortInput>;
  readonly id?: InputMaybe<SortEnumType>;
  readonly investorInformation?: InputMaybe<InvestorInformationSortInput>;
  readonly offeringId?: InputMaybe<SortEnumType>;
  readonly recordStatus?: InputMaybe<RecordStatusSortInput>;
  readonly version?: InputMaybe<SortEnumType>;
  readonly wallCrossMeeting?: InputMaybe<SortEnumType>;
  readonly wallCrossStatus?: InputMaybe<SortEnumType>;
};

export type WallCrossOwner = {
  readonly __typename?: 'WallCrossOwner';
  readonly auditInfo: AuditInfo;
  readonly cmgEntityKey: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly investorId: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
  readonly offeringId: Scalars['UUID']['output'];
  readonly recordStatus: OrderBookRecordStatus;
  readonly version: Scalars['String']['output'];
};

export type WallCrossOwnerDataInput = {
  readonly cmgEntityKey: Scalars['String']['input'];
};

export enum WallCrossStatus {
  ComplianceOverTheWall = 'COMPLIANCE_OVER_THE_WALL',
  CompliancePassedNotOverTheWall = 'COMPLIANCE_PASSED_NOT_OVER_THE_WALL',
  CompliancePassedOverTheWall = 'COMPLIANCE_PASSED_OVER_THE_WALL',
  ContactedPending = 'CONTACTED_PENDING',
  InvestmentsOverTheWall = 'INVESTMENTS_OVER_THE_WALL',
  InvestmentsPassedNotOverTheWall = 'INVESTMENTS_PASSED_NOT_OVER_THE_WALL',
  InvestmentsPassedOverTheWall = 'INVESTMENTS_PASSED_OVER_THE_WALL',
  NotContacted = 'NOT_CONTACTED',
}

export type WallCrossTrackerFull = {
  readonly __typename?: 'WallCrossTrackerFull';
  readonly investors: ReadonlyArray<WallCrossInvestorFull>;
  readonly offeringId: Scalars['UUID']['output'];
  readonly summaries: WallCrossTrackerSummaries;
};

export type WallCrossTrackerFullInvestorsArgs = {
  order?: InputMaybe<ReadonlyArray<WallCrossInvestorFullSortInput>>;
};

export type WallCrossTrackerMetricSummaries = {
  readonly __typename?: 'WallCrossTrackerMetricSummaries';
  readonly ioiSubmissions: Scalars['Int']['output'];
  readonly issuerMeetings: Scalars['Int']['output'];
};

export type WallCrossTrackerStatusSummaries = {
  readonly __typename?: 'WallCrossTrackerStatusSummaries';
  readonly complianceOverTheWall: Scalars['Int']['output'];
  readonly contactedOrPending: Scalars['Int']['output'];
  readonly investmentsOverTheWall: Scalars['Int']['output'];
  readonly passes: Scalars['Int']['output'];
};

export type WallCrossTrackerSummaries = {
  readonly __typename?: 'WallCrossTrackerSummaries';
  readonly metricSummaries: WallCrossTrackerMetricSummaries;
  readonly offeringId: Scalars['UUID']['output'];
  readonly statusSummaries: WallCrossTrackerStatusSummaries;
};

export type Wire = {
  readonly __typename?: 'Wire';
  readonly createdAt: Scalars['Instant']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: WireStatus;
  readonly templateType: WireTemplateType;
  readonly wireMessages: ReadonlyArray<WireMessageLimited>;
};

export type WireMessage = {
  readonly __typename?: 'WireMessage';
  readonly emailAddresses: ReadonlyArray<Scalars['String']['output']>;
  readonly expiredAt?: Maybe<Scalars['Instant']['output']>;
  readonly firmSnapshot?: Maybe<FirmSnapshot>;
  readonly htmlBody: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly respondedAt?: Maybe<Scalars['Instant']['output']>;
  readonly responseStatus?: Maybe<SentWireResponseStatus>;
  readonly sentAt?: Maybe<Scalars['Instant']['output']>;
  readonly wireMessageAndResponseStatus: WireMessageAndResponseStatus;
};

export enum WireMessageAndResponseStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Obsolete = 'OBSOLETE',
  ReadyToSend = 'READY_TO_SEND',
  Sent = 'SENT',
}

export type WireMessageLimited = {
  readonly __typename?: 'WireMessageLimited';
  readonly expiredAt?: Maybe<Scalars['Instant']['output']>;
  readonly firmSnapshot?: Maybe<FirmSnapshot>;
  readonly htmlBody: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly respondedAt?: Maybe<Scalars['Instant']['output']>;
  readonly responseStatus?: Maybe<SentWireResponseStatus>;
  readonly sentAt?: Maybe<Scalars['Instant']['output']>;
  readonly wireMessageAndResponseStatus: WireMessageAndResponseStatus;
};

export type WireMessageLimitedReadDtoFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<WireMessageLimitedReadDtoFilterInput>>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<WireMessageLimitedReadDtoFilterInput>>;
  readonly respondedAt?: InputMaybe<InstantOperationFilterInput>;
  readonly responseStatus?: InputMaybe<SentWireResponseStatusFilterInput>;
  readonly sentAt?: InputMaybe<InstantOperationFilterInput>;
};

export type WireOfferingDetail = {
  readonly __typename?: 'WireOfferingDetail';
  readonly id: Scalars['ID']['output'];
  readonly issuerName: Scalars['String']['output'];
  readonly lastTradeBeforeOffer?: Maybe<Scalars['Decimal']['output']>;
  readonly managers: ReadonlyArray<FinraOfferingManager>;
  readonly offerPrice?: Maybe<Scalars['Decimal']['output']>;
  readonly pricingDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly pricingInstrumentSymbol?: Maybe<Scalars['String']['output']>;
  readonly regulatoryFilings: RegulatoryFilings;
  readonly stage: OfferingStage;
  /** Display name for Stage */
  readonly stageDisplayName?: Maybe<Scalars['String']['output']>;
  readonly stockSymbols: ReadonlyArray<Scalars['String']['output']>;
  readonly totalSharesBaseOffering?: Maybe<Scalars['Long']['output']>;
  readonly tradeDate?: Maybe<Scalars['LocalDate']['output']>;
  readonly type: OfferingType;
  /** Display name for Type */
  readonly typeDisplayName?: Maybe<Scalars['String']['output']>;
};

export type WirePreview = {
  readonly __typename?: 'WirePreview';
  readonly htmlContent: Scalars['String']['output'];
};

export type WireReadDtoFilterInput = {
  readonly and?: InputMaybe<ReadonlyArray<WireReadDtoFilterInput>>;
  readonly createdAt?: InputMaybe<InstantOperationFilterInput>;
  readonly id?: InputMaybe<UuidOperationFilterInput>;
  readonly or?: InputMaybe<ReadonlyArray<WireReadDtoFilterInput>>;
  readonly sender?: InputMaybe<StringOperationFilterInput>;
  readonly status?: InputMaybe<WireStatusFilterInput>;
  readonly templateType?: InputMaybe<WireTemplateTypeFilterInput>;
  readonly wireMessages?: InputMaybe<ListFilterInputTypeOfWireMessageLimitedReadDtoFilterInput>;
};

export type WireReadDtoSortInput = {
  readonly createdAt?: InputMaybe<SortEnumType>;
  readonly id?: InputMaybe<SortEnumType>;
  readonly sender?: InputMaybe<SortEnumType>;
  readonly status?: InputMaybe<SortEnumType>;
  readonly templateType?: InputMaybe<SortEnumType>;
};

export type WireResponse = SentWireStatus | ServiceError;

export enum WireStatus {
  Draft = 'DRAFT',
  Outdated = 'OUTDATED',
  Sent = 'SENT',
}

export type WireStatusFilterInput = {
  readonly eq?: InputMaybe<WireStatus>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<WireStatus>>>;
  readonly neq?: InputMaybe<WireStatus>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<WireStatus>>>;
};

export enum WireTemplateType {
  DesignationWithIntegration = 'DESIGNATION_WITH_INTEGRATION',
  DesignationWithIntegrationConvertible = 'DESIGNATION_WITH_INTEGRATION_CONVERTIBLE',
  FreeForm = 'FREE_FORM',
  FreeFormConvertible = 'FREE_FORM_CONVERTIBLE',
  GreenShoe = 'GREEN_SHOE',
  GreenShoeConvertible = 'GREEN_SHOE_CONVERTIBLE',
  IssuerAllocation = 'ISSUER_ALLOCATION',
  IssuerIndication = 'ISSUER_INDICATION',
  ManagerBillingAndDelivery = 'MANAGER_BILLING_AND_DELIVERY',
  ManagerBillingAndDeliveryConvertible = 'MANAGER_BILLING_AND_DELIVERY_CONVERTIBLE',
  NonSyndicateMemberFreeForm = 'NON_SYNDICATE_MEMBER_FREE_FORM',
  NonSyndicateMemberFreeFormConvertible = 'NON_SYNDICATE_MEMBER_FREE_FORM_CONVERTIBLE',
  NonSyndicateMemberPayment = 'NON_SYNDICATE_MEMBER_PAYMENT',
  NonSyndicateMemberPaymentConvertible = 'NON_SYNDICATE_MEMBER_PAYMENT_CONVERTIBLE',
  NonSyndicateMemberSellingGroupInvitationConvertible = 'NON_SYNDICATE_MEMBER_SELLING_GROUP_INVITATION_CONVERTIBLE',
  NonSyndicateMemberSellingGroupInvitationFo = 'NON_SYNDICATE_MEMBER_SELLING_GROUP_INVITATION_FO',
  NonSyndicateMemberSellingGroupInvitationIpo = 'NON_SYNDICATE_MEMBER_SELLING_GROUP_INVITATION_IPO',
  NonSyndicateMemberSellingGroupTermsRetention = 'NON_SYNDICATE_MEMBER_SELLING_GROUP_TERMS_RETENTION',
  NonSyndicateMemberSellingGroupTermsRetentionConvertible = 'NON_SYNDICATE_MEMBER_SELLING_GROUP_TERMS_RETENTION_CONVERTIBLE',
  NonSyndicateMemberTermination = 'NON_SYNDICATE_MEMBER_TERMINATION',
  NonSyndicateMemberTerminationConvertible = 'NON_SYNDICATE_MEMBER_TERMINATION_CONVERTIBLE',
  Payment = 'PAYMENT',
  PaymentConvertible = 'PAYMENT_CONVERTIBLE',
  PotAccount = 'POT_ACCOUNT',
  PotAccountConvertible = 'POT_ACCOUNT_CONVERTIBLE',
  PotAllocation = 'POT_ALLOCATION',
  PotAllocationConvertible = 'POT_ALLOCATION_CONVERTIBLE',
  PricingTerms = 'PRICING_TERMS',
  PricingTermsConvertible = 'PRICING_TERMS_CONVERTIBLE',
  PricingTermsRetention = 'PRICING_TERMS_RETENTION',
  PricingTermsRetentionConvertible = 'PRICING_TERMS_RETENTION_CONVERTIBLE',
  RegulationM = 'REGULATION_M',
  RegulationMConvertible = 'REGULATION_M_CONVERTIBLE',
  ResearchRestrictionConvertible = 'RESEARCH_RESTRICTION_CONVERTIBLE',
  ResearchRestrictionFo = 'RESEARCH_RESTRICTION_FO',
  ResearchRestrictionIpo = 'RESEARCH_RESTRICTION_IPO',
  Retention = 'RETENTION',
  RetentionConvertible = 'RETENTION_CONVERTIBLE',
  SellingGroupInvitationConvertible = 'SELLING_GROUP_INVITATION_CONVERTIBLE',
  SellingGroupInvitationFo = 'SELLING_GROUP_INVITATION_FO',
  SellingGroupInvitationIpo = 'SELLING_GROUP_INVITATION_IPO',
  SellingGroupTerms = 'SELLING_GROUP_TERMS',
  SellingGroupTermsConvertible = 'SELLING_GROUP_TERMS_CONVERTIBLE',
  Termination = 'TERMINATION',
  TerminationConvertible = 'TERMINATION_CONVERTIBLE',
  UnderwriterInvitationConvertible = 'UNDERWRITER_INVITATION_CONVERTIBLE',
  UnderwriterInvitationFo = 'UNDERWRITER_INVITATION_FO',
  UnderwriterInvitationIpo = 'UNDERWRITER_INVITATION_IPO',
}

export type WireTemplateTypeFilterInput = {
  readonly eq?: InputMaybe<WireTemplateType>;
  readonly in?: InputMaybe<ReadonlyArray<InputMaybe<WireTemplateType>>>;
  readonly neq?: InputMaybe<WireTemplateType>;
  readonly nin?: InputMaybe<ReadonlyArray<InputMaybe<WireTemplateType>>>;
};

export type WireValidationBase = {
  readonly managers: ReadonlyArray<ManagerValidation>;
  readonly orderBookErrors: ReadonlyArray<OrderBookErrorType>;
  readonly sender: ManagerValidation;
  readonly settlementErrors: ReadonlyArray<SettlementErrorType>;
};

export type XcNotificationSetting = {
  readonly __typename?: 'XcNotificationSetting';
  readonly isEnabled: Scalars['Boolean']['output'];
  readonly notificationType?: Maybe<EmailNotificationType>;
  /** Display name for NotificationType */
  readonly notificationTypeDisplayName?: Maybe<Scalars['String']['output']>;
};

export type UpdateNotificationSettings = {
  readonly emailNotificationType?: InputMaybe<EmailNotificationType>;
  readonly isActive: Scalars['Boolean']['input'];
};

export type UpdatePrivateManagerEconomicsDataInput = {
  readonly incentiveFeePercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly managementPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly overallotmentExercisedShares?: InputMaybe<Scalars['Long']['input']>;
  readonly sellingConcessionPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  readonly underwritingBaseShares?: InputMaybe<Scalars['Long']['input']>;
  readonly underwritingPercentage?: InputMaybe<Scalars['Decimal']['input']>;
};
